(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4c53"];
var parcelRegister = parcelRequire.register;
parcelRegister("S0nQY", function(module, exports) {
/**
 * TinyMCE version 7.9.3 (2026-05-19)
 */ /**
 * This file bundles the code of
 * DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE
 */ !function() {
    "use strict";
    var e1 = function(e1) {
        if (null === e1) return "null";
        if (void 0 === e1) return "undefined";
        var t = typeof e1;
        return "object" === t && (Array.prototype.isPrototypeOf(e1) || e1.constructor && "Array" === e1.constructor.name) ? "array" : "object" === t && (String.prototype.isPrototypeOf(e1) || e1.constructor && "String" === e1.constructor.name) ? "string" : t;
    }, t = function(e1) {
        return {
            eq: e1
        };
    }, n = t(function(e1, t) {
        return e1 === t;
    }), o = function(e1) {
        return t(function(t, n) {
            if (t.length !== n.length) return !1;
            for(var o = t.length, r = 0; r < o; r++)if (!e1.eq(t[r], n[r])) return !1;
            return !0;
        });
    }, r = function(e1) {
        return t(function(r, s) {
            var a = Object.keys(r), i = Object.keys(s);
            if (!(function(e1, n) {
                return function(e1, n) {
                    return t(function(t, o) {
                        return e1.eq(n(t), n(o));
                    });
                }(o(e1), function(e1) {
                    return function(e1, t) {
                        return Array.prototype.slice.call(e1).sort(t);
                    }(e1, n);
                });
            })(n).eq(a, i)) return !1;
            for(var l = a.length, d = 0; d < l; d++){
                var c = a[d];
                if (!e1.eq(r[c], s[c])) return !1;
            }
            return !0;
        });
    }, s = t(function(t, n) {
        if (t === n) return !0;
        var a = e1(t);
        return a === e1(n) && (function(e1) {
            return -1 !== [
                "undefined",
                "boolean",
                "number",
                "string",
                "function",
                "xml",
                "null"
            ].indexOf(e1);
        }(a) ? t === n : "array" === a ? o(s).eq(t, n) : "object" === a && r(s).eq(t, n));
    });
    const a = Object.getPrototypeOf, i = (e1, t, n)=>{
        var o;
        return !!n(e1, t.prototype) || (null === (o = e1.constructor) || void 0 === o ? void 0 : o.name) === t.name;
    }, l = (e1)=>(t)=>((e1)=>{
                const t = typeof e1;
                return null === e1 ? "null" : "object" === t && Array.isArray(e1) ? "array" : "object" === t && i(e1, String, (e1, t)=>t.isPrototypeOf(e1)) ? "string" : t;
            })(t) === e1, d = (e1)=>(t)=>typeof t === e1, c = (e1)=>(t)=>e1 === t, u = (e1, t)=>f(e1) && i(e1, t, (e1, t)=>a(e1) === t), m = l("string"), f = l("object"), g = (e1)=>u(e1, Object), p = l("array"), h = c(null), b = d("boolean"), v = c(void 0), y = (e1)=>null == e1, C = (e1)=>!y(e1), w = d("function"), E = d("number"), _ = (e1, t)=>{
        if (p(e1)) {
            for(let n = 0, o = e1.length; n < o; ++n)if (!t(e1[n])) return !1;
            return !0;
        }
        return !1;
    }, x = ()=>{}, S = (e1, t)=>(...n)=>e1(t.apply(null, n)), k = (e1, t)=>(n)=>e1(t(n)), N = (e1)=>()=>e1, R = (e1)=>e1, A = (e1, t)=>e1 === t;
    function T(e1, ...t) {
        return (...n)=>{
            const o = t.concat(n);
            return e1.apply(null, o);
        };
    }
    const O = (e1)=>(t)=>!e1(t), B = (e1)=>()=>{
            throw new Error(e1);
        }, P = (e1)=>e1(), D = (e1)=>{
        e1();
    }, L = N(!1), M = N(!0);
    class I {
        constructor(e1, t){
            this.tag = e1, this.value = t;
        }
        static some(e1) {
            return new I(!0, e1);
        }
        static none() {
            return I.singletonNone;
        }
        fold(e1, t) {
            return this.tag ? t(this.value) : e1();
        }
        isSome() {
            return this.tag;
        }
        isNone() {
            return !this.tag;
        }
        map(e1) {
            return this.tag ? I.some(e1(this.value)) : I.none();
        }
        bind(e1) {
            return this.tag ? e1(this.value) : I.none();
        }
        exists(e1) {
            return this.tag && e1(this.value);
        }
        forall(e1) {
            return !this.tag || e1(this.value);
        }
        filter(e1) {
            return !this.tag || e1(this.value) ? this : I.none();
        }
        getOr(e1) {
            return this.tag ? this.value : e1;
        }
        or(e1) {
            return this.tag ? this : e1;
        }
        getOrThunk(e1) {
            return this.tag ? this.value : e1();
        }
        orThunk(e1) {
            return this.tag ? this : e1();
        }
        getOrDie(e1) {
            if (this.tag) return this.value;
            throw new Error(null != e1 ? e1 : "Called getOrDie on None");
        }
        static from(e1) {
            return C(e1) ? I.some(e1) : I.none();
        }
        getOrNull() {
            return this.tag ? this.value : null;
        }
        getOrUndefined() {
            return this.value;
        }
        each(e1) {
            this.tag && e1(this.value);
        }
        toArray() {
            return this.tag ? [
                this.value
            ] : [];
        }
        toString() {
            return this.tag ? `some(${this.value})` : "none()";
        }
    }
    I.singletonNone = new I(!1);
    const F = Array.prototype.slice, U = Array.prototype.indexOf, z = Array.prototype.push, j = (e1, t)=>U.call(e1, t), H = (e1, t)=>j(e1, t) > -1, $ = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; n++)if (t(e1[n], n)) return !0;
        return !1;
    }, V = (e1, t)=>{
        const n = e1.length, o = new Array(n);
        for(let r = 0; r < n; r++){
            const n = e1[r];
            o[r] = t(n, r);
        }
        return o;
    }, q = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; n++)t(e1[n], n);
    }, W = (e1, t)=>{
        for(let n = e1.length - 1; n >= 0; n--)t(e1[n], n);
    }, K = (e1, t)=>{
        const n = [], o = [];
        for(let r = 0, s = e1.length; r < s; r++){
            const s = e1[r];
            (t(s, r) ? n : o).push(s);
        }
        return {
            pass: n,
            fail: o
        };
    }, Y = (e1, t)=>{
        const n = [];
        for(let o = 0, r = e1.length; o < r; o++){
            const r = e1[o];
            t(r, o) && n.push(r);
        }
        return n;
    }, G = (e1, t, n)=>(W(e1, (e1, o)=>{
            n = t(n, e1, o);
        }), n), X = (e1, t, n)=>(q(e1, (e1, o)=>{
            n = t(n, e1, o);
        }), n), Z = (e1, t, n)=>{
        for(let o = 0, r = e1.length; o < r; o++){
            const r = e1[o];
            if (t(r, o)) return I.some(r);
            if (n(r, o)) break;
        }
        return I.none();
    }, Q = (e1, t)=>Z(e1, t, L), J = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; n++)if (t(e1[n], n)) return I.some(n);
        return I.none();
    }, ee = (e1)=>{
        const t = [];
        for(let n = 0, o = e1.length; n < o; ++n){
            if (!p(e1[n])) throw new Error("Arr.flatten item " + n + " was not an array, input: " + e1);
            z.apply(t, e1[n]);
        }
        return t;
    }, te = (e1, t)=>ee(V(e1, t)), ne = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; ++n)if (!0 !== t(e1[n], n)) return !1;
        return !0;
    }, oe = (e1)=>{
        const t = F.call(e1, 0);
        return t.reverse(), t;
    }, re = (e1, t)=>Y(e1, (e1)=>!H(t, e1)), se = (e1, t)=>{
        const n = {};
        for(let o = 0, r = e1.length; o < r; o++){
            const r = e1[o];
            n[String(r)] = t(r, o);
        }
        return n;
    }, ae = (e1, t)=>{
        const n = F.call(e1, 0);
        return n.sort(t), n;
    }, ie = (e1, t)=>t >= 0 && t < e1.length ? I.some(e1[t]) : I.none(), le = (e1)=>ie(e1, 0), de = (e1)=>ie(e1, e1.length - 1), ce = w(Array.from) ? Array.from : (e1)=>F.call(e1), ue = (e1, t)=>{
        for(let n = 0; n < e1.length; n++){
            const o = t(e1[n], n);
            if (o.isSome()) return o;
        }
        return I.none();
    }, me = (e1, t)=>{
        const n = [], o = w(t) ? (e1)=>$(n, (n)=>t(n, e1)) : (e1)=>H(n, e1);
        for(let t = 0, r = e1.length; t < r; t++){
            const r = e1[t];
            o(r) || n.push(r);
        }
        return n;
    }, fe = Object.keys, ge = Object.hasOwnProperty, pe = (e1, t)=>{
        const n = fe(e1);
        for(let o = 0, r = n.length; o < r; o++){
            const r = n[o];
            t(e1[r], r);
        }
    }, he = (e1, t)=>be(e1, (e1, n)=>({
                k: n,
                v: t(e1, n)
            })), be = (e1, t)=>{
        const n = {};
        return pe(e1, (e1, o)=>{
            const r = t(e1, o);
            n[r.k] = r.v;
        }), n;
    }, ve = (e1)=>(t, n)=>{
            e1[n] = t;
        }, ye = (e1, t, n, o)=>{
        pe(e1, (e1, r)=>{
            (t(e1, r) ? n : o)(e1, r);
        });
    }, Ce = (e1, t)=>{
        const n = {};
        return ye(e1, t, ve(n), x), n;
    }, we = (e1, t)=>{
        const n = [];
        return pe(e1, (e1, o)=>{
            n.push(t(e1, o));
        }), n;
    }, Ee = (e1)=>we(e1, R), _e = (e1, t)=>xe(e1, t) ? I.from(e1[t]) : I.none(), xe = (e1, t)=>ge.call(e1, t), Se = (e1, t)=>xe(e1, t) && void 0 !== e1[t] && null !== e1[t], ke = (e1)=>{
        if (!p(e1)) throw new Error("cases must be an array");
        if (0 === e1.length) throw new Error("there must be at least one case");
        const t = [], n = {};
        return q(e1, (o, r)=>{
            const s = fe(o);
            if (1 !== s.length) throw new Error("one and only one name per case");
            const a = s[0], i = o[a];
            if (void 0 !== n[a]) throw new Error("duplicate key detected:" + a);
            if ("cata" === a) throw new Error("cannot have a case named cata (sorry)");
            if (!p(i)) throw new Error("case arguments must be an array");
            t.push(a), n[a] = (...n)=>{
                const o = n.length;
                if (o !== i.length) throw new Error("Wrong number of arguments to case " + a + ". Expected " + i.length + " (" + i + "), got " + o);
                return {
                    fold: (...t)=>{
                        if (t.length !== e1.length) throw new Error("Wrong number of arguments to fold. Expected " + e1.length + ", got " + t.length);
                        return t[r].apply(null, n);
                    },
                    match: (e1)=>{
                        const o = fe(e1);
                        if (t.length !== o.length) throw new Error("Wrong number of arguments to match. Expected: " + t.join(",") + "\nActual: " + o.join(","));
                        if (!ne(t, (e1)=>H(o, e1))) throw new Error("Not all branches were specified when using match. Specified: " + o.join(", ") + "\nRequired: " + t.join(", "));
                        return e1[a].apply(null, n);
                    },
                    log: (e1)=>{
                        console.log(e1, {
                            constructors: t,
                            constructor: a,
                            params: n
                        });
                    }
                };
            };
        }), n;
    }, Ne = (e1)=>{
        let t = e1;
        return {
            get: ()=>t,
            set: (e1)=>{
                t = e1;
            }
        };
    }, Re = (e1)=>{
        const t = (t)=>t(e1), n = N(e1), o = ()=>r, r = {
            tag: !0,
            inner: e1,
            fold: (t, n)=>n(e1),
            isValue: M,
            isError: L,
            map: (t)=>Te.value(t(e1)),
            mapError: o,
            bind: t,
            exists: t,
            forall: t,
            getOr: n,
            or: o,
            getOrThunk: n,
            orThunk: o,
            getOrDie: n,
            each: (t)=>{
                t(e1);
            },
            toOptional: ()=>I.some(e1)
        };
        return r;
    }, Ae = (e1)=>{
        const t = ()=>n, n = {
            tag: !1,
            inner: e1,
            fold: (t, n)=>t(e1),
            isValue: L,
            isError: M,
            map: t,
            mapError: (t)=>Te.error(t(e1)),
            bind: t,
            exists: L,
            forall: M,
            getOr: R,
            or: R,
            getOrThunk: P,
            orThunk: P,
            getOrDie: B(String(e1)),
            each: x,
            toOptional: I.none
        };
        return n;
    }, Te = {
        value: Re,
        error: Ae,
        fromOption: (e1, t)=>e1.fold(()=>Ae(t), Re)
    }, Oe = "undefined" != typeof window ? window : Function("return this;")(), Be = ()=>window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967295;
    let Pe = 0;
    const De = (e1)=>{
        const t = (new Date).getTime(), n = Math.floor(1e9 * Be());
        return Pe++, e1 + "_" + n + Pe + String(t);
    }, Le = (e1)=>(...t)=>{
            if (0 === t.length) throw new Error("Can't merge zero objects");
            const n = {};
            for(let o = 0; o < t.length; o++){
                const r = t[o];
                for(const t in r)xe(r, t) && (n[t] = e1(n[t], r[t]));
            }
            return n;
        }, Me = Le((e1, t)=>g(e1) && g(t) ? Me(e1, t) : t), Ie = Le((e1, t)=>t), Fe = (e1, t, n = A)=>e1.exists((e1)=>n(e1, t)), Ue = (e1, t, n = A)=>ze(e1, t, n).getOr(e1.isNone() && t.isNone()), ze = (e1, t, n)=>e1.isSome() && t.isSome() ? I.some(n(e1.getOrDie(), t.getOrDie())) : I.none(), je = (e1, t)=>e1 ? I.some(t) : I.none(), He = (e1, t)=>((e1, t)=>{
            let n = null != t ? t : Oe;
            for(let t = 0; t < e1.length && null != n; ++t)n = n[e1[t]];
            return n;
        })(e1.split("."), t);
    ke([
        {
            bothErrors: [
                "error1",
                "error2"
            ]
        },
        {
            firstError: [
                "error1",
                "value2"
            ]
        },
        {
            secondError: [
                "value1",
                "error2"
            ]
        },
        {
            bothValues: [
                "value1",
                "value2"
            ]
        }
    ]);
    const $e = (e1)=>{
        const t = Ne(I.none()), n = ()=>t.get().each((e1)=>clearInterval(e1));
        return {
            clear: ()=>{
                n(), t.set(I.none());
            },
            isSet: ()=>t.get().isSome(),
            get: ()=>t.get(),
            set: (o)=>{
                n(), t.set(I.some(setInterval(o, e1)));
            }
        };
    }, Ve = ()=>{
        const e1 = ((e1)=>{
            const t = Ne(I.none()), n = ()=>t.get().each(e1);
            return {
                clear: ()=>{
                    n(), t.set(I.none());
                },
                isSet: ()=>t.get().isSome(),
                get: ()=>t.get(),
                set: (e1)=>{
                    n(), t.set(I.some(e1));
                }
            };
        })(x);
        return {
            ...e1,
            on: (t)=>e1.get().each(t)
        };
    }, qe = (e1, t, n)=>"" === t || e1.length >= t.length && e1.substr(n, n + t.length) === t, We = (e1, t)=>Ye(e1, t) ? ((e1, t)=>e1.substring(t))(e1, t.length) : e1, Ke = (e1, t, n = 0, o)=>{
        const r = e1.indexOf(t, n);
        return -1 !== r && (!!v(o) || r + t.length <= o);
    }, Ye = (e1, t)=>qe(e1, t, 0), Ge = (e1, t)=>qe(e1, t, e1.length - t.length), Xe = (e1)=>(t)=>t.replace(e1, ""), Ze = Xe(/^\s+|\s+$/g), Qe = Xe(/^\s+/g), Je = Xe(/\s+$/g), et = (e1)=>e1.length > 0, tt = (e1)=>!et(e1), nt = (e1, t = 10)=>{
        const n = parseInt(e1, t);
        return isNaN(n) ? I.none() : I.some(n);
    }, ot = (e1, t)=>{
        let n = null;
        return {
            cancel: ()=>{
                h(n) || (clearTimeout(n), n = null);
            },
            throttle: (...o)=>{
                h(n) && (n = setTimeout(()=>{
                    n = null, e1.apply(null, o);
                }, t));
            }
        };
    }, rt = (e1, t)=>{
        let n = null;
        const o = ()=>{
            h(n) || (clearTimeout(n), n = null);
        };
        return {
            cancel: o,
            throttle: (...r)=>{
                o(), n = setTimeout(()=>{
                    n = null, e1.apply(null, r);
                }, t);
            }
        };
    }, st = (e1)=>{
        let t, n = !1;
        return (...o)=>(n || (n = !0, t = e1.apply(null, o)), t);
    }, at = "\ufeff", it = "\xa0", lt = (e1)=>e1 === at, dt = (e1)=>{
        const t = {};
        return q(e1, (e1)=>{
            t[e1] = {};
        }), fe(t);
    }, ct = (e1)=>void 0 !== e1.length, ut = Array.isArray, mt = (e1, t, n)=>{
        if (!e1) return !1;
        if (n = n || e1, ct(e1)) {
            for(let o = 0, r = e1.length; o < r; o++)if (!1 === t.call(n, e1[o], o, e1)) return !1;
        } else for(const o in e1)if (xe(e1, o) && !1 === t.call(n, e1[o], o, e1)) return !1;
        return !0;
    }, ft = (e1, t)=>{
        const n = [];
        return mt(e1, (o, r)=>{
            n.push(t(o, r, e1));
        }), n;
    }, gt = (e1, t)=>{
        const n = [];
        return mt(e1, (o, r)=>{
            t && !t(o, r, e1) || n.push(o);
        }), n;
    }, pt = (e1, t, n, o)=>{
        let r = v(n) ? e1[0] : n;
        for(let n = 0; n < e1.length; n++)r = t.call(o, r, e1[n], n);
        return r;
    }, ht = (e1, t, n)=>{
        for(let o = 0, r = e1.length; o < r; o++)if (t.call(n, e1[o], o, e1)) return o;
        return -1;
    }, bt = (e1)=>e1[e1.length - 1], vt = ()=>yt(0, 0), yt = (e1, t)=>({
            major: e1,
            minor: t
        }), Ct = {
        nu: yt,
        detect: (e1, t)=>{
            const n = String(t).toLowerCase();
            return 0 === e1.length ? vt() : ((e1, t)=>{
                const n = ((e1, t)=>{
                    for(let n = 0; n < e1.length; n++){
                        const o = e1[n];
                        if (o.test(t)) return o;
                    }
                })(e1, t);
                if (!n) return {
                    major: 0,
                    minor: 0
                };
                const o = (e1)=>Number(t.replace(n, "$" + e1));
                return yt(o(1), o(2));
            })(e1, n);
        },
        unknown: vt
    }, wt = (e1, t)=>{
        const n = String(t).toLowerCase();
        return Q(e1, (e1)=>e1.search(n));
    }, Et = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/, _t = (e1)=>(t)=>Ke(t, e1), xt = [
        {
            name: "Edge",
            versionRegexes: [
                /.*?edge\/ ?([0-9]+)\.([0-9]+)$/
            ],
            search: (e1)=>Ke(e1, "edge/") && Ke(e1, "chrome") && Ke(e1, "safari") && Ke(e1, "applewebkit")
        },
        {
            name: "Chromium",
            brand: "Chromium",
            versionRegexes: [
                /.*?chrome\/([0-9]+)\.([0-9]+).*/,
                Et
            ],
            search: (e1)=>Ke(e1, "chrome") && !Ke(e1, "chromeframe")
        },
        {
            name: "IE",
            versionRegexes: [
                /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
                /.*?rv:([0-9]+)\.([0-9]+).*/
            ],
            search: (e1)=>Ke(e1, "msie") || Ke(e1, "trident")
        },
        {
            name: "Opera",
            versionRegexes: [
                Et,
                /.*?opera\/([0-9]+)\.([0-9]+).*/
            ],
            search: _t("opera")
        },
        {
            name: "Firefox",
            versionRegexes: [
                /.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/
            ],
            search: _t("firefox")
        },
        {
            name: "Safari",
            versionRegexes: [
                Et,
                /.*?cpu os ([0-9]+)_([0-9]+).*/
            ],
            search: (e1)=>(Ke(e1, "safari") || Ke(e1, "mobile/")) && Ke(e1, "applewebkit")
        }
    ], St = [
        {
            name: "Windows",
            search: _t("win"),
            versionRegexes: [
                /.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/
            ]
        },
        {
            name: "iOS",
            search: (e1)=>Ke(e1, "iphone") || Ke(e1, "ipad"),
            versionRegexes: [
                /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
                /.*cpu os ([0-9]+)_([0-9]+).*/,
                /.*cpu iphone os ([0-9]+)_([0-9]+).*/
            ]
        },
        {
            name: "Android",
            search: _t("android"),
            versionRegexes: [
                /.*?android\ ?([0-9]+)\.([0-9]+).*/
            ]
        },
        {
            name: "macOS",
            search: _t("mac os x"),
            versionRegexes: [
                /.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/
            ]
        },
        {
            name: "Linux",
            search: _t("linux"),
            versionRegexes: []
        },
        {
            name: "Solaris",
            search: _t("sunos"),
            versionRegexes: []
        },
        {
            name: "FreeBSD",
            search: _t("freebsd"),
            versionRegexes: []
        },
        {
            name: "ChromeOS",
            search: _t("cros"),
            versionRegexes: [
                /.*?chrome\/([0-9]+)\.([0-9]+).*/
            ]
        }
    ], kt = {
        browsers: N(xt),
        oses: N(St)
    }, Nt = "Edge", Rt = "Chromium", At = "Opera", Tt = "Firefox", Ot = "Safari", Bt = (e1)=>{
        const t = e1.current, n = e1.version, o = (e1)=>()=>t === e1;
        return {
            current: t,
            version: n,
            isEdge: o(Nt),
            isChromium: o(Rt),
            isIE: o("IE"),
            isOpera: o(At),
            isFirefox: o(Tt),
            isSafari: o(Ot)
        };
    }, Pt = ()=>Bt({
            current: void 0,
            version: Ct.unknown()
        }), Dt = Bt, Lt = (N(Nt), N(Rt), N("IE"), N(At), N(Tt), N(Ot), "Windows"), Mt = "Android", It = "Linux", Ft = "macOS", Ut = "Solaris", zt = "FreeBSD", jt = "ChromeOS", Ht = (e1)=>{
        const t = e1.current, n = e1.version, o = (e1)=>()=>t === e1;
        return {
            current: t,
            version: n,
            isWindows: o(Lt),
            isiOS: o("iOS"),
            isAndroid: o(Mt),
            isMacOS: o(Ft),
            isLinux: o(It),
            isSolaris: o(Ut),
            isFreeBSD: o(zt),
            isChromeOS: o(jt)
        };
    }, $t = ()=>Ht({
            current: void 0,
            version: Ct.unknown()
        }), Vt = Ht, qt = (N(Lt), N("iOS"), N(Mt), N(It), N(Ft), N(Ut), N(zt), N(jt), (e1)=>window.matchMedia(e1).matches);
    let Wt = st(()=>((e1, t, n)=>{
            const o = kt.browsers(), r = kt.oses(), s = t.bind((e1)=>((e1, t)=>ue(t.brands, (t)=>{
                        const n = t.brand.toLowerCase();
                        return Q(e1, (e1)=>{
                            var t;
                            return n === (null === (t = e1.brand) || void 0 === t ? void 0 : t.toLowerCase());
                        }).map((e1)=>({
                                current: e1.name,
                                version: Ct.nu(parseInt(t.version, 10), 0)
                            }));
                    }))(o, e1)).orThunk(()=>((e1, t)=>wt(e1, t).map((e1)=>{
                        const n = Ct.detect(e1.versionRegexes, t);
                        return {
                            current: e1.name,
                            version: n
                        };
                    }))(o, e1)).fold(Pt, Dt), a = ((e1, t)=>wt(e1, t).map((e1)=>{
                    const n = Ct.detect(e1.versionRegexes, t);
                    return {
                        current: e1.name,
                        version: n
                    };
                }))(r, e1).fold($t, Vt), i = ((e1, t, n, o)=>{
                const r = e1.isiOS() && !0 === /ipad/i.test(n), s = e1.isiOS() && !r, a = e1.isiOS() || e1.isAndroid(), i = a || o("(pointer:coarse)"), l = r || !s && a && o("(min-device-width:768px)"), d = s || a && !l, c = t.isSafari() && e1.isiOS() && !1 === /safari/i.test(n), u = !d && !l && !c;
                return {
                    isiPad: N(r),
                    isiPhone: N(s),
                    isTablet: N(l),
                    isPhone: N(d),
                    isTouch: N(i),
                    isAndroid: e1.isAndroid,
                    isiOS: e1.isiOS,
                    isWebView: N(c),
                    isDesktop: N(u)
                };
            })(a, s, e1, n);
            return {
                browser: s,
                os: a,
                deviceType: i
            };
        })(window.navigator.userAgent, I.from(window.navigator.userAgentData), qt));
    const Kt = ()=>Wt(), Yt = Object.getPrototypeOf, Gt = (e1)=>{
        const t = He("ownerDocument.defaultView", e1);
        return f(e1) && (((e1)=>((e1, t)=>{
                const n = ((e1, t)=>He(e1, t))(e1, t);
                if (null == n) throw new Error(e1 + " not available on this browser");
                return n;
            })("HTMLElement", e1))(t).prototype.isPrototypeOf(e1) || /^HTML\w*Element$/.test(Yt(e1).constructor.name));
    }, Xt = window.navigator.userAgent, Zt = Kt(), Qt = Zt.browser, Jt = Zt.os, en = Zt.deviceType, tn = -1 !== Xt.indexOf("Windows Phone"), nn = {
        transparentSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        documentMode: Qt.isIE() ? document.documentMode || 7 : 10,
        cacheSuffix: null,
        container: null,
        canHaveCSP: !Qt.isIE(),
        windowsPhone: tn,
        browser: {
            current: Qt.current,
            version: Qt.version,
            isChromium: Qt.isChromium,
            isEdge: Qt.isEdge,
            isFirefox: Qt.isFirefox,
            isIE: Qt.isIE,
            isOpera: Qt.isOpera,
            isSafari: Qt.isSafari
        },
        os: {
            current: Jt.current,
            version: Jt.version,
            isAndroid: Jt.isAndroid,
            isChromeOS: Jt.isChromeOS,
            isFreeBSD: Jt.isFreeBSD,
            isiOS: Jt.isiOS,
            isLinux: Jt.isLinux,
            isMacOS: Jt.isMacOS,
            isSolaris: Jt.isSolaris,
            isWindows: Jt.isWindows
        },
        deviceType: {
            isDesktop: en.isDesktop,
            isiPad: en.isiPad,
            isiPhone: en.isiPhone,
            isPhone: en.isPhone,
            isTablet: en.isTablet,
            isTouch: en.isTouch,
            isWebView: en.isWebView
        }
    }, on = /^\s*|\s*$/g, rn = (e1)=>y(e1) ? "" : ("" + e1).replace(on, ""), sn = function(e1, t, n, o) {
        o = o || this, e1 && (n && (e1 = e1[n]), mt(e1, (e1, r)=>!1 !== t.call(o, e1, r, n) && (sn(e1, t, n, o), !0)));
    }, an = {
        trim: rn,
        isArray: ut,
        is: (e1, t)=>t ? !("array" !== t || !ut(e1)) || typeof e1 === t : void 0 !== e1,
        toArray: (e1)=>{
            if (ut(e1)) return e1;
            {
                const t = [];
                for(let n = 0, o = e1.length; n < o; n++)t[n] = e1[n];
                return t;
            }
        },
        makeMap: (e1, t, n = {})=>{
            const o = m(e1) ? e1.split(t || ",") : e1 || [];
            let r = o.length;
            for(; r--;)n[o[r]] = {};
            return n;
        },
        each: mt,
        map: ft,
        grep: gt,
        inArray: (e1, t)=>{
            if (e1) {
                for(let n = 0, o = e1.length; n < o; n++)if (e1[n] === t) return n;
            }
            return -1;
        },
        hasOwn: xe,
        extend: (e1, ...t)=>{
            for(let n = 0; n < t.length; n++){
                const o = t[n];
                for(const t in o)if (xe(o, t)) {
                    const n = o[t];
                    void 0 !== n && (e1[t] = n);
                }
            }
            return e1;
        },
        walk: sn,
        resolve: (e1, t = window)=>{
            const n = e1.split(".");
            for(let e1 = 0, o = n.length; e1 < o && (t = t[n[e1]]); e1++);
            return t;
        },
        explode: (e1, t)=>p(e1) ? e1 : "" === e1 ? [] : ft(e1.split(t || ","), rn),
        _addCacheSuffix: (e1)=>{
            const t = nn.cacheSuffix;
            return t && (e1 += (-1 === e1.indexOf("?") ? "?" : "&") + t), e1;
        }
    }, ln = (e1)=>{
        if (null == e1) throw new Error("Node cannot be null or undefined");
        return {
            dom: e1
        };
    }, dn = (e1, t)=>{
        const n = (t || document).createElement("div");
        if (n.innerHTML = e1, !n.hasChildNodes() || n.childNodes.length > 1) {
            const t = "HTML does not have a single root node";
            throw console.error(t, e1), new Error(t);
        }
        return ln(n.childNodes[0]);
    }, cn = (e1, t)=>{
        const n = (t || document).createElement(e1);
        return ln(n);
    }, un = (e1, t)=>{
        const n = (t || document).createTextNode(e1);
        return ln(n);
    }, mn = ln, fn = (e1, t, n)=>I.from(e1.dom.elementFromPoint(t, n)).map(ln), gn = (e1, t, n)=>{
        const o = e1.document.createRange();
        var r;
        return r = o, t.fold((e1)=>{
            r.setStartBefore(e1.dom);
        }, (e1, t)=>{
            r.setStart(e1.dom, t);
        }, (e1)=>{
            r.setStartAfter(e1.dom);
        }), ((e1, t)=>{
            t.fold((t)=>{
                e1.setEndBefore(t.dom);
            }, (t, n)=>{
                e1.setEnd(t.dom, n);
            }, (t)=>{
                e1.setEndAfter(t.dom);
            });
        })(o, n), o;
    }, pn = (e1, t, n, o, r)=>{
        const s = e1.document.createRange();
        return s.setStart(t.dom, n), s.setEnd(o.dom, r), s;
    }, hn = ke([
        {
            ltr: [
                "start",
                "soffset",
                "finish",
                "foffset"
            ]
        },
        {
            rtl: [
                "start",
                "soffset",
                "finish",
                "foffset"
            ]
        }
    ]), bn = (e1, t, n)=>t(mn(n.startContainer), n.startOffset, mn(n.endContainer), n.endOffset);
    hn.ltr, hn.rtl;
    const vn = (e1, t)=>{
        const n = e1.dom;
        if (1 !== n.nodeType) return !1;
        {
            const e1 = n;
            if (void 0 !== e1.matches) return e1.matches(t);
            if (void 0 !== e1.msMatchesSelector) return e1.msMatchesSelector(t);
            if (void 0 !== e1.webkitMatchesSelector) return e1.webkitMatchesSelector(t);
            if (void 0 !== e1.mozMatchesSelector) return e1.mozMatchesSelector(t);
            throw new Error("Browser lacks native selectors");
        }
    }, yn = (e1)=>1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType || 0 === e1.childElementCount, Cn = (e1, t)=>e1.dom === t.dom, wn = (e1, t)=>{
        const n = e1.dom, o = t.dom;
        return n !== o && n.contains(o);
    }, En = (e1, t)=>{
        const n = [], o = (e1)=>(n.push(e1), t(e1));
        let r = t(e1);
        do r = r.bind(o);
        while (r.isSome());
        return n;
    }, _n = (e1)=>e1.dom.nodeName.toLowerCase(), xn = (e1)=>e1.dom.nodeType, Sn = (e1)=>(t)=>xn(t) === e1, kn = (e1)=>Nn(e1) && Gt(e1.dom), Nn = Sn(1), Rn = Sn(3), An = Sn(9), Tn = Sn(11), On = (e1)=>(t)=>Nn(t) && _n(t) === e1, Bn = (e1)=>mn(e1.dom.ownerDocument), Pn = (e1)=>An(e1) ? e1 : Bn(e1), Dn = (e1)=>mn(Pn(e1).dom.defaultView), Ln = (e1)=>I.from(e1.dom.parentNode).map(mn), Mn = (e1)=>I.from(e1.dom.parentElement).map(mn), In = (e1, t)=>{
        const n = w(t) ? t : L;
        let o = e1.dom;
        const r = [];
        for(; null !== o.parentNode && void 0 !== o.parentNode;){
            const e1 = o.parentNode, t = mn(e1);
            if (r.push(t), !0 === n(t)) break;
            o = e1;
        }
        return r;
    }, Fn = (e1)=>I.from(e1.dom.previousSibling).map(mn), Un = (e1)=>I.from(e1.dom.nextSibling).map(mn), zn = (e1)=>oe(En(e1, Fn)), jn = (e1)=>En(e1, Un), Hn = (e1)=>V(e1.dom.childNodes, mn), $n = (e1, t)=>{
        const n = e1.dom.childNodes;
        return I.from(n[t]).map(mn);
    }, Vn = (e1)=>$n(e1, 0), qn = (e1)=>$n(e1, e1.dom.childNodes.length - 1), Wn = (e1)=>e1.dom.childNodes.length, Kn = (e1)=>Tn(e1) && C(e1.dom.host), Yn = (e1)=>mn(e1.dom.getRootNode()), Gn = (e1)=>Kn(e1) ? e1 : ((e1)=>{
            const t = e1.dom.head;
            if (null == t) throw new Error("Head is not available yet");
            return mn(t);
        })(Pn(e1)), Xn = (e1)=>mn(e1.dom.host), Zn = (e1)=>{
        if (C(e1.target)) {
            const t = mn(e1.target);
            if (Nn(t) && Qn(t) && e1.composed && e1.composedPath) {
                const t = e1.composedPath();
                if (t) return le(t);
            }
        }
        return I.from(e1.target);
    }, Qn = (e1)=>C(e1.dom.shadowRoot), Jn = (e1, t, n, o)=>((e1, t, n, o, r)=>{
            const s = ((e1, t)=>(n)=>{
                    e1(n) && t(((e1)=>{
                        const t = mn(Zn(e1).getOr(e1.target)), n = ()=>e1.stopPropagation(), o = ()=>e1.preventDefault(), r = S(o, n);
                        return ((e1, t, n, o, r, s, a)=>({
                                target: e1,
                                x: t,
                                y: n,
                                stop: o,
                                prevent: r,
                                kill: s,
                                raw: a
                            }))(t, e1.clientX, e1.clientY, n, o, r, e1);
                    })(n));
                })(n, o);
            return e1.dom.addEventListener(t, s, r), {
                unbind: T(eo, e1, t, s, r)
            };
        })(e1, t, n, o, !1), eo = (e1, t, n, o)=>{
        e1.dom.removeEventListener(t, n, o);
    }, to = M, no = ()=>mn(document), oo = (e1, t = !1)=>e1.dom.focus({
            preventScroll: t
        }), ro = (e1)=>{
        const t = Yn(e1).dom;
        return e1.dom === t.activeElement;
    }, so = (e1 = no())=>I.from(e1.dom.activeElement).map(mn), ao = (e1, t)=>{
        Ln(e1).each((n)=>{
            n.dom.insertBefore(t.dom, e1.dom);
        });
    }, io = (e1, t)=>{
        Un(e1).fold(()=>{
            Ln(e1).each((e1)=>{
                co(e1, t);
            });
        }, (e1)=>{
            ao(e1, t);
        });
    }, lo = (e1, t)=>{
        Vn(e1).fold(()=>{
            co(e1, t);
        }, (n)=>{
            e1.dom.insertBefore(t.dom, n.dom);
        });
    }, co = (e1, t)=>{
        e1.dom.appendChild(t.dom);
    }, uo = (e1, t)=>{
        ao(e1, t), co(t, e1);
    }, mo = (e1, t)=>{
        q(t, (t)=>{
            co(e1, t);
        });
    }, fo = (e1, t, n)=>{
        if (!(m(n) || b(n) || E(n))) throw console.error("Invalid call to Attribute.set. Key ", t, ":: Value ", n, ":: Element ", e1), new Error("Attribute value was not simple");
        e1.setAttribute(t, n + "");
    }, go = (e1, t, n)=>{
        fo(e1.dom, t, n);
    }, po = (e1, t)=>{
        const n = e1.dom;
        pe(t, (e1, t)=>{
            fo(n, t, e1);
        });
    }, ho = (e1, t)=>{
        const n = e1.dom.getAttribute(t);
        return null === n ? void 0 : n;
    }, bo = (e1, t)=>I.from(ho(e1, t)), vo = (e1, t)=>{
        const n = e1.dom;
        return !(!n || !n.hasAttribute) && n.hasAttribute(t);
    }, yo = (e1, t)=>{
        e1.dom.removeAttribute(t);
    }, Co = (e1)=>X(e1.dom.attributes, (e1, t)=>(e1[t.name] = t.value, e1), {}), wo = (e1)=>{
        e1.dom.textContent = "", q(Hn(e1), (e1)=>{
            Eo(e1);
        });
    }, Eo = (e1)=>{
        const t = e1.dom;
        null !== t.parentNode && t.parentNode.removeChild(t);
    }, _o = (e1)=>{
        const t = Hn(e1);
        var n, o;
        t.length > 0 && (n = e1, q(o = t, (e1, t)=>{
            const r = 0 === t ? n : o[t - 1];
            io(r, e1);
        })), Eo(e1);
    }, xo = (e1, t)=>mn(e1.dom.cloneNode(t)), So = (e1)=>xo(e1, !1), ko = (e1)=>xo(e1, !0), No = (e1)=>V(e1, mn), Ro = (e1)=>e1.dom.innerHTML, Ao = (e1, t)=>{
        const n = Bn(e1).dom, o = mn(n.createDocumentFragment()), r = ((e1, t)=>{
            const n = (t || document).createElement("div");
            return n.innerHTML = e1, Hn(mn(n));
        })(t, n);
        mo(o, r), wo(e1), co(e1, o);
    }, To = (e1)=>void 0 !== e1.style && w(e1.style.getPropertyValue), Oo = (e1)=>{
        const t = Rn(e1) ? e1.dom.parentNode : e1.dom;
        if (null == t || null === t.ownerDocument) return !1;
        const n = t.ownerDocument;
        return ((e1)=>{
            const t = Yn(e1);
            return Kn(t) ? I.some(t) : I.none();
        })(mn(t)).fold(()=>n.body.contains(t), k(Oo, Xn));
    }, Bo = (e1, t, n)=>{
        if (!m(n)) throw console.error("Invalid call to CSS.set. Property ", t, ":: Value ", n, ":: Element ", e1), new Error("CSS value must be a string: " + n);
        To(e1) && e1.style.setProperty(t, n);
    }, Po = (e1, t, n)=>{
        const o = e1.dom;
        Bo(o, t, n);
    }, Do = (e1, t)=>{
        const n = e1.dom;
        pe(t, (e1, t)=>{
            Bo(n, t, e1);
        });
    }, Lo = (e1, t)=>{
        const n = e1.dom, o = window.getComputedStyle(n).getPropertyValue(t);
        return "" !== o || Oo(e1) ? o : Mo(n, t);
    }, Mo = (e1, t)=>To(e1) ? e1.style.getPropertyValue(t) : "", Io = (e1, t)=>{
        const n = e1.dom, o = Mo(n, t);
        return I.from(o).filter((e1)=>e1.length > 0);
    }, Fo = (e1)=>{
        const t = {}, n = e1.dom;
        if (To(n)) for(let e1 = 0; e1 < n.style.length; e1++){
            const o = n.style.item(e1);
            t[o] = n.style[o];
        }
        return t;
    }, Uo = (e1, t)=>{
        ((e1, t)=>{
            To(e1) && e1.style.removeProperty(t);
        })(e1.dom, t), Fe(bo(e1, "style").map(Ze), "") && yo(e1, "style");
    }, zo = ((e1)=>{
        const t = (t)=>{
            const n = ((e1)=>{
                const t = e1.dom;
                return Oo(e1) ? t.getBoundingClientRect().height : t.offsetHeight;
            })(t);
            if (n <= 0 || null === n) {
                const n = Lo(t, e1);
                return parseFloat(n) || 0;
            }
            return n;
        }, n = (e1, t)=>X(t, (t, n)=>{
                const o = Lo(e1, n), r = void 0 === o ? 0 : parseInt(o, 10);
                return isNaN(r) ? t : t + r;
            }, 0);
        return {
            set: (t, n)=>{
                if (!E(n) && !n.match(/^[0-9]+$/)) throw new Error(e1 + ".set accepts only positive integer values. Value was " + n);
                const o = t.dom;
                To(o) && (o.style[e1] = n + "px");
            },
            get: t,
            getOuter: t,
            aggregate: n,
            max: (e1, t, o)=>{
                const r = n(e1, o);
                return t > r ? t - r : 0;
            }
        };
    })("height"), jo = (e1, t)=>({
            left: e1,
            top: t,
            translate: (n, o)=>jo(e1 + n, t + o)
        }), Ho = jo, $o = (e1, t)=>void 0 !== e1 ? e1 : void 0 !== t ? t : 0, Vo = (e1)=>{
        const t = e1.dom, n = t.ownerDocument.body;
        return n === t ? Ho(n.offsetLeft, n.offsetTop) : Oo(e1) ? ((e1)=>{
            const t = e1.getBoundingClientRect();
            return Ho(t.left, t.top);
        })(t) : Ho(0, 0);
    }, qo = (e1)=>{
        const t = void 0 !== e1 ? e1.dom : document, n = t.body.scrollLeft || t.documentElement.scrollLeft, o = t.body.scrollTop || t.documentElement.scrollTop;
        return Ho(n, o);
    }, Wo = (e1, t, n)=>{
        const o = (void 0 !== n ? n.dom : document).defaultView;
        o && o.scrollTo(e1, t);
    }, Ko = (e1, t)=>{
        Kt().browser.isSafari() && w(e1.dom.scrollIntoViewIfNeeded) ? e1.dom.scrollIntoViewIfNeeded(!1) : e1.dom.scrollIntoView(t);
    }, Yo = (e1, t)=>{
        const n = (t || document).createDocumentFragment();
        return q(e1, (e1)=>{
            n.appendChild(e1.dom);
        }), mn(n);
    }, Go = ((e1)=>{
        const t = (t)=>e1(t) ? I.from(t.dom.nodeValue) : I.none();
        return {
            get: (n)=>{
                if (!e1(n)) throw new Error("Can only get text value of a text node");
                return t(n).getOr("");
            },
            getOption: t,
            set: (t, n)=>{
                if (!e1(t)) throw new Error("Can only set raw text value of a text node");
                t.dom.nodeValue = n;
            }
        };
    })(Rn), Xo = (e1)=>Go.get(e1), Zo = (e1, t)=>Go.set(e1, t), Qo = (e1, t)=>{
        const n = ho(e1, t);
        return void 0 === n || "" === n ? [] : n.split(" ");
    };
    var Jo = (e1, t, n, o, r)=>e1(n, o) ? I.some(n) : w(r) && r(n) ? I.none() : t(n, o, r);
    const er = (e1, t, n)=>{
        let o = e1.dom;
        const r = w(n) ? n : L;
        for(; o.parentNode;){
            o = o.parentNode;
            const e1 = mn(o);
            if (t(e1)) return I.some(e1);
            if (r(e1)) break;
        }
        return I.none();
    }, tr = (e1, t, n)=>Jo((e1, t)=>t(e1), er, e1, t, n), nr = (e1, t)=>{
        const n = (e1)=>{
            for(let o = 0; o < e1.childNodes.length; o++){
                const r = mn(e1.childNodes[o]);
                if (t(r)) return I.some(r);
                const s = n(e1.childNodes[o]);
                if (s.isSome()) return s;
            }
            return I.none();
        };
        return n(e1.dom);
    }, or = (e1, t, n)=>er(e1, (e1)=>vn(e1, t), n), rr = (e1, t)=>((e1, t)=>{
            const n = void 0 === t ? document : t.dom;
            return yn(n) ? I.none() : I.from(n.querySelector(e1)).map(mn);
        })(t, e1), sr = (e1, t, n)=>Jo((e1, t)=>vn(e1, t), or, e1, t, n), ar = (e1)=>void 0 !== e1.dom.classList, ir = (e1)=>Qo(e1, "class"), lr = (e1, t)=>((e1, t, n)=>{
            const o = Qo(e1, t).concat([
                n
            ]);
            return go(e1, t, o.join(" ")), !0;
        })(e1, "class", t), dr = (e1, t)=>((e1, t, n)=>{
            const o = Y(Qo(e1, t), (e1)=>e1 !== n);
            return o.length > 0 ? go(e1, t, o.join(" ")) : yo(e1, t), !1;
        })(e1, "class", t), cr = (e1, t)=>{
        ar(e1) ? e1.dom.classList.add(t) : lr(e1, t);
    }, ur = (e1)=>{
        0 === (ar(e1) ? e1.dom.classList : ir(e1)).length && yo(e1, "class");
    }, mr = (e1, t)=>{
        ar(e1) ? e1.dom.classList.remove(t) : dr(e1, t), ur(e1);
    }, fr = (e1, t)=>ar(e1) && e1.dom.classList.contains(t), gr = (e1, t = !1)=>{
        var n;
        return Oo(e1) ? e1.dom.isContentEditable : (n = e1, sr(n, "[contenteditable]")).fold(N(t), (e1)=>"true" === pr(e1));
    }, pr = (e1)=>e1.dom.contentEditable, hr = (e1, t)=>{
        e1.dom.contentEditable = t ? "true" : "false";
    }, br = (e1, t)=>{
        let n = [];
        return q(Hn(e1), (e1)=>{
            t(e1) && (n = n.concat([
                e1
            ])), n = n.concat(br(e1, t));
        }), n;
    }, vr = (e1, t)=>((e1, t)=>{
            const n = void 0 === t ? document : t.dom;
            return yn(n) ? [] : V(n.querySelectorAll(e1), mn);
        })(t, e1), yr = (e1, t, n)=>er(e1, t, n).isSome(), Cr = (e1, t)=>((e1, t)=>{
            const n = e1.dom;
            return n.parentNode ? ((e1, t)=>Q(e1.dom.childNodes, (e1)=>t(mn(e1))).map(mn))(mn(n.parentNode), (n)=>!Cn(e1, n) && t(n)) : I.none();
        })(e1, t).isSome(), wr = (e1, t)=>nr(e1, t).isSome(), Er = (e1)=>w(e1) ? e1 : L, _r = (e1, t, n)=>{
        const o = t(e1), r = Er(n);
        return o.orThunk(()=>r(e1) ? I.none() : ((e1, t, n)=>{
                let o = e1.dom;
                const r = Er(n);
                for(; o.parentNode;){
                    o = o.parentNode;
                    const e1 = mn(o), n = t(e1);
                    if (n.isSome()) return n;
                    if (r(e1)) break;
                }
                return I.none();
            })(e1, t, r));
    }, xr = [
        "img",
        "br"
    ], Sr = (e1)=>{
        var t;
        return (t = e1, Go.getOption(t)).filter((e1)=>0 !== e1.trim().length || e1.indexOf(it) > -1).isSome() || H(xr, _n(e1)) || ((e1)=>kn(e1) && "false" === ho(e1, "contenteditable"))(e1);
    }, kr = (e1, t, n, o)=>({
            start: e1,
            soffset: t,
            finish: n,
            foffset: o
        }), Nr = ke([
        {
            before: [
                "element"
            ]
        },
        {
            on: [
                "element",
                "offset"
            ]
        },
        {
            after: [
                "element"
            ]
        }
    ]), Rr = {
        before: Nr.before,
        on: Nr.on,
        after: Nr.after,
        cata: (e1, t, n, o)=>e1.fold(t, n, o),
        getStart: (e1)=>e1.fold(R, R, R)
    }, Ar = ke([
        {
            domRange: [
                "rng"
            ]
        },
        {
            relative: [
                "startSitu",
                "finishSitu"
            ]
        },
        {
            exact: [
                "start",
                "soffset",
                "finish",
                "foffset"
            ]
        }
    ]), Tr = {
        domRange: Ar.domRange,
        relative: Ar.relative,
        exact: Ar.exact,
        exactFromRange: (e1)=>Ar.exact(e1.start, e1.soffset, e1.finish, e1.foffset),
        getWin: (e1)=>{
            const t = ((e1)=>e1.match({
                    domRange: (e1)=>mn(e1.startContainer),
                    relative: (e1, t)=>Rr.getStart(e1),
                    exact: (e1, t, n, o)=>e1
                }))(e1);
            return Dn(t);
        },
        range: kr
    }, Or = (e1, t)=>{
        const n = _n(e1);
        return "input" === n ? Rr.after(e1) : H([
            "br",
            "img"
        ], n) ? 0 === t ? Rr.before(e1) : Rr.after(e1) : Rr.on(e1, t);
    }, Br = (e1, t)=>{
        const n = e1.fold(Rr.before, Or, Rr.after), o = t.fold(Rr.before, Or, Rr.after);
        return Tr.relative(n, o);
    }, Pr = (e1, t, n, o)=>{
        const r = Or(e1, t), s = Or(n, o);
        return Tr.relative(r, s);
    }, Dr = (e1)=>{
        const t = Tr.getWin(e1).dom, n = (e1, n, o, r)=>pn(t, e1, n, o, r), o = ((e1)=>e1.match({
                domRange: (e1)=>{
                    const t = mn(e1.startContainer), n = mn(e1.endContainer);
                    return Pr(t, e1.startOffset, n, e1.endOffset);
                },
                relative: Br,
                exact: Pr
            }))(e1);
        return ((e1, t)=>{
            const n = ((e1, t)=>t.match({
                    domRange: (e1)=>({
                            ltr: N(e1),
                            rtl: I.none
                        }),
                    relative: (t, n)=>({
                            ltr: st(()=>gn(e1, t, n)),
                            rtl: st(()=>I.some(gn(e1, n, t)))
                        }),
                    exact: (t, n, o, r)=>({
                            ltr: st(()=>pn(e1, t, n, o, r)),
                            rtl: st(()=>I.some(pn(e1, o, r, t, n)))
                        })
                }))(e1, t);
            return ((e1, t)=>{
                const n = t.ltr();
                return n.collapsed ? t.rtl().filter((e1)=>!1 === e1.collapsed).map((e1)=>hn.rtl(mn(e1.endContainer), e1.endOffset, mn(e1.startContainer), e1.startOffset)).getOrThunk(()=>bn(0, hn.ltr, n)) : bn(0, hn.ltr, n);
            })(0, n);
        })(t, o).match({
            ltr: n,
            rtl: n
        });
    }, Lr = (e1, t, n)=>((e1, t, n)=>((e1, t, n)=>e1.caretPositionFromPoint ? ((e1, t, n)=>{
                    var o;
                    return I.from(null === (o = e1.caretPositionFromPoint) || void 0 === o ? void 0 : o.call(e1, t, n)).bind((t)=>{
                        if (null === t.offsetNode) return I.none();
                        const n = e1.createRange();
                        return n.setStart(t.offsetNode, t.offset), n.collapse(), I.some(n);
                    });
                })(e1, t, n) : e1.caretRangeFromPoint ? ((e1, t, n)=>{
                    var o;
                    return I.from(null === (o = e1.caretRangeFromPoint) || void 0 === o ? void 0 : o.call(e1, t, n));
                })(e1, t, n) : I.none())(e1.document, t, n).map((e1)=>kr(mn(e1.startContainer), e1.startOffset, mn(e1.endContainer), e1.endOffset)))(e1, t, n), Mr = (e1, t, n, o)=>({
            x: e1,
            y: t,
            width: n,
            height: o,
            right: e1 + n,
            bottom: t + o
        }), Ir = (e1)=>{
        const t = void 0 === e1 ? window : e1, n = t.document, o = qo(mn(n));
        return ((e1)=>{
            const t = void 0 === e1 ? window : e1;
            return Kt().browser.isFirefox() ? I.none() : I.from(t.visualViewport);
        })(t).fold(()=>{
            const e1 = t.document.documentElement, n = e1.clientWidth, r = e1.clientHeight;
            return Mr(o.left, o.top, n, r);
        }, (e1)=>Mr(Math.max(e1.pageLeft, o.left), Math.max(e1.pageTop, o.top), e1.width, e1.height));
    };
    class Fr {
        constructor(e1, t){
            this.node = e1, this.rootNode = t, this.current = this.current.bind(this), this.next = this.next.bind(this), this.prev = this.prev.bind(this), this.prev2 = this.prev2.bind(this);
        }
        current() {
            return this.node;
        }
        next(e1) {
            return this.node = this.findSibling(this.node, "firstChild", "nextSibling", e1), this.node;
        }
        prev(e1) {
            return this.node = this.findSibling(this.node, "lastChild", "previousSibling", e1), this.node;
        }
        prev2(e1) {
            return this.node = this.findPreviousNode(this.node, e1), this.node;
        }
        findSibling(e1, t, n, o) {
            if (e1) {
                if (!o && e1[t]) return e1[t];
                if (e1 !== this.rootNode) {
                    let t = e1[n];
                    if (t) return t;
                    for(let o = e1.parentNode; o && o !== this.rootNode; o = o.parentNode)if (t = o[n], t) return t;
                }
            }
        }
        findPreviousNode(e1, t) {
            if (e1) {
                const n = e1.previousSibling;
                if (this.rootNode && n === this.rootNode) return;
                if (n) {
                    if (!t) {
                        for(let e1 = n.lastChild; e1; e1 = e1.lastChild)if (!e1.lastChild) return e1;
                    }
                    return n;
                }
                const o = e1.parentNode;
                if (o && o !== this.rootNode) return o;
            }
        }
    }
    const Ur = /^[ \t\r\n]*$/, zr = (e1)=>Ur.test(e1), jr = (e1)=>"\n" === e1 || "\r" === e1, Hr = (e1, t = 4, n = !0, o = !0)=>{
        const r = ((e1, t)=>t <= 0 ? "" : new Array(t + 1).join(" "))(0, t), s = e1.replace(/\t/g, r), a = X(s, (e1, t)=>((e1)=>-1 !== " \f\t\v".indexOf(e1))(t) || t === it ? e1.pcIsSpace || "" === e1.str && n || e1.str.length === s.length - 1 && o || ((e1, t)=>t < e1.length && t >= 0 && jr(e1[t]))(s, e1.str.length + 1) ? {
                pcIsSpace: !1,
                str: e1.str + it
            } : {
                pcIsSpace: !0,
                str: e1.str + " "
            } : {
                pcIsSpace: jr(t),
                str: e1.str + t
            }, {
            pcIsSpace: !1,
            str: ""
        });
        return a.str;
    }, $r = (e1)=>(t)=>!!t && t.nodeType === e1, Vr = (e1)=>!!e1 && !Object.getPrototypeOf(e1), qr = $r(1), Wr = (e1)=>qr(e1) && kn(mn(e1)), Kr = (e1)=>{
        const t = e1.toLowerCase();
        return (e1)=>C(e1) && e1.nodeName.toLowerCase() === t;
    }, Yr = (e1)=>{
        const t = e1.map((e1)=>e1.toLowerCase());
        return (e1)=>{
            if (e1 && e1.nodeName) {
                const n = e1.nodeName.toLowerCase();
                return H(t, n);
            }
            return !1;
        };
    }, Gr = (e1, t)=>{
        const n = t.toLowerCase().split(" ");
        return (t)=>{
            if (qr(t)) {
                const o = t.ownerDocument.defaultView;
                if (o) for(let r = 0; r < n.length; r++){
                    const s = o.getComputedStyle(t, null);
                    if ((s ? s.getPropertyValue(e1) : null) === n[r]) return !0;
                }
            }
            return !1;
        };
    }, Xr = (e1)=>qr(e1) && e1.hasAttribute("data-mce-bogus"), Zr = (e1)=>qr(e1) && "TABLE" === e1.tagName, Qr = (e1)=>(t)=>{
            if (Wr(t)) {
                if (t.contentEditable === e1) return !0;
                if (t.getAttribute("data-mce-contenteditable") === e1) return !0;
            }
            return !1;
        }, Jr = Yr([
        "textarea",
        "input"
    ]), es = $r(3), ts = $r(4), ns = $r(7), os = $r(8), rs = $r(9), ss = $r(11), as = Kr("br"), is = Kr("img"), ls = Kr("a"), ds = Qr("true"), cs = Qr("false"), us = (e1)=>Wr(e1) && e1.isContentEditable && C(e1.parentElement) && !e1.parentElement.isContentEditable, ms = Yr([
        "td",
        "th"
    ]), fs = Yr([
        "td",
        "th",
        "caption"
    ]), gs = Yr([
        "video",
        "audio",
        "object",
        "embed"
    ]), ps = Kr("li"), hs = Kr("details"), bs = Kr("summary"), vs = {
        skipBogus: !0,
        includeZwsp: !1,
        checkRootAsContent: !1
    }, ys = (e1)=>qr(e1) && e1.hasAttribute("data-mce-bookmark");
    const Cs = (e1, t, n, o)=>es(e1) && !((e1, t, n)=>zr(e1.data) && !((e1, t, n)=>{
                const o = mn(t), r = mn(e1), s = n.getWhitespaceElements();
                return yr(r, (e1)=>xe(s, _n(e1)), T(Cn, o));
            })(e1, t, n))(e1, t, n) && (!o.includeZwsp || !((e1)=>{
            for (const t of e1)if (!lt(t)) return !1;
            return !0;
        })(e1.data)), ws = (e1, t, n, o)=>w(o.isContent) && o.isContent(t) || ((e1, t)=>qr(e1) && xe(t.getNonEmptyElements(), e1.nodeName))(t, e1) || ys(t) || ((e1)=>qr(e1) && "A" === e1.nodeName && !e1.hasAttribute("href") && (e1.hasAttribute("name") || e1.hasAttribute("id")))(t) || Cs(t, n, e1, o) || cs(t) || ds(t) && ((e1)=>Mn(mn(e1)).exists((e1)=>!gr(e1)))(t), Es = (e1, t, n)=>{
        const o = {
            ...vs,
            ...n
        };
        if (o.checkRootAsContent && ws(e1, t, t, o)) return !1;
        let r = t.firstChild, s = 0;
        if (!r) return !0;
        const a = new Fr(r, t);
        do {
            if (o.skipBogus && qr(r)) {
                const e1 = r.getAttribute("data-mce-bogus");
                if (e1) {
                    r = a.next("all" === e1);
                    continue;
                }
            }
            if (os(r)) r = a.next(!0);
            else if (as(r)) s++, r = a.next();
            else {
                if (ws(e1, r, t, o)) return !1;
                r = a.next();
            }
        }while (r);
        return s <= 1;
    }, _s = (e1, t, n)=>Es(e1, t.dom, {
            checkRootAsContent: !0,
            ...n
        }), xs = (e1, t, n)=>ws(e1, t, t, {
            includeZwsp: vs.includeZwsp,
            ...n
        }), Ss = (e1)=>{
        const t = e1.toLowerCase();
        return "svg" === t ? "svg" : "math" === t ? "math" : "html";
    }, ks = (e1)=>"html" !== Ss(e1), Ns = (e1)=>ks(e1.nodeName), Rs = (e1)=>Ss(e1.nodeName), As = [
        "svg",
        "math"
    ], Ts = "data-mce-block", Os = (e1)=>V(((e1)=>Y(fe(e1), (e1)=>!/[A-Z]/.test(e1)))(e1), (e1)=>{
            const t = CSS.escape(e1);
            return `${t}:` + V(As, (e1)=>`not(${e1} ${t})`).join(":");
        }).join(","), Bs = (e1, t)=>C(t.querySelector(e1)) ? (t.setAttribute(Ts, "true"), "inline-boundary" === t.getAttribute("data-mce-selected") && t.removeAttribute("data-mce-selected"), !0) : (t.removeAttribute(Ts), !1), Ps = (e1, t)=>{
        const n = Os(e1.getTransparentElements()), o = Os(e1.getBlockElements());
        return Y(t.querySelectorAll(n), (e1)=>Bs(o, e1));
    }, Ds = (e1, t, n)=>{
        var o;
        const r = n ? "lastChild" : "firstChild";
        for(let n = t[r]; n; n = n[r])if (Es(e1, n, {
            checkRootAsContent: !0
        })) return void (null === (o = n.parentNode) || void 0 === o || o.removeChild(n));
    }, Ls = (e1, t, n)=>{
        const o = e1.getBlockElements(), r = mn(t), s = (e1)=>_n(e1) in o, a = (e1)=>Cn(e1, r);
        q(No(n), (t)=>{
            er(t, s, a).each((n)=>{
                const o = ((t)=>Y(Hn(t), (t)=>s(t) && !e1.isValidChild(_n(n), _n(t))))(t);
                if (o.length > 0) {
                    const t = Mn(n);
                    q(o, (t)=>{
                        er(t, s, a).each((n)=>{
                            ((e1, t, n)=>{
                                const o = document.createRange(), r = t.parentNode;
                                if (r) {
                                    o.setStartBefore(t), o.setEndBefore(n);
                                    const s = o.extractContents();
                                    Ds(e1, s, !0), o.setStartAfter(n), o.setEndAfter(t);
                                    const a = o.extractContents();
                                    Ds(e1, a, !1), Es(e1, s, {
                                        checkRootAsContent: !0
                                    }) || r.insertBefore(s, t), Es(e1, n, {
                                        checkRootAsContent: !0
                                    }) || r.insertBefore(n, t), Es(e1, a, {
                                        checkRootAsContent: !0
                                    }) || r.insertBefore(a, t), r.removeChild(t);
                                }
                            })(e1, n.dom, t.dom);
                        });
                    }), t.each((t)=>Ps(e1, t.dom));
                }
            });
        });
    }, Ms = (e1, t)=>{
        const n = Ps(e1, t);
        Ls(e1, t, n), ((e1, t, n)=>{
            q([
                ...n,
                ...js(e1, t) ? [
                    t
                ] : []
            ], (t)=>q(vr(mn(t), t.nodeName.toLowerCase()), (t)=>{
                    Hs(e1, t.dom) && _o(t);
                }));
        })(e1, t, n);
    }, Is = (e1, t)=>{
        if (zs(e1, t)) {
            const n = Os(e1.getBlockElements());
            Bs(n, t);
        }
    }, Fs = (e1)=>e1.hasAttribute(Ts), Us = (e1, t)=>xe(e1.getTransparentElements(), t), zs = (e1, t)=>qr(t) && Us(e1, t.nodeName), js = (e1, t)=>zs(e1, t) && Fs(t), Hs = (e1, t)=>zs(e1, t) && !Fs(t), $s = (e1, t)=>1 === t.type && Us(e1, t.name) && m(t.attr(Ts)), Vs = Kt().browser, qs = (e1)=>Q(e1, Nn), Ws = (e1, t)=>e1.children && H(e1.children, t), Ks = (e1, t = {})=>{
        let n = 0;
        const o = {}, r = mn(e1), s = Pn(r), a = (e1)=>{
            co(Gn(r), e1);
        }, i = (e1)=>{
            const t = Gn(r);
            rr(t, "#" + e1).each(Eo);
        }, l = (e1)=>_e(o, e1).getOrThunk(()=>({
                    id: "mce-u" + n++,
                    passed: [],
                    failed: [],
                    count: 0
                })), d = (e1)=>new Promise((n, r)=>{
                let i;
                const d = an._addCacheSuffix(e1), c = l(d);
                o[d] = c, c.count++;
                const u = (e1, t)=>{
                    q(e1, D), c.status = t, c.passed = [], c.failed = [], i && (i.onload = null, i.onerror = null, i = null);
                }, m = ()=>u(c.passed, 2), f = ()=>u(c.failed, 3);
                if (n && c.passed.push(n), r && c.failed.push(r), 1 === c.status) return;
                if (2 === c.status) return void m();
                if (3 === c.status) return void f();
                c.status = 1;
                const g = cn("link", s.dom);
                po(g, {
                    rel: "stylesheet",
                    type: "text/css",
                    id: c.id
                }), t.contentCssCors && go(g, "crossOrigin", "anonymous"), t.referrerPolicy && go(g, "referrerpolicy", t.referrerPolicy), i = g.dom, i.onload = m, i.onerror = f, a(g), go(g, "href", d);
            }), c = (e1)=>{
            const t = an._addCacheSuffix(e1);
            _e(o, t).each((e1)=>{
                0 == --e1.count && (delete o[t], i(e1.id));
            });
        };
        return {
            load: d,
            loadRawCss: (e1, t)=>{
                const n = l(e1);
                o[e1] = n, n.count++;
                const r = cn("style", s.dom);
                po(r, {
                    rel: "stylesheet",
                    type: "text/css",
                    id: n.id,
                    "data-mce-key": e1
                }), r.dom.innerHTML = t, a(r);
            },
            loadAll: (e1)=>Promise.allSettled(V(e1, (e1)=>d(e1).then(N(e1)))).then((e1)=>{
                    const t = K(e1, (e1)=>"fulfilled" === e1.status);
                    return t.fail.length > 0 ? Promise.reject(V(t.fail, (e1)=>e1.reason)) : V(t.pass, (e1)=>e1.value);
                }),
            unload: c,
            unloadRawCss: (e1)=>{
                _e(o, e1).each((t)=>{
                    0 == --t.count && (delete o[e1], i(t.id));
                });
            },
            unloadAll: (e1)=>{
                q(e1, (e1)=>{
                    c(e1);
                });
            },
            _setReferrerPolicy: (e1)=>{
                t.referrerPolicy = e1;
            },
            _setContentCssCors: (e1)=>{
                t.contentCssCors = e1;
            }
        };
    }, Ys = (()=>{
        const e1 = new WeakMap;
        return {
            forElement: (t, n)=>{
                const o = Yn(t).dom;
                return I.from(e1.get(o)).getOrThunk(()=>{
                    const t = Ks(o, n);
                    return e1.set(o, t), t;
                });
            }
        };
    })(), Gs = (e1, t)=>C(e1) && (xs(t, e1) || t.isInline(e1.nodeName.toLowerCase())), Xs = (e1)=>((e1)=>"span" === e1.nodeName.toLowerCase())(e1) && "bookmark" === e1.getAttribute("data-mce-type"), Zs = (e1, t, n, o)=>{
        var r;
        const s = o || t;
        if (qr(t) && Xs(t)) return t;
        const a = t.childNodes;
        for(let t = a.length - 1; t >= 0; t--)Zs(e1, a[t], n, s);
        if (qr(t)) {
            const e1 = t.childNodes;
            1 === e1.length && Xs(e1[0]) && (null === (r = t.parentNode) || void 0 === r || r.insertBefore(e1[0], t));
        }
        return ((e1)=>ss(e1) || rs(e1))(t) || xs(n, t) || ((e1)=>!!qr(e1) && e1.childNodes.length > 0)(t) || ((e1, t, n)=>es(e1) && e1.data.length > 0 && ((e1, t, n)=>{
                const o = new Fr(e1, t).prev(!1), r = new Fr(e1, t).next(!1), s = v(o) || Gs(o, n), a = v(r) || Gs(r, n);
                return s && a;
            })(e1, t, n))(t, s, n) || e1.remove(t), t;
    }, Qs = an.makeMap, Js = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, ea = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, ta = /[<>&\"\']/g, na = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi, oa = {
        128: "\u20ac",
        130: "\u201a",
        131: "\u0192",
        132: "\u201e",
        133: "\u2026",
        134: "\u2020",
        135: "\u2021",
        136: "\u02c6",
        137: "\u2030",
        138: "\u0160",
        139: "\u2039",
        140: "\u0152",
        142: "\u017d",
        145: "\u2018",
        146: "\u2019",
        147: "\u201c",
        148: "\u201d",
        149: "\u2022",
        150: "\u2013",
        151: "\u2014",
        152: "\u02dc",
        153: "\u2122",
        154: "\u0161",
        155: "\u203a",
        156: "\u0153",
        158: "\u017e",
        159: "\u0178"
    }, ra = {
        '"': "&quot;",
        "'": "&#39;",
        "<": "&lt;",
        ">": "&gt;",
        "&": "&amp;",
        "`": "&#96;"
    }, sa = {
        "&lt;": "<",
        "&gt;": ">",
        "&amp;": "&",
        "&quot;": '"',
        "&apos;": "'"
    }, aa = (e1, t)=>{
        const n = {};
        if (e1) {
            const o = e1.split(",");
            t = t || 10;
            for(let e1 = 0; e1 < o.length; e1 += 2){
                const r = String.fromCharCode(parseInt(o[e1], t));
                if (!ra[r]) {
                    const t = "&" + o[e1 + 1] + ";";
                    n[r] = t, n[t] = r;
                }
            }
            return n;
        }
    }, ia = aa("50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro", 32), la = (e1, t)=>e1.replace(t ? Js : ea, (e1)=>ra[e1] || e1), da = (e1, t)=>e1.replace(t ? Js : ea, (e1)=>e1.length > 1 ? "&#" + (1024 * (e1.charCodeAt(0) - 55296) + (e1.charCodeAt(1) - 56320) + 65536) + ";" : ra[e1] || "&#" + e1.charCodeAt(0) + ";"), ca = (e1, t, n)=>{
        const o = n || ia;
        return e1.replace(t ? Js : ea, (e1)=>ra[e1] || o[e1] || e1);
    }, ua = {
        encodeRaw: la,
        encodeAllRaw: (e1)=>("" + e1).replace(ta, (e1)=>ra[e1] || e1),
        encodeNumeric: da,
        encodeNamed: ca,
        getEncodeFunc: (e1, t)=>{
            const n = aa(t) || ia, o = Qs(e1.replace(/\+/g, ","));
            return o.named && o.numeric ? (e1, t)=>e1.replace(t ? Js : ea, (e1)=>void 0 !== ra[e1] ? ra[e1] : void 0 !== n[e1] ? n[e1] : e1.length > 1 ? "&#" + (1024 * (e1.charCodeAt(0) - 55296) + (e1.charCodeAt(1) - 56320) + 65536) + ";" : "&#" + e1.charCodeAt(0) + ";") : o.named ? t ? (e1, t)=>ca(e1, t, n) : ca : o.numeric ? da : la;
        },
        decode: (e1)=>e1.replace(na, (e1, t)=>t ? (t = "x" === t.charAt(0).toLowerCase() ? parseInt(t.substr(1), 16) : parseInt(t, 10)) > 65535 ? (t -= 65536, String.fromCharCode(55296 + (t >> 10), 56320 + (1023 & t))) : oa[t] || String.fromCharCode(t) : sa[e1] || ia[e1] || ((e1)=>{
                    const t = cn("div").dom;
                    return t.innerHTML = e1, t.textContent || t.innerText || e1;
                })(e1))
    }, ma = (e1, t)=>(e1 = an.trim(e1)) ? e1.split(t || " ") : [], fa = (e1)=>new RegExp("^" + e1.replace(/([?+*])/g, ".$1") + "$"), ga = (e1)=>Object.freeze([
            "id",
            "accesskey",
            "class",
            "dir",
            "lang",
            "style",
            "tabindex",
            "title",
            "role",
            ..."html4" !== e1 ? [
                "contenteditable",
                "contextmenu",
                "draggable",
                "dropzone",
                "hidden",
                "spellcheck",
                "translate",
                "itemprop",
                "itemscope",
                "itemtype"
            ] : [],
            ..."html5-strict" !== e1 ? [
                "xml:lang"
            ] : []
        ]), pa = (e1)=>{
        let t, n;
        t = "address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul", n = "a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd label map noscript object q s samp script select small span strong sub sup textarea u var #text #comment", "html4" !== e1 && (t += " article aside details dialog figure main header footer hgroup section nav a ins del canvas map", n += " audio canvas command data datalist mark meter output picture progress time wbr video ruby bdi keygen svg"), "html5-strict" !== e1 && (n = [
            n,
            "acronym applet basefont big font strike tt"
        ].join(" "), t = [
            t,
            "center dir isindex noframes"
        ].join(" "));
        const o = [
            t,
            n
        ].join(" ");
        return {
            blockContent: t,
            phrasingContent: n,
            flowContent: o
        };
    }, ha = (e1)=>{
        const { blockContent: t, phrasingContent: n, flowContent: o } = pa(e1), r = (e1)=>Object.freeze(e1.split(" "));
        return Object.freeze({
            blockContent: r(t),
            phrasingContent: r(n),
            flowContent: r(o)
        });
    }, ba = {
        html4: st(()=>ha("html4")),
        html5: st(()=>ha("html5")),
        "html5-strict": st(()=>ha("html5-strict"))
    }, va = (e1, t)=>{
        const { blockContent: n, phrasingContent: o, flowContent: r } = ba[e1]();
        return "blocks" === t ? I.some(n) : "phrasing" === t ? I.some(o) : "flow" === t ? I.some(r) : I.none();
    }, ya = (e1)=>I.from(/^(@?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)$/.exec(e1)).map((e1)=>({
                preset: "@" === e1[1],
                name: e1[2]
            })), Ca = {}, wa = an.makeMap, Ea = an.each, _a = an.extend, xa = an.explode, Sa = (e1, t = {})=>{
        const n = wa(e1, " ", wa(e1.toUpperCase(), " "));
        return _a(n, t);
    }, ka = (e1)=>Sa("td th li dt dd figcaption caption details summary", e1.getTextBlockElements()), Na = (e1, t)=>{
        if (e1) {
            const n = {};
            return m(e1) && (e1 = {
                "*": e1
            }), Ea(e1, (e1, o)=>{
                n[o] = n[o.toUpperCase()] = "map" === t ? wa(e1, /[, ]/) : xa(e1, /[, ]/);
            }), n;
        }
    }, Ra = (e1 = {})=>{
        var t;
        const n = {}, o = {};
        let r = [];
        const s = {}, a = {}, i = (t, n, o)=>{
            const r = e1[t];
            if (r) return wa(r, /[, ]/, wa(r.toUpperCase(), /[, ]/));
            {
                let e1 = Ca[t];
                return e1 || (e1 = Sa(n, o), Ca[t] = e1), e1;
            }
        }, l = null !== (t = e1.schema) && void 0 !== t ? t : "html5", d = ((e1)=>{
            const t = ga(e1), { phrasingContent: n, flowContent: o } = pa(e1), r = {}, s = (e1, t, n)=>{
                r[e1] = {
                    attributes: se(t, N({})),
                    attributesOrder: t,
                    children: se(n, N({}))
                };
            }, a = (e1, n = "", o = "")=>{
                const r = ma(o), a = ma(e1);
                let i = a.length;
                const l = [
                    ...t,
                    ...ma(n)
                ];
                for(; i--;)s(a[i], l.slice(), r);
            }, i = (e1, t)=>{
                const n = ma(e1), o = ma(t);
                let s = n.length;
                for(; s--;){
                    const e1 = r[n[s]];
                    for(let t = 0, n = o.length; t < n; t++)e1.attributes[o[t]] = {}, e1.attributesOrder.push(o[t]);
                }
            };
            return "html5-strict" !== e1 && (q(ma("acronym applet basefont big font strike tt"), (e1)=>{
                a(e1, "", n);
            }), q(ma("center dir isindex noframes"), (e1)=>{
                a(e1, "", o);
            })), a("html", "manifest", "head body"), a("head", "", "base command link meta noscript script style title"), a("title hr noscript br"), a("base", "href target"), a("link", "href rel media hreflang type sizes hreflang"), a("meta", "name http-equiv content charset"), a("style", "media type scoped"), a("script", "src async defer type charset"), a("body", "onafterprint onbeforeprint onbeforeunload onblur onerror onfocus onhashchange onload onmessage onoffline ononline onpagehide onpageshow onpopstate onresize onscroll onstorage onunload", o), a("dd div", "", o), a("address dt caption", "", "html4" === e1 ? n : o), a("h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn", "", n), a("blockquote", "cite", o), a("ol", "reversed start type", "li"), a("ul", "", "li"), a("li", "value", o), a("dl", "", "dt dd"), a("a", "href target rel media hreflang type", "html4" === e1 ? n : o), a("q", "cite", n), a("ins del", "cite datetime", o), a("img", "src sizes srcset alt usemap ismap width height"), a("iframe", "src name width height", o), a("embed", "src type width height"), a("object", "data type typemustmatch name usemap form width height", [
                o,
                "param"
            ].join(" ")), a("param", "name value"), a("map", "name", [
                o,
                "area"
            ].join(" ")), a("area", "alt coords shape href target rel media hreflang type"), a("table", "border", "caption colgroup thead tfoot tbody tr" + ("html4" === e1 ? " col" : "")), a("colgroup", "span", "col"), a("col", "span"), a("tbody thead tfoot", "", "tr"), a("tr", "", "td th"), a("td", "colspan rowspan headers", o), a("th", "colspan rowspan headers scope abbr", o), a("form", "accept-charset action autocomplete enctype method name novalidate target", o), a("fieldset", "disabled form name", [
                o,
                "legend"
            ].join(" ")), a("label", "form for", n), a("input", "accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate formtarget height list max maxlength min multiple name pattern readonly required size src step type value width"), a("button", "disabled form formaction formenctype formmethod formnovalidate formtarget name type value", "html4" === e1 ? o : n), a("select", "disabled form multiple name required size", "option optgroup"), a("optgroup", "disabled label", "option"), a("option", "disabled label selected value"), a("textarea", "cols dirname disabled form maxlength name readonly required rows wrap"), a("menu", "type label", [
                o,
                "li"
            ].join(" ")), a("noscript", "", o), "html4" !== e1 && (a("wbr"), a("ruby", "", [
                n,
                "rt rp"
            ].join(" ")), a("figcaption", "", o), a("mark rt rp bdi", "", n), a("summary", "", [
                n,
                "h1 h2 h3 h4 h5 h6"
            ].join(" ")), a("canvas", "width height", o), a("data", "value", n), a("video", "src crossorigin poster preload autoplay mediagroup loop muted controls width height buffered", [
                o,
                "track source"
            ].join(" ")), a("audio", "src crossorigin preload autoplay mediagroup loop muted controls buffered volume", [
                o,
                "track source"
            ].join(" ")), a("picture", "", "img source"), a("source", "src srcset type media sizes"), a("track", "kind src srclang label default"), a("datalist", "", [
                n,
                "option"
            ].join(" ")), a("article section nav aside main header footer", "", o), a("hgroup", "", "h1 h2 h3 h4 h5 h6"), a("figure", "", [
                o,
                "figcaption"
            ].join(" ")), a("time", "datetime", n), a("dialog", "open", o), a("command", "type label icon disabled checked radiogroup command"), a("output", "for form name", n), a("progress", "value max", n), a("meter", "value min max low high optimum", n), a("details", "open", [
                o,
                "summary"
            ].join(" ")), a("keygen", "autofocus challenge disabled form keytype name"), s("svg", "id tabindex lang xml:space class style x y width height viewBox preserveAspectRatio zoomAndPan transform".split(" "), [])), "html5-strict" !== e1 && (i("script", "language xml:space"), i("style", "xml:space"), i("object", "declare classid code codebase codetype archive standby align border hspace vspace"), i("embed", "align name hspace vspace"), i("param", "valuetype type"), i("a", "charset name rev shape coords"), i("br", "clear"), i("applet", "codebase archive code object alt name width height align hspace vspace"), i("img", "name longdesc align border hspace vspace"), i("iframe", "longdesc frameborder marginwidth marginheight scrolling align"), i("font basefont", "size color face"), i("input", "usemap align"), i("select"), i("textarea"), i("h1 h2 h3 h4 h5 h6 div p legend caption", "align"), i("ul", "type compact"), i("li", "type"), i("ol dl menu dir", "compact"), i("pre", "width xml:space"), i("hr", "align noshade size width"), i("isindex", "prompt"), i("table", "summary width frame rules cellspacing cellpadding align bgcolor"), i("col", "width align char charoff valign"), i("colgroup", "width align char charoff valign"), i("thead", "align char charoff valign"), i("tr", "align char charoff valign bgcolor"), i("th", "axis align char charoff valign nowrap bgcolor width height"), i("form", "accept"), i("td", "abbr axis scope align char charoff valign nowrap bgcolor width height"), i("tfoot", "align char charoff valign"), i("tbody", "align char charoff valign"), i("area", "nohref"), i("body", "background bgcolor text link vlink alink")), "html4" !== e1 && (i("input button select textarea", "autofocus"), i("input textarea", "placeholder"), i("a", "download"), i("link script img", "crossorigin"), i("img", "loading"), i("iframe", "sandbox seamless allow allowfullscreen loading referrerpolicy")), "html4" !== e1 && q([
                r.video,
                r.audio
            ], (e1)=>{
                delete e1.children.audio, delete e1.children.video;
            }), q(ma("a form meter progress dfn"), (e1)=>{
                r[e1] && delete r[e1].children[e1];
            }), delete r.caption.children.table, delete r.script, r;
        })(l);
        !1 === e1.verify_html && (e1.valid_elements = "*[*]");
        const c = Na(e1.valid_styles), u = Na(e1.invalid_styles, "map"), g = Na(e1.valid_classes, "map"), h = i("whitespace_elements", "pre script noscript style textarea video audio iframe object code"), v = i("self_closing_elements", "colgroup dd dt li option p td tfoot th thead tr"), y = i("void_elements", "area base basefont br col frame hr img input isindex link meta param embed source wbr track"), C = i("boolean_attributes", "checked compact declare defer disabled ismap multiple nohref noresize noshade nowrap readonly selected autoplay loop controls allowfullscreen"), w = "td th iframe video audio object script code", E = i("non_empty_elements", w + " pre svg textarea summary", y), _ = i("move_caret_before_on_enter_elements", w + " table", y), x = "h1 h2 h3 h4 h5 h6", S = i("text_block_elements", x + " p div address pre form blockquote center dir fieldset header footer article section hgroup aside main nav figure"), k = i("block_elements", "hr table tbody thead tfoot th tr td li ol ul caption dl dt dd noscript menu isindex option datalist select optgroup figcaption details summary html body multicol listing", S), R = i("text_inline_elements", "span strong b em i font s strike u var cite dfn code mark q sup sub samp"), A = i("transparent_elements", "a ins del canvas map"), T = i("wrap_block_elements", "pre " + x);
        Ea("script noscript iframe noframes noembed title style textarea xmp plaintext".split(" "), (e1)=>{
            a[e1] = new RegExp("</" + e1 + "[^>]*>", "gi");
        });
        const O = (e1)=>{
            const t = I.from(n["@"]), o = /[*?+]/;
            q(((e1, t)=>{
                const n = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)])?$/;
                return te(ma(t, ","), (t)=>{
                    const o = n.exec(t);
                    if (o) {
                        const t = o[1], n = o[2], r = o[3], s = o[4], a = o[5], i = {
                            attributes: {},
                            attributesOrder: []
                        };
                        if (e1.each((e1)=>((e1, t)=>{
                                pe(e1.attributes, (e1, n)=>{
                                    t.attributes[n] = e1;
                                }), t.attributesOrder.push(...e1.attributesOrder);
                            })(e1, i)), "#" === t ? i.paddEmpty = !0 : "-" === t && (i.removeEmpty = !0), "!" === s && (i.removeEmptyAttrs = !0), a && ((e1, t)=>{
                            const n = /^([!\-])?(\w+[\\:]:\w+|[^=~<]+)?(?:([=~<])(.*))?$/, o = /[*?+]/, { attributes: r, attributesOrder: s } = t;
                            q(ma(e1, "|"), (e1)=>{
                                const a = n.exec(e1);
                                if (a) {
                                    const e1 = {}, n = a[1], i = a[2].replace(/[\\:]:/g, ":"), l = a[3], d = a[4];
                                    if ("!" === n && (t.attributesRequired = t.attributesRequired || [], t.attributesRequired.push(i), e1.required = !0), "-" === n) return delete r[i], void s.splice(an.inArray(s, i), 1);
                                    if (l && ("=" === l ? (t.attributesDefault = t.attributesDefault || [], t.attributesDefault.push({
                                        name: i,
                                        value: d
                                    }), e1.defaultValue = d) : "~" === l ? (t.attributesForced = t.attributesForced || [], t.attributesForced.push({
                                        name: i,
                                        value: d
                                    }), e1.forcedValue = d) : "<" === l && (e1.validValues = an.makeMap(d, "?"))), o.test(i)) {
                                        const n = e1;
                                        t.attributePatterns = t.attributePatterns || [], n.pattern = fa(i), t.attributePatterns.push(n);
                                    } else r[i] || s.push(i), r[i] = e1;
                                }
                            });
                        })(a, i), r && (i.outputName = n), "@" === n) {
                            if (!e1.isNone()) return [];
                            e1 = I.some(i);
                        }
                        return [
                            r ? {
                                name: n,
                                element: i,
                                aliasName: r
                            } : {
                                name: n,
                                element: i
                            }
                        ];
                    }
                    return [];
                });
            })(t, null != e1 ? e1 : ""), ({ name: e1, element: t, aliasName: s })=>{
                if (s && (n[s] = t), o.test(e1)) {
                    const n = t;
                    n.pattern = fa(e1), r.push(n);
                } else n[e1] = t;
            });
        }, B = (e1)=>{
            r = [], q(fe(n), (e1)=>{
                delete n[e1];
            }), O(e1);
        }, P = (e1, t)=>{
            var r, a;
            delete Ca.text_block_elements, delete Ca.block_elements;
            const i = !!t.extends && !oe(t.extends), d = t.extends;
            if (o[e1] = d ? o[d] : {}, s[e1] = null != d ? d : e1, E[e1.toUpperCase()] = {}, E[e1] = {}, i || (k[e1.toUpperCase()] = {}, k[e1] = {}), d && !n[e1] && n[d]) {
                const t = ((e1)=>{
                    const t = (e1)=>p(e1) ? V(e1, t) : ((e1)=>f(e1) && e1.source && "[object RegExp]" === Object.prototype.toString.call(e1))(e1) ? new RegExp(e1.source, e1.flags) : f(e1) ? he(e1, t) : e1;
                    return t(e1);
                })(n[d]);
                delete t.removeEmptyAttrs, delete t.removeEmpty, n[e1] = t;
            } else n[e1] = {
                attributesOrder: [],
                attributes: {}
            };
            if (p(t.attributes)) {
                const o = (e1)=>{
                    s.attributesOrder.push(e1), s.attributes[e1] = {};
                }, s = null !== (r = n[e1]) && void 0 !== r ? r : {};
                delete s.attributesDefault, delete s.attributesForced, delete s.attributePatterns, delete s.attributesRequired, s.attributesOrder = [], s.attributes = {}, q(t.attributes, (e1)=>{
                    const t = ga(l);
                    ya(e1).each(({ preset: e1, name: n })=>{
                        e1 ? "global" === n && q(t, o) : o(n);
                    });
                }), n[e1] = s;
            }
            if (b(t.padEmpty)) {
                const o = null !== (a = n[e1]) && void 0 !== a ? a : {};
                o.paddEmpty = t.padEmpty, n[e1] = o;
            }
            if (p(t.children)) {
                const n = {}, r = (e1)=>{
                    n[e1] = {};
                }, s = (e1)=>{
                    va(l, e1).each((e1)=>{
                        q(e1, r);
                    });
                };
                q(t.children, (e1)=>{
                    ya(e1).each(({ preset: e1, name: t })=>{
                        e1 ? s(t) : r(t);
                    });
                }), o[e1] = n;
            }
            d && pe(o, (t, n)=>{
                t[d] && (o[n] = t = _a({}, o[n]), t[e1] = t[d]);
            });
        }, D = (e1)=>{
            f(e1) ? pe(e1, (e1, t)=>P(t, e1)) : m(e1) && ((e1)=>{
                q(((e1)=>{
                    const t = /^(~)?(.+)$/;
                    return te(ma(e1, ","), (e1)=>{
                        const n = t.exec(e1);
                        return n ? [
                            {
                                cloneName: "~" === n[1] ? "span" : "div",
                                name: n[2]
                            }
                        ] : [];
                    });
                })(null != e1 ? e1 : ""), ({ name: e1, cloneName: t })=>{
                    P(e1, {
                        extends: t
                    });
                });
            })(e1);
        }, L = (e1)=>{
            q(((e1)=>{
                const t = /^([+\-]?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)\[([^\]]+)]$/;
                return te(ma(e1, ","), (e1)=>{
                    const n = t.exec(e1);
                    if (n) {
                        const e1 = n[1], t = e1 ? ((e1)=>"-" === e1 ? "remove" : "add")(e1) : "replace";
                        return [
                            {
                                operation: t,
                                name: n[2],
                                validChildren: te(ma(n[3], "|"), (e1)=>ya(e1).toArray())
                            }
                        ];
                    }
                    return [];
                });
            })(null != e1 ? e1 : ""), ({ operation: e1, name: t, validChildren: n })=>{
                const r = "replace" === e1 ? {
                    "#comment": {}
                } : o[t], s = (t)=>{
                    "remove" === e1 ? delete r[t] : r[t] = {};
                };
                q(n, ({ preset: e1, name: t })=>{
                    e1 ? ((e1)=>{
                        va(l, e1).each((e1)=>{
                            q(e1, s);
                        });
                    })(t) : s(t);
                }), o[t] = r;
            });
        }, M = (e1)=>{
            const t = n[e1];
            if (t) return t;
            let o = r.length;
            for(; o--;){
                const t = r[o];
                if (t.pattern.test(e1)) return t;
            }
        }, F = N(c), U = N(u), z = N(g), j = N(C), H = N(k), $ = N(S), W = N(R), K = N(Object.seal(y)), Y = N(v), G = N(E), X = N(_), Z = N(h), Q = N(A), J = N(T), ee = N(Object.seal(a)), ne = (e1, t)=>{
            const n = M(e1);
            if (n) {
                if (!t) return !0;
                {
                    if (n.attributes[t]) return !0;
                    const e1 = n.attributePatterns;
                    if (e1) {
                        let n = e1.length;
                        for(; n--;)if (e1[n].pattern.test(t)) return !0;
                    }
                }
            }
            return !1;
        }, oe = (e1)=>xe(H(), e1), re = (e1)=>!Ye(e1, "#") && ne(e1) && !oe(e1), ae = N(s);
        return e1.valid_elements ? (B(e1.valid_elements), Ea(d, (e1, t)=>{
            o[t] = e1.children;
        })) : (Ea(d, (e1, t)=>{
            n[t] = {
                attributes: e1.attributes,
                attributesOrder: e1.attributesOrder
            }, o[t] = e1.children;
        }), Ea(ma("strong/b em/i"), (e1)=>{
            const t = ma(e1, "/");
            n[t[1]].outputName = t[0];
        }), Ea(R, (t, o)=>{
            n[o] && (e1.padd_empty_block_inline_children && (n[o].paddInEmptyBlock = !0), n[o].removeEmpty = !0);
        }), Ea(ma("ol ul blockquote a table tbody"), (e1)=>{
            n[e1] && (n[e1].removeEmpty = !0);
        }), Ea(ma("p h1 h2 h3 h4 h5 h6 th td pre div address caption li summary"), (e1)=>{
            n[e1] && (n[e1].paddEmpty = !0);
        }), Ea(ma("span"), (e1)=>{
            n[e1].removeEmptyAttrs = !0;
        })), delete n.svg, D(e1.custom_elements), L(e1.valid_children), O(e1.extended_valid_elements), L("+ol[ul|ol],+ul[ul|ol]"), Ea({
            dd: "dl",
            dt: "dl",
            li: "ul ol",
            td: "tr",
            th: "tr",
            tr: "tbody thead tfoot",
            tbody: "table",
            thead: "table",
            tfoot: "table",
            legend: "fieldset",
            area: "map",
            param: "video audio object"
        }, (e1, t)=>{
            n[t] && (n[t].parentsRequired = ma(e1));
        }), e1.invalid_elements && Ea(xa(e1.invalid_elements), (e1)=>{
            n[e1] && delete n[e1];
        }), M("span") || O("span[!data-mce-type|*]"), {
            type: l,
            children: o,
            elements: n,
            getValidStyles: F,
            getValidClasses: z,
            getBlockElements: H,
            getInvalidStyles: U,
            getVoidElements: K,
            getTextBlockElements: $,
            getTextInlineElements: W,
            getBoolAttrs: j,
            getElementRule: M,
            getSelfClosingElements: Y,
            getNonEmptyElements: G,
            getMoveCaretBeforeOnEnterElements: X,
            getWhitespaceElements: Z,
            getTransparentElements: Q,
            getSpecialElements: ee,
            isValidChild: (e1, t)=>{
                const n = o[e1.toLowerCase()];
                return !(!n || !n[t.toLowerCase()]);
            },
            isValid: ne,
            isBlock: oe,
            isInline: re,
            isWrapper: (e1)=>xe(J(), e1) || re(e1),
            getCustomElements: ae,
            addValidElements: O,
            setValidElements: B,
            addCustomElements: D,
            addValidChildren: L
        };
    }, Aa = (e1)=>{
        const t = e1.toString(16);
        return (1 === t.length ? "0" + t : t).toUpperCase();
    }, Ta = (e1)=>((e1)=>{
            var t;
            return {
                value: (t = e1, We(t, "#").toUpperCase())
            };
        })(Aa(e1.red) + Aa(e1.green) + Aa(e1.blue)), Oa = /^\s*rgb\s*\(\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*(\d+)\s*\)\s*$/i, Ba = /^\s*rgba\s*\(\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*((?:\d?\.\d+|\d+)%?)\s*\)\s*$/i, Pa = (e1, t, n, o)=>((e1, t, n, o)=>({
                red: e1,
                green: t,
                blue: n,
                alpha: o
            }))(parseInt(e1, 10), parseInt(t, 10), parseInt(n, 10), parseFloat(o)), Da = (e1)=>{
        const t = Oa.exec(e1);
        if (null !== t) return I.some(Pa(t[1], t[2], t[3], "1"));
        const n = Ba.exec(e1);
        return null !== n ? I.some(Pa(n[1], n[2], n[3], n[4])) : I.none();
    }, La = (e1)=>`rgba(${e1.red},${e1.green},${e1.blue},${e1.alpha})`, Ma = (e1)=>Da(e1).map(Ta).map((e1)=>"#" + e1.value).getOr(e1), Ia = (e1 = {}, t)=>{
        const n = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi, o = /\s*([^:]+):\s*([^;]+);?/g, r = /\s+$/, s = {};
        let a, i;
        const l = at;
        t && (a = t.getValidStyles(), i = t.getInvalidStyles());
        const d = "\\\" \\' \\; \\: ; : \ufeff".split(" ");
        for(let e1 = 0; e1 < d.length; e1++)s[d[e1]] = l + e1, s[l + e1] = d[e1];
        const c = {
            parse: (t)=>{
                const a = {};
                let i = !1;
                const d = e1.url_converter, u = e1.url_converter_scope || c, m = (e1, t, n)=>{
                    const o = a[e1 + "-top" + t];
                    if (!o) return;
                    const r = a[e1 + "-right" + t];
                    if (!r) return;
                    const s = a[e1 + "-bottom" + t];
                    if (!s) return;
                    const i = a[e1 + "-left" + t];
                    if (!i) return;
                    const l = [
                        o,
                        r,
                        s,
                        i
                    ];
                    let d = l.length - 1;
                    for(; d-- && l[d] === l[d + 1];);
                    d > -1 && n || (a[e1 + t] = -1 === d ? l[0] : l.join(" "), delete a[e1 + "-top" + t], delete a[e1 + "-right" + t], delete a[e1 + "-bottom" + t], delete a[e1 + "-left" + t]);
                }, f = (e1)=>{
                    const t = a[e1];
                    if (!t) return;
                    const n = t.indexOf(",") > -1 ? [
                        t
                    ] : t.split(" ");
                    let o = n.length;
                    for(; o--;)if (n[o] !== n[0]) return !1;
                    return a[e1] = n[0], !0;
                }, g = (e1)=>(i = !0, s[e1]), p = (e1, t)=>(i && (e1 = e1.replace(/\uFEFF[0-9]/g, (e1)=>s[e1])), t || (e1 = e1.replace(/\\([\'\";:])/g, "$1")), e1), h = (e1)=>String.fromCharCode(parseInt(e1.slice(1), 16)), b = (e1)=>e1.replace(/\\[0-9a-f]+/gi, h), v = (t, n, o, r, s, a)=>{
                    if (s = s || a) return "'" + (s = p(s)).replace(/\'/g, "\\'") + "'";
                    if (n = p(n || o || r || ""), !e1.allow_script_urls) {
                        const t = n.replace(/[\s\r\n]+/g, "");
                        if (/(java|vb)script:/i.test(t)) return "";
                        if (!e1.allow_svg_data_urls && /^data:image\/svg/i.test(t)) return "";
                    }
                    return d && (n = d.call(u, n, "style")), "url('" + n.replace(/\'/g, "\\'") + "')";
                };
                if (t) {
                    let s;
                    for(t = (t = t.replace(/[\u0000-\u001F]/g, "")).replace(/\\[\"\';:\uFEFF]/g, g).replace(/\"[^\"]+\"|\'[^\']+\'/g, (e1)=>e1.replace(/[;:]/g, g)); s = o.exec(t);){
                        o.lastIndex = s.index + s[0].length;
                        let t = s[1].replace(r, "").toLowerCase(), d = s[2].replace(r, "");
                        if (t && d) {
                            if (t = b(t), d = b(d), -1 !== t.indexOf(l) || -1 !== t.indexOf('"')) continue;
                            if (!e1.allow_script_urls && ("behavior" === t || /expression\s*\(|\/\*|\*\//.test(d))) continue;
                            "font-weight" === t && "700" === d ? d = "bold" : "color" !== t && "background-color" !== t || (d = d.toLowerCase()), "rgb" == (E = d, Oa.test(E) ? "rgb" : Ba.test(E) ? "rgba" : "other") && Da(d).each((e1)=>{
                                d = Ma(La(e1)).toLowerCase();
                            }), d = d.replace(n, v), a[t] = i ? p(d, !0) : d;
                        }
                    }
                    m("border", "", !0), m("border", "-width"), m("border", "-color"), m("border", "-style"), m("padding", ""), m("margin", ""), C = "border-style", w = "border-color", f(y = "border-width") && f(C) && f(w) && (a.border = a[y] + " " + a[C] + " " + a[w], delete a[y], delete a[C], delete a[w]), "medium none" === a.border && delete a.border, "none" === a["border-image"] && delete a["border-image"];
                }
                var y, C, w, E;
                return a;
            },
            serialize: (e1, t)=>{
                let n = "";
                const o = (t, o)=>{
                    const r = o[t];
                    if (r) for(let t = 0, o = r.length; t < o; t++){
                        const o = r[t], s = e1[o];
                        s && (n += (n.length > 0 ? " " : "") + o + ": " + s + ";");
                    }
                };
                return t && a ? (o("*", a), o(t, a)) : pe(e1, (e1, o)=>{
                    e1 && ((e1, t)=>{
                        if (!i || !t) return !0;
                        let n = i["*"];
                        return !(n && n[e1] || (n = i[t], n && n[e1]));
                    })(o, t) && (n += (n.length > 0 ? " " : "") + o + ": " + e1 + ";");
                }), n;
            }
        };
        return c;
    }, Fa = {
        keyLocation: !0,
        layerX: !0,
        layerY: !0,
        returnValue: !0,
        webkitMovementX: !0,
        webkitMovementY: !0,
        keyIdentifier: !0,
        mozPressure: !0,
        mozInputSource: !0
    }, Ua = (e1, t)=>{
        const n = null != t ? t : {};
        for(const t in e1)xe(Fa, t) || (n[t] = e1[t]);
        return C(e1.composedPath) && (n.composedPath = ()=>e1.composedPath()), C(e1.getModifierState) && (n.getModifierState = (t)=>e1.getModifierState(t)), C(e1.getTargetRanges) && (n.getTargetRanges = ()=>e1.getTargetRanges()), n;
    }, za = (e1, t, n, o)=>{
        var r;
        const s = Ua(t, o);
        return s.type = e1, y(s.target) && (s.target = null !== (r = s.srcElement) && void 0 !== r ? r : n), ((e1)=>y(e1.preventDefault) || ((e1)=>e1 instanceof Event || w(e1.initEvent))(e1))(t) && (s.preventDefault = ()=>{
            s.defaultPrevented = !0, s.isDefaultPrevented = M, w(t.preventDefault) && t.preventDefault();
        }, s.stopPropagation = ()=>{
            s.cancelBubble = !0, s.isPropagationStopped = M, w(t.stopPropagation) && t.stopPropagation();
        }, s.stopImmediatePropagation = ()=>{
            s.isImmediatePropagationStopped = M, s.stopPropagation();
        }, ((e1)=>e1.isDefaultPrevented === M || e1.isDefaultPrevented === L)(s) || (s.isDefaultPrevented = !0 === s.defaultPrevented ? M : L, s.isPropagationStopped = !0 === s.cancelBubble ? M : L, s.isImmediatePropagationStopped = L)), s;
    }, ja = /^(?:mouse|contextmenu)|click/, Ha = (e1, t, n, o)=>{
        e1.addEventListener(t, n, o || !1);
    }, $a = (e1, t, n, o)=>{
        e1.removeEventListener(t, n, o || !1);
    }, Va = (e1, t)=>{
        const n = za(e1.type, e1, document, t);
        if (((e1)=>C(e1) && ja.test(e1.type))(e1) && v(e1.pageX) && !v(e1.clientX)) {
            const t = n.target.ownerDocument || document, o = t.documentElement, r = t.body, s = n;
            s.pageX = e1.clientX + (o && o.scrollLeft || r && r.scrollLeft || 0) - (o && o.clientLeft || r && r.clientLeft || 0), s.pageY = e1.clientY + (o && o.scrollTop || r && r.scrollTop || 0) - (o && o.clientTop || r && r.clientTop || 0);
        }
        return n;
    }, qa = (e1, t, n)=>{
        const o = e1.document, r = {
            type: "ready"
        };
        if (n.domLoaded) return void t(r);
        const s = ()=>{
            $a(e1, "DOMContentLoaded", s), $a(e1, "load", s), n.domLoaded || (n.domLoaded = !0, t(r)), e1 = null;
        };
        "complete" === o.readyState || "interactive" === o.readyState && o.body ? s() : Ha(e1, "DOMContentLoaded", s), n.domLoaded || Ha(e1, "load", s);
    };
    class Wa {
        constructor(){
            this.domLoaded = !1, this.events = {}, this.count = 1, this.expando = "mce-data-" + (+new Date).toString(32), this.hasFocusIn = "onfocusin" in document.documentElement, this.count = 1;
        }
        bind(e1, t, n, o) {
            const r = this;
            let s;
            const a = window, i = (e1)=>{
                r.executeHandlers(Va(e1 || a.event), l);
            };
            if (!e1 || es(e1) || os(e1)) return n;
            let l;
            e1[r.expando] ? l = e1[r.expando] : (l = r.count++, e1[r.expando] = l, r.events[l] = {}), o = o || e1;
            const d = t.split(" ");
            let c = d.length;
            for(; c--;){
                let t = d[c], u = i, m = !1, f = !1;
                "DOMContentLoaded" === t && (t = "ready"), r.domLoaded && "ready" === t && "complete" === e1.readyState ? n.call(o, Va({
                    type: t
                })) : (r.hasFocusIn || "focusin" !== t && "focusout" !== t || (m = !0, f = "focusin" === t ? "focus" : "blur", u = (e1)=>{
                    const t = Va(e1 || a.event);
                    t.type = "focus" === t.type ? "focusin" : "focusout", r.executeHandlers(t, l);
                }), s = r.events[l][t], s ? "ready" === t && r.domLoaded ? n(Va({
                    type: t
                })) : s.push({
                    func: n,
                    scope: o
                }) : (r.events[l][t] = s = [
                    {
                        func: n,
                        scope: o
                    }
                ], s.fakeName = f, s.capture = m, s.nativeHandler = u, "ready" === t ? qa(e1, u, r) : Ha(e1, f || t, u, m)));
            }
            return e1 = s = null, n;
        }
        unbind(e1, t, n) {
            if (!e1 || es(e1) || os(e1)) return this;
            const o = e1[this.expando];
            if (o) {
                let r = this.events[o];
                if (t) {
                    const o = t.split(" ");
                    let s = o.length;
                    for(; s--;){
                        const t = o[s], a = r[t];
                        if (a) {
                            if (n) {
                                let e1 = a.length;
                                for(; e1--;)if (a[e1].func === n) {
                                    const n = a.nativeHandler, o = a.fakeName, s = a.capture, i = a.slice(0, e1).concat(a.slice(e1 + 1));
                                    i.nativeHandler = n, i.fakeName = o, i.capture = s, r[t] = i;
                                }
                            }
                            n && 0 !== a.length || (delete r[t], $a(e1, a.fakeName || t, a.nativeHandler, a.capture));
                        }
                    }
                } else pe(r, (t, n)=>{
                    $a(e1, t.fakeName || n, t.nativeHandler, t.capture);
                }), r = {};
                for(const e1 in r)if (xe(r, e1)) return this;
                delete this.events[o];
                try {
                    delete e1[this.expando];
                } catch (t) {
                    e1[this.expando] = null;
                }
            }
            return this;
        }
        fire(e1, t, n) {
            return this.dispatch(e1, t, n);
        }
        dispatch(e1, t, n) {
            if (!e1 || es(e1) || os(e1)) return this;
            const o = Va({
                type: t,
                target: e1
            }, n);
            do {
                const t = e1[this.expando];
                t && this.executeHandlers(o, t), e1 = e1.parentNode || e1.ownerDocument || e1.defaultView || e1.parentWindow;
            }while (e1 && !o.isPropagationStopped());
            return this;
        }
        clean(e1) {
            if (!e1 || es(e1) || os(e1)) return this;
            if (e1[this.expando] && this.unbind(e1), e1.getElementsByTagName || (e1 = e1.document), e1 && e1.getElementsByTagName) {
                this.unbind(e1);
                const t = e1.getElementsByTagName("*");
                let n = t.length;
                for(; n--;)(e1 = t[n])[this.expando] && this.unbind(e1);
            }
            return this;
        }
        destroy() {
            this.events = {};
        }
        cancel(e1) {
            return e1 && (e1.preventDefault(), e1.stopImmediatePropagation()), !1;
        }
        executeHandlers(e1, t) {
            const n = this.events[t], o = n && n[e1.type];
            if (o) for(let t = 0, n = o.length; t < n; t++){
                const n = o[t];
                if (n && !1 === n.func.call(n.scope, e1) && e1.preventDefault(), e1.isImmediatePropagationStopped()) return;
            }
        }
    }
    Wa.Event = new Wa;
    const Ka = an.each, Ya = an.grep, Ga = "data-mce-style", Xa = an.makeMap("fill-opacity font-weight line-height opacity orphans widows z-index zoom", " "), Za = (e1, t, n)=>{
        y(n) || "" === n ? yo(e1, t) : go(e1, t, n);
    }, Qa = (e1)=>e1.replace(/[A-Z]/g, (e1)=>"-" + e1.toLowerCase()), Ja = (e1, t)=>{
        let n = 0;
        if (e1) for(let o = e1.nodeType, r = e1.previousSibling; r; r = r.previousSibling){
            const e1 = r.nodeType;
            (!t || !es(r) || e1 !== o && r.data.length) && (n++, o = e1);
        }
        return n;
    }, ei = (e1, t)=>{
        const n = ho(t, "style"), o = e1.serialize(e1.parse(n), _n(t));
        Za(t, Ga, o);
    }, ti = (e1, t, n)=>{
        const o = Qa(t);
        y(n) || "" === n ? Uo(e1, o) : Po(e1, o, ((e1, t)=>E(e1) ? xe(Xa, t) ? e1 + "" : e1 + "px" : e1)(n, o));
    }, ni = (e1, t = {})=>{
        const n = {}, o = window, r = {};
        let s = 0;
        const a = Ys.forElement(mn(e1), {
            contentCssCors: t.contentCssCors,
            referrerPolicy: t.referrerPolicy
        }), i = [], l = t.schema ? t.schema : Ra({}), d = Ia({
            url_converter: t.url_converter,
            url_converter_scope: t.url_converter_scope
        }, t.schema), c = t.ownEvents ? new Wa : Wa.Event, u = l.getBlockElements(), f = (t)=>t && e1 && m(t) ? e1.getElementById(t) : t, h = (e1)=>{
            const t = f(e1);
            return C(t) ? mn(t) : null;
        }, b = (e1, t, n = "")=>{
            let o;
            const r = h(e1);
            if (C(r) && Nn(r)) {
                const e1 = G[t];
                o = e1 && e1.get ? e1.get(r.dom, t) : ho(r, t);
            }
            return C(o) ? o : n;
        }, v = (e1)=>{
            const t = f(e1);
            return y(t) ? [] : t.attributes;
        }, E = (e1, n, o)=>{
            B(e1, (e1)=>{
                if (qr(e1)) {
                    const r = mn(e1), s = "" === o ? null : o, a = ho(r, n), i = G[n];
                    i && i.set ? i.set(r.dom, s, n) : Za(r, n, s), a !== s && t.onSetAttrib && t.onSetAttrib({
                        attrElm: r.dom,
                        attrName: n,
                        attrValue: s
                    });
                }
            });
        }, _ = ()=>t.root_element || e1.body, S = (t, n)=>((e1, t, n)=>{
                let o = 0, r = 0;
                const s = e1.ownerDocument;
                if (n = n || e1, t) {
                    if (n === e1 && t.getBoundingClientRect && "static" === Lo(mn(e1), "position")) {
                        const n = t.getBoundingClientRect();
                        return o = n.left + (s.documentElement.scrollLeft || e1.scrollLeft) - s.documentElement.clientLeft, r = n.top + (s.documentElement.scrollTop || e1.scrollTop) - s.documentElement.clientTop, {
                            x: o,
                            y: r
                        };
                    }
                    let a = t;
                    for(; a && a !== n && a.nodeType && !Ws(a, n);){
                        const e1 = a;
                        o += e1.offsetLeft || 0, r += e1.offsetTop || 0, a = e1.offsetParent;
                    }
                    for(a = t.parentNode; a && a !== n && a.nodeType && !Ws(a, n);)o -= a.scrollLeft || 0, r -= a.scrollTop || 0, a = a.parentNode;
                    r += ((e1)=>Vs.isFirefox() && "table" === _n(e1) ? qs(Hn(e1)).filter((e1)=>"caption" === _n(e1)).bind((e1)=>qs(jn(e1)).map((t)=>{
                                const n = t.dom.offsetTop, o = e1.dom.offsetTop, r = e1.dom.offsetHeight;
                                return n <= o ? -r : 0;
                            })).getOr(0) : 0)(mn(t));
                }
                return {
                    x: o,
                    y: r
                };
            })(e1.body, f(t), n), k = (e1, t, n)=>{
            const o = f(e1);
            var r;
            if (!y(o) && (Wr(o) || qr(r = o) && "http://www.w3.org/2000/svg" === r.namespaceURI)) return n ? Lo(mn(o), Qa(t)) : ("float" === (t = t.replace(/-(\D)/g, (e1, t)=>t.toUpperCase())) && (t = "cssFloat"), o.style ? o.style[t] : void 0);
        }, R = (e1)=>{
            const t = f(e1);
            if (!t) return {
                w: 0,
                h: 0
            };
            let n = k(t, "width"), o = k(t, "height");
            return n && -1 !== n.indexOf("px") || (n = "0"), o && -1 !== o.indexOf("px") || (o = "0"), {
                w: parseInt(n, 10) || t.offsetWidth || t.clientWidth,
                h: parseInt(o, 10) || t.offsetHeight || t.clientHeight
            };
        }, A = (e1, t)=>{
            if (!e1) return !1;
            const n = p(e1) ? e1 : [
                e1
            ];
            return $(n, (e1)=>vn(mn(e1), t));
        }, T = (e1, t, n, o)=>{
            const r = [];
            let s = f(e1);
            o = void 0 === o;
            const a = n || ("BODY" !== _().nodeName ? _().parentNode : null);
            if (m(t)) {
                if ("*" === t) t = qr;
                else {
                    const e1 = t;
                    t = (t)=>A(t, e1);
                }
            }
            for(; s && !(s === a || y(s.nodeType) || rs(s) || ss(s));){
                if (!t || t(s)) {
                    if (!o) return [
                        s
                    ];
                    r.push(s);
                }
                s = s.parentNode;
            }
            return o ? r : null;
        }, O = (e1, t, n)=>{
            let o = t;
            if (e1) {
                m(t) && (o = (e1)=>A(e1, t));
                for(let t = e1[n]; t; t = t[n])if (w(o) && o(t)) return t;
            }
            return null;
        }, B = function(e1, t, n) {
            const o = null != n ? n : this;
            if (p(e1)) {
                const n = [];
                return Ka(e1, (e1, r)=>{
                    const s = f(e1);
                    s && n.push(t.call(o, s, r));
                }), n;
            }
            {
                const n = f(e1);
                return !!n && t.call(o, n);
            }
        }, P = (e1, t)=>{
            B(e1, (e1)=>{
                pe(t, (t, n)=>{
                    E(e1, n, t);
                });
            });
        }, D = (e1, t)=>{
            B(e1, (e1)=>{
                const n = mn(e1);
                Ao(n, t);
            });
        }, L = (t, n, o, r, s)=>B(t, (t)=>{
                const a = m(n) ? e1.createElement(n) : n;
                return C(o) && P(a, o), r && (!m(r) && r.nodeType ? a.appendChild(r) : m(r) && D(a, r)), s ? a : t.appendChild(a);
            }), M = (t, n, o)=>L(e1.createElement(t), t, n, o, !0), I = ua.encodeAllRaw, F = (e1, t)=>B(e1, (e1)=>{
                const n = mn(e1);
                return t && q(Hn(n), (e1)=>{
                    Rn(e1) && 0 === e1.dom.length ? Eo(e1) : ao(n, e1);
                }), Eo(n), n.dom;
            }), U = (e1, t, n)=>{
            B(e1, (e1)=>{
                if (qr(e1)) {
                    const o = mn(e1), r = t.split(" ");
                    q(r, (e1)=>{
                        C(n) ? (n ? cr : mr)(o, e1) : ((e1, t)=>{
                            const n = ar(e1) ? e1.dom.classList.toggle(t) : ((e1, t)=>H(ir(e1), t) ? dr(e1, t) : lr(e1, t))(e1, t);
                            ur(e1);
                        })(o, e1);
                    });
                }
            });
        }, z = (e1, t, n)=>B(t, (o)=>{
                var r;
                const s = p(t) ? e1.cloneNode(!0) : e1;
                return n && Ka(Ya(o.childNodes), (e1)=>{
                    s.appendChild(e1);
                }), null === (r = o.parentNode) || void 0 === r || r.replaceChild(s, o), o;
            }), j = ()=>e1.createRange(), V = (n, r, s, a)=>{
            if (p(n)) {
                let e1 = n.length;
                const t = [];
                for(; e1--;)t[e1] = V(n[e1], r, s, a);
                return t;
            }
            return !t.collect || n !== e1 && n !== o || i.push([
                n,
                r,
                s,
                a
            ]), c.bind(n, r, s, a || Y);
        }, W = (t, n, r)=>{
            if (p(t)) {
                let e1 = t.length;
                const o = [];
                for(; e1--;)o[e1] = W(t[e1], n, r);
                return o;
            }
            if (i.length > 0 && (t === e1 || t === o)) {
                let e1 = i.length;
                for(; e1--;){
                    const [o, s, a] = i[e1];
                    t !== o || n && n !== s || r && r !== a || c.unbind(o, s, a);
                }
            }
            return c.unbind(t, n, r);
        }, K = (e1)=>{
            if (e1 && Wr(e1)) {
                const t = e1.getAttribute("data-mce-contenteditable");
                return t && "inherit" !== t ? t : "inherit" !== e1.contentEditable ? e1.contentEditable : null;
            }
            return null;
        }, Y = {
            doc: e1,
            settings: t,
            win: o,
            files: r,
            stdMode: !0,
            boxModel: !0,
            styleSheetLoader: a,
            boundEvents: i,
            styles: d,
            schema: l,
            events: c,
            isBlock: (e1)=>m(e1) ? xe(u, e1) : qr(e1) && (xe(u, e1.nodeName) || js(l, e1)),
            root: null,
            clone: (e1, t)=>e1.cloneNode(t),
            getRoot: _,
            getViewPort: (e1)=>{
                const t = Ir(e1);
                return {
                    x: t.x,
                    y: t.y,
                    w: t.width,
                    h: t.height
                };
            },
            getRect: (e1)=>{
                const t = f(e1), n = S(t), o = R(t);
                return {
                    x: n.x,
                    y: n.y,
                    w: o.w,
                    h: o.h
                };
            },
            getSize: R,
            getParent: (e1, t, n)=>{
                const o = T(e1, t, n, !1);
                return o && o.length > 0 ? o[0] : null;
            },
            getParents: T,
            get: f,
            getNext: (e1, t)=>O(e1, t, "nextSibling"),
            getPrev: (e1, t)=>O(e1, t, "previousSibling"),
            select: (n, o)=>{
                var r, s;
                const a = null !== (s = null !== (r = f(o)) && void 0 !== r ? r : t.root_element) && void 0 !== s ? s : e1;
                return w(a.querySelectorAll) ? ce(a.querySelectorAll(n)) : [];
            },
            is: A,
            add: L,
            create: M,
            createHTML: (e1, t, n = "")=>{
                let o = "<" + e1;
                for(const e1 in t)Se(t, e1) && (o += " " + e1 + '="' + I(t[e1]) + '"');
                return tt(n) && xe(l.getVoidElements(), e1) ? o + " />" : o + ">" + n + "</" + e1 + ">";
            },
            createFragment: (t)=>{
                const n = e1.createElement("div"), o = e1.createDocumentFragment();
                let r;
                for(o.appendChild(n), t && (n.innerHTML = t); r = n.firstChild;)o.appendChild(r);
                return o.removeChild(n), o;
            },
            remove: F,
            setStyle: (e1, n, o)=>{
                B(e1, (e1)=>{
                    const r = mn(e1);
                    ti(r, n, o), t.update_styles && ei(d, r);
                });
            },
            getStyle: k,
            setStyles: (e1, n)=>{
                B(e1, (e1)=>{
                    const o = mn(e1);
                    pe(n, (e1, t)=>{
                        ti(o, t, e1);
                    }), t.update_styles && ei(d, o);
                });
            },
            removeAllAttribs: (e1)=>B(e1, (e1)=>{
                    const t = e1.attributes;
                    for(let n = t.length - 1; n >= 0; n--)e1.removeAttributeNode(t.item(n));
                }),
            setAttrib: E,
            setAttribs: P,
            getAttrib: b,
            getPos: S,
            parseStyle: (e1)=>d.parse(e1),
            serializeStyle: (e1, t)=>d.serialize(e1, t),
            addStyle: (t)=>{
                if (Y !== ni.DOM && e1 === document) {
                    if (n[t]) return;
                    n[t] = !0;
                }
                let o = e1.getElementById("mceDefaultStyles");
                if (!o) {
                    o = e1.createElement("style"), o.id = "mceDefaultStyles", o.type = "text/css";
                    const t = e1.head;
                    t.firstChild ? t.insertBefore(o, t.firstChild) : t.appendChild(o);
                }
                o.styleSheet ? o.styleSheet.cssText += t : o.appendChild(e1.createTextNode(t));
            },
            loadCSS: (e1)=>{
                e1 || (e1 = ""), q(e1.split(","), (e1)=>{
                    r[e1] = !0, a.load(e1).catch(x);
                });
            },
            addClass: (e1, t)=>{
                U(e1, t, !0);
            },
            removeClass: (e1, t)=>{
                U(e1, t, !1);
            },
            hasClass: (e1, t)=>{
                const n = h(e1), o = t.split(" ");
                return C(n) && ne(o, (e1)=>fr(n, e1));
            },
            toggleClass: U,
            show: (e1)=>{
                B(e1, (e1)=>Uo(mn(e1), "display"));
            },
            hide: (e1)=>{
                B(e1, (e1)=>Po(mn(e1), "display", "none"));
            },
            isHidden: (e1)=>{
                const t = h(e1);
                return C(t) && Fe(Io(t, "display"), "none");
            },
            uniqueId: (e1)=>(e1 || "mce_") + s++,
            setHTML: D,
            getOuterHTML: (e1)=>{
                const t = h(e1);
                return C(t) ? qr(t.dom) ? t.dom.outerHTML : ((e1)=>{
                    const t = cn("div"), n = mn(e1.dom.cloneNode(!0));
                    return co(t, n), Ro(t);
                })(t) : "";
            },
            setOuterHTML: (e1, t)=>{
                B(e1, (e1)=>{
                    qr(e1) && (e1.outerHTML = t);
                });
            },
            decode: ua.decode,
            encode: I,
            insertAfter: (e1, t)=>{
                const n = f(t);
                return B(e1, (e1)=>{
                    const t = null == n ? void 0 : n.parentNode, o = null == n ? void 0 : n.nextSibling;
                    return t && (o ? t.insertBefore(e1, o) : t.appendChild(e1)), e1;
                });
            },
            replace: z,
            rename: (e1, t)=>{
                if (e1.nodeName !== t.toUpperCase()) {
                    const n = M(t);
                    return Ka(v(e1), (t)=>{
                        E(n, t.nodeName, b(e1, t.nodeName));
                    }), z(n, e1, !0), n;
                }
                return e1;
            },
            findCommonAncestor: (e1, t)=>{
                let n = e1;
                for(; n;){
                    let e1 = t;
                    for(; e1 && n !== e1;)e1 = e1.parentNode;
                    if (n === e1) break;
                    n = n.parentNode;
                }
                return !n && e1.ownerDocument ? e1.ownerDocument.documentElement : n;
            },
            run: B,
            getAttribs: v,
            isEmpty: (e1, t, n)=>{
                if (g(t)) {
                    const o = (e1)=>{
                        const n = e1.nodeName.toLowerCase();
                        return Boolean(t[n]);
                    };
                    return Es(l, e1, {
                        ...n,
                        isContent: o
                    });
                }
                return Es(l, e1, n);
            },
            createRng: j,
            nodeIndex: Ja,
            split: (e1, t, n)=>{
                let o, r, s = j();
                if (e1 && t && e1.parentNode && t.parentNode) {
                    const a = e1.parentNode;
                    return s.setStart(a, Ja(e1)), s.setEnd(t.parentNode, Ja(t)), o = s.extractContents(), s = j(), s.setStart(t.parentNode, Ja(t) + 1), s.setEnd(a, Ja(e1) + 1), r = s.extractContents(), a.insertBefore(Zs(Y, o, l), e1), n ? a.insertBefore(n, e1) : a.insertBefore(t, e1), a.insertBefore(Zs(Y, r, l), e1), F(e1), n || t;
                }
            },
            bind: V,
            unbind: W,
            fire: (e1, t, n)=>c.dispatch(e1, t, n),
            dispatch: (e1, t, n)=>c.dispatch(e1, t, n),
            getContentEditable: K,
            getContentEditableParent: (e1)=>{
                const t = _();
                let n = null;
                for(let o = e1; o && o !== t && (n = K(o), null === n); o = o.parentNode);
                return n;
            },
            isEditable: (e1)=>{
                if (C(e1)) {
                    const t = qr(e1) ? e1 : e1.parentElement;
                    return C(t) && Wr(t) && gr(mn(t));
                }
                return !1;
            },
            destroy: ()=>{
                if (i.length > 0) {
                    let e1 = i.length;
                    for(; e1--;){
                        const [t, n, o] = i[e1];
                        c.unbind(t, n, o);
                    }
                }
                pe(r, (e1, t)=>{
                    a.unload(t), delete r[t];
                });
            },
            isChildOf: (e1, t)=>e1 === t || t.contains(e1),
            dumpRng: (e1)=>"startContainer: " + e1.startContainer.nodeName + ", startOffset: " + e1.startOffset + ", endContainer: " + e1.endContainer.nodeName + ", endOffset: " + e1.endOffset
        }, G = ((e1, t, n)=>{
            const o = t.keep_values, r = {
                set: (e1, o, r)=>{
                    const s = mn(e1);
                    w(t.url_converter) && C(o) && (o = t.url_converter.call(t.url_converter_scope || n(), String(o), r, e1)), Za(s, "data-mce-" + r, o), Za(s, r, o);
                },
                get: (e1, t)=>{
                    const n = mn(e1);
                    return ho(n, "data-mce-" + t) || ho(n, t);
                }
            }, s = {
                style: {
                    set: (t, n)=>{
                        const r = mn(t);
                        o && Za(r, Ga, n), yo(r, "style"), m(n) && Do(r, e1.parse(n));
                    },
                    get: (t)=>{
                        const n = mn(t), o = ho(n, Ga) || ho(n, "style");
                        return e1.serialize(e1.parse(o), _n(n));
                    }
                }
            };
            return o && (s.href = s.src = r), s;
        })(d, t, N(Y));
        return Y;
    };
    ni.DOM = ni(document), ni.nodeIndex = Ja;
    const oi = ni.DOM;
    class ri {
        constructor(e1 = {}){
            this.states = {}, this.queue = [], this.scriptLoadedCallbacks = {}, this.queueLoadedCallbacks = [], this.loading = !1, this.settings = e1;
        }
        _setReferrerPolicy(e1) {
            this.settings.referrerPolicy = e1;
        }
        loadScript(e1) {
            return new Promise((t, n)=>{
                const o = oi;
                let r;
                const s = ()=>{
                    o.remove(a), r && (r.onerror = r.onload = r = null);
                }, a = o.uniqueId();
                r = document.createElement("script"), r.id = a, r.type = "text/javascript", r.src = an._addCacheSuffix(e1), this.settings.referrerPolicy && o.setAttrib(r, "referrerpolicy", this.settings.referrerPolicy), r.onload = ()=>{
                    s(), t();
                }, r.onerror = ()=>{
                    s(), n("Failed to load script: " + e1);
                }, (document.getElementsByTagName("head")[0] || document.body).appendChild(r);
            });
        }
        isDone(e1) {
            return 2 === this.states[e1];
        }
        markDone(e1) {
            this.states[e1] = 2;
        }
        add(e1) {
            const t = this;
            return t.queue.push(e1), void 0 === t.states[e1] && (t.states[e1] = 0), new Promise((n, o)=>{
                t.scriptLoadedCallbacks[e1] || (t.scriptLoadedCallbacks[e1] = []), t.scriptLoadedCallbacks[e1].push({
                    resolve: n,
                    reject: o
                });
            });
        }
        load(e1) {
            return this.add(e1);
        }
        remove(e1) {
            delete this.states[e1], delete this.scriptLoadedCallbacks[e1];
        }
        loadQueue() {
            const e1 = this.queue;
            return this.queue = [], this.loadScripts(e1);
        }
        loadScripts(e1) {
            const t = this, n = (e1, n)=>{
                _e(t.scriptLoadedCallbacks, n).each((t)=>{
                    q(t, (t)=>t[e1](n));
                }), delete t.scriptLoadedCallbacks[n];
            }, o = (e1)=>{
                const t = Y(e1, (e1)=>"rejected" === e1.status);
                return t.length > 0 ? Promise.reject(te(t, ({ reason: e1 })=>p(e1) ? e1 : [
                        e1
                    ])) : Promise.resolve();
            }, r = (e1)=>Promise.allSettled(V(e1, (e1)=>2 === t.states[e1] ? (n("resolve", e1), Promise.resolve()) : 3 === t.states[e1] ? (n("reject", e1), Promise.reject(e1)) : (t.states[e1] = 1, t.loadScript(e1).then(()=>{
                        t.states[e1] = 2, n("resolve", e1);
                        const s = t.queue;
                        return s.length > 0 ? (t.queue = [], r(s).then(o)) : Promise.resolve();
                    }, ()=>(t.states[e1] = 3, n("reject", e1), Promise.reject(e1)))))), s = (e1)=>(t.loading = !0, r(e1).then((e1)=>{
                    t.loading = !1;
                    const n = t.queueLoadedCallbacks.shift();
                    return I.from(n).each(D), o(e1);
                })), a = dt(e1);
            return t.loading ? new Promise((e1, n)=>{
                t.queueLoadedCallbacks.push(()=>{
                    s(a).then(e1, n);
                });
            }) : s(a);
        }
    }
    ri.ScriptLoader = new ri;
    const si = {}, ai = Ne("en"), ii = ()=>_e(si, ai.get()), li = {
        getData: ()=>he(si, (e1)=>({
                    ...e1
                })),
        setCode: (e1)=>{
            e1 && ai.set(e1);
        },
        getCode: ()=>ai.get(),
        add: (e1, t)=>{
            let n = si[e1];
            n || (si[e1] = n = {});
            const o = V(fe(t), (e1)=>e1.toLowerCase());
            pe(t, (e1, r)=>{
                const s = r.toLowerCase();
                s !== r && ((e1, t)=>{
                    const n = e1.indexOf(t);
                    return -1 !== n && e1.indexOf(t, n + 1) > n;
                })(o, s) ? (xe(t, s) || (n[s] = e1), n[r] = e1) : n[s] = e1;
            });
        },
        translate: (e1)=>{
            const t = ii().getOr({}), n = (e1)=>w(e1) ? Object.prototype.toString.call(e1) : o(e1) ? "" : "" + e1, o = (e1)=>"" === e1 || null == e1, r = (e1)=>{
                const o = n(e1);
                return xe(t, o) ? n(t[o]) : _e(t, o.toLowerCase()).map(n).getOr(o);
            }, s = (e1)=>e1.replace(/{context:\w+}$/, "");
            if (o(e1)) return "";
            if (f(a = e1) && xe(a, "raw")) return n(e1.raw);
            var a;
            if (((e1)=>p(e1) && e1.length > 1)(e1)) {
                const t = e1.slice(1);
                return s(r(e1[0]).replace(/\{([0-9]+)\}/g, (e1, o)=>xe(t, o) ? n(t[o]) : e1));
            }
            return s(r(e1));
        },
        isRtl: ()=>ii().bind((e1)=>_e(e1, "_dir")).exists((e1)=>"rtl" === e1),
        hasCode: (e1)=>xe(si, e1)
    }, di = ()=>{
        const e1 = [], t = {}, n = {}, o = [], r = (e1, t)=>{
            const n = Y(o, (n)=>n.name === e1 && n.state === t);
            q(n, (e1)=>e1.resolve());
        }, s = (e1)=>xe(t, e1), a = (e1, n)=>{
            const o = li.getCode();
            !o || n && -1 === ("," + (n || "") + ",").indexOf("," + o + ",") || ri.ScriptLoader.add(t[e1] + "/langs/" + o + ".js");
        }, i = (e1, t = "added")=>"added" === t && ((e1)=>xe(n, e1))(e1) || "loaded" === t && s(e1) ? Promise.resolve() : new Promise((n)=>{
                o.push({
                    name: e1,
                    state: t,
                    resolve: n
                });
            });
        return {
            items: e1,
            urls: t,
            lookup: n,
            get: (e1)=>{
                if (n[e1]) return n[e1].instance;
            },
            requireLangPack: (e1, t)=>{
                !1 !== di.languageLoad && (s(e1) ? a(e1, t) : i(e1, "loaded").then(()=>a(e1, t)));
            },
            add: (t, o)=>(e1.push(o), n[t] = {
                    instance: o
                }, r(t, "added"), o),
            remove: (e1)=>{
                delete t[e1], delete n[e1];
            },
            createUrl: (e1, t)=>m(t) ? m(e1) ? {
                    prefix: "",
                    resource: t,
                    suffix: ""
                } : {
                    prefix: e1.prefix,
                    resource: t,
                    suffix: e1.suffix
                } : t,
            load: (e1, o)=>{
                if (t[e1]) return Promise.resolve();
                let s = m(o) ? o : o.prefix + o.resource + o.suffix;
                0 !== s.indexOf("/") && -1 === s.indexOf("://") && (s = di.baseURL + "/" + s), t[e1] = s.substring(0, s.lastIndexOf("/"));
                const a = ()=>(r(e1, "loaded"), Promise.resolve());
                return n[e1] ? a() : ri.ScriptLoader.add(s).then(a);
            },
            waitFor: i
        };
    };
    di.languageLoad = !0, di.baseURL = "", di.PluginManager = di(), di.ThemeManager = di(), di.ModelManager = di();
    const ci = N("mce-annotation"), ui = N("data-mce-annotation"), mi = N("data-mce-annotation-uid"), fi = N("data-mce-annotation-active"), gi = N("data-mce-annotation-classes"), pi = N("data-mce-annotation-attrs"), hi = (e1)=>(t)=>Cn(t, e1), bi = (e1, t)=>{
        const n = e1.selection.getRng(), o = mn(n.startContainer), r = mn(e1.getBody()), s = t.fold(()=>"." + ci(), (e1)=>`[${ui()}="${e1}"]`), a = $n(o, n.startOffset).getOr(o);
        return sr(a, s, hi(r)).bind((t)=>bo(t, `${mi()}`).bind((n)=>bo(t, `${ui()}`).map((t)=>{
                    const o = yi(e1, n);
                    return {
                        uid: n,
                        name: t,
                        elements: o
                    };
                })));
    }, vi = (e1, t)=>vo(e1, "data-mce-bogus") || ((e1, t, n)=>or(e1, '[data-mce-bogus="all"]', n).isSome())(e1, 0, hi(t)), yi = (e1, t)=>{
        const n = mn(e1.getBody()), o = vr(n, `[${mi()}="${t}"]`);
        return Y(o, (e1)=>!vi(e1, n));
    }, Ci = (e1, t)=>{
        const n = mn(e1.getBody()), o = vr(n, `[${ui()}="${t}"]`), r = {};
        return q(o, (e1)=>{
            if (!vi(e1, n)) {
                const t = ho(e1, mi()), n = _e(r, t).getOr([]);
                r[t] = n.concat([
                    e1
                ]);
            }
        }), r;
    }, wi = (e1, t, n = L)=>{
        const o = new Fr(e1, t), r = (e1)=>{
            let t;
            do t = o[e1]();
            while (t && !es(t) && !n(t));
            return I.from(t).filter(es);
        };
        return {
            current: ()=>I.from(o.current()).filter(es),
            next: ()=>r("next"),
            prev: ()=>r("prev"),
            prev2: ()=>r("prev2")
        };
    }, Ei = (e1, t)=>{
        const n = t || ((t)=>e1.isBlock(t) || as(t) || cs(t)), o = (e1, t, n, r)=>{
            if (es(e1)) {
                const n = r(e1, t, e1.data);
                if (-1 !== n) return I.some({
                    container: e1,
                    offset: n
                });
            }
            return n().bind((e1)=>o(e1.container, e1.offset, n, r));
        };
        return {
            backwards: (t, r, s, a)=>{
                const i = wi(t, null != a ? a : e1.getRoot(), n);
                return o(t, r, ()=>i.prev().map((e1)=>({
                            container: e1,
                            offset: e1.length
                        })), s).getOrNull();
            },
            forwards: (t, r, s, a)=>{
                const i = wi(t, null != a ? a : e1.getRoot(), n);
                return o(t, r, ()=>i.next().map((e1)=>({
                            container: e1,
                            offset: 0
                        })), s).getOrNull();
            }
        };
    }, _i = (e1)=>{
        let t;
        return (n)=>(t = t || se(e1, M), xe(t, _n(n)));
    }, xi = (e1)=>Nn(e1) && "br" === _n(e1), Si = _i([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "p",
        "div",
        "address",
        "pre",
        "form",
        "blockquote",
        "center",
        "dir",
        "fieldset",
        "header",
        "footer",
        "article",
        "section",
        "hgroup",
        "aside",
        "nav",
        "figure"
    ]), ki = _i([
        "ul",
        "ol",
        "dl"
    ]), Ni = _i([
        "li",
        "dd",
        "dt"
    ]), Ri = _i([
        "thead",
        "tbody",
        "tfoot"
    ]), Ai = _i([
        "td",
        "th"
    ]), Ti = _i([
        "pre",
        "script",
        "textarea",
        "style"
    ]), Oi = ()=>{
        const e1 = cn("br");
        return go(e1, "data-mce-bogus", "1"), e1;
    }, Bi = (e1)=>{
        wo(e1), co(e1, Oi());
    }, Pi = at, Di = lt, Li = (e1)=>e1.replace(/\uFEFF/g, ""), Mi = qr, Ii = es, Fi = (e1)=>(Ii(e1) && (e1 = e1.parentNode), Mi(e1) && e1.hasAttribute("data-mce-caret")), Ui = (e1)=>Ii(e1) && Di(e1.data), zi = (e1)=>Fi(e1) || Ui(e1), ji = (e1)=>e1.firstChild !== e1.lastChild || !as(e1.firstChild), Hi = (e1)=>{
        const t = e1.container();
        return !!es(t) && (t.data.charAt(e1.offset()) === Pi || e1.isAtStart() && Ui(t.previousSibling));
    }, $i = (e1)=>{
        const t = e1.container();
        return !!es(t) && (t.data.charAt(e1.offset() - 1) === Pi || e1.isAtEnd() && Ui(t.nextSibling));
    }, Vi = (e1)=>Ii(e1) && e1.data[0] === Pi, qi = (e1)=>Ii(e1) && e1.data[e1.data.length - 1] === Pi, Wi = (e1)=>e1 && e1.hasAttribute("data-mce-caret") ? (((e1)=>{
            var t;
            const n = e1.getElementsByTagName("br"), o = n[n.length - 1];
            Xr(o) && (null === (t = o.parentNode) || void 0 === t || t.removeChild(o));
        })(e1), e1.removeAttribute("data-mce-caret"), e1.removeAttribute("data-mce-bogus"), e1.removeAttribute("style"), e1.removeAttribute("data-mce-style"), e1.removeAttribute("_moz_abspos"), e1) : null, Ki = (e1)=>Fi(e1.startContainer), Yi = Math.round, Gi = (e1)=>e1 ? {
            left: Yi(e1.left),
            top: Yi(e1.top),
            bottom: Yi(e1.bottom),
            right: Yi(e1.right),
            width: Yi(e1.width),
            height: Yi(e1.height)
        } : {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            width: 0,
            height: 0
        }, Xi = (e1, t)=>(e1 = Gi(e1), t || (e1.left = e1.left + e1.width), e1.right = e1.left, e1.width = 0, e1), Zi = (e1, t, n)=>e1 >= 0 && e1 <= Math.min(t.height, n.height) / 2, Qi = (e1, t)=>{
        const n = Math.min(t.height / 2, e1.height / 2);
        return e1.bottom - n < t.top || !(e1.top > t.bottom) && Zi(t.top - e1.bottom, e1, t);
    }, Ji = (e1, t)=>e1.top > t.bottom || !(e1.bottom < t.top) && Zi(t.bottom - e1.top, e1, t), el = (e1, t, n)=>{
        const o = Math.max(Math.min(t, e1.left + e1.width), e1.left), r = Math.max(Math.min(n, e1.top + e1.height), e1.top);
        return Math.sqrt((t - o) * (t - o) + (n - r) * (n - r));
    }, tl = (e1)=>{
        const t = e1.startContainer, n = e1.startOffset;
        return t === e1.endContainer && t.hasChildNodes() && e1.endOffset === n + 1 ? t.childNodes[n] : null;
    }, nl = (e1, t)=>{
        if (qr(e1) && e1.hasChildNodes()) {
            const n = e1.childNodes, o = ((e1, t, n)=>Math.min(Math.max(e1, 0), n))(t, 0, n.length - 1);
            return n[o];
        }
        return e1;
    }, ol = new RegExp("[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1abe\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20dd-\u20e0\u20e1\u20e2-\u20e4\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\ua670-\ua672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]"), rl = (e1)=>m(e1) && e1.charCodeAt(0) >= 768 && ol.test(e1), sl = ds, al = cs, il = as, ll = es, dl = Yr([
        "script",
        "style",
        "textarea"
    ]), cl = Yr([
        "img",
        "input",
        "textarea",
        "hr",
        "iframe",
        "video",
        "audio",
        "object",
        "embed"
    ]), ul = Yr([
        "table"
    ]), ml = zi, fl = (e1)=>!ml(e1) && (ll(e1) ? !dl(e1.parentNode) : cl(e1) || il(e1) || ul(e1) || gl(e1)), gl = (e1)=>!((e1)=>qr(e1) && "true" === e1.getAttribute("unselectable"))(e1) && al(e1), pl = (e1, t)=>fl(e1) && ((e1, t)=>{
            for(let n = e1.parentNode; n && n !== t; n = n.parentNode){
                if (gl(n)) return !1;
                if (sl(n)) return !0;
            }
            return !0;
        })(e1, t), hl = qr, bl = fl, vl = Gr("display", "block table"), yl = Gr("float", "left right"), Cl = ((...e1)=>(t)=>{
            for(let n = 0; n < e1.length; n++)if (!e1[n](t)) return !1;
            return !0;
        })(hl, bl, O(yl)), wl = O(Gr("white-space", "pre pre-line pre-wrap")), El = es, _l = as, xl = ni.nodeIndex, Sl = (e1, t)=>t < 0 && qr(e1) && e1.hasChildNodes() ? void 0 : nl(e1, t), kl = (e1)=>e1 ? e1.createRange() : ni.DOM.createRng(), Nl = (e1)=>m(e1) && /[\r\n\t ]/.test(e1), Rl = (e1)=>!!e1.setStart && !!e1.setEnd, Al = (e1)=>{
        const t = e1.startContainer, n = e1.startOffset;
        if (Nl(e1.toString()) && wl(t.parentNode) && es(t)) {
            const e1 = t.data;
            if (Nl(e1[n - 1]) || Nl(e1[n + 1])) return !0;
        }
        return !1;
    }, Tl = (e1)=>0 === e1.left && 0 === e1.right && 0 === e1.top && 0 === e1.bottom, Ol = (e1)=>{
        var t;
        let n;
        const o = e1.getClientRects();
        return n = o.length > 0 ? Gi(o[0]) : Gi(e1.getBoundingClientRect()), !Rl(e1) && _l(e1) && Tl(n) ? ((e1)=>{
            const t = e1.ownerDocument, n = kl(t), o = t.createTextNode(it), r = e1.parentNode;
            r.insertBefore(o, e1), n.setStart(o, 0), n.setEnd(o, 1);
            const s = Gi(n.getBoundingClientRect());
            return r.removeChild(o), s;
        })(e1) : Tl(n) && Rl(e1) && null !== (t = ((e1)=>{
            const t = e1.startContainer, n = e1.endContainer, o = e1.startOffset, r = e1.endOffset;
            if (t === n && es(n) && 0 === o && 1 === r) {
                const t = e1.cloneRange();
                return t.setEndAfter(n), Ol(t);
            }
            return null;
        })(e1)) && void 0 !== t ? t : n;
    }, Bl = (e1, t)=>{
        const n = Xi(e1, t);
        return n.width = 1, n.right = n.left + 1, n;
    }, Pl = (e1, t, n)=>{
        const o = ()=>(n || (n = ((e1)=>{
                const t = [], n = (e1)=>{
                    var n, o;
                    0 !== e1.height && (t.length > 0 && (n = e1, o = t[t.length - 1], n.left === o.left && n.top === o.top && n.bottom === o.bottom && n.right === o.right) || t.push(e1));
                }, o = (e1, t)=>{
                    const o = kl(e1.ownerDocument);
                    if (t < e1.data.length) {
                        if (rl(e1.data[t])) return;
                        if (rl(e1.data[t - 1]) && (o.setStart(e1, t), o.setEnd(e1, t + 1), !Al(o))) return void n(Bl(Ol(o), !1));
                    }
                    t > 0 && (o.setStart(e1, t - 1), o.setEnd(e1, t), Al(o) || n(Bl(Ol(o), !1))), t < e1.data.length && (o.setStart(e1, t), o.setEnd(e1, t + 1), Al(o) || n(Bl(Ol(o), !0)));
                }, r = e1.container(), s = e1.offset();
                if (El(r)) return o(r, s), t;
                if (hl(r)) {
                    if (e1.isAtEnd()) {
                        const e1 = Sl(r, s);
                        El(e1) && o(e1, e1.data.length), Cl(e1) && !_l(e1) && n(Bl(Ol(e1), !1));
                    } else {
                        const a = Sl(r, s);
                        if (El(a) && o(a, 0), Cl(a) && e1.isAtEnd()) return n(Bl(Ol(a), !1)), t;
                        const i = Sl(e1.container(), e1.offset() - 1);
                        Cl(i) && !_l(i) && (vl(i) || vl(a) || !Cl(a)) && n(Bl(Ol(i), !1)), Cl(a) && n(Bl(Ol(a), !0));
                    }
                }
                return t;
            })(Pl(e1, t))), n);
        return {
            container: N(e1),
            offset: N(t),
            toRange: ()=>{
                const n = kl(e1.ownerDocument);
                return n.setStart(e1, t), n.setEnd(e1, t), n;
            },
            getClientRects: o,
            isVisible: ()=>o().length > 0,
            isAtStart: ()=>(El(e1), 0 === t),
            isAtEnd: ()=>El(e1) ? t >= e1.data.length : t >= e1.childNodes.length,
            isEqual: (n)=>n && e1 === n.container() && t === n.offset(),
            getNode: (n)=>Sl(e1, n ? t - 1 : t)
        };
    };
    Pl.fromRangeStart = (e1)=>Pl(e1.startContainer, e1.startOffset), Pl.fromRangeEnd = (e1)=>Pl(e1.endContainer, e1.endOffset), Pl.after = (e1)=>Pl(e1.parentNode, xl(e1) + 1), Pl.before = (e1)=>Pl(e1.parentNode, xl(e1)), Pl.isAbove = (e1, t)=>ze(le(t.getClientRects()), de(e1.getClientRects()), Qi).getOr(!1), Pl.isBelow = (e1, t)=>ze(de(t.getClientRects()), le(e1.getClientRects()), Ji).getOr(!1), Pl.isAtStart = (e1)=>!!e1 && e1.isAtStart(), Pl.isAtEnd = (e1)=>!!e1 && e1.isAtEnd(), Pl.isTextPosition = (e1)=>!!e1 && es(e1.container()), Pl.isElementPosition = (e1)=>!Pl.isTextPosition(e1);
    const Dl = (e1, t)=>{
        es(t) && 0 === t.data.length && e1.remove(t);
    }, Ll = (e1, t, n)=>{
        ss(n) ? ((e1, t, n)=>{
            const o = I.from(n.firstChild), r = I.from(n.lastChild);
            t.insertNode(n), o.each((t)=>Dl(e1, t.previousSibling)), r.each((t)=>Dl(e1, t.nextSibling));
        })(e1, t, n) : ((e1, t, n)=>{
            t.insertNode(n), Dl(e1, n.previousSibling), Dl(e1, n.nextSibling);
        })(e1, t, n);
    }, Ml = es, Il = Xr, Fl = ni.nodeIndex, Ul = (e1)=>{
        const t = e1.parentNode;
        return Il(t) ? Ul(t) : t;
    }, zl = (e1)=>e1 ? pt(e1.childNodes, (e1, t)=>(Il(t) && "BR" !== t.nodeName ? e1 = e1.concat(zl(t)) : e1.push(t), e1), []) : [], jl = (e1)=>(t)=>e1 === t, Hl = (e1)=>(Ml(e1) ? "text()" : e1.nodeName.toLowerCase()) + "[" + ((e1)=>{
            let t, n;
            t = zl(Ul(e1)), n = ht(t, jl(e1), e1), t = t.slice(0, n + 1);
            const o = pt(t, (e1, n, o)=>(Ml(n) && Ml(t[o - 1]) && e1++, e1), 0);
            return t = gt(t, Yr([
                e1.nodeName
            ])), n = ht(t, jl(e1), e1), n - o;
        })(e1) + "]", $l = (e1, t)=>{
        let n, o = [], r = t.container(), s = t.offset();
        if (Ml(r)) n = ((e1, t)=>{
            let n = e1;
            for(; (n = n.previousSibling) && Ml(n);)t += n.data.length;
            return t;
        })(r, s);
        else {
            const e1 = r.childNodes;
            s >= e1.length ? (n = "after", s = e1.length - 1) : n = "before", r = e1[s];
        }
        o.push(Hl(r));
        let a = ((e1, t)=>{
            const n = [];
            for(let o = t.parentNode; o && o !== e1; o = o.parentNode)n.push(o);
            return n;
        })(e1, r);
        return a = gt(a, O(Xr)), o = o.concat(ft(a, (e1)=>Hl(e1))), o.reverse().join("/") + "," + n;
    }, Vl = (e1, t)=>{
        if (!t) return null;
        const n = t.split(","), o = n[0].split("/"), r = n.length > 1 ? n[1] : "before", s = pt(o, (e1, t)=>{
            const n = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(t);
            return n ? ("text()" === n[1] && (n[1] = "#text"), ((e1, t, n)=>{
                let o = zl(e1);
                return o = gt(o, (e1, t)=>!Ml(e1) || !Ml(o[t - 1])), o = gt(o, Yr([
                    t
                ])), o[n];
            })(e1, n[1], parseInt(n[2], 10))) : null;
        }, e1);
        if (!s) return null;
        if (!Ml(s) && s.parentNode) {
            let e1;
            return e1 = "after" === r ? Fl(s) + 1 : Fl(s), Pl(s.parentNode, e1);
        }
        return ((e1, t)=>{
            let n = e1, o = 0;
            for(; Ml(n);){
                const r = n.data.length;
                if (t >= o && t <= o + r) {
                    e1 = n, t -= o;
                    break;
                }
                if (!Ml(n.nextSibling)) {
                    e1 = n, t = r;
                    break;
                }
                o += r, n = n.nextSibling;
            }
            return Ml(e1) && t > e1.data.length && (t = e1.data.length), Pl(e1, t);
        })(s, parseInt(r, 10));
    }, ql = cs, Wl = (e1, t, n, o, r)=>{
        const s = r ? o.startContainer : o.endContainer;
        let a = r ? o.startOffset : o.endOffset;
        const i = [], l = e1.getRoot();
        if (es(s)) i.push(n ? ((e1, t, n)=>{
            let o = e1(t.data.slice(0, n)).length;
            for(let n = t.previousSibling; n && es(n); n = n.previousSibling)o += e1(n.data).length;
            return o;
        })(t, s, a) : a);
        else {
            let t = 0;
            const o = s.childNodes;
            a >= o.length && o.length && (t = 1, a = Math.max(0, o.length - 1)), i.push(e1.nodeIndex(o[a], n) + t);
        }
        for(let t = s; t && t !== l; t = t.parentNode)i.push(e1.nodeIndex(t, n));
        return i;
    }, Kl = (e1, t, n)=>{
        let o = 0;
        return an.each(e1.select(t), (e1)=>"all" === e1.getAttribute("data-mce-bogus") ? void 0 : e1 !== n && void o++), o;
    }, Yl = (e1, t)=>{
        let n = t ? e1.startContainer : e1.endContainer, o = t ? e1.startOffset : e1.endOffset;
        if (qr(n) && "TR" === n.nodeName) {
            const r = n.childNodes;
            n = r[Math.min(t ? o : o - 1, r.length - 1)], n && (o = t ? 0 : n.childNodes.length, t ? e1.setStart(n, o) : e1.setEnd(n, o));
        }
    }, Gl = (e1)=>(Yl(e1, !0), Yl(e1, !1), e1), Xl = (e1, t)=>{
        if (qr(e1) && (e1 = nl(e1, t), ql(e1))) return e1;
        if (zi(e1)) {
            es(e1) && Fi(e1) && (e1 = e1.parentNode);
            let t = e1.previousSibling;
            if (ql(t)) return t;
            if (t = e1.nextSibling, ql(t)) return t;
        }
    }, Zl = (e1, t, n)=>{
        const o = n.getNode(), r = n.getRng();
        if ("IMG" === o.nodeName || ql(o)) {
            const e1 = o.nodeName;
            return {
                name: e1,
                index: Kl(n.dom, e1, o)
            };
        }
        const s = ((e1)=>Xl(e1.startContainer, e1.startOffset) || Xl(e1.endContainer, e1.endOffset))(r);
        if (s) {
            const e1 = s.tagName;
            return {
                name: e1,
                index: Kl(n.dom, e1, s)
            };
        }
        return ((e1, t, n, o)=>{
            const r = t.dom, s = Wl(r, e1, n, o, !0), a = t.isForward(), i = Ki(o) ? {
                isFakeCaret: !0
            } : {};
            return t.isCollapsed() ? {
                start: s,
                forward: a,
                ...i
            } : {
                start: s,
                end: Wl(r, e1, n, o, !1),
                forward: a,
                ...i
            };
        })(e1, n, t, r);
    }, Ql = (e1, t, n)=>{
        const o = {
            "data-mce-type": "bookmark",
            id: t,
            style: "overflow:hidden;line-height:0px"
        };
        return n ? e1.create("span", o, "&#xFEFF;") : e1.create("span", o);
    }, Jl = (e1, t)=>{
        const n = e1.dom;
        let o = e1.getRng();
        const r = n.uniqueId(), s = e1.isCollapsed(), a = e1.getNode(), i = a.nodeName, l = e1.isForward();
        if ("IMG" === i) return {
            name: i,
            index: Kl(n, i, a)
        };
        const d = Gl(o.cloneRange());
        if (!s) {
            d.collapse(!1);
            const e1 = Ql(n, r + "_end", t);
            Ll(n, d, e1);
        }
        o = Gl(o), o.collapse(!0);
        const c = Ql(n, r + "_start", t);
        return Ll(n, o, c), e1.moveToBookmark({
            id: r,
            keep: !0,
            forward: l
        }), {
            id: r,
            forward: l
        };
    }, ed = T(Zl, R, !0), td = (e1)=>"inline-command" === e1.type || "inline-format" === e1.type, nd = (e1)=>"block-command" === e1.type || "block-format" === e1.type, od = (e1)=>{
        var t;
        const n = (t)=>Te.error({
                message: t,
                pattern: e1
            }), o = (t, o, r)=>{
            if (void 0 !== e1.format) {
                let r;
                if (p(e1.format)) {
                    if (!ne(e1.format, m)) return n(t + " pattern has non-string items in the `format` array");
                    r = e1.format;
                } else {
                    if (!m(e1.format)) return n(t + " pattern has non-string `format` parameter");
                    r = [
                        e1.format
                    ];
                }
                return Te.value(o(r));
            }
            return void 0 !== e1.cmd ? m(e1.cmd) ? Te.value(r(e1.cmd, e1.value)) : n(t + " pattern has non-string `cmd` parameter") : n(t + " pattern is missing both `format` and `cmd` parameters");
        };
        if (!f(e1)) return n("Raw pattern is not an object");
        if (!m(e1.start)) return n("Raw pattern is missing `start` parameter");
        if (void 0 !== e1.end) {
            if (!m(e1.end)) return n("Inline pattern has non-string `end` parameter");
            if (0 === e1.start.length && 0 === e1.end.length) return n("Inline pattern has empty `start` and `end` parameters");
            let t = e1.start, r = e1.end;
            return 0 === r.length && (r = t, t = ""), o("Inline", (e1)=>({
                    type: "inline-format",
                    start: t,
                    end: r,
                    format: e1
                }), (e1, n)=>({
                    type: "inline-command",
                    start: t,
                    end: r,
                    cmd: e1,
                    value: n
                }));
        }
        if (void 0 !== e1.replacement) return m(e1.replacement) ? 0 === e1.start.length ? n("Replacement pattern has empty `start` parameter") : Te.value({
            type: "inline-command",
            start: "",
            end: e1.start,
            cmd: "mceInsertContent",
            value: e1.replacement
        }) : n("Replacement pattern has non-string `replacement` parameter");
        {
            const r = null !== (t = e1.trigger) && void 0 !== t ? t : "space";
            return 0 === e1.start.length ? n("Block pattern has empty `start` parameter") : o("Block", (t)=>({
                    type: "block-format",
                    start: e1.start,
                    format: t[0],
                    trigger: r
                }), (t, n)=>({
                    type: "block-command",
                    start: e1.start,
                    cmd: t,
                    value: n,
                    trigger: r
                }));
        }
    }, rd = (e1)=>Y(e1, nd), sd = (e1)=>Y(e1, td), ad = (e1, t)=>({
            ...e1,
            blockPatterns: Y(e1.blockPatterns, (e1)=>((e1, t)=>("block-command" === e1.type || "block-format" === e1.type) && e1.trigger === t)(e1, t))
        }), id = (e1)=>{
        const t = ((e1)=>{
            const t = [], n = [];
            return q(e1, (e1)=>{
                e1.fold((e1)=>{
                    t.push(e1);
                }, (e1)=>{
                    n.push(e1);
                });
            }), {
                errors: t,
                values: n
            };
        })(V(e1, od));
        return q(t.errors, (e1)=>console.error(e1.message, e1.pattern)), t.values;
    }, ld = (e1, t, n)=>{
        e1.dispatch(t, n);
    }, dd = (e1, t, n, o)=>{
        e1.dispatch("FormatApply", {
            format: t,
            node: n,
            vars: o
        });
    }, cd = (e1, t, n, o)=>{
        e1.dispatch("FormatRemove", {
            format: t,
            node: n,
            vars: o
        });
    }, ud = (e1, t)=>e1.dispatch("SetContent", t), md = (e1, t)=>e1.dispatch("GetContent", t), fd = (e1, t)=>{
        e1.dispatch("AutocompleterUpdateActiveRange", t);
    }, gd = (e1, t)=>e1.dispatch("PastePlainTextToggle", {
            state: t
        }), pd = Kt().deviceType, hd = pd.isTouch(), bd = ni.DOM, vd = (e1)=>u(e1, RegExp), yd = (e1)=>(t)=>t.options.get(e1), Cd = (e1)=>m(e1) || f(e1), wd = (e1, t = "")=>(n)=>{
            const o = m(n);
            if (o) {
                if (-1 !== n.indexOf("=")) {
                    const r = ((e1)=>{
                        const t = e1.indexOf("=") > 0 ? e1.split(/[;,](?![^=;,]*(?:[;,]|$))/) : e1.split(",");
                        return X(t, (e1, t)=>{
                            const n = t.split("="), o = n[0], r = n.length > 1 ? n[1] : o;
                            return e1[Ze(o)] = Ze(r), e1;
                        }, {});
                    })(n);
                    return {
                        value: _e(r, e1.id).getOr(t),
                        valid: o
                    };
                }
                return {
                    value: n,
                    valid: o
                };
            }
            return {
                valid: !1,
                message: "Must be a string."
            };
        }, Ed = yd("iframe_attrs"), _d = yd("doctype"), xd = yd("document_base_url"), Sd = yd("body_id"), kd = yd("body_class"), Nd = yd("content_security_policy"), Rd = yd("br_in_pre"), Ad = yd("forced_root_block"), Td = yd("forced_root_block_attrs"), Od = yd("newline_behavior"), Bd = yd("br_newline_selector"), Pd = yd("no_newline_selector"), Dd = yd("keep_styles"), Ld = yd("end_container_on_empty_block"), Md = yd("automatic_uploads"), Id = yd("images_reuse_filename"), Fd = yd("images_replace_blob_uris"), Ud = yd("icons"), zd = yd("icons_url"), jd = yd("images_upload_url"), Hd = yd("images_upload_base_path"), $d = yd("images_upload_credentials"), Vd = yd("images_upload_handler"), qd = yd("content_css_cors"), Wd = yd("referrer_policy"), Kd = yd("language"), Yd = yd("language_url"), Gd = yd("indent_use_margin"), Xd = yd("indentation"), Zd = yd("content_css"), Qd = yd("content_style"), Jd = yd("font_css"), ec = yd("directionality"), tc = yd("inline_boundaries_selector"), nc = yd("object_resizing"), oc = yd("resize_img_proportional"), rc = yd("placeholder"), sc = yd("event_root"), ac = yd("service_message"), ic = yd("theme"), lc = yd("theme_url"), dc = yd("model"), cc = yd("model_url"), uc = yd("inline_boundaries"), mc = yd("formats"), fc = yd("preview_styles"), gc = yd("format_empty_lines"), pc = yd("format_noneditable_selector"), hc = yd("custom_ui_selector"), bc = yd("inline"), vc = yd("hidden_input"), yc = yd("submit_patch"), Cc = yd("add_form_submit_trigger"), wc = yd("add_unload_trigger"), Ec = yd("custom_undo_redo_levels"), _c = yd("disable_nodechange"), xc = yd("readonly"), Sc = yd("editable_root"), kc = yd("content_css_cors"), Nc = yd("plugins"), Rc = yd("external_plugins"), Ac = yd("block_unsupported_drop"), Tc = yd("visual"), Oc = yd("visual_table_class"), Bc = yd("visual_anchor_class"), Pc = yd("iframe_aria_text"), Dc = yd("setup"), Lc = yd("init_instance_callback"), Mc = yd("urlconverter_callback"), Ic = yd("auto_focus"), Fc = yd("browser_spellcheck"), Uc = yd("protect"), zc = yd("paste_block_drop"), jc = yd("paste_data_images"), Hc = yd("paste_preprocess"), $c = yd("paste_postprocess"), Vc = yd("newdocument_content"), qc = yd("paste_webkit_styles"), Wc = yd("paste_remove_styles_if_webkit"), Kc = yd("paste_merge_formats"), Yc = yd("smart_paste"), Gc = yd("paste_as_text"), Xc = yd("paste_tab_spaces"), Zc = yd("allow_html_data_urls"), Qc = yd("text_patterns"), Jc = yd("text_patterns_lookup"), eu = yd("noneditable_class"), tu = yd("editable_class"), nu = yd("noneditable_regexp"), ou = yd("preserve_cdata"), ru = yd("highlight_on_focus"), su = yd("xss_sanitization"), au = yd("init_content_sync"), iu = (e1)=>an.explode(e1.options.get("images_file_types")), lu = yd("table_tab_navigation"), du = yd("details_initial_state"), cu = yd("details_serialized_state"), uu = yd("sandbox_iframes"), mu = (e1)=>e1.options.get("sandbox_iframes_exclusions"), fu = yd("convert_unsafe_embeds"), gu = yd("license_key"), pu = yd("api_key"), hu = yd("disabled"), bu = qr, vu = es, yu = (e1)=>{
        const t = e1.parentNode;
        t && t.removeChild(e1);
    }, Cu = (e1)=>{
        const t = Li(e1);
        return {
            count: e1.length - t.length,
            text: t
        };
    }, wu = (e1)=>{
        let t;
        for(; -1 !== (t = e1.data.lastIndexOf(Pi));)e1.deleteData(t, 1);
    }, Eu = (e1, t)=>(xu(e1), t), _u = (e1, t)=>Pl.isTextPosition(t) ? ((e1, t)=>vu(e1) && t.container() === e1 ? ((e1, t)=>{
                const n = Cu(e1.data.substr(0, t.offset())), o = Cu(e1.data.substr(t.offset()));
                return (n.text + o.text).length > 0 ? (wu(e1), Pl(e1, t.offset() - n.count)) : t;
            })(e1, t) : Eu(e1, t))(e1, t) : ((e1, t)=>t.container() === e1.parentNode ? ((e1, t)=>{
                const n = t.container(), o = ((e1, t)=>{
                    const n = j(e1, t);
                    return -1 === n ? I.none() : I.some(n);
                })(ce(n.childNodes), e1).map((e1)=>e1 < t.offset() ? Pl(n, t.offset() - 1) : t).getOr(t);
                return xu(e1), o;
            })(e1, t) : Eu(e1, t))(e1, t), xu = (e1)=>{
        bu(e1) && zi(e1) && (ji(e1) ? e1.removeAttribute("data-mce-caret") : yu(e1)), vu(e1) && (wu(e1), 0 === e1.data.length && yu(e1));
    }, Su = cs, ku = gs, Nu = ms, Ru = (e1, t, n)=>{
        const o = Xi(t.getBoundingClientRect(), n);
        let r, s;
        if ("BODY" === e1.tagName) {
            const t = e1.ownerDocument.documentElement;
            r = e1.scrollLeft || t.scrollLeft, s = e1.scrollTop || t.scrollTop;
        } else {
            const t = e1.getBoundingClientRect();
            r = e1.scrollLeft - t.left, s = e1.scrollTop - t.top;
        }
        o.left += r, o.right += r, o.top += s, o.bottom += s, o.width = 1;
        let a = t.offsetWidth - t.clientWidth;
        return a > 0 && (n && (a *= -1), o.left += a, o.right += a), o;
    }, Au = (e1, t, n, o)=>{
        const r = Ve();
        let s, a;
        const i = Ad(e1), l = e1.dom, d = ()=>{
            ((e1)=>{
                var t, n;
                const o = vr(mn(e1), "*[contentEditable=false],video,audio,embed,object");
                for(let e1 = 0; e1 < o.length; e1++){
                    const r = o[e1].dom;
                    let s = r.previousSibling;
                    if (qi(s)) {
                        const e1 = s.data;
                        1 === e1.length ? null === (t = s.parentNode) || void 0 === t || t.removeChild(s) : s.deleteData(e1.length - 1, 1);
                    }
                    s = r.nextSibling, Vi(s) && (1 === s.data.length ? null === (n = s.parentNode) || void 0 === n || n.removeChild(s) : s.deleteData(0, 1));
                }
            })(t), a && (xu(a), a = null), r.on((e1)=>{
                l.remove(e1.caret), r.clear();
            }), s && (clearInterval(s), s = void 0);
        };
        return {
            isShowing: r.isSet,
            show: (e1, c)=>{
                let u;
                if (d(), Nu(c)) return null;
                if (!n(c)) return a = ((e1, t)=>{
                    var n;
                    const o = (null !== (n = e1.ownerDocument) && void 0 !== n ? n : document).createTextNode(Pi), r = e1.parentNode;
                    if (t) {
                        const t = e1.previousSibling;
                        if (Ii(t)) {
                            if (zi(t)) return t;
                            if (qi(t)) return t.splitText(t.data.length - 1);
                        }
                        null == r || r.insertBefore(o, e1);
                    } else {
                        const t = e1.nextSibling;
                        if (Ii(t)) {
                            if (zi(t)) return t;
                            if (Vi(t)) return t.splitText(1), t;
                        }
                        e1.nextSibling ? null == r || r.insertBefore(o, e1.nextSibling) : null == r || r.appendChild(o);
                    }
                    return o;
                })(c, e1), u = c.ownerDocument.createRange(), Ou(a.nextSibling) ? (u.setStart(a, 0), u.setEnd(a, 0)) : (u.setStart(a, 1), u.setEnd(a, 1)), u;
                {
                    const n = ((e1, t, n)=>{
                        var o;
                        const r = (null !== (o = t.ownerDocument) && void 0 !== o ? o : document).createElement(e1);
                        r.setAttribute("data-mce-caret", n ? "before" : "after"), r.setAttribute("data-mce-bogus", "all"), r.appendChild(Oi().dom);
                        const s = t.parentNode;
                        return n ? null == s || s.insertBefore(r, t) : t.nextSibling ? null == s || s.insertBefore(r, t.nextSibling) : null == s || s.appendChild(r), r;
                    })(i, c, e1), d = Ru(t, c, e1);
                    l.setStyle(n, "top", d.top), l.setStyle(n, "caret-color", "transparent"), a = n;
                    const m = l.create("div", {
                        class: "mce-visual-caret",
                        "data-mce-bogus": "all"
                    });
                    l.setStyles(m, {
                        ...d
                    }), l.add(t, m), r.set({
                        caret: m,
                        element: c,
                        before: e1
                    }), e1 && l.addClass(m, "mce-visual-caret-before"), s = window.setInterval(()=>{
                        r.on((e1)=>{
                            o() ? l.toggleClass(e1.caret, "mce-visual-caret-hidden") : l.addClass(e1.caret, "mce-visual-caret-hidden");
                        });
                    }, 500), u = c.ownerDocument.createRange(), u.setStart(n, 0), u.setEnd(n, 0);
                }
                return u;
            },
            hide: d,
            getCss: ()=>".mce-visual-caret {position: absolute;background-color: black;background-color: currentcolor;}.mce-visual-caret-hidden {display: none;}*[data-mce-caret] {position: absolute;left: -1000px;right: auto;top: 0;margin: 0;padding: 0;}",
            reposition: ()=>{
                r.on((e1)=>{
                    const n = Ru(t, e1.element, e1.before);
                    l.setStyles(e1.caret, {
                        ...n
                    });
                });
            },
            destroy: ()=>clearInterval(s)
        };
    }, Tu = ()=>nn.browser.isFirefox(), Ou = (e1)=>Su(e1) || ku(e1), Bu = (e1)=>(Ou(e1) || Zr(e1) && Tu()) && Mn(mn(e1)).exists(gr), Pu = ds, Du = cs, Lu = gs, Mu = Gr("display", "block table table-cell table-row table-caption list-item"), Iu = zi, Fu = Fi, Uu = qr, zu = es, ju = fl, Hu = (e1)=>1 === e1, $u = (e1)=>-1 === e1, Vu = (e1, t)=>{
        let n;
        for(; n = e1(t);)if (!Fu(n)) return n;
        return null;
    }, qu = (e1, t, n, o, r)=>{
        const s = new Fr(e1, o), a = Du(e1) || Fu(e1);
        let i;
        if ($u(t)) {
            if (a && (i = Vu(s.prev.bind(s), !0), n(i))) return i;
            for(; i = Vu(s.prev.bind(s), r);)if (n(i)) return i;
        }
        if (Hu(t)) {
            if (a && (i = Vu(s.next.bind(s), !0), n(i))) return i;
            for(; i = Vu(s.next.bind(s), r);)if (n(i)) return i;
        }
        return null;
    }, Wu = (e1, t)=>{
        for(; e1 && e1 !== t;){
            if (Mu(e1)) return e1;
            e1 = e1.parentNode;
        }
        return null;
    }, Ku = (e1, t, n)=>Wu(e1.container(), n) === Wu(t.container(), n), Yu = (e1, t)=>{
        if (!t) return I.none();
        const n = t.container(), o = t.offset();
        return Uu(n) ? I.from(n.childNodes[o + e1]) : I.none();
    }, Gu = (e1, t)=>{
        var n;
        const o = (null !== (n = t.ownerDocument) && void 0 !== n ? n : document).createRange();
        return e1 ? (o.setStartBefore(t), o.setEndBefore(t)) : (o.setStartAfter(t), o.setEndAfter(t)), o;
    }, Xu = (e1, t, n)=>Wu(t, e1) === Wu(n, e1), Zu = (e1, t, n)=>{
        const o = e1 ? "previousSibling" : "nextSibling";
        let r = n;
        for(; r && r !== t;){
            let e1 = r[o];
            if (e1 && Iu(e1) && (e1 = e1[o]), Du(e1) || Lu(e1)) {
                if (Xu(t, e1, r)) return e1;
                break;
            }
            if (ju(e1)) break;
            r = r.parentNode;
        }
        return null;
    }, Qu = T(Gu, !0), Ju = T(Gu, !1), em = (e1, t, n)=>{
        let o;
        const r = T(Zu, !0, t), s = T(Zu, !1, t), a = n.startContainer, i = n.startOffset;
        if (Fi(a)) {
            const e1 = zu(a) ? a.parentNode : a, t = e1.getAttribute("data-mce-caret");
            if ("before" === t && (o = e1.nextSibling, Bu(o))) return Qu(o);
            if ("after" === t && (o = e1.previousSibling, Bu(o))) return Ju(o);
        }
        if (!n.collapsed) return n;
        if (es(a)) {
            if (Iu(a)) {
                if (1 === e1) {
                    if (o = s(a), o) return Qu(o);
                    if (o = r(a), o) return Ju(o);
                }
                if (-1 === e1) {
                    if (o = r(a), o) return Ju(o);
                    if (o = s(a), o) return Qu(o);
                }
                return n;
            }
            if (qi(a) && i >= a.data.length - 1) return 1 === e1 && (o = s(a), o) ? Qu(o) : n;
            if (Vi(a) && i <= 1) return -1 === e1 && (o = r(a), o) ? Ju(o) : n;
            if (i === a.data.length) return o = s(a), o ? Qu(o) : n;
            if (0 === i) return o = r(a), o ? Ju(o) : n;
        }
        return n;
    }, tm = (e1, t)=>Yu(e1 ? 0 : -1, t).filter(Du), nm = (e1, t, n)=>{
        const o = em(e1, t, n);
        return -1 === e1 ? Pl.fromRangeStart(o) : Pl.fromRangeEnd(o);
    }, om = (e1)=>I.from(e1.getNode()).map(mn), rm = (e1, t)=>{
        let n = t;
        for(; n = e1(n);)if (n.isVisible()) return n;
        return n;
    }, sm = (e1, t)=>{
        const n = Ku(e1, t);
        return !(n || !as(e1.getNode())) || n;
    }, am = cs, im = es, lm = qr, dm = as, cm = fl, um = (e1)=>cl(e1) || ((e1)=>!!gl(e1) && !X(ce(e1.getElementsByTagName("*")), (e1, t)=>e1 || sl(t), !1))(e1), mm = pl, fm = (e1, t)=>e1.hasChildNodes() && t < e1.childNodes.length ? e1.childNodes[t] : null, gm = (e1, t)=>{
        if (Hu(e1)) {
            if (cm(t.previousSibling) && !im(t.previousSibling)) return Pl.before(t);
            if (im(t)) return Pl(t, 0);
        }
        if ($u(e1)) {
            if (cm(t.nextSibling) && !im(t.nextSibling)) return Pl.after(t);
            if (im(t)) return Pl(t, t.data.length);
        }
        return $u(e1) ? dm(t) ? Pl.before(t) : Pl.after(t) : Pl.before(t);
    }, pm = (e1, t, n)=>{
        let o, r, s, a;
        if (!lm(n) || !t) return null;
        if (t.isEqual(Pl.after(n)) && n.lastChild) {
            if (a = Pl.after(n.lastChild), $u(e1) && cm(n.lastChild) && lm(n.lastChild)) return dm(n.lastChild) ? Pl.before(n.lastChild) : a;
        } else a = t;
        const i = a.container();
        let l = a.offset();
        if (im(i)) {
            if ($u(e1) && l > 0) return Pl(i, --l);
            if (Hu(e1) && l < i.length) return Pl(i, ++l);
            o = i;
        } else {
            if ($u(e1) && l > 0 && (r = fm(i, l - 1), cm(r))) return !um(r) && (s = qu(r, e1, mm, r), s) ? im(s) ? Pl(s, s.data.length) : Pl.after(s) : im(r) ? Pl(r, r.data.length) : Pl.before(r);
            if (Hu(e1) && l < i.childNodes.length && (r = fm(i, l), cm(r))) return dm(r) ? ((e1, t)=>{
                const n = t.nextSibling;
                return n && cm(n) ? im(n) ? Pl(n, 0) : Pl.before(n) : pm(1, Pl.after(t), e1);
            })(n, r) : !um(r) && (s = qu(r, e1, mm, r), s) ? im(s) ? Pl(s, 0) : Pl.before(s) : im(r) ? Pl(r, 0) : Pl.after(r);
            o = r || a.getNode();
        }
        if (o && (Hu(e1) && a.isAtEnd() || $u(e1) && a.isAtStart()) && (o = qu(o, e1, M, n, !0), mm(o, n))) return gm(e1, o);
        r = o ? qu(o, e1, mm, n) : o;
        const d = bt(Y(((e1, t)=>{
            const n = [];
            let o = e1;
            for(; o && o !== t;)n.push(o), o = o.parentNode;
            return n;
        })(i, n), am));
        return !d || r && d.contains(r) ? r ? gm(e1, r) : null : (a = Hu(e1) ? Pl.after(d) : Pl.before(d), a);
    }, hm = (e1)=>({
            next: (t)=>pm(1, t, e1),
            prev: (t)=>pm(-1, t, e1)
        }), bm = (e1)=>Pl.isTextPosition(e1) ? 0 === e1.offset() : fl(e1.getNode()), vm = (e1)=>{
        if (Pl.isTextPosition(e1)) {
            const t = e1.container();
            return e1.offset() === t.data.length;
        }
        return fl(e1.getNode(!0));
    }, ym = (e1, t)=>!Pl.isTextPosition(e1) && !Pl.isTextPosition(t) && e1.getNode() === t.getNode(!0), Cm = (e1, t, n)=>{
        const o = hm(t);
        return I.from(e1 ? o.next(n) : o.prev(n));
    }, wm = (e1, t, n)=>Cm(e1, t, n).bind((o)=>Ku(n, o, t) && ((e1, t, n)=>{
                var o;
                return e1 ? !ym(t, n) && (o = t, !(!Pl.isTextPosition(o) && as(o.getNode()))) && vm(t) && bm(n) : !ym(n, t) && bm(t) && vm(n);
            })(e1, n, o) ? Cm(e1, t, o) : I.some(o)), Em = (e1, t, n, o)=>wm(e1, t, n).bind((n)=>o(n) ? Em(e1, t, n, o) : I.some(n)), _m = (e1, t)=>{
        const n = e1 ? t.firstChild : t.lastChild;
        var o;
        return es(n) ? I.some(Pl(n, e1 ? 0 : n.data.length)) : n ? fl(n) ? I.some(e1 ? Pl.before(n) : as(o = n) ? Pl.before(o) : Pl.after(o)) : ((e1, t, n)=>{
            const o = e1 ? Pl.before(n) : Pl.after(n);
            return Cm(e1, t, o);
        })(e1, t, n) : I.none();
    }, xm = T(Cm, !0), Sm = T(Cm, !1), km = T(_m, !0), Nm = T(_m, !1), Rm = "_mce_caret", Am = (e1)=>qr(e1) && e1.id === Rm, Tm = (e1, t)=>{
        let n = t;
        for(; n && n !== e1;){
            if (Am(n)) return n;
            n = n.parentNode;
        }
        return null;
    }, Om = (e1)=>xe(e1, "name"), Bm = (e1)=>an.isArray(e1.start), Pm = (e1)=>!(!Om(e1) && b(e1.forward)) || e1.forward, Dm = (e1, t)=>(qr(t) && e1.isBlock(t) && !t.innerHTML && (t.innerHTML = '<br data-mce-bogus="1" />'), t), Lm = (e1, t)=>Nm(e1).fold(L, (e1)=>(t.setStart(e1.container(), e1.offset()), t.setEnd(e1.container(), e1.offset()), !0)), Mm = (e1, t, n)=>!(!((e1)=>!e1.hasChildNodes())(t) || !Tm(e1, t) || (((e1, t)=>{
            var n;
            const o = (null !== (n = e1.ownerDocument) && void 0 !== n ? n : document).createTextNode(Pi);
            e1.appendChild(o), t.setStart(o, 0), t.setEnd(o, 0);
        })(t, n), 0)), Im = (e1, t, n, o)=>{
        const r = n[t ? "start" : "end"], s = e1.getRoot();
        if (r) {
            let e1 = s, n = r[0];
            for(let t = r.length - 1; e1 && t >= 1; t--){
                const n = e1.childNodes;
                if (Mm(s, e1, o)) return !0;
                if (r[t] > n.length - 1) return !!Mm(s, e1, o) || Lm(e1, o);
                e1 = n[r[t]];
            }
            es(e1) && (n = Math.min(r[0], e1.data.length)), qr(e1) && (n = Math.min(r[0], e1.childNodes.length)), t ? o.setStart(e1, n) : o.setEnd(e1, n);
        }
        return !0;
    }, Fm = (e1)=>es(e1) && e1.data.length > 0, Um = (e1, t, n)=>{
        const o = e1.get(n.id + "_" + t), r = null == o ? void 0 : o.parentNode, s = n.keep;
        if (o && r) {
            let a, i;
            if ("start" === t ? s ? o.hasChildNodes() ? (a = o.firstChild, i = 1) : Fm(o.nextSibling) ? (a = o.nextSibling, i = 0) : Fm(o.previousSibling) ? (a = o.previousSibling, i = o.previousSibling.data.length) : (a = r, i = e1.nodeIndex(o) + 1) : (a = r, i = e1.nodeIndex(o)) : s ? o.hasChildNodes() ? (a = o.firstChild, i = 1) : Fm(o.previousSibling) ? (a = o.previousSibling, i = o.previousSibling.data.length) : (a = r, i = e1.nodeIndex(o)) : (a = r, i = e1.nodeIndex(o)), !s) {
                const r = o.previousSibling, s = o.nextSibling;
                let l;
                for(an.each(an.grep(o.childNodes), (e1)=>{
                    es(e1) && (e1.data = e1.data.replace(/\uFEFF/g, ""));
                }); l = e1.get(n.id + "_" + t);)e1.remove(l, !0);
                if (es(s) && es(r) && !nn.browser.isOpera()) {
                    const t = r.data.length;
                    r.appendData(s.data), e1.remove(s), a = r, i = t;
                }
            }
            return I.some(Pl(a, i));
        }
        return I.none();
    }, zm = (e1, t, n)=>((e1, t, n = !1)=>2 === t ? Zl(Li, n, e1) : 3 === t ? ((e1)=>{
                const t = e1.getRng();
                return {
                    start: $l(e1.dom.getRoot(), Pl.fromRangeStart(t)),
                    end: $l(e1.dom.getRoot(), Pl.fromRangeEnd(t)),
                    forward: e1.isForward()
                };
            })(e1) : t ? ((e1)=>({
                    rng: e1.getRng(),
                    forward: e1.isForward()
                }))(e1) : Jl(e1, !1))(e1, t, n), jm = (e1, t)=>{
        ((e1, t)=>{
            const n = e1.dom;
            if (t) {
                if (Bm(t)) return ((e1, t)=>{
                    const n = e1.createRng();
                    return Im(e1, !0, t, n) && Im(e1, !1, t, n) ? I.some({
                        range: n,
                        forward: Pm(t)
                    }) : I.none();
                })(n, t);
                if (((e1)=>m(e1.start))(t)) return ((e1, t)=>{
                    const n = I.from(Vl(e1.getRoot(), t.start)), o = I.from(Vl(e1.getRoot(), t.end));
                    return ze(n, o, (n, o)=>{
                        const r = e1.createRng();
                        return r.setStart(n.container(), n.offset()), r.setEnd(o.container(), o.offset()), {
                            range: r,
                            forward: Pm(t)
                        };
                    });
                })(n, t);
                if (((e1)=>xe(e1, "id"))(t)) return ((e1, t)=>{
                    const n = Um(e1, "start", t), o = Um(e1, "end", t);
                    return ze(n, o.or(n), (n, o)=>{
                        const r = e1.createRng();
                        return r.setStart(Dm(e1, n.container()), n.offset()), r.setEnd(Dm(e1, o.container()), o.offset()), {
                            range: r,
                            forward: Pm(t)
                        };
                    });
                })(n, t);
                if (Om(t)) return ((e1, t)=>I.from(e1.select(t.name)[t.index]).map((t)=>{
                        const n = e1.createRng();
                        return n.selectNode(t), {
                            range: n,
                            forward: !0
                        };
                    }))(n, t);
                if (((e1)=>xe(e1, "rng"))(t)) return I.some({
                    range: t.rng,
                    forward: Pm(t)
                });
            }
            return I.none();
        })(e1, t).each(({ range: t, forward: n })=>{
            e1.setRng(t, n);
        });
    }, Hm = (e1)=>qr(e1) && "SPAN" === e1.tagName && "bookmark" === e1.getAttribute("data-mce-type"), $m = (Vm = it, (e1)=>Vm === e1);
    var Vm;
    const qm = (e1)=>"" !== e1 && -1 !== " \f\n\r\t\v".indexOf(e1), Wm = (e1)=>!qm(e1) && !$m(e1) && !lt(e1), Km = (e1)=>{
        const t = [];
        if (e1) for(let n = 0; n < e1.rangeCount; n++)t.push(e1.getRangeAt(n));
        return t;
    }, Ym = (e1, t)=>{
        const n = vr(t, "td[data-mce-selected],th[data-mce-selected]");
        return n.length > 0 ? n : ((e1)=>Y(((e1)=>te(e1, (e1)=>{
                    const t = tl(e1);
                    return t ? [
                        mn(t)
                    ] : [];
                }))(e1), Ai))(e1);
    }, Gm = (e1)=>Ym(Km(e1.selection.getSel()), mn(e1.getBody())), Xm = (e1, t)=>or(e1, "table", t), Zm = (e1)=>Vn(e1).fold(N([
            e1
        ]), (t)=>[
                e1
            ].concat(Zm(t))), Qm = (e1)=>qn(e1).fold(N([
            e1
        ]), (t)=>"br" === _n(t) ? Fn(t).map((t)=>[
                    e1
                ].concat(Qm(t))).getOr([]) : [
                e1
            ].concat(Qm(t))), Jm = (e1, t)=>ze(((e1)=>{
            const t = e1.startContainer, n = e1.startOffset;
            return es(t) ? 0 === n ? I.some(mn(t)) : I.none() : I.from(t.childNodes[n]).map(mn);
        })(t), ((e1)=>{
            const t = e1.endContainer, n = e1.endOffset;
            return es(t) ? n === t.data.length ? I.some(mn(t)) : I.none() : I.from(t.childNodes[n - 1]).map(mn);
        })(t), (t, n)=>{
            const o = Q(Zm(e1), T(Cn, t)), r = Q(Qm(e1), T(Cn, n));
            return o.isSome() && r.isSome();
        }).getOr(!1), ef = (e1, t, n, o)=>{
        const r = n, s = new Fr(n, r), a = Ce(e1.schema.getMoveCaretBeforeOnEnterElements(), (e1, t)=>!H([
                "td",
                "th",
                "table"
            ], t.toLowerCase()));
        let i = n;
        do {
            if (es(i) && 0 !== an.trim(i.data).length) return void (o ? t.setStart(i, 0) : t.setEnd(i, i.data.length));
            if (a[i.nodeName]) return void (o ? t.setStartBefore(i) : "BR" === i.nodeName ? t.setEndBefore(i) : t.setEndAfter(i));
        }while (i = o ? s.next() : s.prev());
        "BODY" === r.nodeName && (o ? t.setStart(r, 0) : t.setEnd(r, r.childNodes.length));
    }, tf = (e1)=>{
        const t = e1.selection.getSel();
        return C(t) && t.rangeCount > 0;
    }, nf = (e1, t)=>{
        const n = Gm(e1);
        n.length > 0 ? q(n, (n)=>{
            const o = n.dom, r = e1.dom.createRng();
            r.setStartBefore(o), r.setEndAfter(o), t(r, !0);
        }) : t(e1.selection.getRng(), !1);
    }, of = (e1, t, n)=>{
        const o = Jl(e1, t);
        n(o), e1.moveToBookmark(o);
    }, rf = (e1)=>E(null == e1 ? void 0 : e1.nodeType), sf = (e1)=>qr(e1) && !Hm(e1) && !Am(e1) && !Xr(e1), af = (e1, t, n)=>{
        const { selection: o, dom: r } = e1, s = o.getNode(), a = cs(s);
        of(o, !0, ()=>{
            t();
        }), a && cs(s) && r.isChildOf(s, e1.getBody()) ? e1.selection.select(s) : n(o.getStart()) && lf(r, o);
    }, lf = (e1, t)=>{
        var n, o;
        const r = t.getRng(), { startContainer: s, startOffset: a } = r;
        if (!((e1, t)=>{
            if (sf(t) && !/^(TD|TH)$/.test(t.nodeName)) {
                const n = e1.getAttrib(t, "data-mce-selected"), o = parseInt(n, 10);
                return !isNaN(o) && o > 0;
            }
            return !1;
        })(e1, t.getNode()) && qr(s)) {
            const i = s.childNodes, l = e1.getRoot();
            let d;
            if (a < i.length) {
                const t = i[a];
                d = new Fr(t, null !== (n = e1.getParent(t, e1.isBlock)) && void 0 !== n ? n : l);
            } else {
                const t = i[i.length - 1];
                d = new Fr(t, null !== (o = e1.getParent(t, e1.isBlock)) && void 0 !== o ? o : l), d.next(!0);
            }
            for(let n = d.current(); n; n = d.next()){
                if ("false" === e1.getContentEditable(n)) return;
                if (es(n) && !mf(n)) return r.setStart(n, 0), void t.setRng(r);
            }
        }
    }, df = (e1, t, n)=>{
        if (e1) {
            const o = t ? "nextSibling" : "previousSibling";
            for(e1 = n ? e1 : e1[o]; e1; e1 = e1[o])if (qr(e1) || !mf(e1)) return e1;
        }
    }, cf = (e1, t)=>!!e1.getTextBlockElements()[t.nodeName.toLowerCase()] || js(e1, t), uf = (e1, t, n)=>e1.schema.isValidChild(t, n), mf = (e1, t = !1)=>{
        if (C(e1) && es(e1)) {
            const n = t ? e1.data.replace(/ /g, "\xa0") : e1.data;
            return zr(n);
        }
        return !1;
    }, ff = (e1, t)=>{
        const n = e1.dom;
        return sf(t) && "false" === n.getContentEditable(t) && ((e1, t)=>{
            const n = "[data-mce-cef-wrappable]", o = pc(e1), r = tt(o) ? n : `${n},${o}`;
            return vn(mn(t), r);
        })(e1, t) && 0 === n.select('[contenteditable="true"]', t).length;
    }, gf = (e1, t)=>w(e1) ? e1(t) : (C(t) && (e1 = e1.replace(/%(\w+)/g, (e1, n)=>t[n] || e1)), e1), pf = (e1, t)=>(t = t || "", e1 = "" + ((e1 = e1 || "").nodeName || e1), t = "" + (t.nodeName || t), e1.toLowerCase() === t.toLowerCase()), hf = (e1, t)=>{
        if (y(e1)) return null;
        {
            let n = String(e1);
            return "color" !== t && "backgroundColor" !== t || (n = Ma(n)), "fontWeight" === t && 700 === e1 && (n = "bold"), "fontFamily" === t && (n = n.replace(/[\'\"]/g, "").replace(/,\s+/g, ",")), n;
        }
    }, bf = (e1, t, n)=>{
        const o = e1.getStyle(t, n);
        return hf(o, n);
    }, vf = (e1, t)=>{
        let n;
        return e1.getParent(t, (t)=>!!qr(t) && (n = e1.getStyle(t, "text-decoration"), !!n && "none" !== n)), n;
    }, yf = (e1, t, n)=>e1.getParents(t, n, e1.getRoot()), Cf = (e1, t, n)=>{
        const o = e1.formatter.get(t);
        return C(o) && $(o, n);
    }, wf = (e1)=>Se(e1, "block"), Ef = (e1)=>Se(e1, "selector"), _f = (e1)=>Se(e1, "inline"), xf = (e1)=>Ef(e1) && !1 !== e1.expand && !_f(e1), Sf = (e1)=>((e1)=>{
            const t = [];
            let n = e1;
            for(; n;){
                if (es(n) && n.data !== Pi || n.childNodes.length > 1) return [];
                qr(n) && t.push(n), n = n.firstChild;
            }
            return t;
        })(e1).length > 0, kf = (e1)=>Am(e1.dom) && Sf(e1.dom), Nf = Hm, Rf = yf, Af = mf, Tf = cf, Of = (e1, t)=>{
        let n = t;
        for(; n;){
            if (qr(n) && e1.getContentEditable(n)) return "false" === e1.getContentEditable(n) ? n : t;
            n = n.parentNode;
        }
        return t;
    }, Bf = (e1, t, n, o)=>{
        const r = t.data;
        if (e1) {
            for(let e1 = n; e1 > 0; e1--)if (o(r.charAt(e1 - 1))) return e1;
        } else for(let e1 = n; e1 < r.length; e1++)if (o(r.charAt(e1))) return e1;
        return -1;
    }, Pf = (e1, t, n)=>Bf(e1, t, n, (e1)=>$m(e1) || qm(e1)), Df = (e1, t, n)=>Bf(e1, t, n, Wm), Lf = (e1, t, n, o, r, s)=>{
        let a;
        const i = e1.getParent(n, (t)=>us(t) || e1.isBlock(t)), l = C(i) ? i : t, d = (t, n, o)=>{
            const s = Ei(e1), i = r ? s.backwards : s.forwards;
            return I.from(i(t, n, (e1, t)=>Nf(e1.parentNode) ? -1 : (a = e1, o(r, e1, t)), l));
        };
        return d(n, o, Pf).bind((e1)=>s ? d(e1.container, e1.offset + (r ? -1 : 0), Df) : I.some(e1)).orThunk(()=>a ? I.some({
                container: a,
                offset: r ? 0 : a.length
            }) : I.none());
    }, Mf = (e1, t, n, o, r)=>{
        const s = o[r];
        es(o) && tt(o.data) && s && (o = s);
        const a = Rf(e1, o);
        for(let o = 0; o < a.length; o++)for(let r = 0; r < t.length; r++){
            const s = t[r];
            if ((!C(s.collapsed) || s.collapsed === n.collapsed) && Ef(s) && e1.is(a[o], s.selector)) return a[o];
        }
        return o;
    }, If = (e1, t, n, o)=>{
        var r;
        let s = n;
        const a = e1.getRoot(), i = t[0];
        if (wf(i) && (s = i.wrapper ? null : e1.getParent(n, i.block, a)), !s) {
            const t = null !== (r = e1.getParent(n, "LI,TD,TH,SUMMARY")) && void 0 !== r ? r : a;
            s = e1.getParent(es(n) ? n.parentNode : n, (t)=>t !== a && Tf(e1.schema, t), t);
        }
        if (s && wf(i) && i.wrapper && (s = Rf(e1, s, "ul,ol").reverse()[0] || s), !s) for(s = n; s && s[o] && !e1.isBlock(s[o]) && (s = s[o], !pf(s, "br")););
        return s || n;
    }, Ff = (e1, t, n, o)=>{
        const r = n.parentNode;
        return !C(n[o]) && (!(r !== t && !y(r) && !e1.isBlock(r)) || Ff(e1, t, r, o));
    }, Uf = (e1, t, n, o, r, s)=>{
        let a = n;
        const i = r ? "previousSibling" : "nextSibling", l = e1.getRoot();
        if (es(n) && !Af(n) && (r ? o > 0 : o < n.data.length)) return n;
        for(; a;){
            if (us(a)) return n;
            if (!t[0].block_expand && e1.isBlock(a)) return s ? a : n;
            for(let t = a[i]; t; t = t[i]){
                const n = es(t) && !Ff(e1, l, t, i);
                if (!Nf(t) && (!as(d = t) || !d.getAttribute("data-mce-bogus") || d.nextSibling) && !Af(t, n)) return a;
            }
            if (a === l || a.parentNode === l) {
                n = a;
                break;
            }
            a = a.parentNode;
        }
        var d;
        return n;
    }, zf = (e1)=>Nf(e1.parentNode) || Nf(e1), jf = (e1, t, n, o = {})=>{
        const { includeTrailingSpace: r = !1, expandToBlock: s = !0 } = o, a = e1.getParent(t.commonAncestorContainer, (e1)=>us(e1)), i = C(a) ? a : e1.getRoot();
        let { startContainer: l, startOffset: d, endContainer: c, endOffset: u } = t;
        const m = n[0];
        return qr(l) && l.hasChildNodes() && (l = nl(l, d), es(l) && (d = 0)), qr(c) && c.hasChildNodes() && (c = nl(c, t.collapsed ? u : u - 1), es(c) && (u = c.data.length)), l = Of(e1, l), c = Of(e1, c), zf(l) && (l = Nf(l) ? l : l.parentNode, l = t.collapsed ? l.previousSibling || l : l.nextSibling || l, es(l) && (d = t.collapsed ? l.length : 0)), zf(c) && (c = Nf(c) ? c : c.parentNode, c = t.collapsed ? c.nextSibling || c : c.previousSibling || c, es(c) && (u = t.collapsed ? 0 : c.length)), t.collapsed && (Lf(e1, i, l, d, !0, r).each(({ container: e1, offset: t })=>{
            l = e1, d = t;
        }), Lf(e1, i, c, u, !1, r).each(({ container: e1, offset: t })=>{
            c = e1, u = t;
        })), (_f(m) || m.block_expand) && (_f(m) && es(l) && 0 !== d || (l = Uf(e1, n, l, d, !0, s)), _f(m) && es(c) && u !== c.data.length || (c = Uf(e1, n, c, u, !1, s))), xf(m) && (l = Mf(e1, n, t, l, "previousSibling"), c = Mf(e1, n, t, c, "nextSibling")), (wf(m) || Ef(m)) && (l = If(e1, n, l, "previousSibling"), c = If(e1, n, c, "nextSibling"), wf(m) && (e1.isBlock(l) || (l = Uf(e1, n, l, d, !0, s), es(l) && (d = 0)), e1.isBlock(c) || (c = Uf(e1, n, c, u, !1, s), es(c) && (u = c.data.length)))), qr(l) && l.parentNode && (d = e1.nodeIndex(l), l = l.parentNode), qr(c) && c.parentNode && (u = e1.nodeIndex(c) + 1, c = c.parentNode), {
            startContainer: l,
            startOffset: d,
            endContainer: c,
            endOffset: u
        };
    }, Hf = (e1, t, n)=>{
        var o;
        const r = t.startOffset, s = nl(t.startContainer, r), a = t.endOffset, i = nl(t.endContainer, a - 1), l = (e1)=>{
            const t = e1[0];
            es(t) && t === s && r >= t.data.length && e1.splice(0, 1);
            const n = e1[e1.length - 1];
            return 0 === a && e1.length > 0 && n === i && es(n) && e1.splice(e1.length - 1, 1), e1;
        }, d = (e1, t, n)=>{
            const o = [];
            for(; e1 && e1 !== n; e1 = e1[t])o.push(e1);
            return o;
        }, c = (t, n)=>e1.getParent(t, (e1)=>e1.parentNode === n, n), u = (e1, t, o)=>{
            const r = o ? "nextSibling" : "previousSibling";
            for(let s = e1, a = s.parentNode; s && s !== t; s = a){
                a = s.parentNode;
                const t = d(s === e1 ? s : s[r], r);
                t.length && (o || t.reverse(), n(l(t)));
            }
        };
        if (s === i) return n(l([
            s
        ]));
        const m = null !== (o = e1.findCommonAncestor(s, i)) && void 0 !== o ? o : e1.getRoot();
        if (e1.isChildOf(s, i)) return u(s, m, !0);
        if (e1.isChildOf(i, s)) return u(i, m);
        const f = c(s, m) || s, g = c(i, m) || i;
        u(s, f, !0);
        const p = d(f === s ? f : f.nextSibling, "nextSibling", g === i ? g.nextSibling : g);
        p.length && n(l(p)), u(i, g);
    }, $f = [
        'pre[class*=language-][contenteditable="false"]',
        "figure.image",
        "div[data-ephox-embed-iri]",
        "div.tiny-pageembed",
        "div.mce-toc",
        "div[data-mce-toc]",
        "div.mce-footnotes"
    ], Vf = (e1, t, n, o, r, s)=>{
        const { uid: a = t, ...i } = n;
        cr(e1, ci()), go(e1, `${mi()}`, a), go(e1, `${ui()}`, o);
        const { attributes: l = {}, classes: d = [] } = r(a, i);
        if (po(e1, l), ((e1, t)=>{
            q(t, (t)=>{
                cr(e1, t);
            });
        })(e1, d), s) {
            d.length > 0 && go(e1, `${gi()}`, d.join(","));
            const t = fe(l);
            t.length > 0 && go(e1, `${pi()}`, t.join(","));
        }
    }, qf = (e1, t, n, o, r)=>{
        const s = cn("span", e1);
        return Vf(s, t, n, o, r, !1), s;
    }, Wf = (e1, t, n, o, r, s)=>{
        const a = [], i = qf(e1.getDoc(), n, s, o, r), l = Ve(), d = ()=>{
            l.clear();
        }, c = (e1)=>{
            q(e1, u);
        }, u = (t)=>{
            switch(((e1, t, n, o)=>Mn(t).fold(()=>"skipping", (r)=>"br" === o || ((e1)=>Rn(e1) && Xo(e1) === Pi)(t) ? "valid" : ((e1)=>Nn(e1) && fr(e1, ci()))(t) ? "existing" : Am(t.dom) ? "caret" : $($f, (e1)=>vn(t, e1)) ? "valid-block" : uf(e1, n, o) && uf(e1, _n(r), n) ? "valid" : "invalid-child"))(e1, t, "span", _n(t))){
                case "invalid-child":
                    {
                        d();
                        const e1 = Hn(t);
                        c(e1), d();
                        break;
                    }
                case "valid-block":
                    d(), Vf(t, n, s, o, r, !0);
                    break;
                case "valid":
                    {
                        const e1 = l.get().getOrThunk(()=>{
                            const e1 = So(i);
                            return a.push(e1), l.set(e1), e1;
                        });
                        uo(t, e1);
                        break;
                    }
            }
        };
        return Hf(e1.dom, t, (e1)=>{
            d(), ((e1)=>{
                const t = V(e1, mn);
                c(t);
            })(e1);
        }), a;
    }, Kf = (e1)=>{
        const t = (()=>{
            const e1 = {};
            return {
                register: (t, n)=>{
                    e1[t] = {
                        name: t,
                        settings: n
                    };
                },
                lookup: (t)=>_e(e1, t).map((e1)=>e1.settings),
                getNames: ()=>fe(e1)
            };
        })();
        ((e1, t)=>{
            const n = ui(), o = (e1)=>I.from(e1.attr(n)).bind(t.lookup), r = (e1)=>{
                var t, n;
                e1.attr(mi(), null), e1.attr(ui(), null), e1.attr(fi(), null);
                const o = I.from(e1.attr(pi())).map((e1)=>e1.split(",")).getOr([]), r = I.from(e1.attr(gi())).map((e1)=>e1.split(",")).getOr([]);
                q(o, (t)=>e1.attr(t, null));
                const s = null !== (n = null === (t = e1.attr("class")) || void 0 === t ? void 0 : t.split(" ")) && void 0 !== n ? n : [], a = re(s, [
                    ci()
                ].concat(r));
                e1.attr("class", a.length > 0 ? a.join(" ") : null), e1.attr(gi(), null), e1.attr(pi(), null);
            };
            e1.serializer.addTempAttr(fi()), e1.serializer.addAttributeFilter(n, (e1)=>{
                for (const t of e1)o(t).each((e1)=>{
                    !1 === e1.persistent && ("span" === t.name ? t.unwrap() : r(t));
                });
            });
        })(e1, t);
        const n = ((e1, t)=>{
            const n = Ne({}), o = ()=>({
                    listeners: [],
                    previous: Ve()
                }), r = (e1, t)=>{
                s(e1, (e1)=>(t(e1), e1));
            }, s = (e1, t)=>{
                const r = n.get(), s = t(_e(r, e1).getOrThunk(o));
                r[e1] = s, n.set(r);
            }, a = (t, n)=>{
                q(yi(e1, t), (e1)=>{
                    n ? go(e1, fi(), "true") : yo(e1, fi());
                });
            }, i = rt(()=>{
                const n = ae(t.getNames());
                q(n, (t)=>{
                    s(t, (n)=>{
                        const o = n.previous.get();
                        return bi(e1, I.some(t)).fold(()=>{
                            o.each((e1)=>{
                                ((e1)=>{
                                    r(e1, (t)=>{
                                        q(t.listeners, (t)=>t(!1, e1));
                                    });
                                })(t), n.previous.clear(), a(e1, !1);
                            });
                        }, ({ uid: e1, name: t, elements: s })=>{
                            Fe(o, e1) || (o.each((e1)=>a(e1, !1)), ((e1, t, n)=>{
                                r(e1, (o)=>{
                                    q(o.listeners, (o)=>o(!0, e1, {
                                            uid: t,
                                            nodes: V(n, (e1)=>e1.dom)
                                        }));
                                });
                            })(t, e1, s), n.previous.set(e1), a(e1, !0));
                        }), {
                            previous: n.previous,
                            listeners: n.listeners
                        };
                    });
                });
            }, 30);
            return e1.on("remove", ()=>{
                i.cancel();
            }), e1.on("NodeChange", ()=>{
                i.throttle();
            }), {
                addListener: (e1, t)=>{
                    s(e1, (e1)=>({
                            previous: e1.previous,
                            listeners: e1.listeners.concat([
                                t
                            ])
                        }));
                }
            };
        })(e1, t), o = On("span"), r = (e1)=>{
            q(e1, (e1)=>{
                o(e1) ? _o(e1) : ((e1)=>{
                    mr(e1, ci()), yo(e1, `${mi()}`), yo(e1, `${ui()}`), yo(e1, `${fi()}`);
                    const t = bo(e1, `${pi()}`).map((e1)=>e1.split(",")).getOr([]), n = bo(e1, `${gi()}`).map((e1)=>e1.split(",")).getOr([]);
                    var o;
                    q(t, (t)=>yo(e1, t)), o = e1, q(n, (e1)=>{
                        mr(o, e1);
                    }), yo(e1, `${gi()}`), yo(e1, `${pi()}`);
                })(e1);
            });
        };
        return {
            register: (e1, n)=>{
                t.register(e1, n);
            },
            annotate: (n, o)=>{
                t.lookup(n).each((t)=>{
                    ((e1, t, n, o)=>{
                        e1.undoManager.transact(()=>{
                            const r = e1.selection, s = r.getRng(), a = Gm(e1).length > 0, i = De("mce-annotation");
                            if (s.collapsed && !a && ((e1, t)=>{
                                const n = jf(e1.dom, t, [
                                    {
                                        inline: "span"
                                    }
                                ]);
                                t.setStart(n.startContainer, n.startOffset), t.setEnd(n.endContainer, n.endOffset), e1.selection.setRng(t);
                            })(e1, s), r.getRng().collapsed && !a) {
                                const s = qf(e1.getDoc(), i, o, t, n.decorate);
                                Ao(s, it), r.getRng().insertNode(s.dom), r.select(s.dom);
                            } else of(r, !1, ()=>{
                                nf(e1, (r)=>{
                                    Wf(e1, r, i, t, n.decorate, o);
                                });
                            });
                        });
                    })(e1, n, t, o);
                });
            },
            annotationChanged: (e1, t)=>{
                n.addListener(e1, t);
            },
            remove: (t)=>{
                bi(e1, I.some(t)).each(({ elements: t })=>{
                    const n = e1.selection.getBookmark();
                    r(t), e1.selection.moveToBookmark(n);
                });
            },
            removeAll: (t)=>{
                const n = e1.selection.getBookmark();
                pe(Ci(e1, t), (e1, t)=>{
                    r(e1);
                }), e1.selection.moveToBookmark(n);
            },
            getAll: (t)=>{
                const n = Ci(e1, t);
                return he(n, (e1)=>V(e1, (e1)=>e1.dom));
            }
        };
    }, Yf = (e1)=>({
            getBookmark: T(zm, e1),
            moveToBookmark: T(jm, e1)
        });
    Yf.isBookmarkNode = Hm;
    const Gf = (e1, t, n)=>!n.collapsed && $(n.getClientRects(), (n)=>((e1, t, n)=>t >= e1.left && t <= e1.right && n >= e1.top && n <= e1.bottom)(n, e1, t)), Xf = (e1, t)=>{
        const n = Rn(t) ? Xo(t).length : Hn(t).length + 1;
        return e1 > n ? n : e1 < 0 ? 0 : e1;
    }, Zf = (e1)=>Tr.range(e1.start, Xf(e1.soffset, e1.start), e1.finish, Xf(e1.foffset, e1.finish)), Qf = (e1, t)=>!Vr(t.dom) && (wn(e1, t) || Cn(e1, t)), Jf = (e1)=>(t)=>Qf(e1, t.start) && Qf(e1, t.finish), eg = (e1)=>Tr.range(mn(e1.startContainer), e1.startOffset, mn(e1.endContainer), e1.endOffset), tg = (e1)=>{
        const t = document.createRange();
        try {
            return t.setStart(e1.start.dom, e1.soffset), t.setEnd(e1.finish.dom, e1.foffset), I.some(t);
        } catch (e1) {
            return I.none();
        }
    }, ng = (e1)=>{
        const t = ((e1)=>e1.inline || nn.browser.isFirefox())(e1) ? (n = mn(e1.getBody()), ((e1)=>{
            const t = e1.getSelection();
            return (t && 0 !== t.rangeCount ? I.from(t.getRangeAt(0)) : I.none()).map(eg);
        })(Dn(n).dom).filter(Jf(n))) : I.none();
        var n;
        e1.bookmark = t.isSome() ? t : e1.bookmark;
    }, og = (e1)=>(e1.bookmark ? e1.bookmark : I.none()).bind((t)=>{
            var n, o;
            return n = mn(e1.getBody()), o = t, I.from(o).filter(Jf(n)).map(Zf);
        }).bind(tg), rg = {
        isEditorUIElement: (e1)=>{
            const t = e1.className.toString();
            return -1 !== t.indexOf("tox-") || -1 !== t.indexOf("mce-");
        }
    }, sg = {
        setEditorTimeout: (e1, t, n)=>((e1, t)=>(E(t) || (t = 0), window.setTimeout(e1, t)))(()=>{
                e1.removed || t();
            }, n),
        setEditorInterval: (e1, t, n)=>{
            const o = ((e1, t)=>(E(t) || (t = 0), window.setInterval(e1, t)))(()=>{
                e1.removed ? window.clearInterval(o) : t();
            }, n);
            return o;
        }
    }, ag = (e1, t)=>e1.view(t).fold(N([]), (t)=>{
            const n = e1.owner(t), o = ag(e1, n);
            return [
                t
            ].concat(o);
        });
    var ig = Object.freeze({
        __proto__: null,
        view: (e1)=>{
            var t;
            return (e1.dom === document ? I.none() : I.from(null === (t = e1.dom.defaultView) || void 0 === t ? void 0 : t.frameElement)).map(mn);
        },
        owner: (e1)=>Pn(e1)
    });
    const lg = (e1)=>{
        const t = no(), n = qo(t), o = ((e1, t)=>{
            const n = t.owner(e1);
            return ag(t, n);
        })(e1, ig), r = Vo(e1), s = G(o, (e1, t)=>{
            const n = Vo(t);
            return {
                left: e1.left + n.left,
                top: e1.top + n.top
            };
        }, {
            left: 0,
            top: 0
        });
        return Ho(s.left + r.left + n.left, s.top + r.top + n.top);
    };
    let dg;
    const cg = ni.DOM, ug = (e1)=>{
        const t = e1.classList;
        return void 0 !== t && (t.contains("tox-edit-area") || t.contains("tox-edit-area__iframe") || t.contains("mce-content-body"));
    }, mg = (e1, t)=>{
        const n = hc(e1), o = cg.getParent(t, (t)=>((e1)=>qr(e1) && rg.isEditorUIElement(e1))(t) || !!n && e1.dom.is(t, n));
        return null !== o;
    }, fg = (e1)=>{
        try {
            const t = Yn(mn(e1.getElement()));
            return so(t).fold(()=>document.body, (e1)=>e1.dom);
        } catch (e1) {
            return document.body;
        }
    }, gg = (e1, t)=>{
        const n = t.editor;
        ((e1)=>{
            const t = ot(()=>{
                ng(e1);
            }, 0);
            e1.on("init", ()=>{
                e1.inline && ((e1, t)=>{
                    const n = ()=>{
                        t.throttle();
                    };
                    ni.DOM.bind(document, "mouseup", n), e1.on("remove", ()=>{
                        ni.DOM.unbind(document, "mouseup", n);
                    });
                })(e1, t), ((e1, t)=>{
                    ((e1, t)=>{
                        e1.on("mouseup touchend", (e1)=>{
                            t.throttle();
                        });
                    })(e1, t), e1.on("keyup NodeChange AfterSetSelectionRange", (t)=>{
                        ((e1)=>"nodechange" === e1.type && e1.selectionChange)(t) || ng(e1);
                    });
                })(e1, t);
            }), e1.on("remove", ()=>{
                t.cancel();
            });
        })(n);
        const o = (e1, t)=>{
            ru(e1) && !0 !== e1.inline && t(mn(e1.getContainer()), "tox-edit-focus");
        };
        n.on("focusin", ()=>{
            const t = e1.focusedEditor;
            if (ug(fg(n)) && o(n, cr), t !== n) {
                t && t.dispatch("blur", {
                    focusedEditor: n
                }), e1.setActive(n), e1.focusedEditor = n, n.dispatch("focus", {
                    blurredEditor: t
                }), n.focus(!0);
                const o = Kt().browser;
                !0 !== n.inline && (o.isSafari() || o.isChromium()) && ((e1)=>{
                    if (!e1.iframeElement) return;
                    const t = mn(e1.iframeElement), n = lg(t), o = Ir(window);
                    (n.top < o.y || n.top > o.bottom - 25) && t.dom.scrollIntoView({
                        block: "center"
                    });
                })(n);
            }
        }), n.on("focusout", ()=>{
            sg.setEditorTimeout(n, ()=>{
                const t = e1.focusedEditor;
                ug(fg(n)) && t === n || o(n, mr), mg(n, fg(n)) || t !== n || (n.dispatch("blur", {
                    focusedEditor: null
                }), e1.focusedEditor = null);
            });
        }), dg || (dg = (t)=>{
            const n = e1.activeEditor;
            n && Zn(t).each((t)=>{
                const o = t;
                o.ownerDocument === document && (o === document.body || mg(n, o) || e1.focusedEditor !== n || (n.dispatch("blur", {
                    focusedEditor: null
                }), e1.focusedEditor = null));
            });
        }, cg.bind(document, "focusin", dg));
    }, pg = (e1, t)=>{
        e1.focusedEditor === t.editor && (e1.focusedEditor = null), !e1.activeEditor && dg && (cg.unbind(document, "focusin", dg), dg = null);
    }, hg = (e1, t)=>{
        ((e1, t)=>((e1)=>e1.collapsed ? I.from(nl(e1.startContainer, e1.startOffset)).map(mn) : I.none())(t).bind((t)=>Ri(t) ? I.some(t) : wn(e1, t) ? I.none() : I.some(e1)))(mn(e1.getBody()), t).bind((e1)=>km(e1.dom)).fold(()=>{
            e1.selection.normalize();
        }, (t)=>e1.selection.setRng(t.toRange()));
    }, bg = (e1)=>{
        if (e1.setActive) try {
            e1.setActive();
        } catch (t) {
            e1.focus();
        }
        else e1.focus();
    }, vg = (e1)=>e1.inline ? ((e1)=>{
            const t = e1.getBody();
            var n, o;
            return t && (n = mn(t), ro(n) || (o = n, so(Yn(o)).filter((e1)=>o.dom.contains(e1.dom))).isSome());
        })(e1) : ((e1)=>C(e1.iframeElement) && ro(mn(e1.iframeElement)))(e1), yg = (e1)=>vg(e1) || ((e1)=>{
            const t = Yn(mn(e1.getElement()));
            return so(t).filter((t)=>!ug(t.dom) && mg(e1, t.dom)).isSome();
        })(e1), Cg = (e1)=>e1.editorManager.setActive(e1), wg = {
        BACKSPACE: 8,
        DELETE: 46,
        DOWN: 40,
        ENTER: 13,
        ESC: 27,
        LEFT: 37,
        RIGHT: 39,
        SPACEBAR: 32,
        TAB: 9,
        UP: 38,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        modifierPressed: (e1)=>e1.shiftKey || e1.ctrlKey || e1.altKey || wg.metaKeyPressed(e1),
        metaKeyPressed: (e1)=>nn.os.isMacOS() || nn.os.isiOS() ? e1.metaKey : e1.ctrlKey && !e1.altKey
    }, Eg = "data-mce-selected", _g = Math.abs, xg = Math.round, Sg = {
        nw: [
            0,
            0,
            -1,
            -1
        ],
        ne: [
            1,
            0,
            1,
            -1
        ],
        se: [
            1,
            1,
            1,
            1
        ],
        sw: [
            0,
            1,
            -1,
            1
        ]
    }, kg = (e1, t)=>{
        const n = t.dom, o = t.getDoc(), r = document, s = t.getBody();
        let a, i, l, d, c, u, m, f, g, p, h, b, v, y, w;
        const E = (e1)=>C(e1) && (is(e1) || n.is(e1, "figure.image")), _ = (e1)=>gs(e1) || n.hasClass(e1, "mce-preview-object"), x = (e1)=>{
            const n = e1.target;
            ((e1, t)=>{
                if (((e1)=>"longpress" === e1.type || 0 === e1.type.indexOf("touch"))(e1)) {
                    const n = e1.touches[0];
                    return E(e1.target) && !Gf(n.clientX, n.clientY, t);
                }
                return E(e1.target) && !Gf(e1.clientX, e1.clientY, t);
            })(e1, t.selection.getRng()) && !e1.isDefaultPrevented() && t.selection.select(n);
        }, S = (e1)=>n.hasClass(e1, "mce-preview-object") && C(e1.firstElementChild) ? [
                e1,
                e1.firstElementChild
            ] : n.is(e1, "figure.image") ? [
                e1.querySelector("img")
            ] : [
                e1
            ], k = (e1)=>{
            const o = nc(t);
            return !(!o || t.mode.isReadOnly()) && "false" !== e1.getAttribute("data-mce-resize") && e1 !== t.getBody() && (n.hasClass(e1, "mce-preview-object") && C(e1.firstElementChild) ? vn(mn(e1.firstElementChild), o) : vn(mn(e1), o));
        }, N = (e1, o, r)=>{
            if (C(r)) {
                const s = S(e1);
                q(s, (e1)=>{
                    e1.style[o] || !t.schema.isValid(e1.nodeName.toLowerCase(), o) ? n.setStyle(e1, o, r) : n.setAttrib(e1, o, "" + r);
                });
            }
        }, R = (e1, t, n)=>{
            N(e1, "width", t), N(e1, "height", n);
        }, A = (e1)=>{
            let o, r, c, C, x;
            o = e1.screenX - u, r = e1.screenY - m, b = o * d[2] + f, v = r * d[3] + g, b = b < 5 ? 5 : b, v = v < 5 ? 5 : v, c = (E(a) || _(a)) && !1 !== oc(t) ? !wg.modifierPressed(e1) : wg.modifierPressed(e1), c && (_g(o) > _g(r) ? (v = xg(b * p), b = xg(v / p)) : (b = xg(v / p), v = xg(b * p))), R(i, b, v), C = d.startPos.x + o, x = d.startPos.y + r, C = C > 0 ? C : 0, x = x > 0 ? x : 0, n.setStyles(l, {
                left: C,
                top: x,
                display: "block"
            }), l.innerHTML = b + " &times; " + v, o = s.scrollWidth - y, r = s.scrollHeight - w, o + r !== 0 && n.setStyles(l, {
                left: C - o,
                top: x - r
            }), h || (((e1, t, n, o, r)=>{
                e1.dispatch("ObjectResizeStart", {
                    target: t,
                    width: n,
                    height: o,
                    origin: r
                });
            })(t, a, f, g, "corner-" + d.name), h = !0);
        }, T = ()=>{
            const e1 = h;
            h = !1, e1 && (N(a, "width", b), N(a, "height", v)), n.unbind(o, "mousemove", A), n.unbind(o, "mouseup", T), r !== o && (n.unbind(r, "mousemove", A), n.unbind(r, "mouseup", T)), n.remove(i), n.remove(l), n.remove(c), O(a), e1 && (((e1, t, n, o, r)=>{
                e1.dispatch("ObjectResized", {
                    target: t,
                    width: n,
                    height: o,
                    origin: r
                });
            })(t, a, b, v, "corner-" + d.name), n.setAttrib(a, "style", n.getAttrib(a, "style"))), t.nodeChanged();
        }, O = (e1)=>{
            M();
            const h = n.getPos(e1, s), C = h.x, E = h.y, x = e1.getBoundingClientRect(), N = x.width || x.right - x.left, O = x.height || x.bottom - x.top;
            a !== e1 && (P(), a = e1, b = v = 0);
            const B = t.dispatch("ObjectSelected", {
                target: e1
            });
            k(e1) && !B.isDefaultPrevented() ? pe(Sg, (e1, t)=>{
                let h = n.get("mceResizeHandle" + t);
                h && n.remove(h), h = n.add(s, "div", {
                    id: "mceResizeHandle" + t,
                    "data-mce-bogus": "all",
                    class: "mce-resizehandle",
                    unselectable: !0,
                    style: "cursor:" + t + "-resize; margin:0; padding:0"
                }), n.bind(h, "mousedown", (h)=>{
                    h.stopImmediatePropagation(), h.preventDefault(), ((h)=>{
                        const b = S(a)[0];
                        u = h.screenX, m = h.screenY, f = b.clientWidth, g = b.clientHeight, p = g / f, d = e1, d.name = t, d.startPos = {
                            x: N * e1[0] + C,
                            y: O * e1[1] + E
                        }, y = s.scrollWidth, w = s.scrollHeight, c = n.add(s, "div", {
                            class: "mce-resize-backdrop",
                            "data-mce-bogus": "all"
                        }), n.setStyles(c, {
                            position: "fixed",
                            left: "0",
                            top: "0",
                            width: "100%",
                            height: "100%"
                        }), i = ((e1, t)=>{
                            if (_(t)) return e1.create("img", {
                                src: nn.transparentSrc
                            });
                            if (Zr(t)) {
                                const n = Ye(d.name, "n") ? le : de, o = t.cloneNode(!0);
                                return n(e1.select("tr", o)).each((t)=>{
                                    const n = e1.select("td,th", t);
                                    e1.setStyle(t, "height", null), q(n, (t)=>e1.setStyle(t, "height", null));
                                }), o;
                            }
                            return t.cloneNode(!0);
                        })(n, a), n.addClass(i, "mce-clonedresizable"), n.setAttrib(i, "data-mce-bogus", "all"), i.contentEditable = "false", n.setStyles(i, {
                            left: C,
                            top: E,
                            margin: 0
                        }), R(i, N, O), i.removeAttribute(Eg), s.appendChild(i), n.bind(o, "mousemove", A), n.bind(o, "mouseup", T), r !== o && (n.bind(r, "mousemove", A), n.bind(r, "mouseup", T)), l = n.add(s, "div", {
                            class: "mce-resize-helper",
                            "data-mce-bogus": "all"
                        }, f + " &times; " + g);
                    })(h);
                }), e1.elm = h, n.setStyles(h, {
                    left: N * e1[0] + C - h.offsetWidth / 2,
                    top: O * e1[1] + E - h.offsetHeight / 2
                });
            }) : P(!1);
        }, B = ot(O, 0), P = (e1 = !0)=>{
            B.cancel(), M(), a && e1 && a.removeAttribute(Eg), pe(Sg, (e1, t)=>{
                const o = n.get("mceResizeHandle" + t);
                o && (n.unbind(o), n.remove(o));
            });
        }, D = (e1, t)=>n.isChildOf(e1, t), L = (o)=>{
            if (h || t.removed || t.composing) return;
            const r = "mousedown" === o.type ? o.target : e1.getNode(), a = sr(mn(r), "table,img,figure.image,hr,video,span.mce-preview-object,details").map((e1)=>e1.dom).filter((e1)=>n.isEditable(e1.parentElement) || "IMG" === e1.nodeName && n.isEditable(e1)).getOrUndefined(), i = C(a) ? n.getAttrib(a, Eg, "1") : "1";
            if (q(n.select(`img[${Eg}],hr[${Eg}]`), (e1)=>{
                e1.removeAttribute(Eg);
            }), C(a) && D(a, s) && yg(t)) {
                I();
                const t = e1.getStart(!0);
                if (D(t, a) && D(e1.getEnd(!0), a)) return n.setAttrib(a, Eg, i), void B.throttle(a);
            }
            P();
        }, M = ()=>{
            pe(Sg, (e1)=>{
                e1.elm && (n.unbind(e1.elm), delete e1.elm);
            });
        }, I = ()=>{
            try {
                t.getDoc().execCommand("enableObjectResizing", !1, "false");
            } catch (e1) {}
        };
        return t.on("init", ()=>{
            I(), t.on("NodeChange ResizeEditor ResizeWindow ResizeContent drop", L), t.on("keyup compositionend", (e1)=>{
                a && "TABLE" === a.nodeName && L(e1);
            }), t.on("hide blur", P), t.on("contextmenu longpress", x, !0);
        }), t.on("remove", M), {
            isResizable: k,
            showResizeRect: O,
            hideResizeRect: P,
            updateResizeRect: L,
            destroy: ()=>{
                B.cancel(), a = i = c = null;
            }
        };
    }, Ng = (e1, t, n)=>{
        const o = Dn(mn(n));
        return Lr(o.dom, e1, t).map((e1)=>{
            const t = n.createRange();
            return t.setStart(e1.start.dom, e1.soffset), t.setEnd(e1.finish.dom, e1.foffset), t;
        }).getOrUndefined();
    }, Rg = (e1, t)=>C(e1) && C(t) && e1.startContainer === t.startContainer && e1.startOffset === t.startOffset && e1.endContainer === t.endContainer && e1.endOffset === t.endOffset, Ag = (e1, t, n)=>null !== ((e1, t, n)=>{
            let o = e1;
            for(; o && o !== t;){
                if (n(o)) return o;
                o = o.parentNode;
            }
            return null;
        })(e1, t, n), Tg = (e1, t, n)=>Ag(e1, t, (e1)=>e1.nodeName === n), Og = (e1, t)=>zi(e1) && !Ag(e1, t, Am), Bg = (e1, t, n)=>{
        const o = t.parentNode;
        if (o) {
            const r = new Fr(t, e1.getParent(o, e1.isBlock) || e1.getRoot());
            let s;
            for(; s = r[n ? "prev" : "next"]();)if (as(s)) return !0;
        }
        return !1;
    }, Pg = (e1, t, n, o, r)=>{
        const s = e1.getRoot(), a = e1.schema.getNonEmptyElements(), i = r.parentNode;
        let l, d;
        if (!i) return I.none();
        const c = e1.getParent(i, e1.isBlock) || s;
        if (o && as(r) && t && e1.isEmpty(c)) return I.some(Pl(i, e1.nodeIndex(r)));
        const u = new Fr(r, c);
        for(; d = u[o ? "prev" : "next"]();){
            if ("false" === e1.getContentEditableParent(d) || Og(d, s)) return I.none();
            if (es(d) && d.data.length > 0) return Tg(d, s, "A") ? I.none() : I.some(Pl(d, o ? d.data.length : 0));
            if (e1.isBlock(d) || a[d.nodeName.toLowerCase()]) return I.none();
            l = d;
        }
        return os(l) ? I.none() : n && l ? I.some(Pl(l, 0)) : I.none();
    }, Dg = (e1, t, n, o)=>{
        const r = e1.getRoot();
        let s, a = !1, i = n ? o.startContainer : o.endContainer, l = n ? o.startOffset : o.endOffset;
        const d = qr(i) && l === i.childNodes.length, c = e1.schema.getNonEmptyElements();
        let u = n;
        if (zi(i)) return I.none();
        if (qr(i) && l > i.childNodes.length - 1 && (u = !1), rs(i) && (i = r, l = 0), i === r) {
            if (u && (s = i.childNodes[l > 0 ? l - 1 : 0], s)) {
                if (zi(s)) return I.none();
                if (c[s.nodeName] || Zr(s)) return I.none();
            }
            if (i.hasChildNodes()) {
                if (l = Math.min(!u && l > 0 ? l - 1 : l, i.childNodes.length - 1), i = i.childNodes[l], l = es(i) && d ? i.data.length : 0, !t && i === r.lastChild && Zr(i)) return I.none();
                if (((e1, t)=>{
                    let n = t;
                    for(; n && n !== e1;){
                        if (cs(n)) return !0;
                        n = n.parentNode;
                    }
                    return !1;
                })(r, i) || zi(i)) return I.none();
                if (hs(i)) return I.none();
                if (i.hasChildNodes() && !Zr(i)) {
                    s = i;
                    const t = new Fr(i, r);
                    do {
                        if (cs(s) || zi(s)) {
                            a = !1;
                            break;
                        }
                        if (es(s) && s.data.length > 0) {
                            l = u ? 0 : s.data.length, i = s, a = !0;
                            break;
                        }
                        if (c[s.nodeName.toLowerCase()] && !fs(s)) {
                            l = e1.nodeIndex(s), i = s.parentNode, u || l++, a = !0;
                            break;
                        }
                    }while (s = u ? t.next() : t.prev());
                }
            }
        }
        return t && (es(i) && 0 === l && Pg(e1, d, t, !0, i).each((e1)=>{
            i = e1.container(), l = e1.offset(), a = !0;
        }), qr(i) && (s = i.childNodes[l], s || (s = i.childNodes[l - 1]), !s || !as(s) || ((e1)=>{
            var t;
            return "A" === (null === (t = e1.previousSibling) || void 0 === t ? void 0 : t.nodeName);
        })(s) || Bg(e1, s, !1) || Bg(e1, s, !0) || Pg(e1, d, t, !0, s).each((e1)=>{
            i = e1.container(), l = e1.offset(), a = !0;
        }))), u && !t && es(i) && l === i.data.length && Pg(e1, d, t, !1, i).each((e1)=>{
            i = e1.container(), l = e1.offset(), a = !0;
        }), a && i ? I.some(Pl(i, l)) : I.none();
    }, Lg = (e1, t)=>{
        const n = t.collapsed, o = t.cloneRange(), r = Pl.fromRangeStart(t);
        return Dg(e1, n, !0, o).each((e1)=>{
            n && Pl.isAbove(r, e1) || o.setStart(e1.container(), e1.offset());
        }), n || Dg(e1, n, !1, o).each((e1)=>{
            o.setEnd(e1.container(), e1.offset());
        }), n && o.collapse(!0), Rg(t, o) ? I.none() : I.some(o);
    }, Mg = (e1, t)=>e1.splitText(t), Ig = (e1)=>{
        let t = e1.startContainer, n = e1.startOffset, o = e1.endContainer, r = e1.endOffset;
        if (t === o && es(t)) {
            if (n > 0 && n < t.data.length) {
                if (o = Mg(t, n), t = o.previousSibling, r > n) {
                    r -= n;
                    const e1 = Mg(o, r).previousSibling;
                    t = o = e1, r = e1.data.length, n = 0;
                } else r = 0;
            }
        } else if (es(t) && n > 0 && n < t.data.length && (t = Mg(t, n), n = 0), es(o) && r > 0 && r < o.data.length) {
            const e1 = Mg(o, r).previousSibling;
            o = e1, r = e1.data.length;
        }
        return {
            startContainer: t,
            startOffset: n,
            endContainer: o,
            endOffset: r
        };
    }, Fg = (e1)=>({
            walk: (t, n)=>Hf(e1, t, n),
            split: Ig,
            expand: (t, n = {
                type: "word"
            })=>{
                if ("word" === n.type) {
                    const n = jf(e1, t, [
                        {
                            inline: "span"
                        }
                    ], {
                        includeTrailingSpace: !1,
                        expandToBlock: !1
                    }), o = e1.createRng();
                    return o.setStart(n.startContainer, n.startOffset), o.setEnd(n.endContainer, n.endOffset), o;
                }
                return t;
            },
            normalize: (t)=>Lg(e1, t).fold(L, (e1)=>(t.setStart(e1.startContainer, e1.startOffset), t.setEnd(e1.endContainer, e1.endOffset), !0))
        });
    Fg.compareRanges = Rg, Fg.getCaretRangeFromPoint = Ng, Fg.getSelectedNode = tl, Fg.getNode = nl;
    const Ug = (e1)=>"textarea" === _n(e1), zg = (e1, t)=>{
        const n = ((e1)=>{
            const t = e1.dom.ownerDocument, n = t.body, o = t.defaultView, r = t.documentElement;
            if (n === e1.dom) return Ho(n.offsetLeft, n.offsetTop);
            const s = $o(null == o ? void 0 : o.pageYOffset, r.scrollTop), a = $o(null == o ? void 0 : o.pageXOffset, r.scrollLeft), i = $o(r.clientTop, n.clientTop), l = $o(r.clientLeft, n.clientLeft);
            return Vo(e1).translate(a - l, s - i);
        })(e1), o = ((e1)=>zo.get(e1))(e1);
        return {
            element: e1,
            bottom: n.top + o,
            height: o,
            pos: n,
            cleanup: t
        };
    }, jg = (e1, t, n, o)=>{
        qg(e1, (r, s)=>$g(e1, t, n, o), n);
    }, Hg = (e1, t, n, o, r)=>{
        const s = {
            elm: o.element.dom,
            alignToTop: r
        };
        ((e1, t)=>e1.dispatch("ScrollIntoView", t).isDefaultPrevented())(e1, s) || (n(e1, t, qo(t).top, o, r), ((e1, t)=>{
            e1.dispatch("AfterScrollIntoView", t);
        })(e1, s));
    }, $g = (e1, t, n, o)=>{
        const r = mn(e1.getBody()), s = mn(e1.getDoc());
        r.dom.offsetWidth;
        const a = ((e1, t)=>{
            const n = ((e1, t)=>{
                const n = Hn(e1);
                if (0 === n.length || Ug(e1)) return {
                    element: e1,
                    offset: t
                };
                if (t < n.length && !Ug(n[t])) return {
                    element: n[t],
                    offset: 0
                };
                {
                    const o = n[n.length - 1];
                    return Ug(o) ? {
                        element: e1,
                        offset: t
                    } : "img" === _n(o) ? {
                        element: o,
                        offset: 1
                    } : Rn(o) ? {
                        element: o,
                        offset: Xo(o).length
                    } : {
                        element: o,
                        offset: Hn(o).length
                    };
                }
            })(e1, t), o = dn('<span data-mce-bogus="all" style="display: inline-block;">\ufeff</span>');
            return ao(n.element, o), zg(o, ()=>Eo(o));
        })(mn(n.startContainer), n.startOffset);
        Hg(e1, s, t, a, o), a.cleanup();
    }, Vg = (e1, t, n, o)=>{
        const r = mn(e1.getDoc());
        Hg(e1, r, n, ((e1)=>zg(mn(e1), x))(t), o);
    }, qg = (e1, t, n)=>{
        const o = n.startContainer, r = n.startOffset, s = n.endContainer, a = n.endOffset;
        t(mn(o), mn(s));
        const i = e1.dom.createRng();
        i.setStart(o, r), i.setEnd(s, a), e1.selection.setRng(n);
    }, Wg = (e1, t, n, o, r)=>{
        const s = t.pos;
        if (o) Wo(s.left, Math.max(0, s.top - 30), r);
        else {
            const o = s.top - n + t.height + 30;
            Wo(-e1.getBody().getBoundingClientRect().left, o, r);
        }
    }, Kg = (e1, t, n, o, r, s)=>{
        const a = o + n, i = r.pos.top, l = r.bottom, d = l - i >= o;
        i < n ? Wg(e1, r, o, !1 !== s, t) : i > a ? Wg(e1, r, o, d ? !1 !== s : !0 === s, t) : l > a && !d && Wg(e1, r, o, !0 === s, t);
    }, Yg = (e1, t, n, o, r)=>{
        const s = Dn(t).dom.innerHeight;
        Kg(e1, t, n, s, o, r);
    }, Gg = (e1, t, n, o, r)=>{
        const s = Dn(t).dom.innerHeight;
        Kg(e1, t, n, s, o, r);
        const a = lg(o.element), i = Ir(window);
        a.top < i.y ? Ko(o.element, !1 !== r) : a.top > i.bottom && Ko(o.element, !0 === r);
    }, Xg = (e1, t, n)=>jg(e1, Yg, t, n), Zg = (e1, t, n)=>Vg(e1, t, Yg, n), Qg = (e1, t, n)=>jg(e1, Gg, t, n), Jg = (e1, t, n)=>Vg(e1, t, Gg, n), ep = (e1, t, n)=>{
        (e1.inline ? Xg : Qg)(e1, t, n);
    }, tp = (e1, t)=>t.collapsed ? e1.isEditable(t.startContainer) : e1.isEditable(t.startContainer) && e1.isEditable(t.endContainer), np = (e1, t, n, o, r)=>{
        const s = n ? t.startContainer : t.endContainer, a = n ? t.startOffset : t.endOffset;
        return I.from(s).map(mn).map((e1)=>o && t.collapsed ? e1 : $n(e1, r(e1, a)).getOr(e1)).bind((e1)=>Nn(e1) ? I.some(e1) : Ln(e1).filter(Nn)).map((e1)=>e1.dom).getOr(e1);
    }, op = (e1, t, n = !1)=>np(e1, t, !0, n, (e1, t)=>Math.min(Wn(e1), t)), rp = (e1, t, n = !1)=>np(e1, t, !1, n, (e1, t)=>t > 0 ? t - 1 : t), sp = (e1, t)=>{
        const n = e1;
        for(; e1 && es(e1) && 0 === e1.length;)e1 = t ? e1.nextSibling : e1.previousSibling;
        return e1 || n;
    }, ap = (e1, t)=>V(t, (t)=>{
            const n = e1.dispatch("GetSelectionRange", {
                range: t
            });
            return n.range !== t ? n.range : t;
        }), ip = {
        "#text": 3,
        "#comment": 8,
        "#cdata": 4,
        "#pi": 7,
        "#doctype": 10,
        "#document-fragment": 11
    }, lp = (e1, t, n)=>{
        const o = n ? "lastChild" : "firstChild", r = n ? "prev" : "next";
        if (e1[o]) return e1[o];
        if (e1 !== t) {
            let n = e1[r];
            if (n) return n;
            for(let o = e1.parent; o && o !== t; o = o.parent)if (n = o[r], n) return n;
        }
    }, dp = (e1)=>{
        var t;
        const n = null !== (t = e1.value) && void 0 !== t ? t : "";
        if (!zr(n)) return !1;
        const o = e1.parent;
        return !o || "span" === o.name && !o.attr("style") || !/^[ ]+$/.test(n);
    }, cp = (e1)=>{
        const t = "a" === e1.name && !e1.attr("href") && e1.attr("id");
        return e1.attr("name") || e1.attr("id") && !e1.firstChild || e1.attr("data-mce-bookmark") || t;
    };
    class up {
        static create(e1, t) {
            const n = new up(e1, ip[e1] || 1);
            return t && pe(t, (e1, t)=>{
                n.attr(t, e1);
            }), n;
        }
        constructor(e1, t){
            this.name = e1, this.type = t, 1 === t && (this.attributes = [], this.attributes.map = {});
        }
        replace(e1) {
            const t = this;
            return e1.parent && e1.remove(), t.insert(e1, t), t.remove(), t;
        }
        attr(e1, t) {
            const n = this;
            if (!m(e1)) return C(e1) && pe(e1, (e1, t)=>{
                n.attr(t, e1);
            }), n;
            const o = n.attributes;
            if (o) {
                if (void 0 !== t) {
                    if (null === t) {
                        if (e1 in o.map) {
                            delete o.map[e1];
                            let t = o.length;
                            for(; t--;)if (o[t].name === e1) return o.splice(t, 1), n;
                        }
                        return n;
                    }
                    if (e1 in o.map) {
                        let n = o.length;
                        for(; n--;)if (o[n].name === e1) {
                            o[n].value = t;
                            break;
                        }
                    } else o.push({
                        name: e1,
                        value: t
                    });
                    return o.map[e1] = t, n;
                }
                return o.map[e1];
            }
        }
        clone() {
            const e1 = this, t = new up(e1.name, e1.type), n = e1.attributes;
            if (n) {
                const e1 = [];
                e1.map = {};
                for(let t = 0, o = n.length; t < o; t++){
                    const o = n[t];
                    "id" !== o.name && (e1[e1.length] = {
                        name: o.name,
                        value: o.value
                    }, e1.map[o.name] = o.value);
                }
                t.attributes = e1;
            }
            return t.value = e1.value, t;
        }
        wrap(e1) {
            const t = this;
            return t.parent && (t.parent.insert(e1, t), e1.append(t)), t;
        }
        unwrap() {
            const e1 = this;
            for(let t = e1.firstChild; t;){
                const n = t.next;
                e1.insert(t, e1, !0), t = n;
            }
            e1.remove();
        }
        remove() {
            const e1 = this, t = e1.parent, n = e1.next, o = e1.prev;
            return t && (t.firstChild === e1 ? (t.firstChild = n, n && (n.prev = null)) : o && (o.next = n), t.lastChild === e1 ? (t.lastChild = o, o && (o.next = null)) : n && (n.prev = o), e1.parent = e1.next = e1.prev = null), e1;
        }
        append(e1) {
            const t = this;
            e1.parent && e1.remove();
            const n = t.lastChild;
            return n ? (n.next = e1, e1.prev = n, t.lastChild = e1) : t.lastChild = t.firstChild = e1, e1.parent = t, e1;
        }
        insert(e1, t, n) {
            e1.parent && e1.remove();
            const o = t.parent || this;
            return n ? (t === o.firstChild ? o.firstChild = e1 : t.prev && (t.prev.next = e1), e1.prev = t.prev, e1.next = t, t.prev = e1) : (t === o.lastChild ? o.lastChild = e1 : t.next && (t.next.prev = e1), e1.next = t.next, e1.prev = t, t.next = e1), e1.parent = o, e1;
        }
        getAll(e1) {
            const t = this, n = [];
            for(let o = t.firstChild; o; o = lp(o, t))o.name === e1 && n.push(o);
            return n;
        }
        children() {
            const e1 = [];
            for(let t = this.firstChild; t; t = t.next)e1.push(t);
            return e1;
        }
        empty() {
            const e1 = this;
            if (e1.firstChild) {
                const t = [];
                for(let n = e1.firstChild; n; n = lp(n, e1))t.push(n);
                let n = t.length;
                for(; n--;){
                    const e1 = t[n];
                    e1.parent = e1.firstChild = e1.lastChild = e1.next = e1.prev = null;
                }
            }
            return e1.firstChild = e1.lastChild = null, e1;
        }
        isEmpty(e1, t = {}, n) {
            var o;
            const r = this;
            let s = r.firstChild;
            if (cp(r)) return !1;
            if (s) do {
                if (1 === s.type) {
                    if (s.attr("data-mce-bogus")) continue;
                    if (e1[s.name]) return !1;
                    if (cp(s)) return !1;
                }
                if (8 === s.type) return !1;
                if (3 === s.type && !dp(s)) return !1;
                if (3 === s.type && s.parent && t[s.parent.name] && zr(null !== (o = s.value) && void 0 !== o ? o : "")) return !1;
                if (n && n(s)) return !1;
            }while (s = lp(s, r));
            return !0;
        }
        walk(e1) {
            return lp(this, null, e1);
        }
    }
    const mp = an.makeMap("NOSCRIPT STYLE SCRIPT XMP IFRAME NOEMBED NOFRAMES PLAINTEXT", " "), fp = (e1)=>m(e1.nodeValue) && e1.nodeValue.includes(Pi), gp = (e1)=>(0 === e1.length ? "" : `${V(e1, (e1)=>`[${e1}]`).join(",")},`) + '[data-mce-bogus="all"]', pp = (e1)=>document.createTreeWalker(e1, NodeFilter.SHOW_COMMENT, (e1)=>fp(e1) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP), hp = (e1)=>document.createTreeWalker(e1, NodeFilter.SHOW_TEXT, (e1)=>{
            if (fp(e1)) {
                const t = e1.parentNode;
                return t && xe(mp, t.nodeName) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_SKIP;
        }), bp = (e1)=>null !== pp(e1).nextNode(), vp = (e1)=>null !== hp(e1).nextNode(), yp = (e1, t)=>null !== t.querySelector(gp(e1)), Cp = (e1, t)=>{
        q(((e1, t)=>t.querySelectorAll(gp(e1)))(e1, t), (t)=>{
            const n = mn(t);
            "all" === ho(n, "data-mce-bogus") ? Eo(n) : q(e1, (e1)=>{
                vo(n, e1) && yo(n, e1);
            });
        });
    }, wp = (e1)=>{
        let t = e1.nextNode();
        for(; null !== t;)t.nodeValue = null, t = e1.nextNode();
    }, Ep = S(wp, pp), _p = S(wp, hp), xp = (e1, t)=>{
        const n = [
            {
                condition: T(yp, t),
                action: T(Cp, t)
            },
            {
                condition: bp,
                action: Ep
            },
            {
                condition: vp,
                action: _p
            }
        ];
        let o = e1, r = !1;
        return q(n, ({ condition: t, action: n })=>{
            t(o) && (r || (o = e1.cloneNode(!0), r = !0), n(o));
        }), o;
    }, Sp = (e1)=>{
        const t = vr(e1, "[data-mce-bogus]");
        q(t, (e1)=>{
            "all" === ho(e1, "data-mce-bogus") ? Eo(e1) : xi(e1) ? (ao(e1, un(at)), Eo(e1)) : _o(e1);
        });
    }, kp = (e1)=>{
        const t = vr(e1, "input");
        q(t, (e1)=>{
            yo(e1, "name");
        });
    }, Np = (e1, t, n)=>{
        let o;
        return o = "raw" === t.format ? an.trim(Li(xp(n, e1.serializer.getTempAttrs()).innerHTML)) : "text" === t.format ? ((e1, t)=>{
            const n = e1.getDoc(), o = Yn(mn(e1.getBody())), r = cn("div", n);
            go(r, "data-mce-bogus", "all"), Do(r, {
                position: "fixed",
                left: "-9999999px",
                top: "0"
            }), Ao(r, t.innerHTML), Sp(r), kp(r);
            const s = ((e1)=>Kn(e1) ? e1 : mn(Pn(e1).dom.body))(o);
            co(s, r);
            const a = Li(r.dom.innerText);
            return Eo(r), a;
        })(e1, n) : "tree" === t.format ? e1.serializer.serialize(n, t) : ((e1, t)=>{
            const n = Ad(e1), o = new RegExp(`^(<${n}[^>]*>(&nbsp;|&#160;|\\s|\xa0|<br \\/>|)<\\/${n}>[\r\n]*|<br \\/>[\r\n]*)$`);
            return t.replace(o, "");
        })(e1, e1.serializer.serialize(n, t)), "text" !== t.format && !Ti(mn(n)) && m(o) ? an.trim(o) : o;
    }, Rp = an.makeMap, Ap = (e1)=>{
        const t = [], n = (e1 = e1 || {}).indent, o = Rp(e1.indent_before || ""), r = Rp(e1.indent_after || ""), s = ua.getEncodeFunc(e1.entity_encoding || "raw", e1.entities), a = "xhtml" !== e1.element_format;
        return {
            start: (e1, i, l)=>{
                if (n && o[e1] && t.length > 0) {
                    const e1 = t[t.length - 1];
                    e1.length > 0 && "\n" !== e1 && t.push("\n");
                }
                if (t.push("<", e1), i) for(let e1 = 0, n = i.length; e1 < n; e1++){
                    const n = i[e1];
                    t.push(" ", n.name, '="', s(n.value, !0), '"');
                }
                if (t[t.length] = !l || a ? ">" : " />", l && n && r[e1] && t.length > 0) {
                    const e1 = t[t.length - 1];
                    e1.length > 0 && "\n" !== e1 && t.push("\n");
                }
            },
            end: (e1)=>{
                let o;
                t.push("</", e1, ">"), n && r[e1] && t.length > 0 && (o = t[t.length - 1], o.length > 0 && "\n" !== o && t.push("\n"));
            },
            text: (e1, n)=>{
                e1.length > 0 && (t[t.length] = n ? e1 : s(e1));
            },
            cdata: (e1)=>{
                t.push("<![CDATA[", e1, "]]>");
            },
            comment: (e1)=>{
                t.push("\x3c!--", e1, "--\x3e");
            },
            pi: (e1, o)=>{
                o ? t.push("<?", e1, " ", s(o), "?>") : t.push("<?", e1, "?>"), n && t.push("\n");
            },
            doctype: (e1)=>{
                t.push("<!DOCTYPE", e1, ">", n ? "\n" : "");
            },
            reset: ()=>{
                t.length = 0;
            },
            getContent: ()=>t.join("").replace(/\n$/, "")
        };
    }, Tp = (e1 = {}, t = Ra())=>{
        const n = Ap(e1);
        return e1.validate = !("validate" in e1) || e1.validate, {
            serialize: (o)=>{
                const r = e1.validate, s = {
                    3: (e1)=>{
                        var t;
                        n.text(null !== (t = e1.value) && void 0 !== t ? t : "", e1.raw);
                    },
                    8: (e1)=>{
                        var t;
                        n.comment(null !== (t = e1.value) && void 0 !== t ? t : "");
                    },
                    7: (e1)=>{
                        n.pi(e1.name, e1.value);
                    },
                    10: (e1)=>{
                        var t;
                        n.doctype(null !== (t = e1.value) && void 0 !== t ? t : "");
                    },
                    4: (e1)=>{
                        var t;
                        n.cdata(null !== (t = e1.value) && void 0 !== t ? t : "");
                    },
                    11: (e1)=>{
                        let t = e1;
                        if (t = t.firstChild) do a(t);
                        while (t = t.next);
                    }
                };
                n.reset();
                const a = (e1)=>{
                    var o;
                    const i = s[e1.type];
                    if (i) i(e1);
                    else {
                        const s = e1.name, i = s in t.getVoidElements();
                        let l = e1.attributes;
                        if (r && l && l.length > 1) {
                            const n = [];
                            n.map = {};
                            const o = t.getElementRule(e1.name);
                            if (o) {
                                for(let e1 = 0, t = o.attributesOrder.length; e1 < t; e1++){
                                    const t = o.attributesOrder[e1];
                                    if (t in l.map) {
                                        const e1 = l.map[t];
                                        n.map[t] = e1, n.push({
                                            name: t,
                                            value: e1
                                        });
                                    }
                                }
                                for(let e1 = 0, t = l.length; e1 < t; e1++){
                                    const t = l[e1].name;
                                    if (!(t in n.map)) {
                                        const e1 = l.map[t];
                                        n.map[t] = e1, n.push({
                                            name: t,
                                            value: e1
                                        });
                                    }
                                }
                                l = n;
                            }
                        }
                        if (n.start(s, l, i), ks(s)) m(e1.value) && n.text(e1.value, !0), n.end(s);
                        else if (!i) {
                            let t = e1.firstChild;
                            if (t) {
                                "pre" !== s && "textarea" !== s || 3 !== t.type || "\n" !== (null === (o = t.value) || void 0 === o ? void 0 : o[0]) || n.text("\n", !0);
                                do a(t);
                                while (t = t.next);
                            }
                            n.end(s);
                        }
                    }
                };
                return 1 !== o.type || e1.inner ? 3 === o.type ? s[3](o) : s[11](o) : a(o), n.getContent();
            }
        };
    }, Op = new Set;
    q([
        "margin",
        "margin-left",
        "margin-right",
        "margin-top",
        "margin-bottom",
        "padding",
        "padding-left",
        "padding-right",
        "padding-top",
        "padding-bottom",
        "border",
        "border-width",
        "border-style",
        "border-color",
        "background",
        "background-attachment",
        "background-clip",
        "background-image",
        "background-origin",
        "background-position",
        "background-repeat",
        "background-size",
        "float",
        "position",
        "left",
        "right",
        "top",
        "bottom",
        "z-index",
        "display",
        "transform",
        "width",
        "max-width",
        "min-width",
        "height",
        "max-height",
        "min-height",
        "overflow",
        "overflow-x",
        "overflow-y",
        "text-overflow",
        "vertical-align",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function"
    ], (e1)=>{
        Op.add(e1);
    });
    const Bp = new Set;
    q([
        "background-color"
    ], (e1)=>{
        Bp.add(e1);
    });
    const Pp = [
        "font",
        "text-decoration",
        "text-emphasis"
    ], Dp = (e1, t)=>fe(((e1, t)=>e1.parseStyle(e1.getAttrib(t, "style")))(e1, t)), Lp = (e1, t)=>$(Dp(e1, t), (e1)=>((e1)=>Op.has(e1))(e1)), Mp = (e1, t, n)=>I.from(n.container()).filter(es).exists((o)=>{
            const r = e1 ? 0 : -1;
            return t(o.data.charAt(n.offset() + r));
        }), Ip = T(Mp, !0, qm), Fp = T(Mp, !1, qm), Up = (e1)=>{
        const t = e1.container();
        return es(t) && (0 === t.data.length || Di(t.data) && Yf.isBookmarkNode(t.parentNode));
    }, zp = (e1, t)=>(n)=>Yu(e1 ? 0 : -1, n).filter(t).isSome(), jp = (e1)=>is(e1) && "block" === Lo(mn(e1), "display"), Hp = (e1)=>cs(e1) && !((e1)=>qr(e1) && "all" === e1.getAttribute("data-mce-bogus"))(e1), $p = zp(!0, jp), Vp = zp(!1, jp), qp = zp(!0, gs), Wp = zp(!1, gs), Kp = zp(!0, Zr), Yp = zp(!1, Zr), Gp = zp(!0, Hp), Xp = zp(!1, Hp), Zp = (e1, t)=>((e1, t, n)=>wn(t, e1) ? In(e1, (e1)=>n(e1) || Cn(e1, t)).slice(0, -1) : [])(e1, t, L), Qp = (e1, t)=>[
            e1
        ].concat(Zp(e1, t)), Jp = (e1, t, n)=>Em(e1, t, n, Up), eh = (e1, t, n)=>Q(Qp(mn(t.container()), e1), ((e1)=>(t)=>e1.isBlock(_n(t)))(n)), th = (e1, t, n, o)=>Jp(e1, t.dom, n).forall((e1)=>eh(t, n, o).fold(()=>!Ku(e1, n, t.dom), (o)=>!Ku(e1, n, t.dom) && wn(o, mn(e1.container())))), nh = (e1, t, n, o)=>eh(t, n, o).fold(()=>Jp(e1, t.dom, n).forall((e1)=>!Ku(e1, n, t.dom)), (t)=>Jp(e1, t.dom, n).isNone()), oh = T(nh, !1), rh = T(nh, !0), sh = T(th, !1), ah = T(th, !0), ih = (e1)=>om(e1).exists(xi), lh = (e1, t, n, o)=>{
        const r = Y(Qp(mn(n.container()), t), (e1)=>o.isBlock(_n(e1))), s = le(r).getOr(t);
        return Cm(e1, s.dom, n).filter(ih);
    }, dh = (e1, t, n)=>om(t).exists(xi) || lh(!0, e1, t, n).isSome(), ch = (e1, t, n)=>((e1)=>I.from(e1.getNode(!0)).map(mn))(t).exists(xi) || lh(!1, e1, t, n).isSome(), uh = T(lh, !1), mh = T(lh, !0), fh = (e1)=>Pl.isTextPosition(e1) && !e1.isAtStart() && !e1.isAtEnd(), gh = (e1, t, n)=>{
        const o = Y(Qp(mn(t.container()), e1), (e1)=>n.isBlock(_n(e1)));
        return le(o).getOr(e1);
    }, ph = (e1, t, n)=>fh(t) ? Fp(t) : Fp(t) || Sm(gh(e1, t, n).dom, t).exists(Fp), hh = (e1, t, n)=>fh(t) ? Ip(t) : Ip(t) || xm(gh(e1, t, n).dom, t).exists(Ip), bh = (e1)=>om(e1).bind((e1)=>tr(e1, Nn)).exists((e1)=>((e1)=>H([
                    "pre",
                    "pre-wrap"
                ], e1))(Lo(e1, "white-space"))), vh = (e1, t)=>(n)=>{
            var o;
            return o = new Fr(n, e1)[t](), C(o) && cs(o) && Mu(o);
        }, yh = (e1, t, n)=>!bh(t) && (((e1, t, n)=>((e1, t)=>Sm(e1.dom, t).isNone())(e1, t) || ((e1, t)=>xm(e1.dom, t).isNone())(e1, t) || oh(e1, t, n) || rh(e1, t, n) || ch(e1, t, n) || dh(e1, t, n))(e1, t, n) || ph(e1, t, n) || hh(e1, t, n)), Ch = (e1, t, n)=>!bh(t) && (oh(e1, t, n) || sh(e1, t, n) || ch(e1, t, n) || ph(e1, t, n) || ((e1, t)=>{
            const n = Sm(e1.dom, t).getOr(t), o = vh(e1.dom, "prev");
            return t.isAtStart() && (o(t.container()) || o(n.container()));
        })(e1, t)), wh = (e1, t, n)=>!bh(t) && (rh(e1, t, n) || ah(e1, t, n) || dh(e1, t, n) || hh(e1, t, n) || ((e1, t)=>{
            const n = xm(e1.dom, t).getOr(t), o = vh(e1.dom, "next");
            return t.isAtEnd() && (o(t.container()) || o(n.container()));
        })(e1, t)), Eh = (e1, t, n)=>Ch(e1, t, n) || wh(e1, ((e1)=>{
            const t = e1.container(), n = e1.offset();
            return es(t) && n < t.data.length ? Pl(t, n + 1) : e1;
        })(t), n), _h = (e1, t)=>$m(e1.charAt(t)), xh = (e1, t)=>qm(e1.charAt(t)), Sh = (e1, t, n, o)=>{
        const r = t.data, s = Pl(t, 0);
        return n || !_h(r, 0) || Eh(e1, s, o) ? !!(n && xh(r, 0) && Ch(e1, s, o)) && (t.data = it + r.slice(1), !0) : (t.data = " " + r.slice(1), !0);
    }, kh = (e1, t, n, o)=>{
        const r = t.data, s = Pl(t, r.length - 1);
        return n || !_h(r, r.length - 1) || Eh(e1, s, o) ? !!(n && xh(r, r.length - 1) && wh(e1, s, o)) && (t.data = r.slice(0, -1) + it, !0) : (t.data = r.slice(0, -1) + " ", !0);
    }, Nh = (e1, t, n)=>{
        const o = t.container();
        if (!es(o)) return I.none();
        if (((e1)=>{
            const t = e1.container();
            return es(t) && Ke(t.data, it);
        })(t)) {
            const r = Sh(e1, o, !1, n) || ((e1)=>{
                const t = e1.data, n = ((e1)=>{
                    const t = e1.split("");
                    return V(t, (e1, n)=>$m(e1) && n > 0 && n < t.length - 1 && Wm(t[n - 1]) && Wm(t[n + 1]) ? " " : e1).join("");
                })(t);
                return n !== t && (e1.data = n, !0);
            })(o) || kh(e1, o, !1, n);
            return je(r, t);
        }
        if (Eh(e1, t, n)) {
            const r = Sh(e1, o, !0, n) || kh(e1, o, !0, n);
            return je(r, t);
        }
        return I.none();
    }, Rh = (e1, t, n, o)=>{
        if (0 === n) return;
        const r = mn(e1), s = er(r, (e1)=>o.isBlock(_n(e1))).getOr(r), a = e1.data.slice(t, t + n), i = t + n >= e1.data.length && wh(s, Pl(e1, e1.data.length), o), l = 0 === t && Ch(s, Pl(e1, 0), o);
        e1.replaceData(t, n, Hr(a, 4, l, i));
    }, Ah = (e1, t, n)=>{
        const o = e1.data.slice(t), r = o.length - Qe(o).length;
        Rh(e1, t, r, n);
    }, Th = (e1, t, n)=>{
        const o = e1.data.slice(0, t), r = o.length - Je(o).length;
        Rh(e1, t - r, r, n);
    }, Oh = (e1, t, n, o, r = !0)=>{
        const s = Je(e1.data).length, a = r ? e1 : t, i = r ? t : e1;
        return r ? a.appendData(i.data) : a.insertData(0, i.data), Eo(mn(i)), o && Ah(a, s, n), a;
    }, Bh = (e1, t)=>((e1, t)=>{
            const n = e1.container(), o = e1.offset();
            return !Pl.isTextPosition(e1) && n === t.parentNode && o > Pl.before(t).offset();
        })(t, e1) ? Pl(t.container(), t.offset() - 1) : t, Ph = (e1)=>{
        var t;
        return fl(e1.previousSibling) ? I.some((t = e1.previousSibling, es(t) ? Pl(t, t.data.length) : Pl.after(t))) : e1.previousSibling ? Nm(e1.previousSibling) : I.none();
    }, Dh = (e1)=>{
        var t;
        return fl(e1.nextSibling) ? I.some((t = e1.nextSibling, es(t) ? Pl(t, 0) : Pl.before(t))) : e1.nextSibling ? km(e1.nextSibling) : I.none();
    }, Lh = (e1, t, n)=>((e1, t, n)=>e1 ? ((e1, t)=>Dh(t).orThunk(()=>Ph(t)).orThunk(()=>((e1, t)=>xm(e1, Pl.after(t)).orThunk(()=>Sm(e1, Pl.before(t))))(e1, t)))(t, n) : ((e1, t)=>Ph(t).orThunk(()=>Dh(t)).orThunk(()=>((e1, t)=>I.from(t.previousSibling ? t.previousSibling : t.parentNode).bind((t)=>Sm(e1, Pl.before(t))).orThunk(()=>xm(e1, Pl.after(t))))(e1, t)))(t, n))(e1, t, n).map(T(Bh, n)), Mh = (e1, t, n)=>{
        n.fold(()=>{
            e1.focus();
        }, (n)=>{
            e1.selection.setRng(n.toRange(), t);
        });
    }, Ih = (e1, t)=>t && xe(e1.schema.getBlockElements(), _n(t)), Fh = (e1, t, n, o = !0, r = !1)=>{
        const s = Lh(t, e1.getBody(), n.dom), a = er(n, T(Ih, e1), (i = e1.getBody(), (e1)=>e1.dom === i));
        var i;
        const l = ((e1, t, n, o)=>{
            const r = Fn(e1).filter(Rn), s = Un(e1).filter(Rn);
            var a, i, l, d;
            return Eo(e1), (a = r, i = s, l = t, d = (e1, t, r)=>{
                const s = e1.dom, a = t.dom, i = s.data.length;
                return Oh(s, a, n, o), r.container() === a ? Pl(s, i) : r;
            }, a.isSome() && i.isSome() && l.isSome() ? I.some(d(a.getOrDie(), i.getOrDie(), l.getOrDie())) : I.none()).orThunk(()=>(o && (r.each((e1)=>Th(e1.dom, e1.dom.length, n)), s.each((e1)=>Ah(e1.dom, 0, n))), t));
        })(n, s, e1.schema, ((e1, t)=>xe(e1.schema.getTextInlineElements(), _n(t)))(e1, n));
        e1.dom.isEmpty(e1.getBody()) ? (e1.setContent(""), e1.selection.setCursorLocation()) : a.bind((t)=>((e1, t, n)=>{
                if (_s(e1, t)) {
                    const e1 = dn('<br data-mce-bogus="1">');
                    return n ? q(Hn(t), (e1)=>{
                        kf(e1) || Eo(e1);
                    }) : wo(t), co(t, e1), I.some(Pl.before(e1.dom));
                }
                return I.none();
            })(e1.schema, t, r)).fold(()=>{
            o && Mh(e1, t, l);
        }, (n)=>{
            o && Mh(e1, t, I.some(n));
        });
    }, Uh = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/, zh = (e1, t)=>vn(mn(t), tc(e1)) && !js(e1.schema, t) && e1.dom.isEditable(t), jh = (e1)=>{
        var t;
        return "rtl" === ni.DOM.getStyle(e1, "direction", !0) || ((e1)=>Uh.test(e1))(null !== (t = e1.textContent) && void 0 !== t ? t : "");
    }, Hh = (e1, t, n)=>{
        const o = ((e1, t, n)=>Y(ni.DOM.getParents(n.container(), "*", t), e1))(e1, t, n);
        return I.from(o[o.length - 1]);
    }, $h = (e1, t)=>{
        const n = t.container(), o = t.offset();
        return e1 ? Ui(n) ? es(n.nextSibling) ? Pl(n.nextSibling, 0) : Pl.after(n) : Hi(t) ? Pl(n, o + 1) : t : Ui(n) ? es(n.previousSibling) ? Pl(n.previousSibling, n.previousSibling.data.length) : Pl.before(n) : $i(t) ? Pl(n, o - 1) : t;
    }, Vh = T($h, !0), qh = T($h, !1), Wh = (e1, t)=>{
        const n = (e1)=>e1.stopImmediatePropagation();
        e1.on("beforeinput input", n, !0), e1.getDoc().execCommand(t), e1.off("beforeinput input", n);
    }, Kh = (e1)=>Wh(e1, "Delete"), Yh = (e1)=>Wh(e1, "ForwardDelete"), Gh = (e1)=>Si(e1) || Ni(e1), Xh = (e1, t)=>wn(e1, t) ? tr(t, Gh, ((e1)=>(t)=>Fe(Ln(t), e1, Cn))(e1)) : I.none(), Zh = (e1, t = !0)=>{
        e1.dom.isEmpty(e1.getBody()) && e1.setContent("", {
            no_selection: !t
        });
    }, Qh = (e1, t, n)=>ze(km(n), Nm(n), (o, r)=>{
            const s = $h(!0, o), a = $h(!1, r), i = $h(!1, t);
            return e1 ? xm(n, i).exists((e1)=>e1.isEqual(a) && t.isEqual(s)) : Sm(n, i).exists((e1)=>e1.isEqual(s) && t.isEqual(a));
        }).getOr(!0), Jh = (e1)=>{
        var t;
        return (8 === xn(t = e1) || "#comment" === _n(t) ? Fn(e1) : qn(e1)).bind(Jh).orThunk(()=>I.some(e1));
    }, eb = (e1, t, n, o = !0)=>{
        var r;
        t.deleteContents();
        const s = Jh(n).getOr(n), a = mn(null !== (r = e1.dom.getParent(s.dom, e1.dom.isBlock)) && void 0 !== r ? r : n.dom);
        if (a.dom === e1.getBody() ? Zh(e1, o) : _s(e1.schema, a, {
            checkRootAsContent: !1
        }) && (Bi(a), o && e1.selection.setCursorLocation(a.dom, 0)), !Cn(n, a)) {
            const t = Fe(Ln(a), n) ? [] : Ln(i = a).map(Hn).map((e1)=>Y(e1, (e1)=>!Cn(i, e1))).getOr([]);
            q(t.concat(Hn(n)), (t)=>{
                Cn(t, a) || wn(t, a) || !_s(e1.schema, t) || Eo(t);
            });
        }
        var i;
    }, tb = (e1)=>vr(e1, "td,th"), nb = (e1, t)=>Xm(mn(e1), t), ob = (e1, t)=>({
            start: e1,
            end: t
        }), rb = ke([
        {
            singleCellTable: [
                "rng",
                "cell"
            ]
        },
        {
            fullTable: [
                "table"
            ]
        },
        {
            partialTable: [
                "cells",
                "outsideDetails"
            ]
        },
        {
            multiTable: [
                "startTableCells",
                "endTableCells",
                "betweenRng"
            ]
        }
    ]), sb = (e1, t)=>sr(mn(e1), "td,th", t), ab = (e1)=>!Cn(e1.start, e1.end), ib = (e1, t)=>Xm(e1.start, t).bind((n)=>Xm(e1.end, t).bind((e1)=>je(Cn(n, e1), n))), lb = (e1)=>(t)=>ib(t, e1).map((e1)=>((e1, t, n)=>({
                        rng: e1,
                        table: t,
                        cells: n
                    }))(t, e1, tb(e1))), db = (e1, t, n, o)=>{
        if (n.collapsed || !e1.forall(ab)) return I.none();
        if (t.isSameTable) {
            const t = e1.bind(lb(o));
            return I.some({
                start: t,
                end: t
            });
        }
        {
            const e1 = sb(n.startContainer, o), t = sb(n.endContainer, o), r = e1.bind(((e1)=>(t)=>Xm(t, e1).bind((e1)=>de(tb(e1)).map((e1)=>ob(t, e1))))(o)).bind(lb(o)), s = t.bind(((e1)=>(t)=>Xm(t, e1).bind((e1)=>le(tb(e1)).map((e1)=>ob(e1, t))))(o)).bind(lb(o));
            return I.some({
                start: r,
                end: s
            });
        }
    }, cb = (e1, t)=>J(e1, (e1)=>Cn(e1, t)), ub = (e1)=>ze(cb(e1.cells, e1.rng.start), cb(e1.cells, e1.rng.end), (t, n)=>e1.cells.slice(t, n + 1)), mb = (e1, t)=>{
        const { startTable: n, endTable: o } = t, r = e1.cloneRange();
        return n.each((e1)=>r.setStartAfter(e1.dom)), o.each((e1)=>r.setEndBefore(e1.dom)), r;
    }, fb = (e1, t)=>{
        const n = ((e1)=>(t)=>Cn(e1, t))(e1), o = ((e1, t)=>{
            const n = sb(e1.startContainer, t), o = sb(e1.endContainer, t);
            return ze(n, o, ob);
        })(t, n), r = ((e1, t)=>{
            const n = nb(e1.startContainer, t), o = nb(e1.endContainer, t), r = n.isSome(), s = o.isSome(), a = ze(n, o, Cn).getOr(!1);
            return ((e1)=>ze(e1.startTable, e1.endTable, (t, n)=>{
                    const o = wr(t, (e1)=>Cn(e1, n)), r = wr(n, (e1)=>Cn(e1, t));
                    return o || r ? {
                        ...e1,
                        startTable: o ? I.none() : e1.startTable,
                        endTable: r ? I.none() : e1.endTable,
                        isSameTable: !1,
                        isMultiTable: !1
                    } : e1;
                }).getOr(e1))({
                startTable: n,
                endTable: o,
                isStartInTable: r,
                isEndInTable: s,
                isSameTable: a,
                isMultiTable: !a && r && s
            });
        })(t, n);
        return ((e1, t, n)=>e1.exists((e1)=>((e1, t)=>!ab(e1) && ib(e1, t).exists((e1)=>{
                        const t = e1.dom.rows;
                        return 1 === t.length && 1 === t[0].cells.length;
                    }))(e1, n) && Jm(e1.start, t)))(o, t, n) ? o.map((e1)=>rb.singleCellTable(t, e1.start)) : r.isMultiTable ? ((e1, t, n, o)=>db(e1, t, n, o).bind(({ start: e1, end: o })=>{
                const r = e1.bind(ub).getOr([]), s = o.bind(ub).getOr([]);
                if (r.length > 0 && s.length > 0) {
                    const e1 = mb(n, t);
                    return I.some(rb.multiTable(r, s, e1));
                }
                return I.none();
            }))(o, r, t, n) : ((e1, t, n, o)=>db(e1, t, n, o).bind(({ start: e1, end: t })=>e1.or(t)).bind((e1)=>{
                const { isSameTable: o } = t, r = ub(e1).getOr([]);
                if (o && e1.cells.length === r.length) return I.some(rb.fullTable(e1.table));
                if (r.length > 0) {
                    if (o) return I.some(rb.partialTable(r, I.none()));
                    {
                        const e1 = mb(n, t);
                        return I.some(rb.partialTable(r, I.some({
                            ...t,
                            rng: e1
                        })));
                    }
                }
                return I.none();
            }))(o, r, t, n);
    }, gb = (e1)=>q(e1, (e1)=>{
            yo(e1, "contenteditable"), Bi(e1);
        }), pb = (e1, t, n, o)=>{
        const r = n.cloneRange();
        o ? (r.setStart(n.startContainer, n.startOffset), r.setEndAfter(t.dom.lastChild)) : (r.setStartBefore(t.dom.firstChild), r.setEnd(n.endContainer, n.endOffset)), yb(e1, r, t, !1).each((e1)=>e1());
    }, hb = (e1)=>{
        const t = Gm(e1), n = mn(e1.selection.getNode());
        ms(n.dom) && _s(e1.schema, n) ? e1.selection.setCursorLocation(n.dom, 0) : e1.selection.collapse(!0), t.length > 1 && $(t, (e1)=>Cn(e1, n)) && go(n, "data-mce-selected", "1");
    }, bb = (e1, t, n)=>I.some(()=>{
            const o = e1.selection.getRng(), r = n.bind(({ rng: n, isStartInTable: r })=>{
                const s = ((e1, t)=>I.from(e1.dom.getParent(t, e1.dom.isBlock)).map(mn))(e1, r ? n.endContainer : n.startContainer);
                n.deleteContents(), ((e1, t, n)=>{
                    n.each((n)=>{
                        t ? Eo(n) : (Bi(n), e1.selection.setCursorLocation(n.dom, 0));
                    });
                })(e1, r, s.filter(T(_s, e1.schema)));
                const a = r ? t[0] : t[t.length - 1];
                return pb(e1, a, o, r), _s(e1.schema, a) ? I.none() : I.some(r ? t.slice(1) : t.slice(0, -1));
            }).getOr(t);
            gb(r), hb(e1);
        }), vb = (e1, t, n, o)=>I.some(()=>{
            const r = e1.selection.getRng(), s = t[0], a = n[n.length - 1];
            pb(e1, s, r, !0), pb(e1, a, r, !1);
            const i = _s(e1.schema, s) ? t : t.slice(1), l = _s(e1.schema, a) ? n : n.slice(0, -1);
            gb(i.concat(l)), o.deleteContents(), hb(e1);
        }), yb = (e1, t, n, o = !0)=>I.some(()=>{
            eb(e1, t, n, o);
        }), Cb = (e1, t)=>I.some(()=>Fh(e1, !1, t)), wb = (e1, t)=>Q(Qp(t, e1), Ai), Eb = (e1, t)=>Q(Qp(t, e1), On("caption")), _b = (e1, t)=>I.some(()=>{
            Bi(t), e1.selection.setCursorLocation(t.dom, 0);
        }), xb = (e1, t)=>e1 ? Kp(t) : Yp(t), Sb = (e1, t, n)=>{
        const o = mn(e1.getBody());
        return Eb(o, n).fold(()=>((e1, t, n, o)=>{
                const r = Pl.fromRangeStart(e1.selection.getRng());
                return wb(n, o).bind((o)=>_s(e1.schema, o, {
                        checkRootAsContent: !1
                    }) ? _b(e1, o) : ((e1, t, n, o, r)=>wm(n, e1.getBody(), r).bind((e1)=>wb(t, mn(e1.getNode())).bind((e1)=>Cn(e1, o) ? I.none() : I.some(x))))(e1, n, t, o, r));
            })(e1, t, o, n).orThunk(()=>je(((e1, t)=>{
                    const n = Pl.fromRangeStart(e1.selection.getRng());
                    return xb(t, n) || Cm(t, e1.getBody(), n).exists((e1)=>xb(t, e1));
                })(e1, t), x)), (n)=>((e1, t, n, o)=>{
                const r = Pl.fromRangeStart(e1.selection.getRng());
                return _s(e1.schema, o) ? _b(e1, o) : ((e1, t, n, o, r)=>wm(n, e1.getBody(), r).fold(()=>I.some(x), (s)=>((e1, t, n, o)=>km(e1.dom).bind((r)=>Nm(e1.dom).map((e1)=>t ? n.isEqual(r) && o.isEqual(e1) : n.isEqual(e1) && o.isEqual(r))).getOr(!0))(o, n, r, s) ? ((e1, t)=>_b(e1, t))(e1, o) : ((e1, t, n)=>Eb(e1, mn(n.getNode())).fold(()=>I.some(x), (e1)=>je(!Cn(e1, t), x)))(t, o, s)))(e1, n, t, o, r);
            })(e1, t, o, n));
    }, kb = (e1, t)=>{
        const n = mn(e1.selection.getStart(!0)), o = Gm(e1);
        return e1.selection.isCollapsed() && 0 === o.length ? Sb(e1, t, n) : ((e1, t, n)=>{
            const o = mn(e1.getBody()), r = e1.selection.getRng();
            return 0 !== n.length ? bb(e1, n, I.none()) : ((e1, t, n, o)=>Eb(t, o).fold(()=>((e1, t, n)=>fb(t, n).bind((t)=>t.fold(T(yb, e1), T(Cb, e1), T(bb, e1), T(vb, e1))))(e1, t, n), (t)=>((e1, t)=>_b(e1, t))(e1, t)))(e1, o, r, t);
        })(e1, n, o);
    }, Nb = (e1, t)=>{
        let n = t;
        for(; n && n !== e1;){
            if (ds(n) || cs(n)) return n;
            n = n.parentNode;
        }
        return null;
    }, Rb = [
        "data-ephox-",
        "data-mce-",
        "data-alloy-",
        "data-snooker-",
        "_"
    ], Ab = an.each, Tb = (e1)=>{
        const t = e1.dom, n = new Set(e1.serializer.getTempAttrs()), o = (e1)=>$(Rb, (t)=>Ye(e1, t)) || n.has(e1);
        return {
            compare: (e1, n)=>{
                if (e1.nodeName !== n.nodeName || e1.nodeType !== n.nodeType) return !1;
                const r = (e1)=>{
                    const n = {};
                    return Ab(t.getAttribs(e1), (r)=>{
                        const s = r.nodeName.toLowerCase();
                        "style" === s || o(s) || (n[s] = t.getAttrib(e1, s));
                    }), n;
                }, s = (e1, t)=>{
                    for(const n in e1)if (xe(e1, n)) {
                        const o = t[n];
                        if (v(o)) return !1;
                        if (e1[n] !== o) return !1;
                        delete t[n];
                    }
                    for(const e1 in t)if (xe(t, e1)) return !1;
                    return !0;
                };
                if (qr(e1) && qr(n)) {
                    if (!s(r(e1), r(n))) return !1;
                    if (!s(t.parseStyle(t.getAttrib(e1, "style")), t.parseStyle(t.getAttrib(n, "style")))) return !1;
                }
                return !Hm(e1) && !Hm(n);
            },
            isAttributeInternal: o
        };
    }, Ob = (e1)=>[
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6"
        ].includes(e1.name), Bb = (e1, t, n, o)=>{
        const r = n.name;
        for(let t = 0, s = e1.length; t < s; t++){
            const s = e1[t];
            if (s.name === r) {
                const e1 = o.nodes[r];
                e1 ? e1.nodes.push(n) : o.nodes[r] = {
                    filter: s,
                    nodes: [
                        n
                    ]
                };
            }
        }
        if (n.attributes) for(let e1 = 0, r = t.length; e1 < r; e1++){
            const r = t[e1], s = r.name;
            if (s in n.attributes.map) {
                const e1 = o.attributes[s];
                e1 ? e1.nodes.push(n) : o.attributes[s] = {
                    filter: r,
                    nodes: [
                        n
                    ]
                };
            }
        }
    }, Pb = (e1, t)=>{
        const n = (e1, n)=>{
            pe(e1, (e1)=>{
                const o = ce(e1.nodes);
                q(e1.filter.callbacks, (r)=>{
                    for(let t = o.length - 1; t >= 0; t--){
                        const r = o[t];
                        (n ? void 0 !== r.attr(e1.filter.name) : r.name === e1.filter.name) && !y(r.parent) || o.splice(t, 1);
                    }
                    o.length > 0 && r(o, e1.filter.name, t);
                });
            });
        };
        n(e1.nodes, !1), n(e1.attributes, !0);
    }, Db = (e1, t, n, o = {})=>{
        const r = ((e1, t, n)=>{
            const o = {
                nodes: {},
                attributes: {}
            };
            return n.firstChild && ((n)=>{
                let r = n;
                for(; r = r.walk();)Bb(e1, t, r, o);
            })(n), o;
        })(e1, t, n);
        Pb(r, o);
    }, Lb = (e1, t, n, o)=>{
        if ((e1.pad_empty_with_br || t.insert) && n(o)) {
            const e1 = new up("br", 1);
            t.insert && e1.attr("data-mce-bogus", "1"), o.empty().append(e1);
        } else o.empty().append(new up("#text", 3)).value = it;
    }, Mb = (e1, t)=>{
        const n = null == e1 ? void 0 : e1.firstChild;
        return C(n) && n === e1.lastChild && n.name === t;
    }, Ib = (e1, t, n, o)=>o.isEmpty(t, n, (t)=>((e1, t)=>{
                const n = e1.getElementRule(t.name);
                return !0 === (null == n ? void 0 : n.paddEmpty);
            })(e1, t)), Fb = (e1)=>{
        let t;
        for(let n = e1; n; n = n.parent){
            const e1 = n.attr("contenteditable");
            if ("false" === e1) break;
            "true" === e1 && (t = n);
        }
        return I.from(t);
    }, Ub = (e1, t, n = e1.parent)=>{
        if (t.getSpecialElements()[e1.name]) e1.empty().remove();
        else {
            const o = e1.children();
            for (const e1 of o)n && !t.isValidChild(n.name, e1.name) && Ub(e1, t, n);
            e1.unwrap();
        }
    }, zb = (e1, t, n, o = x)=>{
        const r = t.getTextBlockElements(), s = t.getNonEmptyElements(), a = t.getWhitespaceElements(), i = an.makeMap("tr,td,th,tbody,thead,tfoot,table,summary"), l = new Set, d = (e1)=>e1 !== n && !i[e1.name];
        for(let n = 0; n < e1.length; n++){
            const i = e1[n];
            let c, u, m;
            if (!i.parent || l.has(i)) continue;
            if (r[i.name] && "li" === i.parent.name) {
                let e1 = i.next;
                for(; e1 && r[e1.name];)e1.name = "li", l.add(e1), i.parent.insert(e1, i.parent), e1 = e1.next;
                i.unwrap();
                continue;
            }
            const f = [
                i
            ];
            for(c = i.parent; c && !t.isValidChild(c.name, i.name) && d(c); c = c.parent)f.push(c);
            if (c && f.length > 1) {
                if (jb(t, i, c)) Ub(i, t);
                else {
                    f.reverse(), u = f[0].clone(), o(u);
                    let e1 = u;
                    for(let n = 0; n < f.length - 1; n++){
                        t.isValidChild(e1.name, f[n].name) && n > 0 ? (m = f[n].clone(), o(m), e1.append(m)) : m = e1;
                        for(let e1 = f[n].firstChild; e1 && e1 !== f[n + 1];){
                            const t = e1.next;
                            m.append(e1), e1 = t;
                        }
                        e1 = m;
                    }
                    Ib(t, s, a, u) ? c.insert(i, f[0], !0) : (c.insert(u, f[0], !0), c.insert(i, u)), c = f[0], (Ib(t, s, a, c) || Mb(c, "br")) && c.empty().remove();
                }
            } else if (i.parent) {
                if ("li" === i.name) {
                    let e1 = i.prev;
                    if (e1 && ("ul" === e1.name || "ol" === e1.name)) {
                        e1.append(i);
                        continue;
                    }
                    if (e1 = i.next, e1 && ("ul" === e1.name || "ol" === e1.name) && e1.firstChild) {
                        e1.insert(i, e1.firstChild, !0);
                        continue;
                    }
                    const t = new up("ul", 1);
                    o(t), i.wrap(t);
                    continue;
                }
                if (t.isValidChild(i.parent.name, "div") && t.isValidChild("div", i.name)) {
                    const e1 = new up("div", 1);
                    o(e1), i.wrap(e1);
                } else Ub(i, t);
            }
        }
    }, jb = (e1, t, n = t.parent)=>!(!n || (!e1.children[t.name] || e1.isValidChild(n.name, t.name)) && ("a" !== t.name || !((e1)=>{
            let t = e1;
            for(; t;){
                if ("a" === t.name) return !0;
                t = t.parent;
            }
            return !1;
        })(n)) && (!((e1)=>"summary" === e1.name)(n) || !Ob(t) || (null == n ? void 0 : n.firstChild) === t && (null == n ? void 0 : n.lastChild) === t)), Hb = (e1)=>e1.collapsed ? e1 : ((e1)=>{
            const t = Pl.fromRangeStart(e1), n = Pl.fromRangeEnd(e1), o = e1.commonAncestorContainer;
            return Cm(!1, o, n).map((r)=>!Ku(t, n, o) && Ku(t, r, o) ? ((e1, t, n, o)=>{
                    const r = document.createRange();
                    return r.setStart(e1, t), r.setEnd(n, o), r;
                })(t.container(), t.offset(), r.container(), r.offset()) : e1).getOr(e1);
        })(e1), $b = (e1, t)=>{
        let n = t.firstChild, o = t.lastChild;
        return n && "meta" === n.name && (n = n.next), o && "mce_marker" === o.attr("id") && (o = o.prev), ((e1, t)=>{
            const n = e1.getNonEmptyElements();
            return C(t) && (t.isEmpty(n) || ((e1, t)=>e1.getBlockElements()[t.name] && ((e1)=>C(e1.firstChild) && e1.firstChild === e1.lastChild)(t) && ((e1)=>"br" === e1.name || e1.value === it)(t.firstChild))(e1, t));
        })(e1, o) && (o = null == o ? void 0 : o.prev), !(!n || n !== o || "ul" !== n.name && "ol" !== n.name);
    }, Vb = (e1)=>{
        var t, n;
        return e1.length > 0 && (!(n = e1[e1.length - 1]).firstChild || C(null == (t = n) ? void 0 : t.firstChild) && t.firstChild === t.lastChild && ((e1)=>e1.data === it || as(e1))(t.firstChild)) ? e1.slice(0, -1) : e1;
    }, qb = (e1, t)=>{
        const n = e1.getParent(t, e1.isBlock);
        return n && "LI" === n.nodeName ? n : null;
    }, Wb = (e1, t)=>{
        const n = Pl.after(e1), o = hm(t).prev(n);
        return o ? o.toRange() : null;
    }, Kb = (e1, t, n, o)=>{
        const r = ((e1, t, n)=>{
            const o = t.serialize(n);
            return ((e1)=>{
                var t, n;
                const o = e1.firstChild, r = e1.lastChild;
                return o && "META" === o.nodeName && (null === (t = o.parentNode) || void 0 === t || t.removeChild(o)), r && "mce_marker" === r.id && (null === (n = r.parentNode) || void 0 === n || n.removeChild(r)), e1;
            })(e1.createFragment(o));
        })(t, e1, o), s = qb(t, n.startContainer), a = Vb((i = r.firstChild, Y(null !== (l = null == i ? void 0 : i.childNodes) && void 0 !== l ? l : [], (e1)=>"LI" === e1.nodeName)));
        var i, l;
        const d = t.getRoot(), c = (e1)=>{
            const o = Pl.fromRangeStart(n), r = hm(t.getRoot()), a = 1 === e1 ? r.prev(o) : r.next(o), i = null == a ? void 0 : a.getNode();
            return !i || qb(t, i) !== s;
        };
        return s ? c(1) ? ((e1, t, n)=>{
            const o = e1.parentNode;
            return o && an.each(t, (t)=>{
                o.insertBefore(t, e1);
            }), ((e1, t)=>{
                const n = Pl.before(e1), o = hm(t).next(n);
                return o ? o.toRange() : null;
            })(e1, n);
        })(s, a, d) : c(2) ? ((e1, t, n, o)=>(o.insertAfter(t.reverse(), e1), Wb(t[0], n)))(s, a, d, t) : ((e1, t, n, o)=>{
            const r = ((e1, t)=>{
                const n = t.cloneRange(), o = t.cloneRange();
                return n.setStartBefore(e1), o.setEndAfter(e1), [
                    n.cloneContents(),
                    o.cloneContents()
                ];
            })(e1, o), s = e1.parentNode;
            return s && (s.insertBefore(r[0], e1), an.each(t, (t)=>{
                s.insertBefore(t, e1);
            }), s.insertBefore(r[1], e1), s.removeChild(e1)), Wb(t[t.length - 1], n);
        })(s, a, d, n) : null;
    }, Yb = [
        "pre"
    ], Gb = ms, Xb = (e1)=>Qb(e1, es), Zb = (e1)=>Qb(e1, ls), Qb = (e1, t)=>e1.startContainer === e1.endContainer && e1.endOffset - e1.startOffset == 1 && t(e1.startContainer.childNodes[e1.startOffset]), Jb = (e1, t, n)=>{
        var o, r;
        const s = e1.selection, a = e1.dom, i = e1.parser, l = n.merge, d = Tp({
            validate: !0
        }, e1.schema), c = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;</span>';
        n.preserve_zwsp || (t = Li(t)), -1 === t.indexOf("{$caret}") && (t += "{$caret}"), t = t.replace(/\{\$caret\}/, c);
        let u = s.getRng();
        const m = u.startContainer, f = e1.getBody();
        m === f && s.isCollapsed() && a.isBlock(f.firstChild) && ((e1, t)=>C(t) && !e1.schema.getVoidElements()[t.nodeName])(e1, f.firstChild) && a.isEmpty(f.firstChild) && (u = a.createRng(), u.setStart(f.firstChild, 0), u.setEnd(f.firstChild, 0), s.setRng(u)), s.isCollapsed() || ((e1)=>{
            const t = e1.dom, n = Hb(e1.selection.getRng());
            e1.selection.setRng(n);
            const o = t.getParent(n.startContainer, Gb);
            ((e1, t, n)=>!!C(n) && n === e1.getParent(t.endContainer, Gb) && Jm(mn(n), t))(t, n, o) ? yb(e1, n, mn(o)) : Zb(n) || Xb(n) ? n.deleteContents() : e1.getDoc().execCommand("Delete", !1);
        })(e1);
        const g = s.getNode(), p = {
            context: g.nodeName.toLowerCase(),
            data: n.data,
            insert: !0
        }, h = i.parse(t, p);
        if (!0 === n.paste && $b(e1.schema, h) && ((e1, t)=>!!qb(e1, t))(a, g)) return u = Kb(d, a, s.getRng(), h), u && s.setRng(u), t;
        !0 === n.paste && ((e1, t, n, o)=>{
            var r;
            const s = t.firstChild, a = t.lastChild, i = s === ("bookmark" === a.attr("data-mce-type") ? a.prev : a), l = H(Yb, s.name);
            if (i && l) {
                const t = "false" !== s.attr("contenteditable"), a = (null === (r = e1.getParent(n, e1.isBlock)) || void 0 === r ? void 0 : r.nodeName.toLowerCase()) === s.name, i = I.from(Nb(o, n)).forall(ds);
                return t && a && i;
            }
            return !1;
        })(a, h, g, e1.getBody()) && (null === (o = h.firstChild) || void 0 === o || o.unwrap()), ((e1)=>{
            let t = e1;
            for(; t = t.walk();)1 === t.type && t.attr("data-mce-fragment", "1");
        })(h);
        let b = h.lastChild;
        if (b && "mce_marker" === b.attr("id")) {
            const t = b;
            for(b = b.prev; b && "table" !== b.name; b = b.walk(!0))if (3 === b.type || !a.isBlock(b.name)) {
                b.parent && e1.schema.isValidChild(b.parent.name, "span") && b.parent.insert(t, b, "br" === b.name);
                break;
            }
        }
        if (e1._selectionOverrides.showBlockCaretContainer(g), p.invalid || ((e1, t, n)=>{
            var o;
            return $(n.children(), Ob) && "SUMMARY" === (null === (o = e1.getParent(t, e1.isBlock)) || void 0 === o ? void 0 : o.nodeName);
        })(a, g, h)) {
            e1.selection.setContent(c);
            let n, o = s.getNode();
            const l = e1.getBody();
            for(rs(o) ? o = n = l : n = o; n && n !== l;)o = n, n = n.parentNode;
            t = o === l ? l.innerHTML : a.getOuterHTML(o);
            const u = i.parse(t), m = ((e1)=>{
                for(let t = e1; t; t = t.walk())if ("mce_marker" === t.attr("id")) return I.some(t);
                return I.none();
            })(u), f = m.bind(Fb).getOr(u);
            m.each((e1)=>e1.replace(h));
            const g = h.children(), p = null !== (r = h.parent) && void 0 !== r ? r : u;
            h.unwrap();
            const b = Y(g, (t)=>jb(e1.schema, t, p));
            zb(b, e1.schema, f), Db(i.getNodeFilters(), i.getAttributeFilters(), u), t = d.serialize(u), o === l ? a.setHTML(l, t) : a.setOuterHTML(o, t);
        } else t = d.serialize(h), ((e1, t, n)=>{
            var o;
            "all" === n.getAttribute("data-mce-bogus") ? null === (o = n.parentNode) || void 0 === o || o.insertBefore(e1.dom.createFragment(t), n) : ((e1, t)=>{
                if (e1.isBlock(t) && e1.isEditable(t)) {
                    const e1 = t.childNodes;
                    return 1 === e1.length && as(e1[0]) || 0 === e1.length;
                }
                return !1;
            })(e1.dom, n) ? e1.dom.setHTML(n, t) : e1.selection.setContent(t, {
                no_events: !0
            });
        })(e1, t, g);
        var v;
        return ((e1, t)=>{
            const n = e1.schema.getTextInlineElements(), o = e1.dom;
            if (t) {
                const t = e1.getBody(), r = Tb(e1), s = "*[data-mce-fragment]", a = o.select(s);
                an.each(a, (e1)=>{
                    const a = (e1)=>C(n[e1.nodeName.toLowerCase()]), i = (e1)=>1 === e1.childNodes.length;
                    if (!Lp(o, l = e1) && !((e1, t)=>Lp(e1, t) && $(Dp(e1, t), (e1)=>((e1)=>Bp.has(e1))(e1)))(o, l) && a(e1) && i(e1)) {
                        const n = Dp(o, e1), l = (e1, t)=>ne(e1, (e1)=>H(t, e1)), d = (t)=>i(e1) && o.is(t, s) && a(t) && (t.nodeName === e1.nodeName && l(n, Dp(o, t)) || d(t.children[0])), c = (n)=>C(n) && n !== t && (r.compare(e1, n) || c(n.parentElement)), u = (n)=>C(n) && n !== t && o.is(n, s) && (((e1, t, n)=>{
                                const o = Dp(e1, t), r = Dp(e1, n), s = (o)=>{
                                    var r, s;
                                    const a = null !== (r = e1.getStyle(t, o)) && void 0 !== r ? r : "", i = null !== (s = e1.getStyle(n, o)) && void 0 !== s ? s : "";
                                    return et(a) && et(i) && a !== i;
                                };
                                return $(o, (e1)=>{
                                    const t = (t)=>$(t, (t)=>t === e1);
                                    if (!t(r) && t(Pp)) {
                                        const e1 = Y(r, (e1)=>$(Pp, (t)=>Ye(e1, t)));
                                        return $(e1, s);
                                    }
                                    return s(e1);
                                });
                            })(o, e1, n) || u(n.parentElement));
                        (d(e1.children[0]) || c(e1.parentElement) && !u(e1.parentElement)) && o.remove(e1, !0);
                    }
                    var l;
                });
            }
        })(e1, l), ((e1, t)=>{
            var n, o, r;
            let s;
            const a = e1.dom, i = e1.selection;
            if (!t) return;
            i.scrollIntoView(t);
            const l = Nb(e1.getBody(), t);
            if (l && "false" === a.getContentEditable(l)) return a.remove(t), void i.select(l);
            let d = a.createRng();
            const c = t.previousSibling;
            if (es(c)) {
                d.setStart(c, null !== (o = null === (n = c.nodeValue) || void 0 === n ? void 0 : n.length) && void 0 !== o ? o : 0);
                const e1 = t.nextSibling;
                es(e1) && (c.appendData(e1.data), null === (r = e1.parentNode) || void 0 === r || r.removeChild(e1));
            } else d.setStartBefore(t), d.setEndBefore(t);
            const u = a.getParent(t, a.isBlock);
            if (a.remove(t), u && a.isEmpty(u)) {
                const t = Gb(u);
                wo(mn(u)), d.setStart(u, 0), d.setEnd(u, 0), t || ((e1)=>!!e1.getAttribute("data-mce-fragment"))(u) || !(s = ((t)=>{
                    let n = Pl.fromRangeStart(t);
                    return n = hm(e1.getBody()).next(n), null == n ? void 0 : n.toRange();
                })(d)) ? a.add(u, a.create("br", t ? {} : {
                    "data-mce-bogus": "1"
                })) : (d = s, a.remove(u));
            }
            i.setRng(d);
        })(e1, a.get("mce_marker")), v = e1.getBody(), an.each(v.getElementsByTagName("*"), (e1)=>{
            e1.removeAttribute("data-mce-fragment");
        }), ((e1, t, n)=>{
            I.from(e1.getParent(t, "td,th")).map(mn).each((e1)=>((e1, t)=>{
                    qn(e1).each((n)=>{
                        Fn(n).each((o)=>{
                            t.isBlock(_n(e1)) && xi(n) && t.isBlock(_n(o)) && Eo(n);
                        });
                    });
                })(e1, n));
        })(a, s.getStart(), e1.schema), ((e1, t, n)=>{
            const o = In(mn(n), (e1)=>Cn(e1, mn(t)));
            ie(o, o.length - 2).filter(Nn).fold(()=>Ms(e1, t), (t)=>Ms(e1, t.dom));
        })(e1.schema, e1.getBody(), s.getStart()), t;
    }, ev = (e1)=>e1 instanceof up, tv = (e1, t, n)=>{
        e1.dom.setHTML(e1.getBody(), t), !0 !== n && ((e1)=>{
            vg(e1) && km(e1.getBody()).each((t)=>{
                const n = t.getNode(), o = Zr(n) ? km(n).getOr(t) : t;
                e1.selection.setRng(o.toRange());
            });
        })(e1);
    }, nv = pf, ov = (e1, t, n)=>{
        const o = e1.formatter.get(n);
        if (o) for(let n = 0; n < o.length; n++){
            const r = o[n];
            if (Ef(r) && !1 === r.inherit && e1.dom.is(t, r.selector)) return !0;
        }
        return !1;
    }, rv = (e1, t, n, o, r)=>{
        const s = e1.dom.getRoot();
        if (t === s) return !1;
        const a = e1.dom.getParent(t, (t)=>!!ov(e1, t, n) || t.parentNode === s || !!iv(e1, t, n, o, !0));
        return !!iv(e1, a, n, o, r);
    }, sv = (e1, t, n)=>!(!_f(n) || !nv(t, n.inline)) || !(!wf(n) || !nv(t, n.block)) || !!Ef(n) && qr(t) && e1.is(t, n.selector), av = (e1, t, n, o, r, s)=>{
        const a = n[o], i = "attributes" === o;
        if (w(n.onmatch)) return n.onmatch(t, n, o);
        if (a) {
            if (ct(a)) {
                for(let n = 0; n < a.length; n++)if (i ? e1.getAttrib(t, a[n]) : bf(e1, t, a[n])) return !0;
            } else for(const o in a)if (xe(a, o)) {
                const l = i ? e1.getAttrib(t, o) : bf(e1, t, o), d = gf(a[o], s), c = y(l) || tt(l);
                if (c && y(d)) continue;
                if (r && c && !n.exact) return !1;
                if ((!r || n.exact) && !nv(l, hf(d, o))) return !1;
            }
        }
        return !0;
    }, iv = (e1, t, n, o, r)=>{
        const s = e1.formatter.get(n), a = e1.dom;
        if (s && qr(t)) for(let n = 0; n < s.length; n++){
            const i = s[n];
            if (sv(e1.dom, t, i) && av(a, t, i, "attributes", r, o) && av(a, t, i, "styles", r, o)) {
                const n = i.classes;
                if (n) {
                    for(let r = 0; r < n.length; r++)if (!e1.dom.hasClass(t, gf(n[r], o))) return;
                }
                return i;
            }
        }
    }, lv = (e1, t, n, o, r)=>{
        if (o) return rv(e1, o, t, n, r);
        if (o = e1.selection.getNode(), rv(e1, o, t, n, r)) return !0;
        const s = e1.selection.getStart();
        return !(s === o || !rv(e1, s, t, n, r));
    }, dv = Pi, cv = (e1)=>{
        if (e1) {
            const t = new Fr(e1, e1);
            for(let e1 = t.current(); e1; e1 = t.next())if (es(e1)) return e1;
        }
        return null;
    }, uv = (e1)=>{
        const t = cn("span");
        return po(t, {
            id: Rm,
            "data-mce-bogus": "1",
            "data-mce-type": "format-caret"
        }), e1 && co(t, un(dv)), t;
    }, mv = (e1, t, n)=>{
        const o = e1.dom, r = e1.selection;
        if (Sf(t)) Fh(e1, !1, mn(t), n, !0);
        else {
            const e1 = r.getRng(), n = o.getParent(t, o.isBlock), s = e1.startContainer, a = e1.startOffset, i = e1.endContainer, l = e1.endOffset, d = ((e1)=>{
                const t = cv(e1);
                return t && t.data.charAt(0) === dv && t.deleteData(0, 1), t;
            })(t);
            o.remove(t, !0), s === d && a > 0 && e1.setStart(d, a - 1), i === d && l > 0 && e1.setEnd(d, l - 1), n && o.isEmpty(n) && Bi(mn(n)), r.setRng(e1);
        }
    }, fv = (e1, t, n)=>{
        const o = e1.dom, r = e1.selection;
        if (t) mv(e1, t, n);
        else if (!(t = Tm(e1.getBody(), r.getStart()))) for(; t = o.get(Rm);)mv(e1, t, n);
    }, gv = (e1, t)=>(e1.appendChild(t), t), pv = (e1, t)=>{
        var n;
        const o = G(e1, (e1, t)=>gv(e1, t.cloneNode(!1)), t), r = null !== (n = o.ownerDocument) && void 0 !== n ? n : document;
        return gv(o, r.createTextNode(dv));
    }, hv = (e1)=>Zo(e1, Xo(e1).replace(new RegExp(`${it}$`), " ")), bv = (e1, t)=>{
        const n = ()=>{
            null === t || e1.dom.isEmpty(t) || Fn(mn(t)).each((e1)=>{
                Rn(e1) ? hv(e1) : nr(e1, (e1)=>Rn(e1)).each((e1)=>{
                    Rn(e1) && hv(e1);
                });
            });
        };
        e1.once("input", (t)=>{
            t.data && !qm(t.data) && (t.isComposing ? e1.once("compositionend", ()=>{
                n();
            }) : n());
        });
    }, vv = (e1, t, n, o)=>{
        const a = e1.dom, i = e1.selection;
        let l = !1;
        const d = e1.formatter.get(t);
        if (!d) return;
        const c = i.getRng(), u = c.startContainer, m = c.startOffset;
        let f = u;
        es(u) && (m !== u.data.length && (l = !0), f = f.parentNode);
        const g = [];
        let h;
        for(; f;){
            if (iv(e1, f, t, n, o)) {
                h = f;
                break;
            }
            f.nextSibling && (l = !0), g.push(f), f = f.parentNode;
        }
        if (h) {
            if (l) {
                const r = i.getBookmark();
                c.collapse(!0);
                let s = jf(a, c, d, {
                    includeTrailingSpace: !0
                });
                s = Ig(s), e1.formatter.remove(t, n, s, o), i.moveToBookmark(r);
            } else {
                const l = Tm(e1.getBody(), h), d = C(l) ? a.getParents(h.parentNode, M, l) : [], c = uv(!1).dom;
                ((e1, t, n)=>{
                    var o, r;
                    const s = e1.dom, a = s.getParent(n, T(cf, e1.schema));
                    a && s.isEmpty(a) ? null === (o = n.parentNode) || void 0 === o || o.replaceChild(t, n) : (((e1)=>{
                        const t = vr(e1, "br"), n = Y(((e1)=>{
                            const t = [];
                            let n = e1.dom;
                            for(; n;)t.push(mn(n)), n = n.lastChild;
                            return t;
                        })(e1).slice(-1), xi);
                        t.length === n.length && q(n, Eo);
                    })(mn(n)), s.isEmpty(n) ? null === (r = n.parentNode) || void 0 === r || r.replaceChild(t, n) : s.insertAfter(t, n));
                })(e1, c, null != l ? l : h);
                const u = ((e1, t, n, o, a, i)=>{
                    const l = e1.formatter, d = e1.dom, c = Y(fe(l.get()), (e1)=>e1 !== o && !Ke(e1, "removeformat")), u = ((e1, t, n)=>X(n, (n, o)=>{
                            const r = ((e1, t)=>Cf(e1, t, (e1)=>{
                                    const t = (e1)=>w(e1) || e1.length > 1 && "%" === e1.charAt(0);
                                    return $([
                                        "styles",
                                        "attributes"
                                    ], (n)=>_e(e1, n).exists((e1)=>{
                                            const n = p(e1) ? e1 : Ee(e1);
                                            return $(n, t);
                                        }));
                                }))(e1, o);
                            return e1.formatter.matchNode(t, o, {}, r) ? n.concat([
                                o
                            ]) : n;
                        }, []))(e1, n, c);
                    if (Y(u, (t)=>!((e1, t, n)=>{
                            const o = [
                                "inline",
                                "block",
                                "selector",
                                "attributes",
                                "styles",
                                "classes"
                            ], a = (e1)=>Ce(e1, (e1, t)=>$(o, (e1)=>e1 === t));
                            return Cf(e1, t, (t)=>{
                                const o = a(t);
                                return Cf(e1, n, (e1)=>{
                                    const t = a(e1);
                                    return ((e1, t, n = s)=>r(n).eq(e1, t))(o, t);
                                });
                            });
                        })(e1, t, o)).length > 0) {
                        const e1 = n.cloneNode(!1);
                        return d.add(t, e1), l.remove(o, a, e1, i), d.remove(e1), I.some(e1);
                    }
                    return I.none();
                })(e1, c, h, t, n, o), m = pv([
                    ...g,
                    ...u.toArray(),
                    ...d
                ], c);
                l && mv(e1, l, C(l)), i.setCursorLocation(m, 1), bv(e1, c), a.isEmpty(h) && a.remove(h);
            }
        }
    }, yv = (e1)=>{
        const t = uv(!1), n = pv(e1, t.dom);
        return {
            caretContainer: t,
            caretPosition: Pl(n, 0)
        };
    }, Cv = (e1, t)=>{
        const { caretContainer: n, caretPosition: o } = yv(t);
        return ao(mn(e1), n), Eo(mn(e1)), o;
    }, wv = (e1, t)=>{
        if (Am(t.dom)) return !1;
        const n = e1.schema.getTextInlineElements();
        return xe(n, _n(t)) && !Am(t.dom) && !Xr(t.dom);
    }, Ev = {}, _v = Yr([
        "pre"
    ]);
    ((e1)=>{
        Ev[e1] || (Ev[e1] = []), Ev[e1].push((e1)=>{
            if (!e1.selection.getRng().collapsed) {
                const t = e1.selection.getSelectedBlocks(), n = Y(Y(t, _v), ((e1)=>(t)=>{
                        const n = t.previousSibling;
                        return _v(n) && H(e1, n);
                    })(t));
                q(n, (e1)=>{
                    ((e1, t)=>{
                        const n = mn(t), o = Pn(n).dom;
                        Eo(n), mo(mn(e1), [
                            cn("br", o),
                            cn("br", o),
                            ...Hn(n)
                        ]);
                    })(e1.previousSibling, e1);
                });
            }
        });
    })("pre");
    const xv = [
        "fontWeight",
        "fontStyle",
        "color",
        "fontSize",
        "fontFamily"
    ], Sv = (e1, t)=>{
        const n = e1.get(t);
        return p(n) ? Q(n, (e1)=>_f(e1) && "span" === e1.inline && ((e1)=>f(e1.styles) && $(fe(e1.styles), (e1)=>H(xv, e1)))(e1)) : I.none();
    }, kv = (e1, t)=>Sm(t, Pl.fromRangeStart(e1)).isNone(), Nv = (e1, t)=>!1 === xm(t, Pl.fromRangeEnd(e1)).exists((e1)=>!as(e1.getNode()) || xm(t, e1).isSome()), Rv = (e1)=>(t)=>ps(t) && e1.isEditable(t), Av = (e1)=>Y(e1.getSelectedBlocks(), Rv(e1.dom)), Tv = an.each, Ov = (e1)=>qr(e1) && !Hm(e1) && !Am(e1) && !Xr(e1), Bv = (e1, t)=>{
        for(let n = e1; n; n = n[t]){
            if (es(n) && et(n.data)) return e1;
            if (qr(n) && !Hm(n)) return n;
        }
        return e1;
    }, Pv = (e1, t, n)=>{
        const o = Tb(e1), r = Wr(t) && e1.dom.isEditable(t), s = Wr(n) && e1.dom.isEditable(n);
        if (r && s) {
            const r = Bv(t, "previousSibling"), s = Bv(n, "nextSibling");
            if (o.compare(r, s)) {
                for(let e1 = r.nextSibling; e1 && e1 !== s;){
                    const t = e1;
                    e1 = e1.nextSibling, r.appendChild(t);
                }
                return e1.dom.remove(s), an.each(an.grep(s.childNodes), (e1)=>{
                    r.appendChild(e1);
                }), r;
            }
        }
        return n;
    }, Dv = (e1, t, n, o)=>{
        var r;
        if (o && !1 !== t.merge_siblings) {
            const t = null !== (r = Pv(e1, df(o), o)) && void 0 !== r ? r : o;
            Pv(e1, t, df(t, !0));
        }
    }, Lv = (e1, t, n)=>{
        Tv(e1.childNodes, (e1)=>{
            Ov(e1) && (t(e1) && n(e1), e1.hasChildNodes() && Lv(e1, t, n));
        });
    }, Mv = (e1, t)=>(n)=>!(!n || !bf(e1, n, t)), Iv = (e1, t, n)=>(o)=>{
            e1.setStyle(o, t, n), "" === o.getAttribute("style") && o.removeAttribute("style"), ((e1, t)=>{
                "SPAN" === t.nodeName && 0 === e1.getAttribs(t).length && e1.remove(t, !0);
            })(e1, o);
        }, Fv = ke([
        {
            keep: []
        },
        {
            rename: [
                "name"
            ]
        },
        {
            removed: []
        }
    ]), Uv = /^(src|href|style)$/, zv = an.each, jv = pf, Hv = (e1, t, n)=>e1.isChildOf(t, n) && t !== n && !e1.isBlock(n), $v = (e1, t, n)=>{
        let o = t[n ? "startContainer" : "endContainer"], r = t[n ? "startOffset" : "endOffset"];
        if (qr(o)) {
            const e1 = o.childNodes.length - 1;
            !n && r && r--, o = o.childNodes[r > e1 ? e1 : r];
        }
        return es(o) && n && r >= o.data.length && (o = new Fr(o, e1.getBody()).next() || o), es(o) && !n && 0 === r && (o = new Fr(o, e1.getBody()).prev() || o), o;
    }, Vv = (e1, t)=>{
        const n = t ? "firstChild" : "lastChild", o = e1[n];
        return ((e1)=>/^(TR|TH|TD)$/.test(e1.nodeName))(e1) && o ? "TR" === e1.nodeName && o[n] || o : e1;
    }, qv = (e1, t, n, o)=>{
        var r;
        const s = e1.create(n, o);
        return null === (r = t.parentNode) || void 0 === r || r.insertBefore(s, t), s.appendChild(t), s;
    }, Wv = (e1, t, n, o, r)=>{
        const s = mn(t), a = mn(e1.create(o, r)), i = n ? jn(s) : zn(s);
        return mo(a, i), n ? (ao(s, a), lo(a, s)) : (io(s, a), co(a, s)), a.dom;
    }, Kv = (e1, t, n)=>{
        const o = t.parentNode;
        let r;
        const s = e1.dom, a = Ad(e1);
        wf(n) && o === s.getRoot() && (n.list_block && jv(t, n.list_block) || q(ce(t.childNodes), (t)=>{
            uf(e1, a, t.nodeName.toLowerCase()) ? r ? r.appendChild(t) : (r = qv(s, t, a), s.setAttribs(r, Td(e1))) : r = null;
        })), ((e1)=>Ef(e1) && _f(e1) && Fe(_e(e1, "mixed"), !0))(n) && !jv(n.inline, t) || s.remove(t, !0);
    }, Yv = (e1, t, n)=>E(e1) ? {
            name: t,
            value: null
        } : {
            name: e1,
            value: gf(t, n)
        }, Gv = (e1, t)=>{
        "" === e1.getAttrib(t, "style") && (t.removeAttribute("style"), t.removeAttribute("data-mce-style"));
    }, Xv = (e1, t, n, o, r)=>{
        let s = !1;
        zv(n.styles, (a, i)=>{
            const { name: l, value: d } = Yv(i, a, o), c = hf(d, l);
            (n.remove_similar || h(d) || !qr(r) || jv(bf(e1, r, l), c)) && e1.setStyle(t, l, ""), s = !0;
        }), s && Gv(e1, t);
    }, Zv = (e1, t, n, o, r)=>{
        const s = e1.dom, a = Tb(e1), i = e1.schema;
        if (_f(t) && Us(i, t.inline) && js(i, o) && o.parentElement === e1.getBody()) return Kv(e1, o, t), Fv.removed();
        if (!t.ceFalseOverride && o && "false" === s.getContentEditableParent(o)) return Fv.keep();
        if (o && !sv(s, o, t) && !((e1, t)=>t.links && "A" === e1.nodeName)(o, t)) return Fv.keep();
        const l = o, d = t.preserve_attributes;
        if (_f(t) && "all" === t.remove && p(d)) {
            const e1 = Y(s.getAttribs(l), (e1)=>H(d, e1.name.toLowerCase()));
            if (s.removeAllAttribs(l), q(e1, (e1)=>s.setAttrib(l, e1.name, e1.value)), e1.length > 0) return Fv.rename("span");
        }
        if ("all" !== t.remove) {
            Xv(s, l, t, n, r), zv(t.attributes, (e1, o)=>{
                const { name: a, value: i } = Yv(o, e1, n);
                if (t.remove_similar || h(i) || !qr(r) || jv(s.getAttrib(r, a), i)) {
                    if ("class" === a) {
                        const e1 = s.getAttrib(l, a);
                        if (e1) {
                            let t = "";
                            if (q(e1.split(/\s+/), (e1)=>{
                                /mce\-\w+/.test(e1) && (t += (t ? " " : "") + e1);
                            }), t) return void s.setAttrib(l, a, t);
                        }
                    }
                    if (Uv.test(a) && l.removeAttribute("data-mce-" + a), "style" === a && Yr([
                        "li"
                    ])(l) && "none" === s.getStyle(l, "list-style-type")) return l.removeAttribute(a), void s.setStyle(l, "list-style-type", "none");
                    "class" === a && l.removeAttribute("className"), l.removeAttribute(a);
                }
            }), zv(t.classes, (e1)=>{
                e1 = gf(e1, n), qr(r) && !s.hasClass(r, e1) || s.removeClass(l, e1);
            });
            const e1 = s.getAttribs(l);
            for(let t = 0; t < e1.length; t++){
                const n = e1[t].nodeName;
                if (!a.isAttributeInternal(n)) return Fv.keep();
            }
        }
        return "none" !== t.remove ? (Kv(e1, l, t), Fv.removed()) : Fv.keep();
    }, Qv = (e1, t, n, o)=>Zv(e1, t, n, o, o).fold(N(o), (t)=>(e1.dom.createFragment().appendChild(o), e1.dom.rename(o, t)), N(null)), Jv = (e1, t, n, o, r)=>{
        (o || e1.selection.isEditable()) && ((e1, t, n, o, r)=>{
            const s = e1.formatter.get(t), a = s[0], i = e1.dom, l = e1.selection, d = (o)=>{
                const i = ((e1, t, n, o, r)=>{
                    let s;
                    return t.parentNode && q(yf(e1.dom, t.parentNode).reverse(), (t)=>{
                        if (!s && qr(t) && "_start" !== t.id && "_end" !== t.id) {
                            const a = iv(e1, t, n, o, r);
                            a && !1 !== a.split && (s = t);
                        }
                    }), s;
                })(e1, o, t, n, r);
                return ((e1, t, n, o, r, s, a, i)=>{
                    var l, d;
                    let c, u;
                    const m = e1.dom;
                    if (n) {
                        const s = n.parentNode;
                        for(let n = o.parentNode; n && n !== s; n = n.parentNode){
                            let o = m.clone(n, !1);
                            for(let n = 0; n < t.length && (o = Qv(e1, t[n], i, o), null !== o); n++);
                            o && (c && o.appendChild(c), u || (u = o), c = o);
                        }
                        a.mixed && m.isBlock(n) || (o = null !== (l = m.split(n, o)) && void 0 !== l ? l : o), c && u && (null === (d = r.parentNode) || void 0 === d || d.insertBefore(c, r), u.appendChild(r), _f(a) && Dv(e1, a, 0, c));
                    }
                    return o;
                })(e1, s, i, o, o, 0, a, n);
            }, c = (t)=>$(s, (o)=>ey(e1, o, n, t, t)), u = (t)=>{
                const n = ce(t.childNodes), o = c(t) || $(s, (e1)=>sv(i, t, e1)), r = t.parentNode;
                if (!o && C(r) && xf(a) && c(r), a.deep && n.length) for(let e1 = 0; e1 < n.length; e1++)u(n[e1]);
                q([
                    "underline",
                    "line-through",
                    "overline"
                ], (n)=>{
                    qr(t) && e1.dom.getStyle(t, "text-decoration") === n && t.parentNode && vf(i, t.parentNode) === n && ey(e1, {
                        deep: !1,
                        exact: !0,
                        inline: "span",
                        styles: {
                            textDecoration: n
                        }
                    }, void 0, t);
                });
            }, m = (e1)=>{
                const t = i.get(e1 ? "_start" : "_end");
                if (t) {
                    let n = t[e1 ? "firstChild" : "lastChild"];
                    return ((e1)=>Hm(e1) && qr(e1) && ("_start" === e1.id || "_end" === e1.id))(n) && (n = n[e1 ? "firstChild" : "lastChild"]), es(n) && 0 === n.data.length && (n = e1 ? t.previousSibling || t.nextSibling : t.nextSibling || t.previousSibling), i.remove(t, !0), n;
                }
                return null;
            }, f = (t)=>{
                let n, o, r = jf(i, t, s, {
                    includeTrailingSpace: t.collapsed
                });
                if (a.split) {
                    if (r = Ig(r), n = $v(e1, r, !0), o = $v(e1, r), n !== o) {
                        if (n = Vv(n, !0), o = Vv(o, !1), Hv(i, n, o)) {
                            const e1 = I.from(n.firstChild).getOr(n);
                            return d(Wv(i, e1, !0, "span", {
                                id: "_start",
                                "data-mce-type": "bookmark"
                            })), void m(!0);
                        }
                        if (Hv(i, o, n)) {
                            const e1 = I.from(o.lastChild).getOr(o);
                            return d(Wv(i, e1, !1, "span", {
                                id: "_end",
                                "data-mce-type": "bookmark"
                            })), void m(!1);
                        }
                        n = qv(i, n, "span", {
                            id: "_start",
                            "data-mce-type": "bookmark"
                        }), o = qv(i, o, "span", {
                            id: "_end",
                            "data-mce-type": "bookmark"
                        });
                        const e1 = i.createRng();
                        e1.setStartAfter(n), e1.setEndBefore(o), Hf(i, e1, (e1)=>{
                            q(e1, (e1)=>{
                                Hm(e1) || Hm(e1.parentNode) || d(e1);
                            });
                        }), d(n), d(o), n = m(!0), o = m();
                    } else n = o = d(n);
                    r.startContainer = n.parentNode ? n.parentNode : n, r.startOffset = i.nodeIndex(n), r.endContainer = o.parentNode ? o.parentNode : o, r.endOffset = i.nodeIndex(o) + 1;
                }
                Hf(i, r, (e1)=>{
                    q(e1, u);
                });
            };
            if (o) {
                if (rf(o)) {
                    const e1 = i.createRng();
                    e1.setStartBefore(o), e1.setEndAfter(o), f(e1);
                } else f(o);
                cd(e1, t, o, n);
            } else l.isCollapsed() && _f(a) && !Gm(e1).length ? vv(e1, t, n, r) : (af(e1, ()=>nf(e1, f), (o)=>_f(a) && lv(e1, t, n, o)), e1.nodeChanged()), ((e1, t, n)=>{
                "removeformat" === t ? q(Av(e1.selection), (t)=>{
                    q(xv, (n)=>e1.dom.setStyle(t, n, "")), Gv(e1.dom, t);
                }) : Sv(e1.formatter, t).each((t)=>{
                    q(Av(e1.selection), (o)=>Xv(e1.dom, o, t, n, null));
                });
            })(e1, t, n), cd(e1, t, o, n);
        })(e1, t, n, o, r);
    }, ey = (e1, t, n, o, r)=>Zv(e1, t, n, o, r).fold(L, (t)=>(e1.dom.rename(o, t), !0), M), ty = an.each, ny = an.each, oy = (e1, t, n, o)=>{
        if (ny(n.styles, (n, r)=>{
            e1.setStyle(t, r, gf(n, o));
        }), n.styles) {
            const n = e1.getAttrib(t, "style");
            n && e1.setAttrib(t, "data-mce-style", n);
        }
    }, ry = (e1, t, n, o)=>{
        const r = e1.formatter.get(t), s = r[0], a = !o && e1.selection.isCollapsed(), i = e1.dom, l = e1.selection, d = (e1, t = s)=>{
            w(t.onformat) && t.onformat(e1, t, n, o), oy(i, e1, t, n), ny(t.attributes, (t, o)=>{
                i.setAttrib(e1, o, gf(t, n));
            }), ny(t.classes, (t)=>{
                const o = gf(t, n);
                i.hasClass(e1, o) || i.addClass(e1, o);
            });
        }, c = (e1, t)=>{
            let n = !1;
            return ny(e1, (e1)=>!(!Ef(e1) || ("false" !== i.getContentEditable(t) || e1.ceFalseOverride) && (!C(e1.collapsed) || e1.collapsed === a) && i.is(t, e1.selector) && !Am(t) && (d(t, e1), n = !0, 1))), n;
        }, u = (e1)=>{
            if (m(e1)) {
                const t = i.create(e1);
                return d(t), t;
            }
            return null;
        }, f = (o, a, i)=>{
            const l = [];
            let m = !0;
            const f = s.inline || s.block, g = u(f);
            Hf(o, a, (a)=>{
                let u;
                const p = (a)=>{
                    let h = !1, b = m, v = !1;
                    const y = a.parentNode, w = y.nodeName.toLowerCase(), E = o.getContentEditable(a);
                    C(E) && (b = m, m = "true" === E, h = !0, v = ff(e1, a));
                    const _ = m && !h;
                    if (as(a) && !((e1, t, n, o)=>{
                        if (gc(e1) && _f(t) && n.parentNode) {
                            const t = ka(e1.schema), r = Cr(mn(n), (e1)=>Am(e1.dom));
                            return Se(t, o) && Es(e1.schema, n.parentNode, {
                                skipBogus: !1,
                                includeZwsp: !0
                            }) && !r;
                        }
                        return !1;
                    })(e1, s, a, w)) return u = null, void (wf(s) && o.remove(a));
                    if (((o)=>((e1)=>wf(e1) && !0 === e1.wrapper)(s) && iv(e1, o, t, n))(a)) u = null;
                    else {
                        if (((t, n, o)=>{
                            const r = ((e1)=>wf(e1) && !0 !== e1.wrapper)(s) && cf(e1.schema, t) && uf(e1, n, f);
                            return o && r;
                        })(a, w, _)) {
                            const e1 = o.rename(a, f);
                            return d(e1), l.push(e1), void (u = null);
                        }
                        if (Ef(s)) {
                            let e1 = c(r, a);
                            if (!e1 && C(y) && xf(s) && (e1 = c(r, y)), !_f(s) || e1) return void (u = null);
                        }
                        C(g) && ((t, n, r, a)=>{
                            const l = t.nodeName.toLowerCase(), d = uf(e1, f, l) && uf(e1, n, f), c = !i && es(t) && Di(t.data), u = Am(t), m = !_f(s) || !o.isBlock(t);
                            return (r || a) && d && !c && !u && m;
                        })(a, w, _, v) ? (u || (u = o.clone(g, !1), y.insertBefore(u, a), l.push(u)), v && h && (m = b), u.appendChild(a)) : (u = null, q(ce(a.childNodes), p), h && (m = b), u = null);
                    }
                };
                q(a, p);
            }), !0 === s.links && q(l, (e1)=>{
                const t = (e1)=>{
                    "A" === e1.nodeName && d(e1, s), q(ce(e1.childNodes), t);
                };
                t(e1);
            }), q(l, (a)=>{
                const i = ((e1)=>{
                    let t = 0;
                    return q(e1.childNodes, (e1)=>{
                        ((e1)=>C(e1) && es(e1) && 0 === e1.length)(e1) || Hm(e1) || t++;
                    }), t;
                })(a);
                !(l.length > 1) && o.isBlock(a) || 0 !== i ? (_f(s) || wf(s) && s.wrapper) && (s.exact || 1 !== i || (a = ((e1)=>{
                    const t = Q(e1.childNodes, sf).filter((e1)=>"false" !== o.getContentEditable(e1) && sv(o, e1, s));
                    return t.map((t)=>{
                        const n = o.clone(t, !1);
                        return d(n), o.replace(n, e1, !0), o.remove(t, !0), n;
                    }).getOr(e1);
                })(a)), ((e1, t, n, o)=>{
                    ty(t, (t)=>{
                        _f(t) && ty(e1.dom.select(t.inline, o), (o)=>{
                            Ov(o) && ey(e1, t, n, o, t.exact ? o : null);
                        }), ((e1, t, n)=>{
                            if (t.clear_child_styles) {
                                const o = t.links ? "*:not(a)" : "*";
                                Tv(e1.select(o, n), (n)=>{
                                    Ov(n) && e1.isEditable(n) && Tv(t.styles, (t, o)=>{
                                        e1.setStyle(n, o, "");
                                    });
                                });
                            }
                        })(e1.dom, t, o);
                    });
                })(e1, r, n, a), ((e1, t, n, o, r)=>{
                    const s = r.parentNode;
                    iv(e1, s, n, o) && ey(e1, t, o, r) || t.merge_with_parents && s && e1.dom.getParent(s, (s)=>!!iv(e1, s, n, o) && (ey(e1, t, o, r), !0));
                })(e1, s, t, n, a), ((e1, t, n, o)=>{
                    if (t.styles && t.styles.backgroundColor) {
                        const r = Mv(e1, "fontSize");
                        Lv(o, (t)=>r(t) && e1.isEditable(t), Iv(e1, "backgroundColor", gf(t.styles.backgroundColor, n)));
                    }
                })(o, s, n, a), ((e1, t, n, o)=>{
                    const r = (t)=>{
                        if (Wr(t) && qr(t.parentNode) && e1.isEditable(t)) {
                            const n = vf(e1, t.parentNode);
                            e1.getStyle(t, "color") && n ? e1.setStyle(t, "text-decoration", n) : e1.getStyle(t, "text-decoration") === n && e1.setStyle(t, "text-decoration", null);
                        }
                    };
                    t.styles && (t.styles.color || t.styles.textDecoration) && (an.walk(o, r, "childNodes"), r(o));
                })(o, s, 0, a), ((e1, t, n, o)=>{
                    if (_f(t) && ("sub" === t.inline || "sup" === t.inline)) {
                        const n = Mv(e1, "fontSize");
                        Lv(o, (t)=>n(t) && e1.isEditable(t), Iv(e1, "fontSize", ""));
                        const r = Y(e1.select("sup" === t.inline ? "sub" : "sup", o), e1.isEditable);
                        e1.remove(r, !0);
                    }
                })(o, s, 0, a), Dv(e1, s, 0, a)) : o.remove(a, !0);
            });
        }, g = rf(o) ? o : l.getNode();
        if ("false" === i.getContentEditable(g) && !ff(e1, g)) return c(r, o = g), void dd(e1, t, o, n);
        if (s) {
            if (o) {
                if (rf(o)) {
                    if (!c(r, o)) {
                        const e1 = i.createRng();
                        e1.setStartBefore(o), e1.setEndAfter(o), f(i, jf(i, e1, r), !0);
                    }
                } else f(i, o, !0);
            } else a && _f(s) && !Gm(e1).length ? ((e1, t, n)=>{
                let o;
                const r = e1.selection, s = e1.formatter.get(t);
                if (!s) return;
                const a = r.getRng();
                let i = a.startOffset;
                const l = a.startContainer.nodeValue;
                o = Tm(e1.getBody(), r.getStart());
                const d = /[^\s\u00a0\u00ad\u200b\ufeff]/;
                if (l && i > 0 && i < l.length && d.test(l.charAt(i)) && d.test(l.charAt(i - 1))) {
                    const o = r.getBookmark();
                    a.collapse(!0);
                    let i = jf(e1.dom, a, s);
                    i = Ig(i), e1.formatter.apply(t, n, i), r.moveToBookmark(o);
                } else {
                    let s = o ? cv(o) : null;
                    o && (null == s ? void 0 : s.data) === dv || (c = e1.getDoc(), u = uv(!0).dom, o = c.importNode(u, !0), s = o.firstChild, a.insertNode(o), i = 1, bv(e1, o)), e1.formatter.apply(t, n, o), r.setCursorLocation(s, i);
                }
                var c, u;
            })(e1, t, n) : (l.setRng(Hb(l.getRng())), af(e1, ()=>{
                nf(e1, (e1, t)=>{
                    const n = t ? e1 : jf(i, e1, r);
                    f(i, n, !1);
                });
            }, M), e1.nodeChanged()), Sv(e1.formatter, t).each((t)=>{
                q(((e1)=>Y(((e1)=>{
                        const t = e1.getSelectedBlocks(), n = e1.getRng();
                        if (e1.isCollapsed()) return [];
                        if (1 === t.length) return kv(n, t[0]) && Nv(n, t[0]) ? t : [];
                        {
                            const e1 = le(t).filter((e1)=>kv(n, e1)).toArray(), o = de(t).filter((e1)=>Nv(n, e1)).toArray(), r = t.slice(1, -1);
                            return e1.concat(r).concat(o);
                        }
                    })(e1), Rv(e1.dom)))(e1.selection), (e1)=>oy(i, e1, t, n));
            });
            ((e1, t)=>{
                xe(Ev, e1) && q(Ev[e1], (e1)=>{
                    e1(t);
                });
            })(t, e1);
        }
        dd(e1, t, o, n);
    }, sy = (e1, t, n, o)=>{
        (o || e1.selection.isEditable()) && ry(e1, t, n, o);
    }, ay = (e1)=>xe(e1, "vars"), iy = (e1)=>e1.selection.getStart(), ly = (e1, t, n, o, r)=>Z(t, (t)=>{
            const s = e1.formatter.matchNode(t, n, null != r ? r : {}, o);
            return !v(s);
        }, (t)=>!!ov(e1, t, n) || !o && C(e1.formatter.matchNode(t, n, r, !0))), dy = (e1, t)=>{
        const n = null != t ? t : iy(e1);
        return Y(yf(e1.dom, n), (e1)=>qr(e1) && !Xr(e1));
    }, cy = (e1, t, n)=>{
        const o = dy(e1, t);
        pe(n, (n, r)=>{
            const s = (n)=>{
                const s = ly(e1, o, r, n.similar, ay(n) ? n.vars : void 0), a = s.isSome();
                if (n.state.get() !== a) {
                    n.state.set(a);
                    const e1 = s.getOr(t);
                    ay(n) ? n.callback(a, {
                        node: e1,
                        format: r,
                        parents: o
                    }) : q(n.callbacks, (t)=>t(a, {
                            node: e1,
                            format: r,
                            parents: o
                        }));
                }
            };
            q([
                n.withSimilar,
                n.withoutSimilar
            ], s), q(n.withVars, s);
        });
    }, uy = an.explode, my = ()=>{
        const e1 = {};
        return {
            addFilter: (t, n)=>{
                q(uy(t), (t)=>{
                    xe(e1, t) || (e1[t] = {
                        name: t,
                        callbacks: []
                    }), e1[t].callbacks.push(n);
                });
            },
            getFilters: ()=>Ee(e1),
            removeFilter: (t, n)=>{
                q(uy(t), (t)=>{
                    if (xe(e1, t)) {
                        if (C(n)) {
                            const o = e1[t], r = Y(o.callbacks, (e1)=>e1 !== n);
                            r.length > 0 ? o.callbacks = r : delete e1[t];
                        } else delete e1[t];
                    }
                });
            }
        };
    }, fy = (e1)=>e1.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&"), gy = (e1, t, n)=>{
        var o;
        const r = Ia();
        t.convert_fonts_to_spans && ((e1, t, n)=>{
            e1.addNodeFilter("font", (e1)=>{
                q(e1, (e1)=>{
                    const o = t.parse(e1.attr("style")), r = e1.attr("color"), s = e1.attr("face"), a = e1.attr("size");
                    r && (o.color = r), s && (o["font-family"] = s), a && nt(a).each((e1)=>{
                        o["font-size"] = n[e1 - 1];
                    }), e1.name = "span", e1.attr("style", t.serialize(o)), ((e1)=>{
                        q([
                            "color",
                            "face",
                            "size"
                        ], (t)=>{
                            e1.attr(t, null);
                        });
                    })(e1);
                });
            });
        })(e1, r, an.explode(null !== (o = t.font_size_legacy_values) && void 0 !== o ? o : "")), ((e1, t, n)=>{
            e1.addNodeFilter("strike", (e1)=>{
                const o = "html4" !== t.type;
                q(e1, (e1)=>{
                    if (o) e1.name = "s";
                    else {
                        const t = n.parse(e1.attr("style"));
                        t["text-decoration"] = "line-through", e1.name = "span", e1.attr("style", n.serialize(t));
                    }
                });
            });
        })(e1, n, r);
    }, py = (e1)=>{
        const [t, ...n] = e1.split(","), o = n.join(","), r = /data:([^/]+\/[^;]+)(;.+)?/.exec(t);
        if (r) {
            const e1 = ";base64" === r[2], t = ((e1)=>{
                try {
                    return decodeURIComponent(e1);
                } catch (t) {
                    return e1;
                }
            })(o), n = e1 ? ((e1)=>{
                const t = /([a-z0-9+\/=\s]+)/i.exec(e1);
                return t ? t[1] : "";
            })(t) : t;
            return I.some({
                type: r[1],
                data: n,
                base64Encoded: e1
            });
        }
        return I.none();
    }, hy = (e1, t, n = !0)=>{
        let o = t;
        if (n) try {
            o = atob(t);
        } catch (e1) {
            return I.none();
        }
        const r = new Uint8Array(o.length);
        for(let e1 = 0; e1 < r.length; e1++)r[e1] = o.charCodeAt(e1);
        return I.some(new Blob([
            r
        ], {
            type: e1
        }));
    }, by = (e1)=>new Promise((t, n)=>{
            const o = new FileReader;
            o.onloadend = ()=>{
                t(o.result);
            }, o.onerror = ()=>{
                var e1;
                n(null === (e1 = o.error) || void 0 === e1 ? void 0 : e1.message);
            }, o.readAsDataURL(e1);
        });
    let vy = 0;
    const yy = (e1, t, n)=>py(e1).bind(({ data: e1, type: o, base64Encoded: r })=>{
            if (t && !r) return I.none();
            {
                const t = r ? e1 : btoa(e1);
                return n(t, o);
            }
        }), Cy = (e1, t, n)=>{
        const o = e1.create("blobid" + vy++, t, n);
        return e1.add(o), o;
    }, wy = (e1, t, n = !1)=>yy(t, n, (t, n)=>I.from(e1.getByData(t, n)).orThunk(()=>hy(n, t).map((n)=>Cy(e1, n, t)))), Ey = /^(?:(?:(?:[A-Za-z][A-Za-z\d.+-]{0,14}:\/\/(?:[-.~*+=!&;:'%@?^${}(),\w]+@)?|www\.|[-;:&=+$,.\w]+@)([A-Za-z\d-]+(?:\.[A-Za-z\d-]+)*))(?::\d+)?(?:\/(?:[-.~*+=!;:'%@$(),\/\w]*[-~*+=%@$()\/\w])?)?(?:\?(?:[-.~*+=!&;:'%@?^${}(),\/\w]+)?)?(?:#(?:[-.~*+=!&;:'%@?^${}(),\/\w]+)?)?)$/, _y = (e1)=>I.from(e1.match(Ey)).bind((e1)=>ie(e1, 1)).map((e1)=>Ye(e1, "www.") ? e1.substring(4) : e1), xy = (e1, t)=>{
        I.from(e1.attr("src")).bind(_y).forall((e1)=>!H(t, e1)) && e1.attr("sandbox", "");
    }, Sy = (e1, t)=>Ye(e1, `${t}/`), { entries: ky, setPrototypeOf: Ny, isFrozen: Ry, getPrototypeOf: Ay, getOwnPropertyDescriptor: Ty } = Object;
    let { freeze: Oy, seal: By, create: Py } = Object, { apply: Dy, construct: Ly } = "undefined" != typeof Reflect && Reflect;
    Oy || (Oy = function(e1) {
        return e1;
    }), By || (By = function(e1) {
        return e1;
    }), Dy || (Dy = function(e1, t, n) {
        return e1.apply(t, n);
    }), Ly || (Ly = function(e1, t) {
        return new e1(...t);
    });
    const My = Zy(Array.prototype.forEach), Iy = Zy(Array.prototype.lastIndexOf), Fy = Zy(Array.prototype.pop), Uy = Zy(Array.prototype.push), zy = Zy(Array.prototype.splice), jy = Zy(String.prototype.toLowerCase), Hy = Zy(String.prototype.toString), $y = Zy(String.prototype.match), Vy = Zy(String.prototype.replace), qy = Zy(String.prototype.indexOf), Wy = Zy(String.prototype.trim), Ky = Zy(Object.prototype.hasOwnProperty), Yy = Zy(RegExp.prototype.test), Gy = (Xy = TypeError, function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        return Ly(Xy, t);
    });
    var Xy;
    function Zy(e1) {
        return function(t) {
            t instanceof RegExp && (t.lastIndex = 0);
            for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)o[r - 1] = arguments[r];
            return Dy(e1, t, o);
        };
    }
    function Qy(e1, t) {
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : jy;
        Ny && Ny(e1, null);
        let o = t.length;
        for(; o--;){
            let r = t[o];
            if ("string" == typeof r) {
                const e1 = n(r);
                e1 !== r && (Ry(t) || (t[o] = e1), r = e1);
            }
            e1[r] = !0;
        }
        return e1;
    }
    function Jy(e1) {
        for(let t = 0; t < e1.length; t++)Ky(e1, t) || (e1[t] = null);
        return e1;
    }
    function eC(e1) {
        const t = Py(null);
        for (const [n, o] of ky(e1))Ky(e1, n) && (Array.isArray(o) ? t[n] = Jy(o) : o && "object" == typeof o && o.constructor === Object ? t[n] = eC(o) : t[n] = o);
        return t;
    }
    function tC(e1, t) {
        for(; null !== e1;){
            const n = Ty(e1, t);
            if (n) {
                if (n.get) return Zy(n.get);
                if ("function" == typeof n.value) return Zy(n.value);
            }
            e1 = Ay(e1);
        }
        return function() {
            return null;
        };
    }
    const nC = Oy([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]), oC = Oy([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]), rC = Oy([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]), sC = Oy([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]), aC = Oy([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]), iC = Oy([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]), lC = Oy([
        "#text"
    ]), dC = Oy([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns",
        "slot"
    ]), cC = Oy([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "amplitude",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "exponent",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "intercept",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "tablevalues",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]), uC = Oy([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]), mC = Oy([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]), fC = By(/\{\{[\w\W]*|[\w\W]*\}\}/gm), gC = By(/<%[\w\W]*|[\w\W]*%>/gm), pC = By(/\$\{[\w\W]*/gm), hC = By(/^data-[\-\w.\u00B7-\uFFFF]+$/), bC = By(/^aria-[\-\w]+$/), vC = By(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), yC = By(/^(?:\w+script|data):/i), CC = By(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), wC = By(/^html$/i), EC = By(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var _C = Object.freeze({
        __proto__: null,
        ARIA_ATTR: bC,
        ATTR_WHITESPACE: CC,
        CUSTOM_ELEMENT: EC,
        DATA_ATTR: hC,
        DOCTYPE_NAME: wC,
        ERB_EXPR: gC,
        IS_ALLOWED_URI: vC,
        IS_SCRIPT_OR_DATA: yC,
        MUSTACHE_EXPR: fC,
        TMPLIT_EXPR: pC
    });
    const xC = function() {
        return "undefined" == typeof window ? null : window;
    };
    var SC = function e1() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : xC();
        const n = (t)=>e1(t);
        if (n.version = "3.2.6", n.removed = [], !t || !t.document || 9 !== t.document.nodeType || !t.Element) return n.isSupported = !1, n;
        let { document: o } = t;
        const r = o, s = r.currentScript, { DocumentFragment: a, HTMLTemplateElement: i, Node: l, Element: d, NodeFilter: c, NamedNodeMap: u = t.NamedNodeMap || t.MozNamedAttrMap, HTMLFormElement: m, DOMParser: f, trustedTypes: g } = t, p = d.prototype, h = tC(p, "cloneNode"), b = tC(p, "remove"), v = tC(p, "nextSibling"), y = tC(p, "childNodes"), C = tC(p, "parentNode");
        if ("function" == typeof i) {
            const e1 = o.createElement("template");
            e1.content && e1.content.ownerDocument && (o = e1.content.ownerDocument);
        }
        let w, E = "";
        const { implementation: _, createNodeIterator: x, createDocumentFragment: S, getElementsByTagName: k } = o, { importNode: N } = r;
        let R = {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
        n.isSupported = "function" == typeof ky && "function" == typeof C && _ && void 0 !== _.createHTMLDocument;
        const { MUSTACHE_EXPR: A, ERB_EXPR: T, TMPLIT_EXPR: O, DATA_ATTR: B, ARIA_ATTR: P, IS_SCRIPT_OR_DATA: D, ATTR_WHITESPACE: L, CUSTOM_ELEMENT: M } = _C;
        let { IS_ALLOWED_URI: I } = _C, F = null;
        const U = Qy({}, [
            ...nC,
            ...oC,
            ...rC,
            ...aC,
            ...lC
        ]);
        let z = null;
        const j = Qy({}, [
            ...dC,
            ...cC,
            ...uC,
            ...mC
        ]);
        let H = Object.seal(Py(null, {
            tagNameCheck: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: null
            },
            attributeNameCheck: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: !1
            }
        })), $ = null, V = null, q = !0, W = !0, K = !1, Y = !0, G = !1, X = !0, Z = !1, Q = !1, J = !1, ee = !1, te = !1, ne = !1, oe = !0, re = !1, se = !0, ae = !1, ie = {}, le = null;
        const de = Qy({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        let ce = null;
        const ue = Qy({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        let me = null;
        const fe = Qy({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]), ge = "http://www.w3.org/1998/Math/MathML", pe = "http://www.w3.org/2000/svg", he = "http://www.w3.org/1999/xhtml";
        let be = he, ve = !1, ye = null;
        const Ce = Qy({}, [
            ge,
            pe,
            he
        ], Hy);
        let we = Qy({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]), Ee = Qy({}, [
            "annotation-xml"
        ]);
        const _e = Qy({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        let xe = null;
        const Se = [
            "application/xhtml+xml",
            "text/html"
        ];
        let ke = null, Ne = null;
        const Re = o.createElement("form"), Ae = function(e1) {
            return e1 instanceof RegExp || e1 instanceof Function;
        }, Te = function() {
            let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (!Ne || Ne !== e1) {
                if (e1 && "object" == typeof e1 || (e1 = {}), e1 = eC(e1), xe = -1 === Se.indexOf(e1.PARSER_MEDIA_TYPE) ? "text/html" : e1.PARSER_MEDIA_TYPE, ke = "application/xhtml+xml" === xe ? Hy : jy, F = Ky(e1, "ALLOWED_TAGS") ? Qy({}, e1.ALLOWED_TAGS, ke) : U, z = Ky(e1, "ALLOWED_ATTR") ? Qy({}, e1.ALLOWED_ATTR, ke) : j, ye = Ky(e1, "ALLOWED_NAMESPACES") ? Qy({}, e1.ALLOWED_NAMESPACES, Hy) : Ce, me = Ky(e1, "ADD_URI_SAFE_ATTR") ? Qy(eC(fe), e1.ADD_URI_SAFE_ATTR, ke) : fe, ce = Ky(e1, "ADD_DATA_URI_TAGS") ? Qy(eC(ue), e1.ADD_DATA_URI_TAGS, ke) : ue, le = Ky(e1, "FORBID_CONTENTS") ? Qy({}, e1.FORBID_CONTENTS, ke) : de, $ = Ky(e1, "FORBID_TAGS") ? Qy({}, e1.FORBID_TAGS, ke) : eC({}), V = Ky(e1, "FORBID_ATTR") ? Qy({}, e1.FORBID_ATTR, ke) : eC({}), ie = !!Ky(e1, "USE_PROFILES") && e1.USE_PROFILES, q = !1 !== e1.ALLOW_ARIA_ATTR, W = !1 !== e1.ALLOW_DATA_ATTR, K = e1.ALLOW_UNKNOWN_PROTOCOLS || !1, Y = !1 !== e1.ALLOW_SELF_CLOSE_IN_ATTR, G = e1.SAFE_FOR_TEMPLATES || !1, X = !1 !== e1.SAFE_FOR_XML, Z = e1.WHOLE_DOCUMENT || !1, ee = e1.RETURN_DOM || !1, te = e1.RETURN_DOM_FRAGMENT || !1, ne = e1.RETURN_TRUSTED_TYPE || !1, J = e1.FORCE_BODY || !1, oe = !1 !== e1.SANITIZE_DOM, re = e1.SANITIZE_NAMED_PROPS || !1, se = !1 !== e1.KEEP_CONTENT, ae = e1.IN_PLACE || !1, I = e1.ALLOWED_URI_REGEXP || vC, be = e1.NAMESPACE || he, we = e1.MATHML_TEXT_INTEGRATION_POINTS || we, Ee = e1.HTML_INTEGRATION_POINTS || Ee, H = e1.CUSTOM_ELEMENT_HANDLING || {}, e1.CUSTOM_ELEMENT_HANDLING && Ae(e1.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (H.tagNameCheck = e1.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e1.CUSTOM_ELEMENT_HANDLING && Ae(e1.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (H.attributeNameCheck = e1.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e1.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e1.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (H.allowCustomizedBuiltInElements = e1.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), G && (W = !1), te && (ee = !0), ie && (F = Qy({}, lC), z = [], !0 === ie.html && (Qy(F, nC), Qy(z, dC)), !0 === ie.svg && (Qy(F, oC), Qy(z, cC), Qy(z, mC)), !0 === ie.svgFilters && (Qy(F, rC), Qy(z, cC), Qy(z, mC)), !0 === ie.mathMl && (Qy(F, aC), Qy(z, uC), Qy(z, mC))), e1.ADD_TAGS && (F === U && (F = eC(F)), Qy(F, e1.ADD_TAGS, ke)), e1.ADD_ATTR && (z === j && (z = eC(z)), Qy(z, e1.ADD_ATTR, ke)), e1.ADD_URI_SAFE_ATTR && Qy(me, e1.ADD_URI_SAFE_ATTR, ke), e1.FORBID_CONTENTS && (le === de && (le = eC(le)), Qy(le, e1.FORBID_CONTENTS, ke)), se && (F["#text"] = !0), Z && Qy(F, [
                    "html",
                    "head",
                    "body"
                ]), F.table && (Qy(F, [
                    "tbody"
                ]), delete $.tbody), e1.TRUSTED_TYPES_POLICY) {
                    if ("function" != typeof e1.TRUSTED_TYPES_POLICY.createHTML) throw Gy('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                    if ("function" != typeof e1.TRUSTED_TYPES_POLICY.createScriptURL) throw Gy('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                    w = e1.TRUSTED_TYPES_POLICY, E = w.createHTML("");
                } else void 0 === w && (w = function(e1, t) {
                    if ("object" != typeof e1 || "function" != typeof e1.createPolicy) return null;
                    let n = null;
                    const o = "data-tt-policy-suffix";
                    t && t.hasAttribute(o) && (n = t.getAttribute(o));
                    const r = "dompurify" + (n ? "#" + n : "");
                    try {
                        return e1.createPolicy(r, {
                            createHTML: (e1)=>e1,
                            createScriptURL: (e1)=>e1
                        });
                    } catch (e1) {
                        return console.warn("TrustedTypes policy " + r + " could not be created."), null;
                    }
                }(g, s)), null !== w && "string" == typeof E && (E = w.createHTML(""));
                Oy && Oy(e1), Ne = e1;
            }
        }, Oe = Qy({}, [
            ...oC,
            ...rC,
            ...sC
        ]), Be = Qy({}, [
            ...aC,
            ...iC
        ]), Pe = function(e1) {
            Uy(n.removed, {
                element: e1
            });
            try {
                C(e1).removeChild(e1);
            } catch (t) {
                b(e1);
            }
        }, De = function(e1, t) {
            try {
                Uy(n.removed, {
                    attribute: t.getAttributeNode(e1),
                    from: t
                });
            } catch (e1) {
                Uy(n.removed, {
                    attribute: null,
                    from: t
                });
            }
            if (t.removeAttribute(e1), "is" === e1) {
                if (ee || te) try {
                    Pe(t);
                } catch (e1) {}
                else try {
                    t.setAttribute(e1, "");
                } catch (e1) {}
            }
        }, Le = function(e1) {
            let t = null, n = null;
            if (J) e1 = "<remove></remove>" + e1;
            else {
                const t = $y(e1, /^[\r\n\t ]+/);
                n = t && t[0];
            }
            "application/xhtml+xml" === xe && be === he && (e1 = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e1 + "</body></html>");
            const r = w ? w.createHTML(e1) : e1;
            if (be === he) try {
                t = (new f).parseFromString(r, xe);
            } catch (e1) {}
            if (!t || !t.documentElement) {
                t = _.createDocument(be, "template", null);
                try {
                    t.documentElement.innerHTML = ve ? E : r;
                } catch (e1) {}
            }
            const s = t.body || t.documentElement;
            return e1 && n && s.insertBefore(o.createTextNode(n), s.childNodes[0] || null), be === he ? k.call(t, Z ? "html" : "body")[0] : Z ? t.documentElement : s;
        }, Me = function(e1) {
            return x.call(e1.ownerDocument || e1, e1, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
        }, Ie = function(e1) {
            return e1 instanceof m && ("string" != typeof e1.nodeName || "string" != typeof e1.textContent || "function" != typeof e1.removeChild || !(e1.attributes instanceof u) || "function" != typeof e1.removeAttribute || "function" != typeof e1.setAttribute || "string" != typeof e1.namespaceURI || "function" != typeof e1.insertBefore || "function" != typeof e1.hasChildNodes);
        }, Fe = function(e1) {
            return "function" == typeof l && e1 instanceof l;
        };
        function Ue(e1, t, o) {
            My(e1, (e1)=>{
                e1.call(n, t, o, Ne);
            });
        }
        const ze = function(e1) {
            let t = null;
            if (Ue(R.beforeSanitizeElements, e1, null), Ie(e1)) return Pe(e1), !0;
            const o = ke(e1.nodeName);
            if (Ue(R.uponSanitizeElement, e1, {
                tagName: o,
                allowedTags: F
            }), X && e1.hasChildNodes() && !Fe(e1.firstElementChild) && Yy(/<[/\w!]/g, e1.innerHTML) && Yy(/<[/\w!]/g, e1.textContent)) return Pe(e1), !0;
            if (7 === e1.nodeType) return Pe(e1), !0;
            if (X && 8 === e1.nodeType && Yy(/<[/\w]/g, e1.data)) return Pe(e1), !0;
            if (!F[o] || $[o]) {
                if (!$[o] && He(o)) {
                    if (H.tagNameCheck instanceof RegExp && Yy(H.tagNameCheck, o)) return !1;
                    if (H.tagNameCheck instanceof Function && H.tagNameCheck(o)) return !1;
                }
                if (se && !le[o]) {
                    const t = C(e1) || e1.parentNode, n = y(e1) || e1.childNodes;
                    if (n && t) for(let o = n.length - 1; o >= 0; --o){
                        const r = h(n[o], !0);
                        r.__removalCount = (e1.__removalCount || 0) + 1, t.insertBefore(r, v(e1));
                    }
                }
                return Pe(e1), !0;
            }
            return e1 instanceof d && !function(e1) {
                let t = C(e1);
                t && t.tagName || (t = {
                    namespaceURI: be,
                    tagName: "template"
                });
                const n = jy(e1.tagName), o = jy(t.tagName);
                return !!ye[e1.namespaceURI] && (e1.namespaceURI === pe ? t.namespaceURI === he ? "svg" === n : t.namespaceURI === ge ? "svg" === n && ("annotation-xml" === o || we[o]) : Boolean(Oe[n]) : e1.namespaceURI === ge ? t.namespaceURI === he ? "math" === n : t.namespaceURI === pe ? "math" === n && Ee[o] : Boolean(Be[n]) : e1.namespaceURI === he ? !(t.namespaceURI === pe && !Ee[o]) && !(t.namespaceURI === ge && !we[o]) && !Be[n] && (_e[n] || !Oe[n]) : !("application/xhtml+xml" !== xe || !ye[e1.namespaceURI]));
            }(e1) ? (Pe(e1), !0) : "noscript" !== o && "noembed" !== o && "noframes" !== o || !Yy(/<\/no(script|embed|frames)/i, e1.innerHTML) ? (G && 3 === e1.nodeType && (t = e1.textContent, My([
                A,
                T,
                O
            ], (e1)=>{
                t = Vy(t, e1, " ");
            }), e1.textContent !== t && (Uy(n.removed, {
                element: e1.cloneNode()
            }), e1.textContent = t)), Ue(R.afterSanitizeElements, e1, null), !1) : (Pe(e1), !0);
        }, je = function(e1, t, n) {
            if (oe && ("id" === t || "name" === t) && (n in o || n in Re)) return !1;
            if (W && !V[t] && Yy(B, t)) ;
            else if (q && Yy(P, t)) ;
            else if (!z[t] || V[t]) {
                if (!(He(e1) && (H.tagNameCheck instanceof RegExp && Yy(H.tagNameCheck, e1) || H.tagNameCheck instanceof Function && H.tagNameCheck(e1)) && (H.attributeNameCheck instanceof RegExp && Yy(H.attributeNameCheck, t) || H.attributeNameCheck instanceof Function && H.attributeNameCheck(t)) || "is" === t && H.allowCustomizedBuiltInElements && (H.tagNameCheck instanceof RegExp && Yy(H.tagNameCheck, n) || H.tagNameCheck instanceof Function && H.tagNameCheck(n)))) return !1;
            } else if (me[t]) ;
            else if (Yy(I, Vy(n, L, ""))) ;
            else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e1 || 0 !== qy(n, "data:") || !ce[e1]) {
                if (K && !Yy(D, Vy(n, L, ""))) ;
                else if (n) return !1;
            }
            return !0;
        }, He = function(e1) {
            return "annotation-xml" !== e1 && $y(e1, M);
        }, $e = function(e1) {
            Ue(R.beforeSanitizeAttributes, e1, null);
            const { attributes: t } = e1;
            if (!t || Ie(e1)) return;
            const o = {
                attrName: "",
                attrValue: "",
                keepAttr: !0,
                allowedAttributes: z,
                forceKeepAttr: void 0
            };
            let r = t.length;
            for(; r--;){
                const s = t[r], { name: a, namespaceURI: i, value: l } = s, d = ke(a), c = l;
                let u = "value" === a ? c : Wy(c);
                if (o.attrName = d, o.attrValue = u, o.keepAttr = !0, o.forceKeepAttr = void 0, Ue(R.uponSanitizeAttribute, e1, o), u = o.attrValue, !re || "id" !== d && "name" !== d || (De(a, e1), u = "user-content-" + u), X && Yy(/((--!?|])>)|<\/(style|title)/i, u)) {
                    De(a, e1);
                    continue;
                }
                if (o.forceKeepAttr) continue;
                if (!o.keepAttr) {
                    De(a, e1);
                    continue;
                }
                if (!Y && Yy(/\/>/i, u)) {
                    De(a, e1);
                    continue;
                }
                G && My([
                    A,
                    T,
                    O
                ], (e1)=>{
                    u = Vy(u, e1, " ");
                });
                const m = ke(e1.nodeName);
                if (je(m, d, u)) {
                    if (w && "object" == typeof g && "function" == typeof g.getAttributeType) {
                        if (i) ;
                        else switch(g.getAttributeType(m, d)){
                            case "TrustedHTML":
                                u = w.createHTML(u);
                                break;
                            case "TrustedScriptURL":
                                u = w.createScriptURL(u);
                        }
                    }
                    if (u !== c) try {
                        i ? e1.setAttributeNS(i, a, u) : e1.setAttribute(a, u), Ie(e1) ? Pe(e1) : Fy(n.removed);
                    } catch (t) {
                        De(a, e1);
                    }
                } else De(a, e1);
            }
            Ue(R.afterSanitizeAttributes, e1, null);
        }, Ve = function e1(t) {
            let n = null;
            const o = Me(t);
            for(Ue(R.beforeSanitizeShadowDOM, t, null); n = o.nextNode();)Ue(R.uponSanitizeShadowNode, n, null), ze(n), $e(n), n.content instanceof a && e1(n.content);
            Ue(R.afterSanitizeShadowDOM, t, null);
        };
        return n.sanitize = function(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = null, s = null, i = null, d = null;
            if (ve = !e1, ve && (e1 = "\x3c!--\x3e"), "string" != typeof e1 && !Fe(e1)) {
                if ("function" != typeof e1.toString) throw Gy("toString is not a function");
                if ("string" != typeof (e1 = e1.toString())) throw Gy("dirty is not a string, aborting");
            }
            if (!n.isSupported) return e1;
            if (Q || Te(t), n.removed = [], "string" == typeof e1 && (ae = !1), ae) {
                if (e1.nodeName) {
                    const t = ke(e1.nodeName);
                    if (!F[t] || $[t]) throw Gy("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (e1 instanceof l) o = Le("\x3c!----\x3e"), s = o.ownerDocument.importNode(e1, !0), 1 === s.nodeType && "BODY" === s.nodeName || "HTML" === s.nodeName ? o = s : o.appendChild(s);
            else {
                if (!ee && !G && !Z && -1 === e1.indexOf("<")) return w && ne ? w.createHTML(e1) : e1;
                if (o = Le(e1), !o) return ee ? null : ne ? E : "";
            }
            o && J && Pe(o.firstChild);
            const c = Me(ae ? e1 : o);
            for(; i = c.nextNode();)ze(i), $e(i), i.content instanceof a && Ve(i.content);
            if (ae) return e1;
            if (ee) {
                if (te) for(d = S.call(o.ownerDocument); o.firstChild;)d.appendChild(o.firstChild);
                else d = o;
                return (z.shadowroot || z.shadowrootmode) && (d = N.call(r, d, !0)), d;
            }
            let u = Z ? o.outerHTML : o.innerHTML;
            return Z && F["!doctype"] && o.ownerDocument && o.ownerDocument.doctype && o.ownerDocument.doctype.name && Yy(wC, o.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + o.ownerDocument.doctype.name + ">\n" + u), G && My([
                A,
                T,
                O
            ], (e1)=>{
                u = Vy(u, e1, " ");
            }), w && ne ? w.createHTML(u) : u;
        }, n.setConfig = function() {
            Te(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), Q = !0;
        }, n.clearConfig = function() {
            Ne = null, Q = !1;
        }, n.isValidAttribute = function(e1, t, n) {
            Ne || Te({});
            const o = ke(e1), r = ke(t);
            return je(o, r, n);
        }, n.addHook = function(e1, t) {
            "function" == typeof t && Uy(R[e1], t);
        }, n.removeHook = function(e1, t) {
            if (void 0 !== t) {
                const n = Iy(R[e1], t);
                return -1 === n ? void 0 : zy(R[e1], n, 1)[0];
            }
            return Fy(R[e1]);
        }, n.removeHooks = function(e1) {
            R[e1] = [];
        }, n.removeAllHooks = function() {
            R = {
                afterSanitizeAttributes: [],
                afterSanitizeElements: [],
                afterSanitizeShadowDOM: [],
                beforeSanitizeAttributes: [],
                beforeSanitizeElements: [],
                beforeSanitizeShadowDOM: [],
                uponSanitizeAttribute: [],
                uponSanitizeElement: [],
                uponSanitizeShadowNode: []
            };
        }, n;
    }();
    const kC = an.each, NC = an.trim, RC = [
        "source",
        "protocol",
        "authority",
        "userInfo",
        "user",
        "password",
        "host",
        "port",
        "relative",
        "path",
        "directory",
        "file",
        "query",
        "anchor"
    ], AC = {
        ftp: 21,
        http: 80,
        https: 443,
        mailto: 25
    }, TC = [
        "img",
        "video"
    ], OC = (e1, t, n)=>{
        const o = ((e1)=>{
            try {
                return decodeURIComponent(e1);
            } catch (t) {
                return unescape(e1);
            }
        })(t).replace(/\s/g, "");
        return !e1.allow_script_urls && (!!/((java|vb)script|mhtml):/i.test(o) || !e1.allow_html_data_urls && (/^data:image\//i.test(o) ? ((e1, t)=>C(e1) ? !e1 : !C(t) || !H(TC, t))(e1.allow_svg_data_urls, n) && /^data:image\/svg\+xml/i.test(o) : /^data:/i.test(o)));
    };
    class BC {
        static parseDataUri(e1) {
            let t;
            const n = decodeURIComponent(e1).split(","), o = /data:([^;]+)/.exec(n[0]);
            return o && (t = o[1]), {
                type: t,
                data: n[1]
            };
        }
        static isDomSafe(e1, t, n = {}) {
            if (n.allow_script_urls) return !0;
            {
                const o = ua.decode(e1).replace(/[\s\u0000-\u001F]+/g, "");
                return !OC(n, o, t);
            }
        }
        static getDocumentBaseUrl(e1) {
            var t;
            let n;
            return n = 0 !== e1.protocol.indexOf("http") && "file:" !== e1.protocol ? null !== (t = e1.href) && void 0 !== t ? t : "" : e1.protocol + "//" + e1.host + e1.pathname, /^[^:]+:\/\/\/?[^\/]+\//.test(n) && (n = n.replace(/[\?#].*$/, "").replace(/[\/\\][^\/]+$/, ""), /[\/\\]$/.test(n) || (n += "/")), n;
        }
        constructor(e1, t = {}){
            this.path = "", this.directory = "", e1 = NC(e1), this.settings = t;
            const n = t.base_uri, o = this;
            if (/^([\w\-]+):([^\/]{2})/i.test(e1) || /^\s*#/.test(e1)) return void (o.source = e1);
            const r = 0 === e1.indexOf("//");
            if (0 !== e1.indexOf("/") || r || (e1 = (n && n.protocol || "http") + "://mce_host" + e1), !/^[\w\-]*:?\/\//.test(e1)) {
                const t = n ? n.path : new BC(document.location.href).directory;
                if ("" === (null == n ? void 0 : n.protocol)) e1 = "//mce_host" + o.toAbsPath(t, e1);
                else {
                    const r = /([^#?]*)([#?]?.*)/.exec(e1);
                    r && (e1 = (n && n.protocol || "http") + "://mce_host" + o.toAbsPath(t, r[1]) + r[2]);
                }
            }
            e1 = e1.replace(/@@/g, "(mce_at)");
            const s = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?(\[[a-zA-Z0-9:.%]+\]|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(e1);
            s && kC(RC, (e1, t)=>{
                let n = s[t];
                n && (n = n.replace(/\(mce_at\)/g, "@@")), o[e1] = n;
            }), n && (o.protocol || (o.protocol = n.protocol), o.userInfo || (o.userInfo = n.userInfo), o.port || "mce_host" !== o.host || (o.port = n.port), o.host && "mce_host" !== o.host || (o.host = n.host), o.source = ""), r && (o.protocol = "");
        }
        setPath(e1) {
            const t = /^(.*?)\/?(\w+)?$/.exec(e1);
            t && (this.path = t[0], this.directory = t[1], this.file = t[2]), this.source = "", this.getURI();
        }
        toRelative(e1) {
            if ("./" === e1) return e1;
            const t = new BC(e1, {
                base_uri: this
            });
            if ("mce_host" !== t.host && this.host !== t.host && t.host || this.port !== t.port || this.protocol !== t.protocol && "" !== t.protocol) return t.getURI();
            const n = this.getURI(), o = t.getURI();
            if (n === o || "/" === n.charAt(n.length - 1) && n.substr(0, n.length - 1) === o) return n;
            let r = this.toRelPath(this.path, t.path);
            return t.query && (r += "?" + t.query), t.anchor && (r += "#" + t.anchor), r;
        }
        toAbsolute(e1, t) {
            const n = new BC(e1, {
                base_uri: this
            });
            return n.getURI(t && this.isSameOrigin(n));
        }
        isSameOrigin(e1) {
            if (this.host == e1.host && this.protocol == e1.protocol) {
                if (this.port == e1.port) return !0;
                const t = this.protocol ? AC[this.protocol] : null;
                if (t && (this.port || t) == (e1.port || t)) return !0;
            }
            return !1;
        }
        toRelPath(e1, t) {
            let n, o, r = 0, s = "";
            const a = e1.substring(0, e1.lastIndexOf("/")).split("/"), i = t.split("/");
            if (a.length >= i.length) {
                for(n = 0, o = a.length; n < o; n++)if (n >= i.length || a[n] !== i[n]) {
                    r = n + 1;
                    break;
                }
            }
            if (a.length < i.length) {
                for(n = 0, o = i.length; n < o; n++)if (n >= a.length || a[n] !== i[n]) {
                    r = n + 1;
                    break;
                }
            }
            if (1 === r) return t;
            for(n = 0, o = a.length - (r - 1); n < o; n++)s += "../";
            for(n = r - 1, o = i.length; n < o; n++)s += n !== r - 1 ? "/" + i[n] : i[n];
            return s;
        }
        toAbsPath(e1, t) {
            let n = 0;
            const o = /\/$/.test(t) ? "/" : "", r = e1.split("/"), s = t.split("/"), a = [];
            kC(r, (e1)=>{
                e1 && a.push(e1);
            });
            const i = [];
            for(let e1 = s.length - 1; e1 >= 0; e1--)0 !== s[e1].length && "." !== s[e1] && (".." !== s[e1] ? n > 0 ? n-- : i.push(s[e1]) : n++);
            const l = a.length - n;
            let d;
            return d = l <= 0 ? oe(i).join("/") : a.slice(0, l).join("/") + "/" + oe(i).join("/"), 0 !== d.indexOf("/") && (d = "/" + d), o && d.lastIndexOf("/") !== d.length - 1 && (d += o), d;
        }
        getURI(e1 = !1) {
            let t;
            return this.source && !e1 || (t = "", e1 || (this.protocol ? t += this.protocol + "://" : t += "//", this.userInfo && (t += this.userInfo + "@"), this.host && (t += this.host), this.port && (t += ":" + this.port)), this.path && (t += this.path), this.query && (t += "?" + this.query), this.anchor && (t += "#" + this.anchor), this.source = t), this.source;
        }
    }
    const PC = an.makeMap("src,href,data,background,action,formaction,poster,xlink:href"), DC = "data-mce-type";
    let LC = 0;
    const MC = (e1, t, n, o, r)=>{
        var s, a, i, l;
        const d = t.validate, c = n.getSpecialElements();
        8 === e1.nodeType && (!t.allow_conditional_comments && /^\[if/i.test(null !== (s = e1.nodeValue) && void 0 !== s ? s : "") && (e1.nodeValue = " " + e1.nodeValue), t.sanitize && t.allow_html_in_comments && m(e1.nodeValue) && (e1.nodeValue = ((e1)=>e1.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"))(e1.nodeValue)));
        const u = null !== (a = null == r ? void 0 : r.tagName) && void 0 !== a ? a : e1.nodeName.toLowerCase();
        if ("html" !== o && n.isValid(o)) return void (C(r) && (r.allowedTags[u] = !0));
        if (1 !== e1.nodeType || "body" === u) return;
        const f = mn(e1), g = vo(f, DC), p = ho(f, "data-mce-bogus");
        if (!g && m(p)) return void ("all" === p ? Eo(f) : _o(f));
        const h = n.getElementRule(u);
        if (!d || h) {
            if (C(r) && (r.allowedTags[u] = !0), d && h && !g) {
                if (q(null !== (i = h.attributesForced) && void 0 !== i ? i : [], (e1)=>{
                    go(f, e1.name, "{$uid}" === e1.value ? "mce_" + LC++ : e1.value);
                }), q(null !== (l = h.attributesDefault) && void 0 !== l ? l : [], (e1)=>{
                    vo(f, e1.name) || go(f, e1.name, "{$uid}" === e1.value ? "mce_" + LC++ : e1.value);
                }), h.attributesRequired && !$(h.attributesRequired, (e1)=>vo(f, e1))) return void _o(f);
                if (h.removeEmptyAttrs && ((e1)=>{
                    const t = e1.dom.attributes;
                    return null == t || 0 === t.length;
                })(f)) return void _o(f);
                h.outputName && h.outputName !== u && ((e1, t)=>{
                    const n = ((e1, t)=>{
                        const n = cn(t), o = Co(e1);
                        return po(n, o), n;
                    })(e1, t);
                    io(e1, n);
                    const o = Hn(e1);
                    mo(n, o), Eo(e1);
                })(f, h.outputName);
            }
        } else xe(c, u) ? Eo(f) : _o(f);
    }, IC = (e1, t, n, o, r, s)=>"html" !== n && !ks(o) || !(r in PC && OC(e1, s, o)) && (!e1.validate || t.isValid(o, r) || Ye(r, "data-") || Ye(r, "aria-")), FC = (e1, t)=>e1.hasAttribute(DC) && ("id" === t || "class" === t || "style" === t), UC = (e1, t)=>e1 in t.getBoolAttrs(), zC = (e1, t, n, o)=>{
        const { attributes: r } = e1;
        for(let s = r.length - 1; s >= 0; s--){
            const a = r[s], i = a.name, l = a.value;
            IC(t, n, o, e1.tagName.toLowerCase(), i, l) || FC(e1, i) ? UC(i, n) && e1.setAttribute(i, i) : e1.removeAttribute(i);
        }
    }, jC = (e1, t, n)=>{
        const o = SC();
        return o.addHook("uponSanitizeElement", (o, r)=>{
            MC(o, e1, t, n.track(o), r);
        }), o.addHook("uponSanitizeAttribute", (o, r)=>{
            ((e1, t, n, o, r)=>{
                const s = e1.tagName.toLowerCase(), { attrName: a, attrValue: i } = r;
                r.keepAttr = IC(t, n, o, s, a, i), r.keepAttr ? (r.allowedAttributes[a] = !0, UC(a, n) && (r.attrValue = a), t.allow_svg_data_urls && Ye(i, "data:image/svg+xml") && (r.forceKeepAttr = !0)) : FC(e1, a) && (r.forceKeepAttr = !0);
            })(o, e1, t, n.current(), r);
        }), o;
    }, HC = (e1, t)=>{
        const n = SC(), o = t.allow_mathml_annotation_encodings, r = p(o) && o.length > 0;
        n.addHook("uponSanitizeElement", (e1, n)=>{
            var s;
            const a = null !== (s = n.tagName) && void 0 !== s ? s : e1.nodeName.toLowerCase();
            ((e1, n)=>r && "semantics" === n ? I.some(!0) : "annotation" === n ? I.some(qr(e1) && ((e1)=>{
                    const t = e1.getAttribute("encoding");
                    return r && m(t) && H(o, t);
                })(e1)) : p(t.extended_mathml_elements) && t.extended_mathml_elements.includes(n) ? I.from(!0) : I.none())(e1, a).each((o)=>{
                n.allowedTags[a] = o, !o && t.sanitize && qr(e1) && e1.remove();
            });
        }), n.addHook("uponSanitizeAttribute", (e1, n)=>{
            p(t.extended_mathml_attributes) && t.extended_mathml_attributes.includes(n.attrName) && (n.forceKeepAttr = !0);
        }), n.sanitize(e1, {
            IN_PLACE: !0,
            USE_PROFILES: {
                mathMl: !0
            }
        });
    }, $C = (e1)=>(t)=>{
            const n = Rs(t);
            if ("svg" === n) ((e1)=>{
                const t = [
                    "type",
                    "href",
                    "role",
                    "arcrole",
                    "title",
                    "show",
                    "actuate",
                    "label",
                    "from",
                    "to"
                ].map((e1)=>`xlink:${e1}`), n = {
                    IN_PLACE: !0,
                    USE_PROFILES: {
                        html: !0,
                        svg: !0,
                        svgFilters: !0
                    },
                    ALLOWED_ATTR: t
                };
                SC().sanitize(e1, n);
            })(t);
            else {
                if ("math" !== n) throw new Error("Not a namespace element");
                HC(t, e1);
            }
        }, VC = an.makeMap, qC = an.extend, WC = (e1, t, n, o, r)=>{
        const s = e1.name, a = s in n && "title" !== s && "textarea" !== s && "noscript" !== s, i = t.childNodes;
        for(let t = 0, s = i.length; t < s; t++){
            const s = i[t], l = new up(s.nodeName.toLowerCase(), s.nodeType);
            if (qr(s)) {
                const e1 = s.attributes;
                for(let t = 0, n = e1.length; t < n; t++){
                    const n = e1[t];
                    l.attr(n.name, n.value);
                }
                ks(l.name) && (o(s), l.value = s.innerHTML);
            } else es(s) ? (l.value = s.data, a && (l.raw = !0)) : os(s) ? l.value = r ? fy(s.data) : s.data : (ts(s) || ns(s)) && (l.value = s.data);
            ks(l.name) || WC(l, s, n, o, r), e1.append(l);
        }
    }, KC = (e1 = {}, t = Ra())=>{
        const n = my(), o = my(), r = {
            validate: !0,
            root_name: "body",
            sanitize: !0,
            allow_html_in_comments: !0,
            ...e1
        }, s = new DOMParser, a = ((e1, t)=>{
            const n = (()=>{
                const e1 = Ve(), t = ()=>e1.get().map(Rs).getOr("html");
                return {
                    track: (n)=>(Ns(n) ? e1.set(n) : e1.get().exists((e1)=>!e1.contains(n)) && e1.clear(), t()),
                    current: t,
                    reset: ()=>{
                        e1.clear();
                    }
                };
            })();
            if (e1.sanitize) {
                const o = jC(e1, t, n), r = (t, r)=>{
                    o.sanitize(t, ((e1, t)=>{
                        const n = {
                            IN_PLACE: !0,
                            ALLOW_UNKNOWN_PROTOCOLS: !0,
                            ALLOWED_TAGS: [
                                "#comment",
                                "#cdata-section",
                                "body"
                            ],
                            ALLOWED_ATTR: []
                        };
                        return n.PARSER_MEDIA_TYPE = t, e1.allow_script_urls ? n.ALLOWED_URI_REGEXP = /.*/ : e1.allow_html_data_urls && (n.ALLOWED_URI_REGEXP = /^(?!(\w+script|mhtml):)/i), n;
                    })(e1, r)), o.removed = [], n.reset();
                };
                return {
                    sanitizeHtmlElement: r,
                    sanitizeNamespaceElement: $C(e1)
                };
            }
            return {
                sanitizeHtmlElement: (o, r)=>{
                    const s = document.createNodeIterator(o, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT);
                    let a;
                    for(; a = s.nextNode();){
                        const o = n.track(a);
                        MC(a, e1, t, o), qr(a) && zC(a, e1, t, o);
                    }
                    n.reset();
                },
                sanitizeNamespaceElement: x
            };
        })(r, t), i = n.addFilter, l = n.getFilters, d = n.removeFilter, c = o.addFilter, u = o.getFilters, f = o.removeFilter, g = (e1, n)=>{
            const o = m(n.attr(DC)), r = 1 === n.type && !xe(e1, n.name) && !$s(t, n) && !ks(n.name);
            return 3 === n.type || r && !o;
        }, p = {
            schema: t,
            addAttributeFilter: c,
            getAttributeFilters: u,
            removeAttributeFilter: f,
            addNodeFilter: i,
            getNodeFilters: l,
            removeNodeFilter: d,
            parse: (e1, n = {})=>{
                var o;
                const i = r.validate, d = null !== (o = n.context) && void 0 !== o ? o : r.root_name, c = ((e1, n, o = "html")=>{
                    const r = "xhtml" === o ? "application/xhtml+xml" : "text/html", i = xe(t.getSpecialElements(), n.toLowerCase()), l = i ? `<${n}>${e1}</${n}>` : e1, d = s.parseFromString("xhtml" === o ? `<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>${l}</body></html>` : /^[\s]*<head/i.test(e1) || /^[\s]*<html/i.test(e1) || /^[\s]*<!DOCTYPE/i.test(e1) ? `<html>${l}</html>` : `<body>${l}</body>`, r).body;
                    return a.sanitizeHtmlElement(d, r), i ? d.firstChild : d;
                })(e1, d, n.format);
                Ms(t, c);
                const m = new up(d, 11);
                WC(m, c, t.getSpecialElements(), a.sanitizeNamespaceElement, r.sanitize && r.allow_html_in_comments), c.innerHTML = "";
                const [f, p] = ((e1, t, n, o)=>{
                    const r = n.validate, s = t.getNonEmptyElements(), a = t.getWhitespaceElements(), i = qC(VC("script,style,head,html,body,title,meta,param"), t.getBlockElements()), l = ka(t), d = /[ \t\r\n]+/g, c = /^[ \t\r\n]+/, u = /[ \t\r\n]+$/, m = (e1)=>{
                        let t = e1.parent;
                        for(; C(t);){
                            if (t.name in a) return !0;
                            t = t.parent;
                        }
                        return !1;
                    }, f = (n)=>n.name in i || $s(t, n) || ks(n.name) && n.parent === e1, g = (t, n)=>{
                        const r = n ? t.prev : t.next;
                        return !C(r) && !y(t.parent) && f(t.parent) && (t.parent !== e1 || !0 === o.isRootContent);
                    };
                    return [
                        (e1)=>{
                            var t;
                            if (3 === e1.type && !m(e1)) {
                                let n = null !== (t = e1.value) && void 0 !== t ? t : "";
                                n = n.replace(d, " "), (((e1, t)=>C(e1) && (t(e1) || "br" === e1.name))(e1.prev, f) || g(e1, !0)) && (n = n.replace(c, "")), 0 === n.length || " " === n && e1.prev && 8 === e1.prev.type && e1.next && 8 === e1.next.type ? e1.remove() : e1.value = n;
                            }
                        },
                        (e1)=>{
                            var i;
                            if (1 === e1.type) {
                                const i = t.getElementRule(e1.name);
                                if (r && i) {
                                    const r = Ib(t, s, a, e1);
                                    i.paddInEmptyBlock && r && ((e1)=>{
                                        let n = e1;
                                        for(; C(n);){
                                            if (n.name in l) return Ib(t, s, a, n);
                                            n = n.parent;
                                        }
                                        return !1;
                                    })(e1) ? Lb(n, o, f, e1) : i.removeEmpty && r ? f(e1) ? e1.remove() : e1.unwrap() : i.paddEmpty && (r || ((e1)=>{
                                        var t;
                                        return Mb(e1, "#text") && (null === (t = null == e1 ? void 0 : e1.firstChild) || void 0 === t ? void 0 : t.value) === it;
                                    })(e1)) && Lb(n, o, f, e1);
                                }
                            } else if (3 === e1.type && !m(e1)) {
                                let t = null !== (i = e1.value) && void 0 !== i ? i : "";
                                (e1.next && f(e1.next) || g(e1, !1)) && (t = t.replace(u, "")), 0 === t.length ? e1.remove() : e1.value = t;
                            }
                        }
                    ];
                })(m, t, r, n), h = [], b = i ? (e1)=>((e1, n)=>{
                        jb(t, e1) && n.push(e1);
                    })(e1, h) : x, v = {
                    nodes: {},
                    attributes: {}
                }, w = (e1)=>Bb(l(), u(), e1, v);
                if (((e1, t, n)=>{
                    const o = [];
                    for(let n = e1, r = n; n; r = n, n = n.walk()){
                        const s = n;
                        q(t, (e1)=>e1(s)), y(s.parent) && s !== e1 ? n = r : o.push(s);
                    }
                    for(let e1 = o.length - 1; e1 >= 0; e1--){
                        const t = o[e1];
                        q(n, (e1)=>e1(t));
                    }
                })(m, [
                    f,
                    w
                ], [
                    p,
                    b
                ]), h.reverse(), i && h.length > 0) {
                    if (n.context) {
                        const { pass: e1, fail: o } = K(h, (e1)=>e1.parent === m);
                        zb(o, t, m, w), n.invalid = e1.length > 0;
                    } else zb(h, t, m, w);
                }
                const E = ((e1, t)=>{
                    var n;
                    const o = null !== (n = t.forced_root_block) && void 0 !== n ? n : e1.forced_root_block;
                    return !1 === o ? "" : !0 === o ? "p" : o;
                })(r, n);
                return E && ("body" === m.name || n.isRootContent) && ((e1, n)=>{
                    const o = qC(VC("script,style,head,html,body,title,meta,param"), t.getBlockElements()), s = /^[ \t\r\n]+/, a = /[ \t\r\n]+$/;
                    let i = e1.firstChild, l = null;
                    const d = (e1)=>{
                        var t, n;
                        e1 && (i = e1.firstChild, i && 3 === i.type && (i.value = null === (t = i.value) || void 0 === t ? void 0 : t.replace(s, "")), i = e1.lastChild, i && 3 === i.type && (i.value = null === (n = i.value) || void 0 === n ? void 0 : n.replace(a, "")));
                    };
                    if (t.isValidChild(e1.name, n.toLowerCase())) {
                        for(; i;){
                            const t = i.next;
                            g(o, i) ? (l || (l = new up(n, 1), l.attr(r.forced_root_block_attrs), e1.insert(l, i)), l.append(i)) : (d(l), l = null), i = t;
                        }
                        d(l);
                    }
                })(m, E), n.invalid || Pb(v, n), m;
            }
        };
        return ((e1, t)=>{
            var n, o;
            const r = e1.schema;
            e1.addAttributeFilter("href", (e1)=>{
                let n = e1.length;
                const o = (e1)=>{
                    const t = e1 ? an.trim(e1) : "";
                    return /\b(noopener)\b/g.test(t) ? t : ((e1)=>e1.split(" ").filter((e1)=>e1.length > 0).concat([
                            "noopener"
                        ]).sort().join(" "))(t);
                };
                if (!t.allow_unsafe_link_target) for(; n--;){
                    const t = e1[n];
                    "a" === t.name && "_blank" === t.attr("target") && t.attr("rel", o(t.attr("rel")));
                }
            }), t.allow_html_in_named_anchor || e1.addAttributeFilter("id,name", (e1)=>{
                let t, n, o, r, s = e1.length;
                for(; s--;)if (r = e1[s], "a" === r.name && r.firstChild && !r.attr("href")) for(o = r.parent, t = r.lastChild; t && o;)n = t.prev, o.insert(t, r), t = n;
            }), t.fix_list_elements && e1.addNodeFilter("ul,ol", (e1)=>{
                let t, n, o = e1.length;
                for(; o--;)if (t = e1[o], n = t.parent, n && ("ul" === n.name || "ol" === n.name)) {
                    if (t.prev && "li" === t.prev.name) t.prev.append(t);
                    else {
                        const e1 = new up("li", 1);
                        e1.attr("style", "list-style-type: none"), t.wrap(e1);
                    }
                }
            });
            const s = r.getValidClasses();
            t.validate && s && e1.addAttributeFilter("class", (e1)=>{
                var t;
                let n = e1.length;
                for(; n--;){
                    const o = e1[n], r = null !== (t = o.attr("class")) && void 0 !== t ? t : "", a = an.explode(r, " ");
                    let i = "";
                    for(let e1 = 0; e1 < a.length; e1++){
                        const t = a[e1];
                        let n = !1, r = s["*"];
                        r && r[t] && (n = !0), r = s[o.name], !n && r && r[t] && (n = !0), n && (i && (i += " "), i += t);
                    }
                    i.length || (i = null), o.attr("class", i);
                }
            }), ((e1, t)=>{
                const { blob_cache: n } = t;
                if (n) {
                    const t = (e1)=>{
                        const t = e1.attr("src");
                        ((e1)=>e1.attr("src") === nn.transparentSrc || C(e1.attr("data-mce-placeholder")))(e1) || ((e1)=>C(e1.attr("data-mce-bogus")))(e1) || y(t) || wy(n, t, !0).each((t)=>{
                            e1.attr("src", t.blobUri());
                        });
                    };
                    e1.addAttributeFilter("src", (e1)=>q(e1, t));
                }
            })(e1, t);
            const a = null !== (n = t.sandbox_iframes) && void 0 !== n && n, i = me(null !== (o = t.sandbox_iframes_exclusions) && void 0 !== o ? o : []);
            t.convert_unsafe_embeds && e1.addNodeFilter("object,embed", (e1)=>q(e1, (e1)=>{
                    e1.replace((({ type: e1, src: t, width: n, height: o } = {}, r, s)=>{
                        const a = ((e1)=>v(e1) ? "iframe" : Sy(e1, "image") ? "img" : Sy(e1, "video") ? "video" : Sy(e1, "audio") ? "audio" : "iframe")(e1), i = new up(a, 1);
                        return i.attr("audio" === a ? {
                            src: t
                        } : {
                            src: t,
                            width: n,
                            height: o
                        }), "audio" !== a && "video" !== a || i.attr("controls", ""), "iframe" === a && r && xy(i, s), i;
                    })({
                        type: e1.attr("type"),
                        src: "object" === e1.name ? e1.attr("data") : e1.attr("src"),
                        width: e1.attr("width"),
                        height: e1.attr("height")
                    }, a, i));
                })), a && e1.addNodeFilter("iframe", (e1)=>q(e1, (e1)=>xy(e1, i)));
        })(p, r), ((e1, t, n)=>{
            t.inline_styles && gy(e1, t, n);
        })(p, r, t), p;
    }, YC = (e1, t, n)=>{
        const o = ((e1)=>ev(e1) ? Tp({
                validate: !1
            }).serialize(e1) : e1)(e1), r = t(o);
        if (r.isDefaultPrevented()) return r;
        if (ev(e1)) {
            if (r.content !== o) {
                const t = KC({
                    validate: !1,
                    forced_root_block: !1,
                    ...n
                }).parse(r.content, {
                    context: e1.name
                });
                return {
                    ...r,
                    content: t
                };
            }
            return {
                ...r,
                content: e1
            };
        }
        return r;
    }, GC = (e1)=>({
            sanitize: su(e1),
            sandbox_iframes: uu(e1),
            sandbox_iframes_exclusions: mu(e1)
        }), XC = (e1, t)=>{
        if (t.no_events) return Te.value(t);
        {
            const n = ((e1, t)=>e1.dispatch("BeforeGetContent", t))(e1, t);
            return n.isDefaultPrevented() ? Te.error(md(e1, {
                content: "",
                ...n
            }).content) : Te.value(n);
        }
    }, ZC = (e1, t, n)=>{
        if (n.no_events) return t;
        {
            const o = YC(t, (t)=>md(e1, {
                    ...n,
                    content: t
                }), GC(e1));
            return o.content;
        }
    }, QC = (e1, t)=>{
        if (t.no_events) return Te.value(t);
        {
            const n = YC(t.content, (n)=>((e1, t)=>e1.dispatch("BeforeSetContent", t))(e1, {
                    ...t,
                    content: n
                }), GC(e1));
            return n.isDefaultPrevented() ? (ud(e1, n), Te.error(void 0)) : Te.value(n);
        }
    }, JC = (e1, t, n)=>{
        n.no_events || ud(e1, {
            ...n,
            content: t
        });
    }, ew = (e1, t, n)=>({
            element: e1,
            width: t,
            rows: n
        }), tw = (e1, t)=>({
            element: e1,
            cells: t
        }), nw = (e1, t)=>({
            x: e1,
            y: t
        }), ow = (e1, t)=>bo(e1, t).bind(nt).getOr(1), rw = (e1, t, n)=>{
        const o = e1.rows;
        return !!(o[n] ? o[n].cells : [])[t];
    }, sw = (e1)=>X(e1, (e1, t)=>t.cells.length > e1 ? t.cells.length : e1, 0), aw = (e1, t)=>{
        const n = e1.rows;
        for(let e1 = 0; e1 < n.length; e1++){
            const o = n[e1].cells;
            for(let n = 0; n < o.length; n++)if (Cn(o[n], t)) return I.some(nw(n, e1));
        }
        return I.none();
    }, iw = (e1, t, n, o, r)=>{
        const s = [], a = e1.rows;
        for(let e1 = n; e1 <= r; e1++){
            const n = a[e1].cells, r = t < o ? n.slice(t, o + 1) : n.slice(o, t + 1);
            s.push(tw(a[e1].element, r));
        }
        return s;
    }, lw = (e1)=>((e1, t)=>{
            const n = So(e1.element), o = cn("tbody");
            return mo(o, t), co(n, o), n;
        })(e1, ((e1)=>V(e1.rows, (e1)=>{
                const t = V(e1.cells, (e1)=>{
                    const t = ko(e1);
                    return yo(t, "colspan"), yo(t, "rowspan"), t;
                }), n = So(e1.element);
                return mo(n, t), n;
            }))(e1)), dw = (e1, t, n)=>{
        const o = mn(t.commonAncestorContainer), r = Qp(o, e1), s = Y(r, (e1)=>n.isWrapper(_n(e1))), a = ((e1, t)=>Q(e1, (e1)=>"li" === _n(e1) && Jm(e1, t)).fold(N([]), (t)=>((e1)=>Q(e1, (e1)=>"ul" === _n(e1) || "ol" === _n(e1)))(e1).map((e1)=>{
                    const t = cn(_n(e1)), n = Ce(Fo(e1), (e1, t)=>Ye(t, "list-style"));
                    return Do(t, n), [
                        cn("li"),
                        t
                    ];
                }).getOr([])))(r, t), i = s.concat(a.length ? a : ((e1)=>Ni(e1) ? Ln(e1).filter(ki).fold(N([]), (t)=>[
                    e1,
                    t
                ]) : ki(e1) ? [
                e1
            ] : [])(o));
        return V(i, So);
    }, cw = ()=>Yo([]), uw = (e1, t)=>((e1, t)=>or(t, "table", T(Cn, e1)))(e1, t[0]).bind((e1)=>{
            const n = t[0], o = t[t.length - 1], r = ((e1)=>{
                const t = ew(So(e1), 0, []);
                return q(vr(e1, "tr"), (e1, n)=>{
                    q(vr(e1, "td,th"), (o, r)=>{
                        ((e1, t, n, o, r)=>{
                            const s = ow(r, "rowspan"), a = ow(r, "colspan"), i = e1.rows;
                            for(let e1 = n; e1 < n + s; e1++){
                                i[e1] || (i[e1] = tw(ko(o), []));
                                for(let o = t; o < t + a; o++)i[e1].cells[o] = e1 === n && o === t ? r : So(r);
                            }
                        })(t, ((e1, t, n)=>{
                            for(; rw(e1, t, n);)t++;
                            return t;
                        })(t, r, n), n, e1, o);
                    });
                }), ew(t.element, sw(t.rows), t.rows);
            })(e1);
            return ((e1, t, n)=>aw(e1, t).bind((t)=>aw(e1, n).map((n)=>((e1, t, n)=>{
                            const o = t.x, r = t.y, s = n.x, a = n.y, i = r < a ? iw(e1, o, r, s, a) : iw(e1, o, a, s, r);
                            return ew(e1.element, sw(i), i);
                        })(e1, t, n))))(r, n, o).map((e1)=>Yo([
                    lw(e1)
                ]));
        }).getOrThunk(cw), mw = (e1, t, n)=>{
        const o = Ym(t, e1);
        return o.length > 0 ? uw(e1, o) : ((e1, t, n)=>t.length > 0 && t[0].collapsed ? cw() : ((e1, t, n)=>((e1, t)=>{
                    const n = X(t, (e1, t)=>(co(t, e1), t), e1);
                    return t.length > 0 ? Yo([
                        n
                    ]) : n;
                })(mn(t.cloneContents()), dw(e1, t, n)))(e1, t[0], n))(e1, t, n);
    }, fw = (e1, t)=>t >= 0 && t < e1.length && qm(e1.charAt(t)), gw = (e1)=>Li(e1.innerText), pw = (e1)=>qr(e1) ? e1.outerHTML : es(e1) ? ua.encodeRaw(e1.data, !1) : os(e1) ? "\x3c!--" + e1.data + "--\x3e" : "", hw = (e1, t)=>(((e1, t)=>{
            let n = 0;
            q(e1, (e1)=>{
                0 === e1[0] ? n++ : 1 === e1[0] ? (((e1, t, n)=>{
                    const o = ((e1)=>{
                        let t;
                        const n = document.createElement("div"), o = document.createDocumentFragment();
                        for(e1 && (n.innerHTML = e1); t = n.firstChild;)o.appendChild(t);
                        return o;
                    })(t);
                    if (e1.hasChildNodes() && n < e1.childNodes.length) {
                        const t = e1.childNodes[n];
                        e1.insertBefore(o, t);
                    } else e1.appendChild(o);
                })(t, e1[1], n), n++) : 2 === e1[0] && ((e1, t)=>{
                    if (e1.hasChildNodes() && t < e1.childNodes.length) {
                        const n = e1.childNodes[t];
                        e1.removeChild(n);
                    }
                })(t, n);
            });
        })(((e1, t)=>{
            const n = e1.length + t.length + 2, o = new Array(n), r = new Array(n), s = (n, o, r, a, l)=>{
                const d = i(n, o, r, a);
                if (null === d || d.start === o && d.diag === o - a || d.end === n && d.diag === n - r) {
                    let s = n, i = r;
                    for(; s < o || i < a;)s < o && i < a && e1[s] === t[i] ? (l.push([
                        0,
                        e1[s]
                    ]), ++s, ++i) : o - n > a - r ? (l.push([
                        2,
                        e1[s]
                    ]), ++s) : (l.push([
                        1,
                        t[i]
                    ]), ++i);
                } else {
                    s(n, d.start, r, d.start - d.diag, l);
                    for(let t = d.start; t < d.end; ++t)l.push([
                        0,
                        e1[t]
                    ]);
                    s(d.end, o, d.end - d.diag, a, l);
                }
            }, a = (n, o, r, s)=>{
                let a = n;
                for(; a - o < s && a < r && e1[a] === t[a - o];)++a;
                return ((e1, t, n)=>({
                        start: e1,
                        end: t,
                        diag: n
                    }))(n, a, o);
            }, i = (n, s, i, l)=>{
                const d = s - n, c = l - i;
                if (0 === d || 0 === c) return null;
                const u = d - c, m = c + d, f = (m % 2 == 0 ? m : m + 1) / 2;
                let g, p, h, b, v;
                for(o[1 + f] = n, r[1 + f] = s + 1, g = 0; g <= f; ++g){
                    for(p = -g; p <= g; p += 2){
                        for(h = p + f, p === -g || p !== g && o[h - 1] < o[h + 1] ? o[h] = o[h + 1] : o[h] = o[h - 1] + 1, b = o[h], v = b - n + i - p; b < s && v < l && e1[b] === t[v];)o[h] = ++b, ++v;
                        if (u % 2 != 0 && u - g <= p && p <= u + g && r[h - u] <= o[h]) return a(r[h - u], p + n - i, s, l);
                    }
                    for(p = u - g; p <= u + g; p += 2){
                        for(h = p + f - u, p === u - g || p !== u + g && r[h + 1] <= r[h - 1] ? r[h] = r[h + 1] - 1 : r[h] = r[h - 1], b = r[h] - 1, v = b - n + i - p; b >= n && v >= i && e1[b] === t[v];)r[h] = b--, v--;
                        if (u % 2 == 0 && -g <= p && p <= g && r[h] <= o[h + u]) return a(r[h], p + n - i, s, l);
                    }
                }
                return null;
            }, l = [];
            return s(0, e1.length, 0, t.length, l), l;
        })(V(ce(t.childNodes), pw), e1), t), t), bw = st(()=>document.implementation.createHTMLDocument("undo")), vw = (e1)=>{
        const t = e1.serializer.getTempAttrs(), n = xp(e1.getBody(), t);
        return ((e1)=>null !== e1.querySelector("iframe"))(n) ? {
            type: "fragmented",
            fragments: Y(V(ce(n.childNodes), S(Li, pw)), (e1)=>e1.length > 0),
            content: "",
            bookmark: null,
            beforeBookmark: null
        } : {
            type: "complete",
            fragments: null,
            content: Li(n.innerHTML),
            bookmark: null,
            beforeBookmark: null
        };
    }, yw = (e1, t, n)=>{
        const o = n ? t.beforeBookmark : t.bookmark;
        "fragmented" === t.type ? hw(t.fragments, e1.getBody()) : e1.setContent(t.content, {
            format: "raw",
            no_selection: !C(o) || !Bm(o) || !o.isFakeCaret
        }), o && (e1.selection.moveToBookmark(o), e1.selection.scrollIntoView());
    }, Cw = (e1)=>"fragmented" === e1.type ? e1.fragments.join("") : e1.content, ww = (e1)=>{
        const t = cn("body", bw());
        return Ao(t, Cw(e1)), q(vr(t, "*[data-mce-bogus]"), _o), Ro(t);
    }, Ew = (e1, t)=>!(!e1 || !t) && (!!((e1, t)=>Cw(e1) === Cw(t))(e1, t) || ((e1, t)=>ww(e1) === ww(t))(e1, t)), _w = (e1)=>0 === e1.get(), xw = (e1, t, n)=>{
        _w(n) && (e1.typing = t);
    }, Sw = (e1, t)=>{
        e1.typing && (xw(e1, !1, t), e1.add());
    }, kw = (e1)=>({
            init: {
                bindEvents: x
            },
            undoManager: {
                beforeChange: (t, n)=>((e1, t, n)=>{
                        _w(t) && n.set(ed(e1.selection));
                    })(e1, t, n),
                add: (t, n, o, r, s, a)=>((e1, t, n, o, r, s, a)=>{
                        const i = vw(e1), l = an.extend(s || {}, i);
                        if (!_w(o) || e1.removed) return null;
                        const d = t.data[n.get()];
                        if (e1.dispatch("BeforeAddUndo", {
                            level: l,
                            lastLevel: d,
                            originalEvent: a
                        }).isDefaultPrevented()) return null;
                        if (d && Ew(d, l)) return null;
                        t.data[n.get()] && r.get().each((e1)=>{
                            t.data[n.get()].beforeBookmark = e1;
                        });
                        const c = Ec(e1);
                        if (c && t.data.length > c) {
                            for(let e1 = 0; e1 < t.data.length - 1; e1++)t.data[e1] = t.data[e1 + 1];
                            t.data.length--, n.set(t.data.length);
                        }
                        l.bookmark = ed(e1.selection), n.get() < t.data.length - 1 && (t.data.length = n.get() + 1), t.data.push(l), n.set(t.data.length - 1);
                        const u = {
                            level: l,
                            lastLevel: d,
                            originalEvent: a
                        };
                        return n.get() > 0 ? (e1.setDirty(!0), e1.dispatch("AddUndo", u), e1.dispatch("change", u)) : e1.dispatch("AddUndo", u), l;
                    })(e1, t, n, o, r, s, a),
                undo: (t, n, o)=>((e1, t, n, o)=>{
                        let r;
                        return t.typing && (t.add(), t.typing = !1, xw(t, !1, n)), o.get() > 0 && (o.set(o.get() - 1), r = t.data[o.get()], yw(e1, r, !0), e1.setDirty(!0), e1.dispatch("Undo", {
                            level: r
                        })), r;
                    })(e1, t, n, o),
                redo: (t, n)=>((e1, t, n)=>{
                        let o;
                        return t.get() < n.length - 1 && (t.set(t.get() + 1), o = n[t.get()], yw(e1, o, !1), e1.setDirty(!0), e1.dispatch("Redo", {
                            level: o
                        })), o;
                    })(e1, t, n),
                clear: (t, n)=>((e1, t, n)=>{
                        t.data = [], n.set(0), t.typing = !1, e1.dispatch("ClearUndos");
                    })(e1, t, n),
                reset: (e1)=>((e1)=>{
                        e1.clear(), e1.add();
                    })(e1),
                hasUndo: (t, n)=>((e1, t, n)=>n.get() > 0 || t.typing && t.data[0] && !Ew(vw(e1), t.data[0]))(e1, t, n),
                hasRedo: (e1, t)=>((e1, t)=>t.get() < e1.data.length - 1 && !e1.typing)(e1, t),
                transact: (e1, t, n)=>((e1, t, n)=>(Sw(e1, t), e1.beforeChange(), e1.ignore(n), e1.add()))(e1, t, n),
                ignore: (e1, t)=>((e1, t)=>{
                        try {
                            e1.set(e1.get() + 1), t();
                        } finally{
                            e1.set(e1.get() - 1);
                        }
                    })(e1, t),
                extra: (t, n, o, r)=>((e1, t, n, o, r)=>{
                        if (t.transact(o)) {
                            const o = t.data[n.get()].bookmark, s = t.data[n.get() - 1];
                            yw(e1, s, !0), t.transact(r) && (t.data[n.get() - 1].beforeBookmark = o);
                        }
                    })(e1, t, n, o, r)
            },
            formatter: {
                match: (t, n, o, r)=>lv(e1, t, n, o, r),
                matchAll: (t, n)=>((e1, t, n)=>{
                        const o = [], r = {}, s = e1.selection.getStart();
                        return e1.dom.getParent(s, (s)=>{
                            for(let a = 0; a < t.length; a++){
                                const i = t[a];
                                !r[i] && iv(e1, s, i, n) && (r[i] = !0, o.push(i));
                            }
                        }, e1.dom.getRoot()), o;
                    })(e1, t, n),
                matchNode: (t, n, o, r)=>iv(e1, t, n, o, r),
                canApply: (t)=>((e1, t)=>{
                        const n = e1.formatter.get(t), o = e1.dom;
                        if (n && e1.selection.isEditable()) {
                            const t = e1.selection.getStart(), r = yf(o, t);
                            for(let e1 = n.length - 1; e1 >= 0; e1--){
                                const t = n[e1];
                                if (!Ef(t)) return !0;
                                for(let e1 = r.length - 1; e1 >= 0; e1--)if (o.is(r[e1], t.selector)) return !0;
                            }
                        }
                        return !1;
                    })(e1, t),
                closest: (t)=>((e1, t)=>{
                        const n = (t)=>Cn(t, mn(e1.getBody()));
                        return I.from(e1.selection.getStart(!0)).bind((o)=>_r(mn(o), (n)=>ue(t, (t)=>((t, n)=>iv(e1, t.dom, n) ? I.some(n) : I.none())(n, t)), n)).getOrNull();
                    })(e1, t),
                apply: (t, n, o)=>sy(e1, t, n, o),
                remove: (t, n, o, r)=>Jv(e1, t, n, o, r),
                toggle: (t, n, o)=>((e1, t, n, o)=>{
                        const r = e1.formatter.get(t);
                        r && (!lv(e1, t, n, o) || "toggle" in r[0] && !r[0].toggle ? sy(e1, t, n, o) : Jv(e1, t, n, o));
                    })(e1, t, n, o),
                formatChanged: (t, n, o, r, s)=>((e1, t, n, o, r, s)=>(((e1, t, n, o, r, s)=>{
                            const a = t.get();
                            q(n.split(","), (t)=>{
                                const n = _e(a, t).getOrThunk(()=>{
                                    const e1 = {
                                        withSimilar: {
                                            state: Ne(!1),
                                            similar: !0,
                                            callbacks: []
                                        },
                                        withoutSimilar: {
                                            state: Ne(!1),
                                            similar: !1,
                                            callbacks: []
                                        },
                                        withVars: []
                                    };
                                    return a[t] = e1, e1;
                                }), i = ()=>{
                                    const n = dy(e1);
                                    return ly(e1, n, t, r, s).isSome();
                                };
                                if (v(s)) {
                                    const e1 = r ? n.withSimilar : n.withoutSimilar;
                                    e1.callbacks.push(o), 1 === e1.callbacks.length && e1.state.set(i());
                                } else n.withVars.push({
                                    state: Ne(i()),
                                    similar: r,
                                    vars: s,
                                    callback: o
                                });
                            }), t.set(a);
                        })(e1, t, n, o, r, s), {
                            unbind: ()=>((e1, t, n)=>{
                                    const o = e1.get();
                                    q(t.split(","), (e1)=>_e(o, e1).each((t)=>{
                                            o[e1] = {
                                                withSimilar: {
                                                    ...t.withSimilar,
                                                    callbacks: Y(t.withSimilar.callbacks, (e1)=>e1 !== n)
                                                },
                                                withoutSimilar: {
                                                    ...t.withoutSimilar,
                                                    callbacks: Y(t.withoutSimilar.callbacks, (e1)=>e1 !== n)
                                                },
                                                withVars: Y(t.withVars, (e1)=>e1.callback !== n)
                                            };
                                        })), e1.set(o);
                                })(t, n, o)
                        }))(e1, t, n, o, r, s)
            },
            editor: {
                getContent: (t)=>((e1, t)=>I.from(e1.getBody()).fold(N("tree" === t.format ? new up("body", 11) : ""), (n)=>Np(e1, t, n)))(e1, t),
                setContent: (t, n)=>((e1, t, n)=>I.from(e1.getBody()).map((o)=>ev(t) ? ((e1, t, n, o)=>{
                                Db(e1.parser.getNodeFilters(), e1.parser.getAttributeFilters(), n);
                                const r = Tp({
                                    validate: !1
                                }, e1.schema).serialize(n), s = Li(Ti(mn(t)) ? r : an.trim(r));
                                return tv(e1, s, o.no_selection), {
                                    content: n,
                                    html: s
                                };
                            })(e1, o, t, n) : ((e1, t, n, o)=>{
                                if (0 === (n = Li(n)).length || /^\s+$/.test(n)) {
                                    const r = '<br data-mce-bogus="1">';
                                    "TABLE" === t.nodeName ? n = "<tr><td>" + r + "</td></tr>" : /^(UL|OL)$/.test(t.nodeName) && (n = "<li>" + r + "</li>");
                                    const s = Ad(e1);
                                    return e1.schema.isValidChild(t.nodeName.toLowerCase(), s.toLowerCase()) ? (n = r, n = e1.dom.createHTML(s, Td(e1), n)) : n || (n = r), tv(e1, n, o.no_selection), {
                                        content: n,
                                        html: n
                                    };
                                }
                                {
                                    "raw" !== o.format && (n = Tp({
                                        validate: !1
                                    }, e1.schema).serialize(e1.parser.parse(n, {
                                        isRootContent: !0,
                                        insert: !0
                                    })));
                                    const r = Ti(mn(t)) ? n : an.trim(n);
                                    return tv(e1, r, o.no_selection), {
                                        content: r,
                                        html: r
                                    };
                                }
                            })(e1, o, t, n)).getOr({
                            content: t,
                            html: ev(n.content) ? "" : n.content
                        }))(e1, t, n),
                insertContent: (t, n)=>Jb(e1, t, n),
                addVisual: (t)=>((e1, t)=>{
                        const n = e1.dom, o = C(t) ? t : e1.getBody();
                        q(n.select("table,a", o), (t)=>{
                            switch(t.nodeName){
                                case "TABLE":
                                    const o = Oc(e1), r = n.getAttrib(t, "border");
                                    r && "0" !== r || !e1.hasVisual ? n.removeClass(t, o) : n.addClass(t, o);
                                    break;
                                case "A":
                                    if (!n.getAttrib(t, "href")) {
                                        const o = n.getAttrib(t, "name") || t.id, r = Bc(e1);
                                        o && e1.hasVisual ? n.addClass(t, r) : n.removeClass(t, r);
                                    }
                            }
                        }), e1.dispatch("VisualAid", {
                            element: t,
                            hasVisual: e1.hasVisual
                        });
                    })(e1, t)
            },
            selection: {
                getContent: (t, n)=>((e1, t, n = {})=>{
                        const o = ((e1, t)=>({
                                ...e1,
                                format: t,
                                get: !0,
                                selection: !0,
                                getInner: !0
                            }))(n, t);
                        return XC(e1, o).fold(R, (t)=>{
                            const n = ((e1, t)=>{
                                if ("text" === t.format) return ((e1)=>I.from(e1.selection.getRng()).map((t)=>{
                                        var n;
                                        const o = I.from(e1.dom.getParent(t.commonAncestorContainer, e1.dom.isBlock)), r = e1.getBody(), s = ((e1)=>e1.map((e1)=>e1.nodeName).getOr("div").toLowerCase())(o), a = mn(t.cloneContents());
                                        Sp(a), kp(a);
                                        const i = e1.dom.add(r, s, {
                                            "data-mce-bogus": "all",
                                            style: "overflow: hidden; opacity: 0;"
                                        }, a.dom), l = gw(i), d = Li(null !== (n = i.textContent) && void 0 !== n ? n : "");
                                        if (e1.dom.remove(i), fw(d, 0) || fw(d, d.length - 1)) {
                                            const e1 = o.getOr(r), t = gw(e1), n = t.indexOf(l);
                                            return -1 === n ? l : (fw(t, n - 1) ? " " : "") + l + (fw(t, n + l.length) ? " " : "");
                                        }
                                        return l;
                                    }).getOr(""))(e1);
                                {
                                    const n = ((e1, t)=>{
                                        const n = e1.selection.getRng(), o = e1.dom.create("body"), r = e1.selection.getSel(), s = ap(e1, Km(r)), a = t.contextual ? mw(mn(e1.getBody()), s, e1.schema).dom : n.cloneContents();
                                        return a && o.appendChild(a), e1.selection.serializer.serialize(o, t);
                                    })(e1, t);
                                    return "tree" === t.format ? n : e1.selection.isCollapsed() ? "" : n;
                                }
                            })(e1, t);
                            return ZC(e1, n, t);
                        });
                    })(e1, t, n)
            },
            autocompleter: {
                addDecoration: x,
                removeDecoration: x
            },
            raw: {
                getModel: ()=>I.none()
            }
        }), Nw = (e1)=>xe(e1.plugins, "rtc"), Rw = (e1)=>e1.rtcInstance ? e1.rtcInstance : kw(e1), Aw = (e1)=>{
        const t = e1.rtcInstance;
        if (t) return t;
        throw new Error("Failed to get RTC instance not yet initialized.");
    }, Tw = (e1)=>Aw(e1).init.bindEvents(), Ow = (e1)=>0 === e1.dom.length ? (Eo(e1), I.none()) : I.some(e1), Bw = (e1, t, n, o, r)=>{
        e1.bind((e1)=>((o ? Th : Ah)(e1.dom, o ? e1.dom.length : 0, r), t.filter(Rn).map((t)=>((e1, t, n, o, r)=>{
                    const s = e1.dom, a = t.dom, i = o ? s.length : a.length;
                    o ? (Oh(s, a, r, !1, !o), n.setStart(a, i)) : (Oh(a, s, r, !1, !o), n.setEnd(a, i));
                })(e1, t, n, o, r)))).orThunk(()=>{
            const e1 = ((e1, t)=>e1.filter((e1)=>Yf.isBookmarkNode(e1.dom)).bind(t ? Un : Fn))(t, o).or(t).filter(Rn);
            return e1.map((e1)=>((e1, t, n)=>{
                    Ln(e1).each((o)=>{
                        const r = e1.dom;
                        t && Ch(o, Pl(r, 0), n) ? Ah(r, 0, n) : !t && wh(o, Pl(r, r.length), n) && Th(r, r.length, n);
                    });
                })(e1, o, r));
        });
    }, Pw = (e1, t, n)=>{
        if (xe(e1, t)) {
            const o = Y(e1[t], (e1)=>e1 !== n);
            0 === o.length ? delete e1[t] : e1[t] = o;
        }
    };
    const Dw = (e1)=>!(!e1 || !e1.ownerDocument) && wn(mn(e1.ownerDocument), mn(e1)), Lw = (e1, t, n, o)=>{
        let r, s;
        const { selectorChangedWithUnbind: a } = ((e1, t)=>{
            let n, o;
            const r = (t, n)=>Q(n, (n)=>e1.is(n, t)), s = (t)=>e1.getParents(t, void 0, e1.getRoot());
            return {
                selectorChangedWithUnbind: (e1, a)=>(n || (n = {}, o = {}, t.on("NodeChange", (e1)=>{
                        const t = e1.element, a = s(t), i = {};
                        pe(n, (e1, t)=>{
                            r(t, a).each((n)=>{
                                o[t] || (q(e1, (e1)=>{
                                    e1(!0, {
                                        node: n,
                                        selector: t,
                                        parents: a
                                    });
                                }), o[t] = e1), i[t] = e1;
                            });
                        }), pe(o, (e1, n)=>{
                            i[n] || (delete o[n], q(e1, (e1)=>{
                                e1(!1, {
                                    node: t,
                                    selector: n,
                                    parents: a
                                });
                            }));
                        });
                    })), n[e1] || (n[e1] = []), n[e1].push(a), r(e1, s(t.selection.getStart())).each(()=>{
                        o[e1] = n[e1];
                    }), {
                        unbind: ()=>{
                            Pw(n, e1, a), Pw(o, e1, a);
                        }
                    })
            };
        })(e1, o), i = (e1, t)=>((e1, t, n = {})=>{
                const o = ((e1, t)=>({
                        format: "html",
                        ...e1,
                        set: !0,
                        selection: !0,
                        content: t
                    }))(n, t);
                QC(e1, o).each((t)=>{
                    const n = ((e1, t)=>{
                        if ("raw" !== t.format) {
                            const n = e1.selection.getRng(), o = e1.dom.getParent(n.commonAncestorContainer, e1.dom.isBlock), r = o ? {
                                context: o.nodeName.toLowerCase()
                            } : {}, s = e1.parser.parse(t.content, {
                                forced_root_block: !1,
                                ...r,
                                ...t
                            });
                            return Tp({
                                validate: !1
                            }, e1.schema).serialize(s);
                        }
                        return t.content;
                    })(e1, t), o = e1.selection.getRng();
                    ((e1, t, n)=>{
                        const o = I.from(t.firstChild).map(mn), r = I.from(t.lastChild).map(mn);
                        e1.deleteContents(), e1.insertNode(t);
                        const s = o.bind(Fn).filter(Rn).bind(Ow), a = r.bind(Un).filter(Rn).bind(Ow);
                        Bw(s, o, e1, !0, n), Bw(a, r, e1, !1, n), e1.collapse(!1);
                    })(o, o.createContextualFragment(n), e1.schema), e1.selection.setRng(o), ep(e1, o), JC(e1, n, t);
                });
            })(o, e1, t), l = (e1)=>{
            const t = c();
            t.collapse(!!e1), u(t);
        }, d = ()=>t.getSelection ? t.getSelection() : t.document.selection, c = ()=>{
            let n;
            const a = (e1, t, n)=>{
                try {
                    return t.compareBoundaryPoints(e1, n);
                } catch (e1) {
                    return -1;
                }
            }, i = t.document;
            if (C(o.bookmark) && !vg(o)) {
                const e1 = og(o);
                if (e1.isSome()) return e1.map((e1)=>ap(o, [
                        e1
                    ])[0]).getOr(i.createRange());
            }
            try {
                const e1 = d();
                e1 && !Vr(e1.anchorNode) && (n = e1.rangeCount > 0 ? e1.getRangeAt(0) : i.createRange(), n = ap(o, [
                    n
                ])[0]);
            } catch (e1) {}
            if (n || (n = i.createRange()), rs(n.startContainer) && n.collapsed) {
                const t = e1.getRoot();
                n.setStart(t, 0), n.setEnd(t, 0);
            }
            return r && s && (0 === a(n.START_TO_START, n, r) && 0 === a(n.END_TO_END, n, r) ? n = s : (r = null, s = null)), n;
        }, u = (e1, t)=>{
            if (!((e1)=>!!e1 && Dw(e1.startContainer) && Dw(e1.endContainer))(e1)) return;
            const n = d();
            if (e1 = o.dispatch("SetSelectionRange", {
                range: e1,
                forward: t
            }).range, n) {
                s = e1;
                try {
                    n.removeAllRanges(), n.addRange(e1);
                } catch (e1) {}
                !1 === t && n.extend && (n.collapse(e1.endContainer, e1.endOffset), n.extend(e1.startContainer, e1.startOffset)), r = n.rangeCount > 0 ? n.getRangeAt(0) : null;
            }
            if (!e1.collapsed && e1.startContainer === e1.endContainer && (null == n ? void 0 : n.setBaseAndExtent) && e1.endOffset - e1.startOffset < 2 && e1.startContainer.hasChildNodes()) {
                const t = e1.startContainer.childNodes[e1.startOffset];
                t && "IMG" === t.nodeName && (n.setBaseAndExtent(e1.startContainer, e1.startOffset, e1.endContainer, e1.endOffset), n.anchorNode === e1.startContainer && n.focusNode === e1.endContainer || n.setBaseAndExtent(t, 0, t, 1));
            }
            o.dispatch("AfterSetSelectionRange", {
                range: e1,
                forward: t
            });
        }, m = ()=>{
            const t = d(), n = null == t ? void 0 : t.anchorNode, o = null == t ? void 0 : t.focusNode;
            if (!t || !n || !o || Vr(n) || Vr(o)) return !0;
            const r = e1.createRng(), s = e1.createRng();
            try {
                r.setStart(n, t.anchorOffset), r.collapse(!0), s.setStart(o, t.focusOffset), s.collapse(!0);
            } catch (e1) {
                return !0;
            }
            return r.compareBoundaryPoints(r.START_TO_START, s) <= 0;
        }, f = {
            dom: e1,
            win: t,
            serializer: n,
            editor: o,
            expand: (t = {
                type: "word"
            })=>u(Fg(e1).expand(c(), t)),
            collapse: l,
            setCursorLocation: (t, n)=>{
                const r = e1.createRng();
                C(t) && C(n) ? (r.setStart(t, n), r.setEnd(t, n), u(r), l(!1)) : (ef(e1, r, o.getBody(), !0), u(r));
            },
            getContent: (e1)=>((e1, t = {})=>((e1, t, n)=>Aw(e1).selection.getContent(t, n))(e1, t.format ? t.format : "html", t))(o, e1),
            setContent: i,
            getBookmark: (e1, t)=>g.getBookmark(e1, t),
            moveToBookmark: (e1)=>g.moveToBookmark(e1),
            select: (t, n)=>(((e1, t, n)=>I.from(t).bind((t)=>I.from(t.parentNode).map((o)=>{
                            const r = e1.nodeIndex(t), s = e1.createRng();
                            return s.setStart(o, r), s.setEnd(o, r + 1), n && (ef(e1, s, t, !0), ef(e1, s, t, !1)), s;
                        })))(e1, t, n).each(u), t),
            isCollapsed: ()=>{
                const e1 = c(), t = d();
                return !(!e1 || e1.item) && (e1.compareEndPoints ? 0 === e1.compareEndPoints("StartToEnd", e1) : !t || e1.collapsed);
            },
            isEditable: ()=>{
                if (o.mode.isReadOnly()) return !1;
                const t = c(), n = o.getBody().querySelectorAll('[data-mce-selected="1"]');
                return n.length > 0 ? ne(n, (t)=>e1.isEditable(t.parentElement)) : tp(e1, t);
            },
            isForward: m,
            setNode: (t)=>(i(e1.getOuterHTML(t)), t),
            getNode: ()=>((e1, t)=>{
                    if (!t) return e1;
                    let n = t.startContainer, o = t.endContainer;
                    const r = t.startOffset, s = t.endOffset;
                    let a = t.commonAncestorContainer;
                    t.collapsed || (n === o && s - r < 2 && n.hasChildNodes() && (a = n.childNodes[r]), es(n) && es(o) && (n = n.length === r ? sp(n.nextSibling, !0) : n.parentNode, o = 0 === s ? sp(o.previousSibling, !1) : o.parentNode, n && n === o && (a = n)));
                    const i = es(a) ? a.parentNode : a;
                    return Wr(i) ? i : e1;
                })(o.getBody(), c()),
            getSel: d,
            setRng: u,
            getRng: c,
            getStart: (e1)=>op(o.getBody(), c(), e1),
            getEnd: (e1)=>rp(o.getBody(), c(), e1),
            getSelectedBlocks: (t, n)=>((e1, t, n, o)=>{
                    const r = [], s = e1.getRoot(), a = e1.getParent(n || op(s, t, t.collapsed), e1.isBlock), i = e1.getParent(o || rp(s, t, t.collapsed), e1.isBlock);
                    if (a && a !== s && r.push(a), a && i && a !== i) {
                        let t;
                        const n = new Fr(a, s);
                        for(; (t = n.next()) && t !== i;)e1.isBlock(t) && r.push(t);
                    }
                    return i && a !== i && i !== s && r.push(i), r;
                })(e1, c(), t, n),
            normalize: ()=>{
                const t = c(), n = d();
                if (!(Km(n).length > 1) && tf(o)) {
                    const n = Lg(e1, t);
                    return n.each((e1)=>{
                        u(e1, m());
                    }), n.getOr(t);
                }
                return t;
            },
            selectorChanged: (e1, t)=>(a(e1, t), f),
            selectorChangedWithUnbind: a,
            getScrollContainer: ()=>{
                let t, n = e1.getRoot();
                for(; n && "BODY" !== n.nodeName;){
                    if (n.scrollHeight > n.clientHeight) {
                        t = n;
                        break;
                    }
                    n = n.parentNode;
                }
                return t;
            },
            scrollIntoView: (e1, t)=>{
                C(e1) ? ((e1, t, n)=>{
                    (e1.inline ? Zg : Jg)(e1, t, n);
                })(o, e1, t) : ep(o, c(), t);
            },
            placeCaretAt: (e1, t)=>u(Ng(e1, t, o.getDoc())),
            getBoundingClientRect: ()=>{
                const e1 = c();
                return e1.collapsed ? Pl.fromRangeStart(e1).getClientRects()[0] : e1.getBoundingClientRect();
            },
            destroy: ()=>{
                t = r = s = null, p.destroy();
            }
        }, g = Yf(f), p = kg(f, o);
        return f.bookmarkManager = g, f.controlSelection = p, f;
    }, Mw = (e1, t, n)=>{
        -1 === an.inArray(t, n) && (e1.addAttributeFilter(n, (e1, t)=>{
            let n = e1.length;
            for(; n--;)e1[n].attr(t, null);
        }), t.push(n));
    }, Iw = (e1, t)=>{
        const n = [
            "data-mce-selected"
        ], o = {
            entity_encoding: "named",
            remove_trailing_brs: !0,
            pad_empty_with_br: !1,
            ...e1
        }, r = t && t.dom ? t.dom : ni.DOM, s = t && t.schema ? t.schema : Ra(o), a = KC(o, s);
        return ((e1, t, n)=>{
            e1.addAttributeFilter("data-mce-tabindex", (e1, t)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    o.attr("tabindex", o.attr("data-mce-tabindex")), o.attr(t, null);
                }
            }), e1.addAttributeFilter("src,href,style", (e1, o)=>{
                const r = "data-mce-" + o, s = t.url_converter, a = t.url_converter_scope;
                let i = e1.length;
                for(; i--;){
                    const t = e1[i];
                    let l = t.attr(r);
                    void 0 !== l ? (t.attr(o, l.length > 0 ? l : null), t.attr(r, null)) : (l = t.attr(o), "style" === o ? l = n.serializeStyle(n.parseStyle(l), t.name) : s && (l = s.call(a, l, o, t.name)), t.attr(o, l.length > 0 ? l : null));
                }
            }), e1.addAttributeFilter("class", (e1)=>{
                let t = e1.length;
                for(; t--;){
                    const n = e1[t];
                    let o = n.attr("class");
                    o && (o = o.replace(/(?:^|\s)mce-item-\w+(?!\S)/g, ""), n.attr("class", o.length > 0 ? o : null));
                }
            }), e1.addAttributeFilter("data-mce-type", (e1, t, n)=>{
                let o = e1.length;
                for(; o--;){
                    const t = e1[o];
                    if ("bookmark" === t.attr("data-mce-type") && !n.cleanup) {
                        const e1 = I.from(t.firstChild).exists((e1)=>{
                            var t;
                            return !Di(null !== (t = e1.value) && void 0 !== t ? t : "");
                        });
                        e1 ? t.unwrap() : t.remove();
                    }
                }
            }), e1.addNodeFilter("script,style", (e1, n)=>{
                var o;
                const r = (e1)=>e1.replace(/(<!--\[CDATA\[|\]\]-->)/g, "\n").replace(/^[\r\n]*|[\r\n]*$/g, "").replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, "").replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, "");
                let s = e1.length;
                for(; s--;){
                    const a = e1[s], i = a.firstChild, l = null !== (o = null == i ? void 0 : i.value) && void 0 !== o ? o : "";
                    if ("script" === n) {
                        const e1 = a.attr("type");
                        e1 && a.attr("type", "mce-no/type" === e1 ? null : e1.replace(/^mce\-/, "")), "xhtml" === t.element_format && i && l.length > 0 && (i.value = "// <![CDATA[\n" + r(l) + "\n// ]]>");
                    } else "xhtml" === t.element_format && i && l.length > 0 && (i.value = "\x3c!--\n" + r(l) + "\n--\x3e");
                }
            }), e1.addNodeFilter("#comment", (e1)=>{
                let o = e1.length;
                for(; o--;){
                    const r = e1[o], s = r.value;
                    t.preserve_cdata && 0 === (null == s ? void 0 : s.indexOf("[CDATA[")) && (r.name = "#cdata", r.type = 4, r.value = n.decode(s.replace(/^\[CDATA\[|\]\]$/g, "")));
                }
            }), e1.addNodeFilter("xml:namespace,input", (e1, t)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    7 === o.type ? o.remove() : 1 === o.type && ("input" !== t || o.attr("type") || o.attr("type", "text"));
                }
            }), e1.addAttributeFilter("data-mce-type", (t)=>{
                q(t, (t)=>{
                    "format-caret" === t.attr("data-mce-type") && (t.isEmpty(e1.schema.getNonEmptyElements()) ? t.remove() : t.unwrap());
                });
            }), e1.addAttributeFilter("data-mce-src,data-mce-href,data-mce-style,data-mce-selected,data-mce-expando,data-mce-block,data-mce-type,data-mce-resize,data-mce-placeholder", (e1, t)=>{
                let n = e1.length;
                for(; n--;)e1[n].attr(t, null);
            }), t.remove_trailing_brs && ((e1, t, n)=>{
                t.addNodeFilter("br", (t, o, r)=>{
                    const s = an.extend({}, n.getBlockElements()), a = n.getNonEmptyElements(), i = n.getWhitespaceElements();
                    s.body = 1;
                    const l = (e1)=>e1.name in s || $s(n, e1);
                    for(let o = 0, d = t.length; o < d; o++){
                        let d = t[o], c = d.parent;
                        if (c && l(c) && d === c.lastChild) {
                            let t = d.prev;
                            for(; t;){
                                const e1 = t.name;
                                if ("span" !== e1 || "bookmark" !== t.attr("data-mce-type")) {
                                    "br" === e1 && (d = null);
                                    break;
                                }
                                t = t.prev;
                            }
                            if (d && (d.remove(), Ib(n, a, i, c))) {
                                const t = n.getElementRule(c.name);
                                t && (t.removeEmpty ? c.remove() : t.paddEmpty && Lb(e1, r, l, c));
                            }
                        } else {
                            let e1 = d;
                            for(; c && c.firstChild === e1 && c.lastChild === e1 && (e1 = c, !s[c.name]);)c = c.parent;
                            if (e1 === c) {
                                const e1 = new up("#text", 3);
                                e1.value = it, d.replace(e1);
                            }
                        }
                    }
                });
            })(t, e1, e1.schema);
        })(a, o, r), {
            schema: s,
            addNodeFilter: a.addNodeFilter,
            addAttributeFilter: a.addAttributeFilter,
            serialize: (e1, n = {})=>{
                const i = {
                    format: "html",
                    ...n
                }, l = ((e1, t, n)=>((e1, t)=>C(e1) && e1.hasEventListeners("PreProcess") && !t.no_events)(e1, n) ? ((e1, t, n)=>{
                        let o;
                        const r = e1.dom;
                        let s = t.cloneNode(!0);
                        const a = document.implementation;
                        if (a.createHTMLDocument) {
                            const e1 = a.createHTMLDocument("");
                            an.each("BODY" === s.nodeName ? s.childNodes : [
                                s
                            ], (t)=>{
                                e1.body.appendChild(e1.importNode(t, !0));
                            }), s = "BODY" !== s.nodeName ? e1.body.firstChild : e1.body, o = r.doc, r.doc = e1;
                        }
                        return ((e1, t)=>{
                            e1.dispatch("PreProcess", t);
                        })(e1, {
                            ...n,
                            node: s
                        }), o && (r.doc = o), s;
                    })(e1, t, n) : t)(t, e1, i), d = ((e1, t, n)=>{
                    const o = Li(n.getInner ? t.innerHTML : e1.getOuterHTML(t));
                    return n.selection || Ti(mn(t)) ? o : an.trim(o);
                })(r, l, i), c = ((e1, t, n)=>{
                    const o = n.selection ? {
                        forced_root_block: !1,
                        ...n
                    } : n, r = e1.parse(t, o);
                    return ((e1)=>{
                        const t = (e1)=>"br" === (null == e1 ? void 0 : e1.name), n = e1.lastChild;
                        if (t(n)) {
                            const e1 = n.prev;
                            t(e1) && (n.remove(), e1.remove());
                        }
                    })(r), r;
                })(a, d, i);
                return "tree" === i.format ? c : ((e1, t, n, o, r)=>{
                    const s = ((e1, t, n)=>Tp(e1, t).serialize(n))(t, n, o);
                    return ((e1, t, n)=>{
                        if (!t.no_events && e1) {
                            const o = ((e1, t)=>e1.dispatch("PostProcess", t))(e1, {
                                ...t,
                                content: n
                            });
                            return o.content;
                        }
                        return n;
                    })(e1, r, s);
                })(t, o, s, c, i);
            },
            addRules: s.addValidElements,
            setRules: s.setValidElements,
            addTempAttr: T(Mw, a, n),
            getTempAttrs: N(n),
            getNodeFilters: a.getNodeFilters,
            getAttributeFilters: a.getAttributeFilters,
            removeNodeFilter: a.removeNodeFilter,
            removeAttributeFilter: a.removeAttributeFilter
        };
    }, Fw = (e1, t)=>{
        const n = Iw(e1, t);
        return {
            schema: n.schema,
            addNodeFilter: n.addNodeFilter,
            addAttributeFilter: n.addAttributeFilter,
            serialize: n.serialize,
            addRules: n.addRules,
            setRules: n.setRules,
            addTempAttr: n.addTempAttr,
            getTempAttrs: n.getTempAttrs,
            getNodeFilters: n.getNodeFilters,
            getAttributeFilters: n.getAttributeFilters,
            removeNodeFilter: n.removeNodeFilter,
            removeAttributeFilter: n.removeAttributeFilter
        };
    }, Uw = (e1, t, n = {})=>{
        const o = ((e1, t)=>({
                format: "html",
                ...e1,
                set: !0,
                content: t
            }))(n, t);
        return QC(e1, o).map((t)=>{
            const n = ((e1, t, n)=>Rw(e1).editor.setContent(t, n))(e1, t.content, t);
            return JC(e1, n.html, t), n.content;
        }).getOr(t);
    }, zw = "autoresize_on_init,content_editable_state,padd_empty_with_br,block_elements,boolean_attributes,editor_deselector,editor_selector,elements,file_browser_callback_types,filepicker_validator_handler,force_hex_style_colors,force_p_newlines,gecko_spellcheck,images_dataimg_filter,media_scripts,mode,move_caret_before_on_enter_elements,non_empty_elements,self_closing_elements,short_ended_elements,special,spellchecker_select_languages,spellchecker_whitelist,tab_focus,tabfocus_elements,table_responsive_width,text_block_elements,text_inline_elements,toolbar_drawer,types,validate,whitespace_elements,paste_enable_default_filters,paste_filter_drop,paste_word_valid_elements,paste_retain_style_properties,paste_convert_word_fake_lists,template_cdate_classes,template_mdate_classes,template_selected_content_classes,template_preview_replace_values,template_replace_values,templates,template_cdate_format,template_mdate_format".split(","), jw = [], Hw = "bbcode,colorpicker,contextmenu,fullpage,legacyoutput,spellchecker,template,textcolor,rtc".split(","), $w = [
        {
            name: "export",
            replacedWith: "Export to PDF"
        }
    ], Vw = (e1, t)=>{
        const n = Y(t, (t)=>xe(e1, t));
        return ae(n);
    }, qw = (e1)=>{
        const t = Vw(e1, zw), n = e1.forced_root_block;
        return !1 !== n && "" !== n || t.push("forced_root_block (false only)"), ae(t);
    }, Ww = (e1)=>Vw(e1, jw), Kw = (e1, t)=>{
        const n = an.makeMap(e1.plugins, " "), o = Y(t, (e1)=>xe(n, e1));
        return ae(o);
    }, Yw = (e1)=>Kw(e1, Hw), Gw = (e1)=>Kw(e1, $w.map((e1)=>e1.name)), Xw = (e1)=>Q($w, (t)=>t.name === e1).fold(()=>e1, (t)=>t.replacedWith ? `${e1}, replaced by ${t.replacedWith}` : e1), Zw = ni.DOM, Qw = (e1)=>I.from(e1).each((e1)=>e1.destroy()), Jw = (()=>{
        const e1 = {};
        return {
            add: (t, n)=>{
                e1[t] = n;
            },
            get: (t)=>e1[t] ? e1[t] : {
                    icons: {}
                },
            has: (t)=>xe(e1, t)
        };
    })(), eE = di.ModelManager, tE = (e1, t)=>t.dom[e1], nE = (e1, t)=>parseInt(Lo(t, e1), 10), oE = T(tE, "clientWidth"), rE = T(tE, "clientHeight"), sE = T(nE, "margin-top"), aE = T(nE, "margin-left"), iE = (e1)=>{
        const t = [], n = ()=>{
            const t = e1.theme;
            return t && t.getNotificationManagerImpl ? t.getNotificationManagerImpl() : (()=>{
                const e1 = ()=>{
                    throw new Error("Theme did not provide a NotificationManager implementation.");
                };
                return {
                    open: e1,
                    close: e1,
                    getArgs: e1
                };
            })();
        }, o = ()=>I.from(t[0]), r = ()=>{
            o().each((e1)=>{
                e1.reposition();
            });
        }, s = (e1)=>{
            J(t, (t)=>t === e1).each((e1)=>{
                t.splice(e1, 1);
            });
        }, a = (o, a = !0)=>e1.removed || !((e1)=>{
                var t;
                return (t = e1.inline ? e1.getBody() : e1.getContentAreaContainer(), I.from(t).map(mn)).map(Oo).getOr(!1);
            })(e1) ? {} : (a && e1.dispatch("BeforeOpenNotification", {
                notification: o
            }), Q(t, (e1)=>{
                var t, r;
                return t = n().getArgs(e1), r = o, !(t.type !== r.type || t.text !== r.text || t.progressBar || t.timeout || r.progressBar || r.timeout);
            }).getOrThunk(()=>{
                e1.editorManager.setActive(e1);
                const a = n().open(o, ()=>{
                    s(a);
                }, ()=>yg(e1));
                return ((e1)=>{
                    t.push(e1);
                })(a), r(), e1.dispatch("OpenNotification", {
                    notification: {
                        ...a
                    }
                }), a;
            })), i = N(t);
        return ((e1)=>{
            e1.on("SkinLoaded", ()=>{
                const t = ac(e1);
                t && a({
                    text: t,
                    type: "warning",
                    timeout: 0
                }, !1), r();
            }), e1.on("show ResizeEditor ResizeWindow NodeChange ToggleView FullscreenStateChanged", ()=>{
                requestAnimationFrame(r);
            }), e1.on("remove", ()=>{
                q(t.slice(), (e1)=>{
                    n().close(e1);
                });
            }), e1.on("keydown", (e1)=>{
                var t;
                const n = "f12" === (null === (t = e1.key) || void 0 === t ? void 0 : t.toLowerCase()) || 123 === e1.keyCode;
                e1.altKey && n && (e1.preventDefault(), o().map((e1)=>mn(e1.getEl())).each((e1)=>oo(e1)));
            });
        })(e1), {
            open: a,
            close: ()=>{
                o().each((e1)=>{
                    n().close(e1), s(e1), r();
                });
            },
            getNotifications: i
        };
    }, lE = di.PluginManager, dE = di.ThemeManager, cE = (e1)=>{
        let t = [];
        const n = ()=>{
            const t = e1.theme;
            return t && t.getWindowManagerImpl ? t.getWindowManagerImpl() : (()=>{
                const e1 = ()=>{
                    throw new Error("Theme did not provide a WindowManager implementation.");
                };
                return {
                    open: e1,
                    openUrl: e1,
                    alert: e1,
                    confirm: e1,
                    close: e1
                };
            })();
        }, o = (e1, t)=>(...n)=>t ? t.apply(e1, n) : void 0, r = (n)=>{
            ((t)=>{
                e1.dispatch("CloseWindow", {
                    dialog: t
                });
            })(n), t = Y(t, (e1)=>e1 !== n), 0 === t.length && e1.focus();
        }, s = (n)=>{
            e1.editorManager.setActive(e1), ng(e1), e1.ui.show();
            const o = n();
            return ((n)=>{
                t.push(n), ((t)=>{
                    e1.dispatch("OpenWindow", {
                        dialog: t
                    });
                })(n);
            })(o), o;
        };
        return e1.on("remove", ()=>{
            q(t, (e1)=>{
                n().close(e1);
            });
        }), {
            open: (e1, t)=>s(()=>n().open(e1, t, r)),
            openUrl: (e1)=>s(()=>n().openUrl(e1, r)),
            alert: (e1, t, r)=>{
                const s = n();
                s.alert(e1, o(r || s, t));
            },
            confirm: (e1, t, r)=>{
                const s = n();
                s.confirm(e1, o(r || s, t));
            },
            close: ()=>{
                I.from(t[t.length - 1]).each((e1)=>{
                    n().close(e1), r(e1);
                });
            }
        };
    }, uE = (e1, t)=>{
        e1.notificationManager.open({
            type: "error",
            text: t
        });
    }, mE = (e1, t)=>{
        e1._skinLoaded ? uE(e1, t) : e1.on("SkinLoaded", ()=>{
            uE(e1, t);
        });
    }, fE = (e1, t, n)=>{
        ld(e1, t, {
            message: n
        }), console.error(n);
    }, gE = (e1, t, n)=>n ? `Failed to load ${e1}: ${n} from url ${t}` : `Failed to load ${e1} url: ${t}`, pE = (e1, ...t)=>{
        const n = window.console;
        n && (n.error ? n.error(e1, ...t) : n.log(e1, ...t));
    }, hE = (e1, t, n)=>{
        try {
            e1.getDoc().execCommand(t, !1, String(n));
        } catch (e1) {}
    }, bE = (e1, t, n)=>{
        fr(e1, t) && !n ? mr(e1, t) : n && cr(e1, t);
    }, vE = (e1)=>{
        const t = mn(e1.getBody());
        bE(t, "mce-content-readonly", !0), e1.selection.controlSelection.hideResizeRect(), e1._selectionOverrides.hideFakeCaret(), ((e1)=>{
            I.from(e1.selection.getNode()).each((e1)=>{
                e1.removeAttribute("data-mce-selected");
            });
        })(e1);
    }, yE = (e1)=>{
        const t = mn(e1.getBody());
        bE(t, "mce-content-readonly", !1), e1.hasEditableRoot() && hr(t, !0), ((e1, t)=>{
            hE(e1, "StyleWithCSS", t), hE(e1, "enableInlineTableEditing", t), hE(e1, "enableObjectResizing", t);
        })(e1, !1), yg(e1) && e1.focus(), ((e1)=>{
            e1.selection.setRng(e1.selection.getRng());
        })(e1), e1.nodeChanged();
    }, CE = (e1)=>hu(e1), wE = "data-mce-contenteditable", EE = (e1, t)=>{
        const n = mn(e1.getBody());
        t ? (vE(e1), hr(n, !1), q(vr(n, '*[contenteditable="true"]'), (e1)=>{
            go(e1, wE, "true"), hr(e1, !1);
        })) : (q(vr(n, `*[${wE}="true"]`), (e1)=>{
            yo(e1, wE), hr(e1, !0);
        }), yE(e1));
    }, _E = (e1)=>{
        e1.parser.addAttributeFilter("contenteditable", (t)=>{
            CE(e1) && q(t, (e1)=>{
                e1.attr(wE, e1.attr("contenteditable")), e1.attr("contenteditable", "false");
            });
        }), e1.serializer.addAttributeFilter(wE, (t)=>{
            CE(e1) && q(t, (e1)=>{
                e1.attr("contenteditable", e1.attr(wE));
            });
        }), e1.serializer.addTempAttr(wE);
    }, xE = [
        "copy"
    ], SE = (e1)=>"content/" + e1 + "/content.css", kE = (e1, t)=>{
        const n = e1.editorManager.baseURL + "/skins/content", o = `content${e1.editorManager.suffix}.css`;
        return V(t, (t)=>((e1)=>tinymce.Resource.has(SE(e1)))(t) ? t : ((e1)=>/^[a-z0-9\-]+$/i.test(e1))(t) && !e1.inline ? `${n}/${t}/${o}` : e1.documentBaseURI.toAbsolute(t));
    }, NE = (e1, t)=>{
        const n = {};
        return {
            findAll: (o, r = M)=>{
                const s = Y(((e1)=>e1 ? ce(e1.getElementsByTagName("img")) : [])(o), (t)=>{
                    const n = t.src;
                    return !t.hasAttribute("data-mce-bogus") && !t.hasAttribute("data-mce-placeholder") && !(!n || n === nn.transparentSrc) && (Ye(n, "blob:") ? !e1.isUploaded(n) && r(t) : !!Ye(n, "data:") && r(t));
                }), a = V(s, (e1)=>{
                    const o = e1.src;
                    if (xe(n, o)) return n[o].then((t)=>m(t) ? t : {
                            image: e1,
                            blobInfo: t.blobInfo
                        });
                    {
                        const r = ((e1, t)=>{
                            const n = ()=>Promise.reject("Invalid data URI");
                            if (Ye(t, "blob:")) {
                                const s = e1.getByUri(t);
                                return C(s) ? Promise.resolve(s) : (o = t, Ye(o, "blob:") ? ((e1)=>fetch(e1).then((e1)=>e1.ok ? e1.blob() : Promise.reject()).catch(()=>Promise.reject({
                                            message: `Cannot convert ${e1} to Blob. Resource might not exist or is inaccessible.`,
                                            uriType: "blob"
                                        })))(o) : Ye(o, "data:") ? (r = o, new Promise((e1, t)=>{
                                    py(r).bind(({ type: e1, data: t, base64Encoded: n })=>hy(e1, t, n)).fold(()=>t("Invalid data URI"), e1);
                                })) : Promise.reject("Unknown URI format")).then((t)=>by(t).then((o)=>yy(o, !1, (n)=>I.some(Cy(e1, t, n))).getOrThunk(n)));
                            }
                            var o, r;
                            return Ye(t, "data:") ? wy(e1, t).fold(n, (e1)=>Promise.resolve(e1)) : Promise.reject("Unknown image data format");
                        })(t, o).then((t)=>(delete n[o], {
                                image: e1,
                                blobInfo: t
                            })).catch((e1)=>(delete n[o], e1));
                        return n[o] = r, r;
                    }
                });
                return Promise.all(a);
            }
        };
    }, RE = ()=>{
        let e1 = {};
        const t = (e1, t)=>({
                status: e1,
                resultUri: t
            }), n = (t)=>t in e1;
        return {
            hasBlobUri: n,
            getResultUri: (t)=>{
                const n = e1[t];
                return n ? n.resultUri : null;
            },
            isPending: (t)=>!!n(t) && 1 === e1[t].status,
            isUploaded: (t)=>!!n(t) && 2 === e1[t].status,
            markPending: (n)=>{
                e1[n] = t(1, null);
            },
            markUploaded: (n, o)=>{
                e1[n] = t(2, o);
            },
            removeFailed: (t)=>{
                delete e1[t];
            },
            destroy: ()=>{
                e1 = {};
            }
        };
    };
    let AE = 0;
    const TE = (e1, t)=>{
        const n = {}, o = (e1, n)=>new Promise((o, r)=>{
                const s = new XMLHttpRequest;
                s.open("POST", t.url), s.withCredentials = t.credentials, s.upload.onprogress = (e1)=>{
                    n(e1.loaded / e1.total * 100);
                }, s.onerror = ()=>{
                    r("Image upload failed due to a XHR Transport error. Code: " + s.status);
                }, s.onload = ()=>{
                    if (s.status < 200 || s.status >= 300) return void r("HTTP Error: " + s.status);
                    const e1 = JSON.parse(s.responseText);
                    var n, a;
                    e1 && m(e1.location) ? o((n = t.basePath, a = e1.location, n ? n.replace(/\/$/, "") + "/" + a.replace(/^\//, "") : a)) : r("Invalid JSON: " + s.responseText);
                };
                const a = new FormData;
                a.append("file", e1.blob(), e1.filename()), s.send(a);
            }), r = w(t.handler) ? t.handler : o, s = (e1, t)=>({
                url: t,
                blobInfo: e1,
                status: !0
            }), a = (e1, t)=>({
                url: "",
                blobInfo: e1,
                status: !1,
                error: t
            }), i = (e1, t)=>{
            an.each(n[e1], (e1)=>{
                e1(t);
            }), delete n[e1];
        };
        return {
            upload: (l, d)=>t.url || r !== o ? ((t, o)=>(t = an.grep(t, (t)=>!e1.isUploaded(t.blobUri())), Promise.all(an.map(t, (t)=>e1.isPending(t.blobUri()) ? ((e1)=>{
                            const t = e1.blobUri();
                            return new Promise((e1)=>{
                                n[t] = n[t] || [], n[t].push(e1);
                            });
                        })(t) : ((t, n, o)=>(e1.markPending(t.blobUri()), new Promise((r)=>{
                                let l, d;
                                try {
                                    const c = ()=>{
                                        l && (l.close(), d = x);
                                    }, u = (n)=>{
                                        c(), e1.markUploaded(t.blobUri(), n), i(t.blobUri(), s(t, n)), r(s(t, n));
                                    }, f = (n)=>{
                                        c(), e1.removeFailed(t.blobUri()), i(t.blobUri(), a(t, n)), r(a(t, n));
                                    };
                                    d = (e1)=>{
                                        e1 < 0 || e1 > 100 || I.from(l).orThunk(()=>I.from(o).map(P)).each((t)=>{
                                            l = t, t.progressBar.value(e1);
                                        });
                                    }, n(t, d).then(u, (e1)=>{
                                        f(m(e1) ? {
                                            message: e1
                                        } : e1);
                                    });
                                } catch (e1) {
                                    r(a(t, e1));
                                }
                            })))(t, r, o)))))(l, d) : new Promise((e1)=>{
                    e1([]);
                })
        };
    }, OE = (e1)=>()=>e1.notificationManager.open({
                text: e1.translate("Image uploading..."),
                type: "info",
                timeout: -1,
                progressBar: !0
            }), BE = (e1, t)=>TE(t, {
            url: jd(e1),
            basePath: Hd(e1),
            credentials: $d(e1),
            handler: Vd(e1)
        }), PE = (e1)=>{
        const t = (()=>{
            let e1 = [];
            const t = (e1)=>{
                if (!e1.blob || !e1.base64) throw new Error("blob and base64 representations of the image are required for BlobInfo to be created");
                const t = e1.id || "blobid" + AE++ + (()=>{
                    const e1 = ()=>Math.round(4294967295 * Be()).toString(36);
                    return "s" + (new Date).getTime().toString(36) + e1() + e1() + e1();
                })(), n = e1.name || t, o = e1.blob;
                var r;
                return {
                    id: N(t),
                    name: N(n),
                    filename: N(e1.filename || n + "." + (r = o.type, ({
                        "image/jpeg": "jpg",
                        "image/jpg": "jpg",
                        "image/gif": "gif",
                        "image/png": "png",
                        "image/apng": "apng",
                        "image/avif": "avif",
                        "image/svg+xml": "svg",
                        "image/webp": "webp",
                        "image/bmp": "bmp",
                        "image/tiff": "tiff"
                    })[r.toLowerCase()] || "dat")),
                    blob: N(o),
                    base64: N(e1.base64),
                    blobUri: N(e1.blobUri || URL.createObjectURL(o)),
                    uri: N(e1.uri)
                };
            }, n = (t)=>Q(e1, t).getOrUndefined(), o = (e1)=>n((t)=>t.id() === e1);
            return {
                create: (e1, n, o, r, s)=>{
                    if (m(e1)) return t({
                        id: e1,
                        name: r,
                        filename: s,
                        blob: n,
                        base64: o
                    });
                    if (f(e1)) return t(e1);
                    throw new Error("Unknown input type");
                },
                add: (t)=>{
                    o(t.id()) || e1.push(t);
                },
                get: o,
                getByUri: (e1)=>n((t)=>t.blobUri() === e1),
                getByData: (e1, t)=>n((n)=>n.base64() === e1 && n.blob().type === t),
                findFirst: n,
                removeByUri: (t)=>{
                    e1 = Y(e1, (e1)=>e1.blobUri() !== t || (URL.revokeObjectURL(e1.blobUri()), !1));
                },
                destroy: ()=>{
                    q(e1, (e1)=>{
                        URL.revokeObjectURL(e1.blobUri());
                    }), e1 = [];
                }
            };
        })();
        let n, o;
        const r = RE(), s = [], a = (t)=>(n)=>e1.selection ? t(n) : [], i = (e1, t, n)=>{
            let o = 0;
            do o = e1.indexOf(t, o), -1 !== o && (e1 = e1.substring(0, o) + n + e1.substr(o + t.length), o += n.length - t.length + 1);
            while (-1 !== o);
            return e1;
        }, l = (e1, t, n)=>{
            const o = `src="${n}"${n === nn.transparentSrc ? ' data-mce-placeholder="1"' : ""}`;
            return e1 = i(e1, `src="${t}"`, o), i(e1, 'data-mce-src="' + t + '"', 'data-mce-src="' + n + '"');
        }, d = (t, n)=>{
            q(e1.undoManager.data, (e1)=>{
                "fragmented" === e1.type ? e1.fragments = V(e1.fragments, (e1)=>l(e1, t, n)) : e1.content = l(e1.content, t, n);
            });
        }, c = ()=>(n || (n = BE(e1, r)), p().then(a((o)=>{
                const r = V(o, (e1)=>e1.blobInfo);
                return n.upload(r, OE(e1)).then(a((n)=>{
                    const r = [];
                    let s = !1;
                    const a = V(n, (n, a)=>{
                        const { blobInfo: i, image: l } = o[a];
                        let c = !1;
                        return n.status && Fd(e1) ? (n.url && !Ke(l.src, n.url) && (s = !0), t.removeByUri(l.src), Nw(e1) || ((t, n)=>{
                            const o = e1.convertURL(n, "src");
                            var r;
                            d(t.src, n), po(mn(t), {
                                src: Id(e1) ? (r = n, r + (-1 === r.indexOf("?") ? "?" : "&") + (new Date).getTime()) : n,
                                "data-mce-src": o
                            });
                        })(l, n.url)) : n.error && (n.error.remove && (d(l.src, nn.transparentSrc), r.push(l), c = !0), ((e1, t)=>{
                            mE(e1, li.translate([
                                "Failed to upload image: {0}",
                                t
                            ]));
                        })(e1, n.error.message)), {
                            element: l,
                            status: n.status,
                            uploadUri: n.url,
                            blobInfo: i,
                            removed: c
                        };
                    });
                    return r.length > 0 && !Nw(e1) ? e1.undoManager.transact(()=>{
                        q(No(r), (n)=>{
                            const o = Ln(n);
                            Eo(n), o.each(((e1)=>(t)=>{
                                    ((e1, t)=>e1.dom.isEmpty(t.dom) && C(e1.schema.getTextBlockElements()[_n(t)]))(e1, t) && co(t, dn('<br data-mce-bogus="1" />'));
                                })(e1)), t.removeByUri(n.dom.src);
                        });
                    }) : s && e1.undoManager.dispatchChange(), a;
                }));
            }))), u = ()=>Md(e1) ? c() : Promise.resolve([]), g = (e1)=>ne(s, (t)=>t(e1)), p = ()=>(o || (o = NE(r, t)), o.findAll(e1.getBody(), g).then(a((t)=>{
                const n = Y(t, (t)=>m(t) ? (mE(e1, t), !1) : "blob" !== t.uriType);
                return Nw(e1) || q(n, (e1)=>{
                    d(e1.image.src, e1.blobInfo.blobUri()), e1.image.src = e1.blobInfo.blobUri(), e1.image.removeAttribute("data-mce-src");
                }), n;
            }))), h = (n)=>n.replace(/src="(blob:[^"]+)"/g, (n, o)=>{
                const s = r.getResultUri(o);
                if (s) return 'src="' + s + '"';
                let a = t.getByUri(o);
                return a || (a = X(e1.editorManager.get(), (e1, t)=>e1 || t.editorUpload && t.editorUpload.blobCache.getByUri(o), void 0)), a ? 'src="data:' + a.blob().type + ";base64," + a.base64() + '"' : n;
            });
        return e1.on("SetContent", ()=>{
            Md(e1) ? u() : p();
        }), e1.on("RawSaveContent", (e1)=>{
            e1.content = h(e1.content);
        }), e1.on("GetContent", (e1)=>{
            e1.source_view || "raw" === e1.format || "tree" === e1.format || (e1.content = h(e1.content));
        }), e1.on("PostRender", ()=>{
            e1.parser.addNodeFilter("img", (e1)=>{
                q(e1, (e1)=>{
                    const n = e1.attr("src");
                    if (!n || t.getByUri(n)) return;
                    const o = r.getResultUri(n);
                    o && e1.attr("src", o);
                });
            });
        }), {
            blobCache: t,
            addFilter: (e1)=>{
                s.push(e1);
            },
            uploadImages: c,
            uploadImagesAuto: u,
            scanForImages: p,
            destroy: ()=>{
                t.destroy(), r.destroy(), o = n = null;
            }
        };
    }, DE = {
        remove_similar: !0,
        inherit: !1
    }, LE = {
        selector: "td,th",
        ...DE
    }, ME = {
        tablecellbackgroundcolor: {
            styles: {
                backgroundColor: "%value"
            },
            ...LE
        },
        tablecellverticalalign: {
            styles: {
                "vertical-align": "%value"
            },
            ...LE
        },
        tablecellbordercolor: {
            styles: {
                borderColor: "%value"
            },
            ...LE
        },
        tablecellclass: {
            classes: [
                "%value"
            ],
            ...LE
        },
        tableclass: {
            selector: "table",
            classes: [
                "%value"
            ],
            ...DE
        },
        tablecellborderstyle: {
            styles: {
                borderStyle: "%value"
            },
            ...LE
        },
        tablecellborderwidth: {
            styles: {
                borderWidth: "%value"
            },
            ...LE
        }
    }, IE = N(ME), FE = an.each, UE = ni.DOM, zE = (e1)=>C(e1) && f(e1), jE = (e1, t)=>{
        const n = t && t.schema || Ra({}), o = (e1)=>{
            const t = m(e1) ? {
                name: e1,
                classes: [],
                attrs: {}
            } : e1, n = UE.create(t.name);
            return ((e1, t)=>{
                t.classes.length > 0 && UE.addClass(e1, t.classes.join(" ")), UE.setAttribs(e1, t.attrs);
            })(n, t), n;
        }, r = (e1, t, s)=>{
            let a;
            const i = t[0], l = zE(i) ? i.name : void 0, d = ((e1, t)=>{
                const o = n.getElementRule(e1.nodeName.toLowerCase()), r = null == o ? void 0 : o.parentsRequired;
                return !(!r || !r.length) && (t && H(r, t) ? t : r[0]);
            })(e1, l);
            if (d) l === d ? (a = i, t = t.slice(1)) : a = d;
            else if (i) a = i, t = t.slice(1);
            else if (!s) return e1;
            const c = a ? o(a) : UE.create("div");
            c.appendChild(e1), s && an.each(s, (t)=>{
                const n = o(t);
                c.insertBefore(n, e1);
            });
            const u = zE(a) ? a.siblings : void 0;
            return r(c, t, u);
        }, s = UE.create("div");
        if (e1.length > 0) {
            const t = e1[0], n = o(t), a = zE(t) ? t.siblings : void 0;
            s.appendChild(r(n, e1.slice(1), a));
        }
        return s;
    }, HE = (e1)=>{
        let t = "div";
        const n = {
            name: t,
            classes: [],
            attrs: {},
            selector: e1 = an.trim(e1)
        };
        return "*" !== e1 && (t = e1.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, (e1, t, o, r, s)=>{
            switch(t){
                case "#":
                    n.attrs.id = o;
                    break;
                case ".":
                    n.classes.push(o);
                    break;
                case ":":
                    -1 !== an.inArray("checked disabled enabled read-only required".split(" "), o) && (n.attrs[o] = o);
            }
            if ("[" === r) {
                const e1 = s.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
                e1 && (n.attrs[e1[1]] = e1[2]);
            }
            return "";
        })), n.name = t || "div", n;
    }, $E = (e1, t)=>{
        let n = "", o = fc(e1);
        if ("" === o) return "";
        const r = (e1)=>m(e1) ? e1.replace(/%(\w+)/g, "") : "", s = (t, n)=>UE.getStyle(null != n ? n : e1.getBody(), t, !0);
        if (m(t)) {
            const n = e1.formatter.get(t);
            if (!n) return "";
            t = n[0];
        }
        if ("preview" in t) {
            const e1 = t.preview;
            if (!1 === e1) return "";
            o = e1 || o;
        }
        let a, i = t.block || t.inline || "span";
        const l = (d = t.selector, m(d) ? (d = (d = d.split(/\s*,\s*/)[0]).replace(/\s*(~\+|~|\+|>)\s*/g, "$1"), an.map(d.split(/(?:>|\s+(?![^\[\]]+\]))/), (e1)=>{
            const t = an.map(e1.split(/(?:~\+|~|\+)/), HE), n = t.pop();
            return t.length && (n.siblings = t), n;
        }).reverse()) : []);
        var d;
        l.length > 0 ? (l[0].name || (l[0].name = i), i = t.selector, a = jE(l, e1)) : a = jE([
            i
        ], e1);
        const c = UE.select(i, a)[0] || a.firstChild;
        FE(t.styles, (e1, t)=>{
            const n = r(e1);
            n && UE.setStyle(c, t, n);
        }), FE(t.attributes, (e1, t)=>{
            const n = r(e1);
            n && UE.setAttrib(c, t, n);
        }), FE(t.classes, (e1)=>{
            const t = r(e1);
            UE.hasClass(c, t) || UE.addClass(c, t);
        }), e1.dispatch("PreviewFormats"), UE.setStyles(a, {
            position: "absolute",
            left: -65535
        }), e1.getBody().appendChild(a);
        const u = s("fontSize"), f = /px$/.test(u) ? parseInt(u, 10) : 0;
        return FE(o.split(" "), (e1)=>{
            let t = s(e1, c);
            if (!("background-color" === e1 && /transparent|rgba\s*\([^)]+,\s*0\)/.test(t) && (t = s(e1), "#ffffff" === Ma(t).toLowerCase()) || "color" === e1 && "#000000" === Ma(t).toLowerCase())) {
                if ("font-size" === e1 && /em|%$/.test(t)) {
                    if (0 === f) return;
                    t = parseFloat(t) / (/%$/.test(t) ? 100 : 1) * f + "px";
                }
                "border" === e1 && t && (n += "padding:0 2px;"), n += e1 + ":" + t + ";";
            }
        }), e1.dispatch("AfterPreviewFormats"), UE.remove(a), n;
    }, VE = (e1)=>{
        const t = ((e1)=>{
            const t = {}, n = (e1, o)=>{
                e1 && (m(e1) ? (p(o) || (o = [
                    o
                ]), q(o, (e1)=>{
                    v(e1.deep) && (e1.deep = !Ef(e1)), v(e1.split) && (e1.split = !Ef(e1) || _f(e1)), v(e1.remove) && Ef(e1) && !_f(e1) && (e1.remove = "none"), Ef(e1) && _f(e1) && (e1.mixed = !0, e1.block_expand = !0), m(e1.classes) && (e1.classes = e1.classes.split(/\s+/));
                }), t[e1] = o) : pe(e1, (e1, t)=>{
                    n(t, e1);
                }));
            };
            return n(((e1)=>{
                const t = e1.dom, n = e1.schema.type, o = {
                    valigntop: [
                        {
                            selector: "td,th",
                            styles: {
                                verticalAlign: "top"
                            }
                        }
                    ],
                    valignmiddle: [
                        {
                            selector: "td,th",
                            styles: {
                                verticalAlign: "middle"
                            }
                        }
                    ],
                    valignbottom: [
                        {
                            selector: "td,th",
                            styles: {
                                verticalAlign: "bottom"
                            }
                        }
                    ],
                    alignleft: [
                        {
                            selector: "figure.image",
                            collapsed: !1,
                            classes: "align-left",
                            ceFalseOverride: !0,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "left"
                            },
                            inherit: !1,
                            preview: !1
                        },
                        {
                            selector: "img,audio,video",
                            collapsed: !1,
                            styles: {
                                float: "left"
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-placeholder",
                            styles: {
                                float: "left"
                            },
                            ceFalseOverride: !0
                        },
                        {
                            selector: "table",
                            collapsed: !1,
                            styles: {
                                marginLeft: "0px",
                                marginRight: "auto"
                            },
                            onformat: (e1)=>{
                                t.setStyle(e1, "float", null);
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-preview-object,[data-ephox-embed-iri]",
                            ceFalseOverride: !0,
                            styles: {
                                float: "left"
                            }
                        }
                    ],
                    aligncenter: [
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "center"
                            },
                            inherit: !1,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "figure.image",
                            collapsed: !1,
                            classes: "align-center",
                            ceFalseOverride: !0,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "img,audio,video",
                            collapsed: !1,
                            styles: {
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: !1
                        },
                        {
                            selector: ".mce-placeholder",
                            styles: {
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            ceFalseOverride: !0
                        },
                        {
                            selector: "table",
                            collapsed: !1,
                            styles: {
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-preview-object",
                            ceFalseOverride: !0,
                            styles: {
                                display: "table",
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: !1
                        },
                        {
                            selector: "[data-ephox-embed-iri]",
                            ceFalseOverride: !0,
                            styles: {
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: !1
                        }
                    ],
                    alignright: [
                        {
                            selector: "figure.image",
                            collapsed: !1,
                            classes: "align-right",
                            ceFalseOverride: !0,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "right"
                            },
                            inherit: !1,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "img,audio,video",
                            collapsed: !1,
                            styles: {
                                float: "right"
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-placeholder",
                            styles: {
                                float: "right"
                            },
                            ceFalseOverride: !0
                        },
                        {
                            selector: "table",
                            collapsed: !1,
                            styles: {
                                marginRight: "0px",
                                marginLeft: "auto"
                            },
                            onformat: (e1)=>{
                                t.setStyle(e1, "float", null);
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-preview-object,[data-ephox-embed-iri]",
                            ceFalseOverride: !0,
                            styles: {
                                float: "right"
                            },
                            preview: !1
                        }
                    ],
                    alignjustify: [
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "justify"
                            },
                            inherit: !1,
                            preview: "font-family font-size"
                        }
                    ],
                    bold: [
                        {
                            inline: "strong",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        },
                        {
                            inline: "span",
                            styles: {
                                fontWeight: "bold"
                            }
                        },
                        {
                            inline: "b",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }
                    ],
                    italic: [
                        {
                            inline: "em",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        },
                        {
                            inline: "span",
                            styles: {
                                fontStyle: "italic"
                            }
                        },
                        {
                            inline: "i",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }
                    ],
                    underline: [
                        {
                            inline: "span",
                            styles: {
                                textDecoration: "underline"
                            },
                            exact: !0
                        },
                        {
                            inline: "u",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }
                    ],
                    strikethrough: (()=>{
                        const e1 = {
                            inline: "span",
                            styles: {
                                textDecoration: "line-through"
                            },
                            exact: !0
                        }, t = {
                            inline: "strike",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }, o = {
                            inline: "s",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        };
                        return "html4" !== n ? [
                            o,
                            e1,
                            t
                        ] : [
                            e1,
                            o,
                            t
                        ];
                    })(),
                    forecolor: {
                        inline: "span",
                        styles: {
                            color: "%value"
                        },
                        links: !0,
                        remove_similar: !0,
                        clear_child_styles: !0
                    },
                    hilitecolor: {
                        inline: "span",
                        styles: {
                            backgroundColor: "%value"
                        },
                        links: !0,
                        remove_similar: !0,
                        clear_child_styles: !0
                    },
                    fontname: {
                        inline: "span",
                        toggle: !1,
                        styles: {
                            fontFamily: "%value"
                        },
                        clear_child_styles: !0
                    },
                    fontsize: {
                        inline: "span",
                        toggle: !1,
                        styles: {
                            fontSize: "%value"
                        },
                        clear_child_styles: !0
                    },
                    lineheight: {
                        selector: "h1,h2,h3,h4,h5,h6,p,li,td,th,div",
                        styles: {
                            lineHeight: "%value"
                        }
                    },
                    fontsize_class: {
                        inline: "span",
                        attributes: {
                            class: "%value"
                        }
                    },
                    blockquote: {
                        block: "blockquote",
                        wrapper: !0,
                        remove: "all"
                    },
                    subscript: {
                        inline: "sub"
                    },
                    superscript: {
                        inline: "sup"
                    },
                    code: {
                        inline: "code"
                    },
                    samp: {
                        inline: "samp"
                    },
                    link: {
                        inline: "a",
                        selector: "a",
                        remove: "all",
                        split: !0,
                        deep: !0,
                        onmatch: (e1, t, n)=>qr(e1) && e1.hasAttribute("href"),
                        onformat: (e1, n, o)=>{
                            an.each(o, (n, o)=>{
                                t.setAttrib(e1, o, n);
                            });
                        }
                    },
                    lang: {
                        inline: "span",
                        clear_child_styles: !0,
                        remove_similar: !0,
                        attributes: {
                            lang: "%value",
                            "data-mce-lang": (e1)=>{
                                var t;
                                return null !== (t = null == e1 ? void 0 : e1.customValue) && void 0 !== t ? t : null;
                            }
                        }
                    },
                    removeformat: [
                        {
                            selector: "b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small",
                            remove: "all",
                            split: !0,
                            expand: !1,
                            block_expand: !0,
                            deep: !0
                        },
                        {
                            selector: "span",
                            attributes: [
                                "style",
                                "class"
                            ],
                            remove: "empty",
                            split: !0,
                            expand: !1,
                            deep: !0
                        },
                        {
                            selector: "*",
                            attributes: [
                                "style",
                                "class"
                            ],
                            split: !1,
                            expand: !1,
                            deep: !0
                        }
                    ]
                };
                return an.each("p h1 h2 h3 h4 h5 h6 div address pre dt dd".split(/\s/), (e1)=>{
                    o[e1] = {
                        block: e1,
                        remove: "all"
                    };
                }), o;
            })(e1)), n(IE()), n(mc(e1)), {
                get: (e1)=>C(e1) ? t[e1] : t,
                has: (e1)=>xe(t, e1),
                register: n,
                unregister: (e1)=>(e1 && t[e1] && delete t[e1], t)
            };
        })(e1), n = Ne({});
        return ((e1)=>{
            e1.addShortcut("meta+b", "", "Bold"), e1.addShortcut("meta+i", "", "Italic"), e1.addShortcut("meta+u", "", "Underline");
            for(let t = 1; t <= 6; t++)e1.addShortcut("access+" + t, "", [
                "FormatBlock",
                !1,
                "h" + t
            ]);
            e1.addShortcut("access+7", "", [
                "FormatBlock",
                !1,
                "p"
            ]), e1.addShortcut("access+8", "", [
                "FormatBlock",
                !1,
                "div"
            ]), e1.addShortcut("access+9", "", [
                "FormatBlock",
                !1,
                "address"
            ]);
        })(e1), ((e1)=>{
            e1.on("mouseup keydown", (t)=>{
                var n;
                ((e1, t, n)=>{
                    const o = e1.selection, r = e1.getBody();
                    fv(e1, null, n), 8 !== t && 46 !== t || !o.isCollapsed() || o.getStart().innerHTML !== dv || fv(e1, Tm(r, o.getStart()), !0), 37 !== t && 39 !== t || fv(e1, Tm(r, o.getStart()), !0);
                })(e1, t.keyCode, (n = e1.selection.getRng().endContainer, es(n) && Ge(n.data, it)));
            });
        })(e1), Nw(e1) || ((e1, t)=>{
            e1.set({}), t.on("NodeChange", (n)=>{
                cy(t, n.element, e1.get());
            }), t.on("FormatApply FormatRemove", (n)=>{
                const o = I.from(n.node).map((e1)=>rf(e1) ? e1 : e1.startContainer).bind((e1)=>qr(e1) ? I.some(e1) : I.from(e1.parentElement)).getOrThunk(()=>iy(t));
                cy(t, o, e1.get());
            });
        })(n, e1), {
            get: t.get,
            has: t.has,
            register: t.register,
            unregister: t.unregister,
            apply: (t, n, o)=>{
                ((e1, t, n, o)=>{
                    Aw(e1).formatter.apply(t, n, o);
                })(e1, t, n, o);
            },
            remove: (t, n, o, r)=>{
                ((e1, t, n, o, r)=>{
                    Aw(e1).formatter.remove(t, n, o, r);
                })(e1, t, n, o, r);
            },
            toggle: (t, n, o)=>{
                ((e1, t, n, o)=>{
                    Aw(e1).formatter.toggle(t, n, o);
                })(e1, t, n, o);
            },
            match: (t, n, o, r)=>((e1, t, n, o, r)=>Aw(e1).formatter.match(t, n, o, r))(e1, t, n, o, r),
            closest: (t)=>((e1, t)=>Aw(e1).formatter.closest(t))(e1, t),
            matchAll: (t, n)=>((e1, t, n)=>Aw(e1).formatter.matchAll(t, n))(e1, t, n),
            matchNode: (t, n, o, r)=>((e1, t, n, o, r)=>Aw(e1).formatter.matchNode(t, n, o, r))(e1, t, n, o, r),
            canApply: (t)=>((e1, t)=>Aw(e1).formatter.canApply(t))(e1, t),
            formatChanged: (t, o, r, s)=>((e1, t, n, o, r, s)=>Aw(e1).formatter.formatChanged(t, n, o, r, s))(e1, n, t, o, r, s),
            getCssText: T($E, e1)
        };
    }, qE = (e1)=>{
        switch(e1.toLowerCase()){
            case "undo":
            case "redo":
            case "mcefocus":
                return !0;
            default:
                return !1;
        }
    }, WE = (e1)=>{
        const t = Ve(), n = Ne(0), o = Ne(0), r = {
            data: [],
            typing: !1,
            beforeChange: ()=>{
                ((e1, t, n)=>{
                    Aw(e1).undoManager.beforeChange(t, n);
                })(e1, n, t);
            },
            add: (s, a)=>((e1, t, n, o, r, s, a)=>Aw(e1).undoManager.add(t, n, o, r, s, a))(e1, r, o, n, t, s, a),
            dispatchChange: ()=>{
                e1.setDirty(!0);
                const t = vw(e1);
                t.bookmark = ed(e1.selection), e1.dispatch("change", {
                    level: t,
                    lastLevel: ie(r.data, o.get()).getOrUndefined()
                });
            },
            undo: ()=>((e1, t, n, o)=>Aw(e1).undoManager.undo(t, n, o))(e1, r, n, o),
            redo: ()=>((e1, t, n)=>Aw(e1).undoManager.redo(t, n))(e1, o, r.data),
            clear: ()=>{
                ((e1, t, n)=>{
                    Aw(e1).undoManager.clear(t, n);
                })(e1, r, o);
            },
            reset: ()=>{
                ((e1, t)=>{
                    Aw(e1).undoManager.reset(t);
                })(e1, r);
            },
            hasUndo: ()=>((e1, t, n)=>Aw(e1).undoManager.hasUndo(t, n))(e1, r, o),
            hasRedo: ()=>((e1, t, n)=>Aw(e1).undoManager.hasRedo(t, n))(e1, r, o),
            transact: (t)=>((e1, t, n, o)=>Aw(e1).undoManager.transact(t, n, o))(e1, r, n, t),
            ignore: (t)=>{
                ((e1, t, n)=>{
                    Aw(e1).undoManager.ignore(t, n);
                })(e1, n, t);
            },
            extra: (t, n)=>{
                ((e1, t, n, o, r)=>{
                    Aw(e1).undoManager.extra(t, n, o, r);
                })(e1, r, o, t, n);
            }
        };
        return Nw(e1) || ((e1, t, n)=>{
            const o = Ne(!1), r = (e1)=>{
                xw(t, !1, n), t.add({}, e1);
            };
            e1.on("init", ()=>{
                t.add();
            }), e1.on("BeforeExecCommand", (e1)=>{
                const o = e1.command;
                qE(o) || (Sw(t, n), t.beforeChange());
            }), e1.on("ExecCommand", (e1)=>{
                const t = e1.command;
                qE(t) || r(e1);
            }), e1.on("ObjectResizeStart cut", ()=>{
                t.beforeChange();
            }), e1.on("SaveContent ObjectResized blur", r), e1.on("dragend", r), e1.on("keyup", (n)=>{
                const s = n.keyCode;
                if (n.isDefaultPrevented()) return;
                const a = nn.os.isMacOS() && "Meta" === n.key;
                (s >= 33 && s <= 36 || s >= 37 && s <= 40 || 45 === s || n.ctrlKey || a) && (r(), e1.nodeChanged()), 46 !== s && 8 !== s || e1.nodeChanged(), o.get() && t.typing && !Ew(vw(e1), t.data[0]) && (e1.isDirty() || e1.setDirty(!0), e1.dispatch("TypingUndo"), o.set(!1), e1.nodeChanged());
            }), e1.on("keydown", (e1)=>{
                const s = e1.keyCode;
                if (e1.isDefaultPrevented()) return;
                if (s >= 33 && s <= 36 || s >= 37 && s <= 40 || 45 === s) return void (t.typing && r(e1));
                const a = e1.ctrlKey && !e1.altKey || e1.metaKey;
                if ((s < 16 || s > 20) && 224 !== s && 91 !== s && !t.typing && !a) return t.beforeChange(), xw(t, !0, n), t.add({}, e1), void o.set(!0);
                (nn.os.isMacOS() ? e1.metaKey : e1.ctrlKey && !e1.altKey) && t.beforeChange();
            }), e1.on("mousedown", (e1)=>{
                t.typing && r(e1);
            }), e1.on("input", (e1)=>{
                var t;
                e1.inputType && ("insertReplacementText" === e1.inputType || "insertText" === (t = e1).inputType && null === t.data || ((e1)=>"insertFromPaste" === e1.inputType || "insertFromDrop" === e1.inputType)(e1)) && r(e1);
            }), e1.on("AddUndo Undo Redo ClearUndos", (t)=>{
                t.isDefaultPrevented() || e1.nodeChanged();
            });
        })(e1, r, n), ((e1)=>{
            e1.addShortcut("meta+z", "", "Undo"), e1.addShortcut("meta+y,meta+shift+z", "", "Redo");
        })(e1), r;
    }, KE = [
        9,
        27,
        wg.HOME,
        wg.END,
        19,
        20,
        44,
        144,
        145,
        33,
        34,
        45,
        16,
        17,
        18,
        91,
        92,
        93,
        wg.DOWN,
        wg.UP,
        wg.LEFT,
        wg.RIGHT
    ].concat(nn.browser.isFirefox() ? [
        224
    ] : []), YE = "data-mce-placeholder", GE = (e1)=>"keydown" === e1.type || "keyup" === e1.type, XE = (e1)=>{
        const t = e1.keyCode;
        return t === wg.BACKSPACE || t === wg.DELETE;
    }, ZE = (e1, t)=>({
            from: e1,
            to: t
        }), QE = (e1, t)=>{
        const n = mn(e1), o = mn(t.container());
        return Xh(n, o).map((e1)=>((e1, t)=>({
                    block: e1,
                    position: t
                }))(e1, t));
    }, JE = (e1, t)=>tr(t, (e1)=>Ai(e1) || ds(e1.dom), (t)=>Cn(t, e1)).filter(Nn).getOr(e1), e_ = (e1, t)=>{
        const n = ((e1, t)=>{
            const n = Hn(e1);
            return J(n, (e1)=>t.isBlock(_n(e1))).fold(N(n), (e1)=>n.slice(0, e1));
        })(e1, t);
        return q(n, Eo), n;
    }, t_ = (e1, t, n)=>{
        const o = Qp(n, t);
        return Q(o.reverse(), (t)=>_s(e1, t)).each(Eo);
    }, n_ = (e1, t, n, o, r)=>{
        if (_s(o, n)) return Bi(n), km(n.dom);
        ((e1, t)=>0 === Y(zn(t), (t)=>!_s(e1, t)).length)(o, r) && _s(o, t) && ao(r, cn("br"));
        const s = Sm(n.dom, Pl.before(r.dom));
        return q(e_(t, o), (e1)=>{
            ao(r, e1);
        }), t_(o, e1, t), s;
    }, o_ = (e1, t, n, o)=>{
        if (_s(o, n)) {
            if (_s(o, t)) {
                const e1 = (e1)=>{
                    const t = (e1, n)=>Vn(e1).fold(()=>n, (e1)=>((e1, t)=>e1.isInline(_n(t)))(o, e1) ? t(e1, n.concat(So(e1))) : n);
                    return t(e1, []);
                }, r = G(e1(n), (e1, t)=>(uo(e1, t), t), Oi());
                wo(t), co(t, r);
            }
            return Eo(n), km(t.dom);
        }
        const r = Nm(n.dom);
        return q(e_(t, o), (e1)=>{
            co(n, e1);
        }), t_(o, e1, t), r;
    }, r_ = (e1, t)=>{
        _m(e1, t.dom).bind((e1)=>I.from(e1.getNode())).map(mn).filter(xi).each(Eo);
    }, s_ = (e1, t, n, o)=>(r_(!0, t), r_(!1, n), ((e1, t)=>wn(t, e1) ? ((e1, t)=>{
                const n = Qp(t, e1);
                return I.from(n[n.length - 1]);
            })(t, e1) : I.none())(t, n).fold(T(o_, e1, t, n, o), T(n_, e1, t, n, o))), a_ = (e1, t, n, o, r)=>t ? s_(e1, o, n, r) : s_(e1, n, o, r), i_ = (e1, t)=>{
        const n = mn(e1.getBody()), o = ((e1, t, n, o)=>o.collapsed ? ((e1, t, n, o)=>{
                const r = QE(t, Pl.fromRangeStart(o)), s = r.bind((o)=>Cm(n, t, o.position).bind((o)=>QE(t, o).map((o)=>((e1, t, n, o)=>as(o.position.getNode()) && !_s(e1, o.block) ? _m(!1, o.block.dom).bind((e1)=>e1.isEqual(o.position) ? Cm(n, t, e1).bind((e1)=>QE(t, e1)) : I.some(o)).getOr(o) : o)(e1, t, n, o))));
                return ze(r, s, ZE).filter((e1)=>((e1)=>!Cn(e1.from.block, e1.to.block))(e1) && ((e1, t)=>{
                        const n = mn(e1);
                        return Cn(JE(n, t.from.block), JE(n, t.to.block));
                    })(t, e1) && ((e1)=>!1 === cs(e1.from.block.dom) && !1 === cs(e1.to.block.dom))(e1) && ((e1)=>{
                        const t = (e1)=>Si(e1) || Fs(e1.dom) || Ni(e1);
                        return t(e1.from.block) && t(e1.to.block);
                    })(e1) && ((e1)=>!(wn(e1.to.block, e1.from.block) || wn(e1.from.block, e1.to.block)))(e1));
            })(e1, t, n, o) : I.none())(e1.schema, n.dom, t, e1.selection.getRng()).map((o)=>()=>{
                a_(n, t, o.from.block, o.to.block, e1.schema).each((t)=>{
                    e1.selection.setRng(t.toRange());
                });
            });
        return o;
    }, l_ = (e1, t)=>{
        const n = mn(t), o = T(Cn, e1);
        return er(n, Ai, o).isSome();
    }, d_ = (e1)=>{
        const t = mn(e1.getBody());
        return ((e1, t)=>{
            const n = Sm(e1.dom, Pl.fromRangeStart(t)).isNone(), o = xm(e1.dom, Pl.fromRangeEnd(t)).isNone();
            return !((e1, t)=>l_(e1, t.startContainer) || l_(e1, t.endContainer))(e1, t) && n && o;
        })(t, e1.selection.getRng()) ? ((e1)=>I.some(()=>{
                e1.setContent(""), e1.selection.setCursorLocation();
            }))(e1) : ((e1, t, n)=>{
            const o = t.getRng();
            return ze(Xh(e1, mn(o.startContainer)), Xh(e1, mn(o.endContainer)), (r, s)=>Cn(r, s) ? I.none() : I.some(()=>{
                    o.deleteContents(), a_(e1, !0, r, s, n).each((e1)=>{
                        t.setRng(e1.toRange());
                    });
                })).getOr(I.none());
        })(t, e1.selection, e1.schema);
    }, c_ = (e1, t)=>e1.selection.isCollapsed() ? I.none() : d_(e1), u_ = (e1, t, n, o, r)=>I.from(t._selectionOverrides.showCaret(e1, n, o, r)), m_ = (e1, t)=>e1.dispatch("BeforeObjectSelected", {
            target: t
        }).isDefaultPrevented() ? I.none() : I.some(((e1)=>{
            const t = e1.ownerDocument.createRange();
            return t.selectNode(e1), t;
        })(t)), f_ = (e1, t, n)=>t.collapsed ? ((e1, t, n)=>{
            const o = em(1, e1.getBody(), t), r = Pl.fromRangeStart(o), s = r.getNode();
            if (Ou(s)) return u_(1, e1, s, !r.isAtEnd(), !1);
            const a = r.getNode(!0);
            if (Ou(a)) return u_(1, e1, a, !1, !1);
            const i = Nb(e1.dom.getRoot(), r.getNode());
            return Ou(i) ? u_(1, e1, i, !1, n) : I.none();
        })(e1, t, n).getOr(t) : t, g_ = (e1)=>Gp(e1) || qp(e1), p_ = (e1)=>Xp(e1) || Wp(e1), h_ = (e1, t, n, o, r, s)=>{
        u_(o, e1, s.getNode(!r), r, !0).each((n)=>{
            if (t.collapsed) {
                const e1 = t.cloneRange();
                r ? e1.setEnd(n.startContainer, n.startOffset) : e1.setStart(n.endContainer, n.endOffset), e1.deleteContents();
            } else t.deleteContents();
            e1.selection.setRng(n);
        }), ((e1, t)=>{
            es(t) && 0 === t.data.length && e1.remove(t);
        })(e1.dom, n);
    }, b_ = (e1, t)=>((e1, t)=>{
            const n = e1.selection.getRng();
            if (!es(n.commonAncestorContainer)) return I.none();
            const o = t ? 1 : -1, r = hm(e1.getBody()), s = T(rm, t ? r.next : r.prev), a = t ? g_ : p_, i = nm(o, e1.getBody(), n), l = s(i), d = l ? $h(t, l) : l;
            if (!d || !sm(i, d)) return I.none();
            if (a(d)) return I.some(()=>h_(e1, n, i.getNode(), o, t, d));
            const c = s(d);
            return c && a(c) && sm(d, c) ? I.some(()=>h_(e1, n, i.getNode(), o, t, c)) : I.none();
        })(e1, t), v_ = (e1, t)=>{
        const n = e1.getBody();
        return t ? km(n).filter(Gp) : Nm(n).filter(Xp);
    }, y_ = (e1)=>{
        const t = e1.selection.getRng();
        return !t.collapsed && (v_(e1, !0).exists((e1)=>e1.isEqual(Pl.fromRangeStart(t))) || v_(e1, !1).exists((e1)=>e1.isEqual(Pl.fromRangeEnd(t))));
    }, C_ = ke([
        {
            remove: [
                "element"
            ]
        },
        {
            moveToElement: [
                "element"
            ]
        },
        {
            moveToPosition: [
                "position"
            ]
        }
    ]), w_ = (e1, t, n, o)=>Cm(t, e1, n).bind((r)=>{
            var s;
            return s = r.getNode(), C(s) && (Ai(mn(s)) || Ni(mn(s))) || ((e1, t, n, o, r)=>{
                const s = (t)=>r.isInline(t.nodeName.toLowerCase()) && !Ku(n, o, e1);
                return tm(!t, n).fold(()=>tm(t, o).fold(L, s), s);
            })(e1, t, n, r, o) ? I.none() : t && cs(r.getNode()) || !t && cs(r.getNode(!0)) ? ((e1, t, n, o, r)=>{
                const s = r.getNode(!n);
                return Xh(mn(t), mn(o.getNode())).map((t)=>_s(e1, t) ? C_.remove(t.dom) : C_.moveToElement(s)).orThunk(()=>I.some(C_.moveToElement(s)));
            })(o, e1, t, n, r) : t && Xp(n) || !t && Gp(n) ? I.some(C_.moveToPosition(r)) : I.none();
        }), E_ = (e1, t)=>I.from(Nb(e1.getBody(), t)), __ = (e1, t)=>{
        const n = e1.selection.getNode();
        return E_(e1, n).filter(cs).fold(()=>((e1, t, n, o)=>{
                const r = em(t ? 1 : -1, e1, n), s = Pl.fromRangeStart(r), a = mn(e1);
                return !t && Xp(s) ? I.some(C_.remove(s.getNode(!0))) : t && Gp(s) ? I.some(C_.remove(s.getNode())) : !t && Gp(s) && ch(a, s, o) ? uh(a, s, o).map((e1)=>C_.remove(e1.getNode())) : t && Xp(s) && dh(a, s, o) ? mh(a, s, o).map((e1)=>C_.remove(e1.getNode())) : ((e1, t, n, o)=>((e1, t)=>{
                        const n = t.getNode(!e1), o = e1 ? "after" : "before";
                        return qr(n) && n.getAttribute("data-mce-caret") === o;
                    })(t, n) ? ((e1, t)=>y(t) ? I.none() : e1 && cs(t.nextSibling) ? I.some(C_.moveToElement(t.nextSibling)) : !e1 && cs(t.previousSibling) ? I.some(C_.moveToElement(t.previousSibling)) : I.none())(t, n.getNode(!t)).orThunk(()=>w_(e1, t, n, o)) : w_(e1, t, n, o).bind((t)=>((e1, t, n)=>n.fold((e1)=>I.some(C_.remove(e1)), (e1)=>I.some(C_.moveToElement(e1)), (n)=>Ku(t, n, e1) ? I.none() : I.some(C_.moveToPosition(n))))(e1, n, t)))(e1, t, s, o);
            })(e1.getBody(), t, e1.selection.getRng(), e1.schema).map((n)=>()=>n.fold(((e1, t)=>(n)=>(e1._selectionOverrides.hideFakeCaret(), Fh(e1, t, mn(n)), !0))(e1, t), ((e1, t)=>(n)=>{
                            const o = t ? Pl.before(n) : Pl.after(n);
                            return e1.selection.setRng(o.toRange()), !0;
                        })(e1, t), ((e1)=>(t)=>(e1.selection.setRng(t.toRange()), !0))(e1))), ()=>I.some(x));
    }, x_ = (e1)=>{
        const t = e1.dom, n = e1.selection, o = Nb(e1.getBody(), n.getNode());
        if (ds(o) && t.isBlock(o) && t.isEmpty(o)) {
            const e1 = t.create("br", {
                "data-mce-bogus": "1"
            });
            t.setHTML(o, ""), o.appendChild(e1), n.setRng(Pl.before(e1).toRange());
        }
        return !0;
    }, S_ = (e1, t)=>e1.selection.isCollapsed() ? __(e1, t) : ((e1, t)=>{
            const n = e1.selection.getNode();
            return cs(n) && !ms(n) ? E_(e1, n.parentNode).filter(cs).fold(()=>I.some(()=>{
                    var n;
                    n = mn(e1.getBody()), q(vr(n, ".mce-offscreen-selection"), Eo), Fh(e1, t, mn(e1.selection.getNode())), Zh(e1);
                }), ()=>I.some(x)) : y_(e1) ? I.some(()=>{
                eb(e1, e1.selection.getRng(), mn(e1.getBody()));
            }) : I.none();
        })(e1, t), k_ = (e1)=>e1.hasOwnProperty("text"), N_ = (e1)=>e1.hasOwnProperty("marker"), R_ = (e1, t)=>{
        const n = (e1, n)=>{
            if (es(e1)) return {
                text: e1,
                offset: n
            };
            {
                const o = t(), r = e1.childNodes;
                return n < r.length ? (e1.insertBefore(o, r[n]), {
                    marker: o,
                    before: !0
                }) : (e1.appendChild(o), {
                    marker: o,
                    before: !1
                });
            }
        }, o = n(e1.endContainer, e1.endOffset);
        return {
            start: n(e1.startContainer, e1.startOffset),
            end: o
        };
    }, A_ = (e1)=>{
        var t, n;
        const { start: o, end: r } = e1, s = new window.Range;
        return k_(o) ? s.setStart(o.text, o.offset) : N_(o) && (o.before ? s.setStartBefore(o.marker) : s.setStartAfter(o.marker), null === (t = o.marker.parentNode) || void 0 === t || t.removeChild(o.marker)), k_(r) ? s.setEnd(r.text, r.offset) : N_(r) && (r.before ? s.setEndBefore(r.marker) : s.setEndAfter(r.marker), null === (n = r.marker.parentNode) || void 0 === n || n.removeChild(r.marker)), s;
    }, T_ = (e1, t)=>{
        var n;
        const o = e1.dom, r = o.getParent(e1.selection.getStart(), o.isBlock), s = o.getParent(e1.selection.getEnd(), o.isBlock), a = e1.getBody();
        if ("div" === (null === (n = null == r ? void 0 : r.nodeName) || void 0 === n ? void 0 : n.toLowerCase()) && r && s && r === a.firstChild && s === a.lastChild && !o.isEmpty(a)) {
            const n = r.cloneNode(!1), o = ()=>{
                if (t ? Yh(e1) : Kh(e1), a.firstChild !== r) {
                    const t = R_(e1.selection.getRng(), ()=>document.createElement("span"));
                    Array.from(a.childNodes).forEach((e1)=>n.appendChild(e1)), a.appendChild(n), e1.selection.setRng(A_(t));
                }
            };
            return I.some(o);
        }
        return I.none();
    }, O_ = (e1, t)=>e1.selection.isCollapsed() ? ((e1, t)=>{
            const n = Pl.fromRangeStart(e1.selection.getRng());
            return Cm(t, e1.getBody(), n).filter((e1)=>t ? $p(e1) : Vp(e1)).bind((e1)=>Yu(t ? 0 : -1, e1)).map((t)=>()=>e1.selection.select(t));
        })(e1, t) : I.none(), B_ = es, P_ = (e1)=>B_(e1) && e1.data[0] === Pi, D_ = (e1)=>B_(e1) && e1.data[e1.data.length - 1] === Pi, L_ = (e1)=>{
        var t;
        return (null !== (t = e1.ownerDocument) && void 0 !== t ? t : document).createTextNode(Pi);
    }, M_ = (e1, t)=>e1 ? ((e1)=>{
            var t;
            if (B_(e1.previousSibling)) return D_(e1.previousSibling) || e1.previousSibling.appendData(Pi), e1.previousSibling;
            if (B_(e1)) return P_(e1) || e1.insertData(0, Pi), e1;
            {
                const n = L_(e1);
                return null === (t = e1.parentNode) || void 0 === t || t.insertBefore(n, e1), n;
            }
        })(t) : ((e1)=>{
            var t, n;
            if (B_(e1.nextSibling)) return P_(e1.nextSibling) || e1.nextSibling.insertData(0, Pi), e1.nextSibling;
            if (B_(e1)) return D_(e1) || e1.appendData(Pi), e1;
            {
                const o = L_(e1);
                return e1.nextSibling ? null === (t = e1.parentNode) || void 0 === t || t.insertBefore(o, e1.nextSibling) : null === (n = e1.parentNode) || void 0 === n || n.appendChild(o), o;
            }
        })(t), I_ = T(M_, !0), F_ = T(M_, !1), U_ = (e1, t)=>es(e1.container()) ? M_(t, e1.container()) : M_(t, e1.getNode()), z_ = (e1, t)=>{
        const n = t.get();
        return n && e1.container() === n && Ui(n);
    }, j_ = (e1, t)=>t.fold((t)=>{
            xu(e1.get());
            const n = I_(t);
            return e1.set(n), I.some(Pl(n, n.length - 1));
        }, (t)=>km(t).map((t)=>{
                if (z_(t, e1)) {
                    const t = e1.get();
                    return Pl(t, 1);
                }
                {
                    xu(e1.get());
                    const n = U_(t, !0);
                    return e1.set(n), Pl(n, 1);
                }
            }), (t)=>Nm(t).map((t)=>{
                if (z_(t, e1)) {
                    const t = e1.get();
                    return Pl(t, t.length - 1);
                }
                {
                    xu(e1.get());
                    const n = U_(t, !1);
                    return e1.set(n), Pl(n, n.length - 1);
                }
            }), (t)=>{
            xu(e1.get());
            const n = F_(t);
            return e1.set(n), I.some(Pl(n, 1));
        }), H_ = (e1, t)=>{
        for(let n = 0; n < e1.length; n++){
            const o = e1[n].apply(null, t);
            if (o.isSome()) return o;
        }
        return I.none();
    }, $_ = ke([
        {
            before: [
                "element"
            ]
        },
        {
            start: [
                "element"
            ]
        },
        {
            end: [
                "element"
            ]
        },
        {
            after: [
                "element"
            ]
        }
    ]), V_ = (e1, t)=>Wu(t, e1) || e1, q_ = (e1, t, n)=>{
        const o = Vh(n), r = V_(t, o.container());
        return Hh(e1, r, o).fold(()=>xm(r, o).bind(T(Hh, e1, r)).map((e1)=>$_.before(e1)), I.none);
    }, W_ = (e1, t)=>null === Tm(e1, t), K_ = (e1, t, n)=>Hh(e1, t, n).filter(T(W_, t)), Y_ = (e1, t, n)=>{
        const o = qh(n);
        return K_(e1, t, o).bind((e1)=>Sm(e1, o).isNone() ? I.some($_.start(e1)) : I.none());
    }, G_ = (e1, t, n)=>{
        const o = Vh(n);
        return K_(e1, t, o).bind((e1)=>xm(e1, o).isNone() ? I.some($_.end(e1)) : I.none());
    }, X_ = (e1, t, n)=>{
        const o = qh(n), r = V_(t, o.container());
        return Hh(e1, r, o).fold(()=>Sm(r, o).bind(T(Hh, e1, r)).map((e1)=>$_.after(e1)), I.none);
    }, Z_ = (e1)=>!jh(J_(e1)), Q_ = (e1, t, n)=>H_([
            q_,
            Y_,
            G_,
            X_
        ], [
            e1,
            t,
            n
        ]).filter(Z_), J_ = (e1)=>e1.fold(R, R, R, R), ex = (e1)=>e1.fold(N("before"), N("start"), N("end"), N("after")), tx = (e1)=>e1.fold($_.before, $_.before, $_.after, $_.after), nx = (e1)=>e1.fold($_.start, $_.start, $_.end, $_.end), ox = (e1, t, n, o, r, s)=>ze(Hh(t, n, o), Hh(t, n, r), (t, o)=>t !== o && ((e1, t, n)=>{
                const o = Wu(t, e1), r = Wu(n, e1);
                return C(o) && o === r;
            })(n, t, o) ? $_.after(e1 ? t : o) : s).getOr(s), rx = (e1, t)=>e1.fold(M, (e1)=>{
            var n, o;
            return o = t, !(ex(n = e1) === ex(o) && J_(n) === J_(o));
        }), sx = (e1, t)=>e1 ? t.fold(S(I.some, $_.start), I.none, S(I.some, $_.after), I.none) : t.fold(I.none, S(I.some, $_.before), I.none, S(I.some, $_.end)), ax = (e1, t, n)=>{
        const o = e1 ? 1 : -1;
        return t.setRng(Pl(n.container(), n.offset() + o).toRange()), t.getSel().modify("move", e1 ? "forward" : "backward", "word"), !0;
    };
    var ix;
    !function(e1) {
        e1[e1.Br = 0] = "Br", e1[e1.Block = 1] = "Block", e1[e1.Wrap = 2] = "Wrap", e1[e1.Eol = 3] = "Eol";
    }(ix || (ix = {}));
    const lx = (e1, t)=>-1 === e1 ? oe(t) : t, dx = (e1, t, n)=>1 === e1 ? t.next(n) : t.prev(n), cx = (e1, t, n, o)=>as(o.getNode(1 === t)) ? ix.Br : !1 === Ku(n, o) ? ix.Block : ix.Wrap, ux = (e1, t, n, o)=>{
        const r = hm(n);
        let s = o;
        const a = [];
        for(; s;){
            const n = dx(t, r, s);
            if (!n) break;
            if (as(n.getNode(!1))) return 1 === t ? {
                positions: lx(t, a).concat([
                    n
                ]),
                breakType: ix.Br,
                breakAt: I.some(n)
            } : {
                positions: lx(t, a),
                breakType: ix.Br,
                breakAt: I.some(n)
            };
            if (n.isVisible()) {
                if (e1(s, n)) {
                    const e1 = cx(0, t, s, n);
                    return {
                        positions: lx(t, a),
                        breakType: e1,
                        breakAt: I.some(n)
                    };
                }
                a.push(n), s = n;
            } else s = n;
        }
        return {
            positions: lx(t, a),
            breakType: ix.Eol,
            breakAt: I.none()
        };
    }, mx = (e1, t, n, o)=>t(n, o).breakAt.map((o)=>{
            const r = t(n, o).positions;
            return -1 === e1 ? r.concat(o) : [
                o
            ].concat(r);
        }).getOr([]), fx = (e1, t)=>X(e1, (e1, n)=>e1.fold(()=>I.some(n), (o)=>ze(le(o.getClientRects()), le(n.getClientRects()), (e1, r)=>{
                    const s = Math.abs(t - e1.left);
                    return Math.abs(t - r.left) <= s ? n : o;
                }).or(e1)), I.none()), gx = (e1, t)=>le(t.getClientRects()).bind((t)=>fx(e1, t.left)), px = T(ux, Pl.isAbove, -1), hx = T(ux, Pl.isBelow, 1), bx = T(mx, -1, px), vx = T(mx, 1, hx), yx = (e1, t)=>px(e1, t).breakAt.isNone(), Cx = (e1, t)=>hx(e1, t).breakAt.isNone(), wx = (e1, t)=>gx(bx(e1, t), t), Ex = (e1, t)=>gx(vx(e1, t), t), _x = cs, xx = (e1, t)=>Math.abs(e1.left - t), Sx = (e1, t)=>Math.abs(e1.right - t), kx = (e1, t)=>pt(e1, (e1, n)=>{
            const o = Math.min(xx(e1, t), Sx(e1, t)), r = Math.min(xx(n, t), Sx(n, t));
            return r === o && Se(n, "node") && _x(n.node) || r < o ? n : e1;
        }), Nx = (e1)=>{
        const t = (t)=>V(t, (t)=>{
                const n = Gi(t);
                return n.node = e1, n;
            });
        if (qr(e1)) return t(e1.getClientRects());
        if (es(e1)) {
            const n = e1.ownerDocument.createRange();
            return n.setStart(e1, 0), n.setEnd(e1, e1.data.length), t(n.getClientRects());
        }
        return [];
    }, Rx = (e1)=>te(e1, Nx);
    var Ax;
    !function(e1) {
        e1[e1.Up = -1] = "Up", e1[e1.Down = 1] = "Down";
    }(Ax || (Ax = {}));
    const Tx = (e1, t, n, o, r, s)=>{
        let a = 0;
        const i = [], l = (o)=>{
            let s = Rx([
                o
            ]);
            e1 === Ax.Up && (s = s.reverse());
            for(let e1 = 0; e1 < s.length; e1++){
                const o = s[e1];
                if (!n(o, d)) {
                    if (i.length > 0 && t(o, bt(i)) && a++, o.line = a, r(o)) return !0;
                    i.push(o);
                }
            }
            return !1;
        }, d = bt(s.getClientRects());
        if (!d) return i;
        const c = s.getNode();
        return c && (l(c), ((e1, t, n, o)=>{
            let r = o;
            for(; r = qu(r, e1, pl, t);)if (n(r)) return;
        })(e1, o, l, c)), i;
    }, Ox = T(Tx, Ax.Up, Qi, Ji), Bx = T(Tx, Ax.Down, Ji, Qi), Px = (e1)=>bt(e1.getClientRects()), Dx = (e1)=>(t)=>((e1, t)=>t.line > e1)(e1, t), Lx = (e1)=>(t)=>((e1, t)=>t.line === e1)(e1, t), Mx = (e1, t)=>{
        e1.selection.setRng(t), ep(e1, e1.selection.getRng());
    }, Ix = (e1, t, n)=>I.some(f_(e1, t, n)), Fx = (e1, t, n, o, r, s)=>{
        const a = 1 === t, i = hm(e1.getBody()), l = T(rm, a ? i.next : i.prev), d = a ? o : r;
        if (!n.collapsed) {
            const o = tl(n);
            if (s(o)) return u_(t, e1, o, -1 === t, !1);
            if (y_(e1)) {
                const e1 = n.cloneRange();
                return e1.collapse(-1 === t), I.from(e1);
            }
        }
        const c = nm(t, e1.getBody(), n);
        if (d(c)) return m_(e1, c.getNode(!a));
        let u = l(c);
        const m = Ki(n);
        if (!u) return m ? I.some(n) : I.none();
        if (u = $h(a, u), d(u)) return u_(t, e1, u.getNode(!a), a, !1);
        const f = l(u);
        return f && d(f) && sm(u, f) ? u_(t, e1, f.getNode(!a), a, !1) : m ? Ix(e1, u.toRange(), !1) : I.none();
    }, Ux = (e1, t, n, o, r, s)=>{
        const a = nm(t, e1.getBody(), n), i = bt(a.getClientRects()), l = t === Ax.Down, d = e1.getBody();
        if (!i) return I.none();
        if (y_(e1)) {
            const e1 = l ? Pl.fromRangeEnd(n) : Pl.fromRangeStart(n);
            return (l ? Ex : wx)(d, e1).orThunk(()=>I.from(e1)).map((e1)=>e1.toRange());
        }
        const c = (l ? Bx : Ox)(d, Dx(1), a), u = Y(c, Lx(1)), m = i.left, f = kx(u, m);
        if (f && s(f.node)) {
            const n = Math.abs(m - f.left), o = Math.abs(m - f.right);
            return u_(t, e1, f.node, n < o, !1);
        }
        let g;
        if (g = o(a) ? a.getNode() : r(a) ? a.getNode(!0) : tl(n), g) {
            const n = ((e1, t, n, o)=>{
                const r = hm(t);
                let s, a, i, l;
                const d = [];
                let c = 0;
                e1 === Ax.Down ? (s = r.next, a = Ji, i = Qi, l = Pl.after(o)) : (s = r.prev, a = Qi, i = Ji, l = Pl.before(o));
                const u = Px(l);
                do {
                    if (!l.isVisible()) continue;
                    const e1 = Px(l);
                    if (i(e1, u)) continue;
                    d.length > 0 && a(e1, bt(d)) && c++;
                    const t = Gi(e1);
                    if (t.position = l, t.line = c, n(t)) return d;
                    d.push(t);
                }while (l = s(l));
                return d;
            })(t, d, Dx(1), g);
            let o = kx(Y(n, Lx(1)), m);
            if (o) return Ix(e1, o.position.toRange(), !1);
            if (o = bt(Y(n, Lx(0))), o) return Ix(e1, o.position.toRange(), !1);
        }
        return 0 === u.length ? zx(e1, l).filter(l ? r : o).map((t)=>f_(e1, t.toRange(), !1)) : I.none();
    }, zx = (e1, t)=>{
        const n = e1.selection.getRng(), o = t ? Pl.fromRangeEnd(n) : Pl.fromRangeStart(n), r = (s = o.container(), a = e1.getBody(), er(mn(s), (e1)=>Pu(e1.dom), (e1)=>e1.dom === a).map((e1)=>e1.dom).getOr(a));
        var s, a;
        if (t) {
            const e1 = hx(r, o);
            return de(e1.positions);
        }
        {
            const e1 = px(r, o);
            return le(e1.positions);
        }
    }, jx = (e1, t, n)=>zx(e1, t).filter(n).exists((t)=>(e1.selection.setRng(t.toRange()), !0)), Hx = (e1, t)=>{
        const n = e1.dom.createRng();
        n.setStart(t.container(), t.offset()), n.setEnd(t.container(), t.offset()), e1.selection.setRng(n);
    }, $x = (e1, t)=>{
        e1 ? t.setAttribute("data-mce-selected", "inline-boundary") : t.removeAttribute("data-mce-selected");
    }, Vx = (e1, t, n)=>j_(t, n).map((t)=>(Hx(e1, t), n)), qx = (e1, t, n)=>{
        const o = e1.getBody(), r = ((e1, t, n)=>{
            const o = Pl.fromRangeStart(e1);
            if (e1.collapsed) return o;
            {
                const r = Pl.fromRangeEnd(e1);
                return n ? Sm(t, r).getOr(r) : xm(t, o).getOr(o);
            }
        })(e1.selection.getRng(), o, n);
        return ((e1, t, n, o)=>{
            const r = $h(e1, o), s = Q_(t, n, r);
            return Q_(t, n, r).bind(T(sx, e1)).orThunk(()=>((e1, t, n, o, r)=>{
                    const s = $h(e1, r);
                    return Cm(e1, n, s).map(T($h, e1)).fold(()=>o.map(tx), (r)=>Q_(t, n, r).map(T(ox, e1, t, n, s, r)).filter(T(rx, o))).filter(Z_);
                })(e1, t, n, s, o));
        })(n, T(zh, e1), o, r).bind((n)=>Vx(e1, t, n));
    }, Wx = (e1, t, n)=>!!uc(e1) && qx(e1, t, n).isSome(), Kx = (e1, t, n)=>!!uc(t) && ((e1, t)=>{
            const n = t.selection.getRng(), o = e1 ? Pl.fromRangeEnd(n) : Pl.fromRangeStart(n);
            return !!((e1)=>w(e1.selection.getSel().modify))(t) && (e1 && Hi(o) ? ax(!0, t.selection, o) : !(e1 || !$i(o)) && ax(!1, t.selection, o));
        })(e1, t), Yx = (e1)=>{
        const t = Ne(null), n = T(zh, e1);
        return e1.on("NodeChange", (o)=>{
            uc(e1) && (((e1, t, n)=>{
                const o = V(vr(mn(t.getRoot()), '*[data-mce-selected="inline-boundary"]'), (e1)=>e1.dom), r = Y(o, e1), s = Y(n, e1);
                q(re(r, s), T($x, !1)), q(re(s, r), T($x, !0));
            })(n, e1.dom, o.parents), ((e1, t)=>{
                const n = t.get();
                if (e1.selection.isCollapsed() && !e1.composing && n) {
                    const o = Pl.fromRangeStart(e1.selection.getRng());
                    Pl.isTextPosition(o) && !((e1)=>Hi(e1) || $i(e1))(o) && (Hx(e1, _u(n, o)), t.set(null));
                }
            })(e1, t), ((e1, t, n, o)=>{
                if (t.selection.isCollapsed()) {
                    const r = Y(o, e1);
                    q(r, (o)=>{
                        const r = Pl.fromRangeStart(t.selection.getRng());
                        Q_(e1, t.getBody(), r).bind((e1)=>Vx(t, n, e1));
                    });
                }
            })(n, e1, t, o.parents));
        }), t;
    }, Gx = T(Kx, !0), Xx = T(Kx, !1), Zx = (e1, t, n)=>{
        if (uc(e1)) {
            const o = zx(e1, t).getOrThunk(()=>{
                const n = e1.selection.getRng();
                return t ? Pl.fromRangeEnd(n) : Pl.fromRangeStart(n);
            });
            return Q_(T(zh, e1), e1.getBody(), o).exists((t)=>{
                const o = tx(t);
                return j_(n, o).exists((t)=>(Hx(e1, t), !0));
            });
        }
        return !1;
    }, Qx = (e1, t)=>(n)=>j_(t, n).map((t)=>()=>Hx(e1, t)), Jx = (e1, t, n, o)=>{
        const r = e1.getBody(), s = T(zh, e1);
        e1.undoManager.ignore(()=>{
            e1.selection.setRng(((e1, t)=>{
                const n = document.createRange();
                return n.setStart(e1.container(), e1.offset()), n.setEnd(t.container(), t.offset()), n;
            })(n, o)), Kh(e1), Q_(s, r, Pl.fromRangeStart(e1.selection.getRng())).map(nx).bind(Qx(e1, t)).each(D);
        }), e1.nodeChanged();
    }, eS = (e1, t, n)=>{
        if (e1.selection.isCollapsed() && uc(e1)) {
            const o = Pl.fromRangeStart(e1.selection.getRng());
            return ((e1, t, n, o)=>{
                const r = ((e1, t)=>Wu(t, e1) || e1)(e1.getBody(), o.container()), s = T(zh, e1), a = Q_(s, r, o);
                return a.bind((e1)=>n ? e1.fold(N(I.some(nx(e1))), I.none, N(I.some(tx(e1))), I.none) : e1.fold(I.none, N(I.some(tx(e1))), I.none, N(I.some(nx(e1))))).map(Qx(e1, t)).getOrThunk(()=>{
                    const i = wm(n, r, o), l = i.bind((e1)=>Q_(s, r, e1));
                    return ze(a, l, ()=>Hh(s, r, o).bind((t)=>((e1)=>ze(km(e1), Nm(e1), (t, n)=>{
                                    const o = $h(!0, t), r = $h(!1, n);
                                    return xm(e1, o).forall((e1)=>e1.isEqual(r));
                                }).getOr(!0))(t) ? I.some(()=>{
                                Fh(e1, n, mn(t));
                            }) : I.none())).getOrThunk(()=>l.bind(()=>i.map((r)=>()=>{
                                    n ? Jx(e1, t, o, r) : Jx(e1, t, r, o);
                                })));
                });
            })(e1, t, n, o);
        }
        return I.none();
    }, tS = (e1, t)=>{
        const n = mn(e1.getBody()), o = mn(e1.selection.getStart()), r = Qp(o, n);
        return J(r, t).fold(N(r), (e1)=>r.slice(0, e1));
    }, nS = (e1)=>1 === Wn(e1), oS = (e1, t)=>{
        const n = T(wv, e1);
        return te(t, (e1)=>n(e1) ? [
                e1.dom
            ] : []);
    }, rS = (e1)=>{
        const t = ((e1)=>tS(e1, (t)=>e1.schema.isBlock(_n(t))))(e1);
        return oS(e1, t);
    }, sS = (e1, t)=>{
        const n = Y(((e1)=>tS(e1, (t)=>e1.schema.isBlock(_n(t)) || ((e1)=>Wn(e1) > 1)(t)))(e1), nS);
        return de(n).bind((o)=>{
            const r = Pl.fromRangeStart(e1.selection.getRng());
            return Qh(t, r, o.dom) && !kf(o) ? I.some(()=>((e1, t, n, o)=>{
                    const r = oS(t, o);
                    if (0 === r.length) Fh(t, e1, n);
                    else {
                        const e1 = Cv(n.dom, r);
                        t.selection.setRng(e1.toRange());
                    }
                })(t, e1, o, n)) : I.none();
        });
    }, aS = (e1, t)=>{
        const n = e1.selection.getStart(), o = ((e1, t)=>{
            const n = t.parentElement;
            return as(t) && !h(n) && e1.dom.isEmpty(n);
        })(e1, n) || kf(mn(n)) ? Cv(n, t) : ((e1, t)=>{
            const { caretContainer: n, caretPosition: o } = yv(t);
            return e1.insertNode(n.dom), o;
        })(e1.selection.getRng(), t);
        e1.selection.setRng(o.toRange());
    }, iS = (e1)=>es(e1.startContainer), lS = (e1)=>{
        const t = e1.selection.getRng();
        return ((e1)=>0 === e1.startOffset && iS(e1))(t) && ((e1, t)=>{
            const n = t.startContainer.parentElement;
            return !h(n) && wv(e1, mn(n));
        })(e1, t) && ((e1)=>((e1)=>((e1)=>{
                    const t = e1.startContainer.parentNode, n = e1.endContainer.parentNode;
                    return !h(t) && !h(n) && t.isEqualNode(n);
                })(e1) && ((e1)=>{
                    const t = e1.endContainer;
                    return e1.endOffset === (es(t) ? t.length : t.childNodes.length);
                })(e1))(e1) || ((e1)=>!e1.endContainer.isEqualNode(e1.commonAncestorContainer))(e1))(t);
    }, dS = (e1, t)=>e1.selection.isCollapsed() ? sS(e1, t) : ((e1)=>{
            if (lS(e1)) {
                const t = rS(e1);
                return I.some(()=>{
                    Kh(e1), ((e1, t)=>{
                        const n = re(t, rS(e1));
                        n.length > 0 && aS(e1, n);
                    })(e1, t);
                });
            }
            return I.none();
        })(e1), cS = (e1)=>(((e1)=>{
            const t = e1.selection.getRng();
            return t.collapsed && (iS(t) || e1.dom.isEmpty(t.startContainer)) && !((e1)=>{
                var t, n;
                return t = mn(e1.selection.getStart()), n = e1.schema, yr(t, (e1)=>Am(e1.dom), (e1)=>n.isBlock(_n(e1)));
            })(e1);
        })(e1) && aS(e1, []), !0), uS = (e1, t, n)=>C(n) ? I.some(()=>{
            e1._selectionOverrides.hideFakeCaret(), Fh(e1, t, mn(n));
        }) : I.none(), mS = (e1, t)=>e1.selection.isCollapsed() ? ((e1, t)=>{
            const n = t ? qp : Wp, o = nm(t ? 1 : -1, e1.getBody(), e1.selection.getRng());
            return n(o) ? uS(e1, t, o.getNode(!t)) : I.from($h(t, o)).filter((e1)=>n(e1) && sm(o, e1)).bind((n)=>uS(e1, t, n.getNode(!t)));
        })(e1, t) : ((e1, t)=>{
            const n = e1.selection.getNode();
            return gs(n) ? uS(e1, t, n) : I.none();
        })(e1, t), fS = (e1)=>nt(null != e1 ? e1 : "").getOr(0), gS = (e1, t)=>(e1 || "table" === _n(t) ? "margin" : "padding") + ("rtl" === Lo(t, "direction") ? "-right" : "-left"), pS = (e1)=>{
        const t = bS(e1);
        return !e1.mode.isReadOnly() && (t.length > 1 || ((e1, t)=>ne(t, (t)=>{
                const n = gS(Gd(e1), t), o = Io(t, n).map(fS).getOr(0);
                return "false" !== e1.dom.getContentEditable(t.dom) && o > 0;
            }))(e1, t));
    }, hS = (e1)=>ki(e1) || Ni(e1), bS = (e1)=>Y(No(e1.selection.getSelectedBlocks()), (e1)=>!hS(e1) && !((e1)=>Ln(e1).exists(hS))(e1) && tr(e1, (e1)=>ds(e1.dom) || cs(e1.dom)).exists((e1)=>ds(e1.dom))), vS = (e1, t)=>{
        var n, o;
        if (e1.mode.isReadOnly()) return;
        const { dom: r } = e1, s = Xd(e1), a = null !== (o = null === (n = /[a-z%]+$/i.exec(s)) || void 0 === n ? void 0 : n[0]) && void 0 !== o ? o : "px", i = fS(s), l = Gd(e1);
        q(bS(e1), (e1)=>{
            ((e1, t, n, o, r, s)=>{
                const a = gS(n, mn(s)), i = fS(e1.getStyle(s, a));
                if ("outdent" === t) {
                    const t = Math.max(0, i - o);
                    e1.setStyle(s, a, t ? t + r : "");
                } else {
                    const t = i + o + r;
                    e1.setStyle(s, a, t);
                }
            })(r, t, l, i, a, e1.dom);
        });
    }, yS = (e1)=>vS(e1, "outdent"), CS = (e1)=>{
        if (e1.selection.isCollapsed() && pS(e1)) {
            const t = e1.dom, n = e1.selection.getRng(), o = Pl.fromRangeStart(n), r = t.getParent(n.startContainer, t.isBlock);
            if (null !== r && oh(mn(r), o, e1.schema)) return I.some(()=>yS(e1));
        }
        return I.none();
    }, wS = (e1, t, n)=>ue([
            CS,
            S_,
            b_,
            (e1, n)=>eS(e1, t, n),
            i_,
            kb,
            O_,
            mS,
            c_,
            dS,
            T_
        ], (t)=>t(e1, n)).filter((t)=>e1.selection.isEditable()), ES = (e1)=>void 0 === e1.touches || 1 !== e1.touches.length ? I.none() : I.some(e1.touches[0]), _S = (e1, t)=>xe(e1, t.nodeName), xS = (e1, t)=>!!es(t) || !!qr(t) && !(_S(e1.getBlockElements(), t) || Hm(t) || js(e1, t) || Ns(t)), SS = (e1, t)=>{
        if (es(t)) {
            if (0 === t.data.length) return !0;
            if (/^\s+$/.test(t.data)) return !t.nextSibling || _S(e1, t.nextSibling) || Ns(t.nextSibling);
        }
        return !1;
    }, kS = (e1)=>e1.dom.create(Ad(e1), Td(e1)), NS = (e1, t, n)=>{
        const o = mn(kS(e1)), r = Oi();
        co(o, r), n(t, o);
        const s = document.createRange();
        return s.setStartBefore(r.dom), s.setEndBefore(r.dom), s;
    }, RS = (e1)=>(t)=>-1 !== (" " + t.attr("class") + " ").indexOf(e1), AS = (e1, t, n)=>function(o) {
            const r = arguments, s = r[r.length - 2], a = s > 0 ? t.charAt(s - 1) : "";
            if ('"' === a) return o;
            if (">" === a) {
                const e1 = t.lastIndexOf("<", s);
                if (-1 !== e1 && -1 !== t.substring(e1, s).indexOf('contenteditable="false"')) return o;
            }
            return '<span class="' + n + '" data-mce-content="' + e1.dom.encode(r[0]) + '">' + e1.dom.encode("string" == typeof r[1] ? r[1] : r[0]) + "</span>";
        }, TS = (e1, t)=>ne(e1, (e1)=>{
            const n = t.match(e1);
            return null !== n && n[0].length === t.length;
        }), OS = (e1, t)=>{
        t.hasAttribute("data-mce-caret") && (Wi(t), e1.selection.setRng(e1.selection.getRng()), e1.selection.scrollIntoView(t));
    }, BS = (e1, t)=>{
        const n = ((e1)=>rr(mn(e1.getBody()), "*[data-mce-caret]").map((e1)=>e1.dom).getOrNull())(e1);
        if (n) return "compositionstart" === t.type ? (t.preventDefault(), t.stopPropagation(), void OS(e1, n)) : void (ji(n) && (OS(e1, n), e1.undoManager.add()));
    }, PS = cs, DS = (e1, t, n)=>{
        const o = hm(e1.getBody()), r = T(rm, 1 === t ? o.next : o.prev);
        if (n.collapsed) {
            const o = e1.dom.getParent(n.startContainer, "PRE");
            if (!o) return;
            if (!r(Pl.fromRangeStart(n))) {
                const n = mn(((e1)=>{
                    const t = e1.dom.create(Ad(e1));
                    return t.innerHTML = '<br data-mce-bogus="1">', t;
                })(e1));
                1 === t ? io(mn(o), n) : ao(mn(o), n), e1.selection.select(n.dom, !0), e1.selection.collapse();
            }
        }
    }, LS = (e1, t)=>((e1, t)=>{
            const n = t ? 1 : -1, o = e1.selection.getRng();
            return ((e1, t, n)=>Fx(t, e1, n, Gp, Xp, PS))(n, e1, o).orThunk(()=>(DS(e1, n, o), I.none()));
        })(e1, ((e1, t)=>{
            const n = t ? e1.getEnd(!0) : e1.getStart(!0);
            return jh(n) ? !t : t;
        })(e1.selection, t)).exists((t)=>(Mx(e1, t), !0)), MS = (e1, t)=>((e1, t)=>{
            const n = t ? 1 : -1, o = e1.selection.getRng();
            return ((e1, t, n)=>Ux(t, e1, n, (e1)=>Gp(e1) || Kp(e1), (e1)=>Xp(e1) || Yp(e1), PS))(n, e1, o).orThunk(()=>(DS(e1, n, o), I.none()));
        })(e1, t).exists((t)=>(Mx(e1, t), !0)), IS = (e1, t)=>jx(e1, t, t ? Xp : Gp), FS = (e1, t)=>v_(e1, !t).map((n)=>{
            const o = n.toRange(), r = e1.selection.getRng();
            return t ? o.setStart(r.startContainer, r.startOffset) : o.setEnd(r.endContainer, r.endOffset), o;
        }).exists((t)=>(Mx(e1, t), !0)), US = (e1)=>H([
            "figcaption"
        ], _n(e1)), zS = (e1, t)=>!!e1.selection.isCollapsed() && ((e1, t)=>{
            const n = mn(e1.getBody()), o = Pl.fromRangeStart(e1.selection.getRng());
            return ((e1, t, n)=>{
                const o = T(Cn, t);
                return tr(mn(e1.container()), (e1)=>n.isBlock(_n(e1)), o).filter(US);
            })(o, n, e1.schema).exists(()=>{
                if (((e1, t, n)=>t ? Cx(e1.dom, n) : yx(e1.dom, n))(n, t, o)) {
                    const o = NS(e1, n, t ? co : lo);
                    return e1.selection.setRng(o), !0;
                }
                return !1;
            });
        })(e1, t), jS = (e1, t)=>((e1, t)=>t ? I.from(e1.dom.getParent(e1.selection.getNode(), "details")).map((t)=>((e1, t)=>{
                    const n = e1.selection.getRng(), o = Pl.fromRangeStart(n);
                    return !(e1.getBody().lastChild !== t || !Cx(t, o) || (e1.execCommand("InsertNewBlockAfter"), 0));
                })(e1, t)).getOr(!1) : I.from(e1.dom.getParent(e1.selection.getNode(), "summary")).bind((t)=>I.from(e1.dom.getParent(t, "details")).map((n)=>((e1, t, n)=>{
                        const o = e1.selection.getRng(), r = Pl.fromRangeStart(o);
                        return !(e1.getBody().firstChild !== t || !yx(n, r) || (e1.execCommand("InsertNewBlockBefore"), 0));
                    })(e1, n, t))).getOr(!1))(e1, t), HS = {
        shiftKey: !1,
        altKey: !1,
        ctrlKey: !1,
        metaKey: !1,
        keyCode: 0
    }, $S = (e1, t)=>t.keyCode === e1.keyCode && t.shiftKey === e1.shiftKey && t.altKey === e1.altKey && t.ctrlKey === e1.ctrlKey && t.metaKey === e1.metaKey, VS = (e1, ...t)=>()=>e1.apply(null, t), qS = (e1, t)=>Q(((e1, t)=>te(((e1)=>V(e1, (e1)=>({
                        ...HS,
                        ...e1
                    })))(e1), (e1)=>$S(e1, t) ? [
                    e1
                ] : []))(e1, t), (e1)=>e1.action()), WS = (e1, t)=>ue(((e1, t)=>te(((e1)=>V(e1, (e1)=>({
                        ...HS,
                        ...e1
                    })))(e1), (e1)=>$S(e1, t) ? [
                    e1
                ] : []))(e1, t), (e1)=>e1.action()), KS = (e1, t)=>{
        const n = t ? 1 : -1, o = e1.selection.getRng();
        return Fx(e1, n, o, qp, Wp, gs).exists((t)=>(Mx(e1, t), !0));
    }, YS = (e1, t)=>{
        const n = t ? 1 : -1, o = e1.selection.getRng();
        return Ux(e1, n, o, qp, Wp, gs).exists((t)=>(Mx(e1, t), !0));
    }, GS = (e1, t)=>jx(e1, t, t ? Wp : qp), XS = (e1, t, n)=>te(Hn(e1), (e1)=>vn(e1, t) ? n(e1) ? [
                e1
            ] : [] : XS(e1, t, n)), ZS = (e1, t)=>sr(e1, "table", t), QS = ke([
        {
            none: [
                "current"
            ]
        },
        {
            first: [
                "current"
            ]
        },
        {
            middle: [
                "current",
                "target"
            ]
        },
        {
            last: [
                "current"
            ]
        }
    ]), JS = {
        ...QS,
        none: (e1)=>QS.none(e1)
    }, ek = (e1, t, n, o, r = M)=>{
        const s = 1 === o;
        if (!s && n <= 0) return JS.first(e1[0]);
        if (s && n >= e1.length - 1) return JS.last(e1[e1.length - 1]);
        {
            const s = n + o, a = e1[s];
            return r(a) ? JS.middle(t, a) : ek(e1, t, s, o, r);
        }
    }, tk = (e1, t)=>ZS(e1, t).bind((t)=>{
            const n = XS(t, "th,td", M);
            return J(n, (t)=>Cn(e1, t)).map((e1)=>({
                    index: e1,
                    all: n
                }));
        }), nk = De("image"), ok = De("event"), rk = (e1)=>(t)=>{
            t[ok] = e1;
        }, sk = rk(0), ak = rk(2), ik = rk(1), lk = (e1)=>{
        const t = e1;
        return I.from(t[ok]).exists((e1)=>0 === e1);
    };
    const dk = De("mode"), ck = (e1)=>(t)=>{
            t[dk] = e1;
        }, uk = (e1, t)=>ck(t)(e1), mk = ck(0), fk = ck(2), gk = ck(1), pk = (e1)=>(t)=>{
            const n = t;
            return I.from(n[dk]).exists((t)=>t === e1);
        }, hk = pk(0), bk = pk(1), vk = [
        "none",
        "copy",
        "link",
        "move"
    ], yk = [
        "none",
        "copy",
        "copyLink",
        "copyMove",
        "link",
        "linkMove",
        "move",
        "all",
        "uninitialized"
    ], Ck = ()=>{
        const e1 = new window.DataTransfer;
        let t = "move", n = "all";
        const o = {
            get dropEffect () {
                return t;
            },
            set dropEffect (e){
                H(vk, e) && (t = e);
            },
            get effectAllowed () {
                return n;
            },
            set effectAllowed (e){
                lk(o) && H(yk, e) && (n = e);
            },
            get items () {
                return ((e1, t)=>({
                        ...t,
                        get length () {
                            return t.length;
                        },
                        add: (n, o)=>{
                            if (hk(e1)) {
                                if (!m(n)) return t.add(n);
                                if (!v(o)) return t.add(n, o);
                            }
                            return null;
                        },
                        remove: (n)=>{
                            hk(e1) && t.remove(n);
                        },
                        clear: ()=>{
                            hk(e1) && t.clear();
                        }
                    }))(o, e1.items);
            },
            get files () {
                return bk(o) ? Object.freeze({
                    length: 0,
                    item: (e1)=>null
                }) : e1.files;
            },
            get types () {
                return e1.types;
            },
            setDragImage: (t, n, r)=>{
                var s;
                hk(o) && (s = {
                    image: t,
                    x: n,
                    y: r
                }, o[nk] = s, e1.setDragImage(t, n, r));
            },
            getData: (t)=>bk(o) ? "" : e1.getData(t),
            setData: (t, n)=>{
                hk(o) && e1.setData(t, n);
            },
            clearData: (t)=>{
                hk(o) && e1.clearData(t);
            }
        };
        return mk(o), o;
    }, wk = (e1, t)=>e1.setData("text/html", t), Ek = (e1, t, n, o, r)=>{
        const s = vr(mn(n), "td,th,caption").map((e1)=>e1.dom), a = Y(((e1, t)=>te(t, (t)=>{
                const n = ((e1, t)=>({
                        left: e1.left - t,
                        top: e1.top - t,
                        right: e1.right + -2,
                        bottom: e1.bottom + -2,
                        width: e1.width + t,
                        height: e1.height + t
                    }))(Gi(t.getBoundingClientRect()), -1);
                return [
                    {
                        x: n.left,
                        y: e1(n),
                        cell: t
                    },
                    {
                        x: n.right,
                        y: e1(n),
                        cell: t
                    }
                ];
            }))(e1, s), (e1)=>t(e1, r));
        return ((e1, t, n)=>X(e1, (e1, o)=>e1.fold(()=>I.some(o), (e1)=>{
                    const r = Math.sqrt(Math.abs(e1.x - t) + Math.abs(e1.y - n)), s = Math.sqrt(Math.abs(o.x - t) + Math.abs(o.y - n));
                    return I.some(s < r ? o : e1);
                }), I.none()))(a, o, r).map((e1)=>e1.cell);
    }, _k = T(Ek, (e1)=>e1.bottom, (e1, t)=>e1.y < t), xk = T(Ek, (e1)=>e1.top, (e1, t)=>e1.y > t), Sk = (e1, t, n)=>{
        const o = e1(t, n);
        return ((e1)=>e1.breakType === ix.Wrap && 0 === e1.positions.length)(o) || !as(n.getNode()) && ((e1)=>e1.breakType === ix.Br && 1 === e1.positions.length)(o) ? !((e1, t, n)=>n.breakAt.exists((n)=>e1(t, n).breakAt.isSome()))(e1, t, o) : o.breakAt.isNone();
    }, kk = T(Sk, px), Nk = T(Sk, hx), Rk = (e1, t, n, o)=>{
        const r = e1.selection.getRng(), s = t ? 1 : -1;
        return !(!Tu() || !((e1, t, n)=>{
            const o = Pl.fromRangeStart(t);
            return _m(!e1, n).exists((e1)=>e1.isEqual(o));
        })(t, r, n) || (u_(s, e1, n, !t, !1).each((t)=>{
            Mx(e1, t);
        }), 0));
    }, Ak = (e1, t, n)=>{
        const o = ((e1, t)=>{
            const n = t.getNode(e1);
            return Zr(n) ? I.some(n) : I.none();
        })(!!t, n), r = !1 === t;
        o.fold(()=>Mx(e1, n.toRange()), (o)=>_m(r, e1.getBody()).filter((e1)=>e1.isEqual(n)).fold(()=>Mx(e1, n.toRange()), (n)=>((e1, t, n)=>{
                    t.undoManager.transact(()=>{
                        const o = e1 ? io : ao, r = NS(t, mn(n), o);
                        Mx(t, r);
                    });
                })(t, e1, o)));
    }, Tk = (e1, t, n, o)=>{
        const r = e1.selection.getRng(), s = Pl.fromRangeStart(r), a = e1.getBody();
        if (!t && kk(o, s)) {
            const o = ((e1, t, n)=>((e1, t)=>le(t.getClientRects()).bind((t)=>_k(e1, t.left, t.top)).bind((e1)=>{
                        var n;
                        return gx(Nm(n = e1).map((e1)=>px(n, e1).positions.concat(e1)).getOr([]), t);
                    }))(t, n).orThunk(()=>le(n.getClientRects()).bind((n)=>fx(bx(e1, Pl.before(t)), n.left))).getOr(Pl.before(t)))(a, n, s);
            return Ak(e1, t, o), !0;
        }
        if (t && Nk(o, s)) {
            const o = ((e1, t, n)=>((e1, t)=>de(t.getClientRects()).bind((t)=>xk(e1, t.left, t.top)).bind((e1)=>{
                        var n;
                        return gx(km(n = e1).map((e1)=>[
                                e1
                            ].concat(hx(n, e1).positions)).getOr([]), t);
                    }))(t, n).orThunk(()=>le(n.getClientRects()).bind((n)=>fx(vx(e1, Pl.after(t)), n.left))).getOr(Pl.after(t)))(a, n, s);
            return Ak(e1, t, o), !0;
        }
        return !1;
    }, Ok = (e1, t, n)=>I.from(e1.dom.getParent(e1.selection.getNode(), "td,th")).bind((o)=>I.from(e1.dom.getParent(o, "table")).map((r)=>n(e1, t, r, o))).getOr(!1), Bk = (e1, t)=>Ok(e1, t, Rk), Pk = (e1, t)=>Ok(e1, t, Tk), Dk = (e1, t, n)=>n.fold(I.none, I.none, (e1, t)=>{
            var n;
            return (n = t, nr(n, Sr)).map((e1)=>((e1)=>{
                    const t = Tr.exact(e1, 0, e1, 0);
                    return Dr(t);
                })(e1));
        }, (n)=>e1.mode.isReadOnly() || !Lk(n) ? I.none() : (e1.execCommand("mceTableInsertRowAfter"), Mk(e1, t, n))), Lk = (e1)=>tr(e1, On("table")).exists(gr), Mk = (e1, t, n)=>{
        var o, r;
        return Dk(e1, t, (r = Fk, tk(o = n, void 0).fold(()=>JS.none(o), (e1)=>ek(e1.all, o, e1.index, 1, r))));
    }, Ik = (e1, t, n)=>{
        var o, r;
        return Dk(e1, t, (r = Fk, tk(o = n, void 0).fold(()=>JS.none(), (e1)=>ek(e1.all, o, e1.index, -1, r))));
    }, Fk = (e1)=>gr(e1) || wr(e1, Uk), Uk = (e1)=>kn(e1) && gr(e1), zk = (e1, t)=>{
        const n = [
            "table",
            "li",
            "dl"
        ], o = mn(e1.getBody()), r = (e1)=>{
            const t = _n(e1);
            return Cn(e1, o) || H(n, t);
        }, s = e1.selection.getRng();
        return ((e1, t)=>((e1, t, n = L)=>n(t) ? I.none() : H(e1, _n(t)) ? I.some(t) : or(t, e1.join(","), (e1)=>vn(e1, "table") || n(e1)))([
                "td",
                "th"
            ], e1, t))(mn(t ? s.endContainer : s.startContainer), r).map((n)=>(ZS(n, r).each((t)=>{
                e1.model.table.clearSelectedCells(t.dom);
            }), e1.selection.collapse(!t), (t ? Mk : Ik)(e1, r, n).each((t)=>{
                e1.selection.setRng(t);
            }), !0)).getOr(!1);
    }, jk = (e1, t)=>({
            container: e1,
            offset: t
        }), Hk = ni.DOM, $k = (e1)=>(t)=>e1 === t ? -1 : 0, Vk = (e1, t, n)=>{
        if (es(e1) && t >= 0) return I.some(jk(e1, t));
        {
            const o = Ei(Hk);
            return I.from(o.backwards(e1, t, $k(e1), n)).map((e1)=>jk(e1.container, e1.container.data.length));
        }
    }, qk = (e1, t, n)=>{
        if (!es(e1)) return I.none();
        const o = e1.data;
        if (t >= 0 && t <= o.length) return I.some(jk(e1, t));
        {
            const o = Ei(Hk);
            return I.from(o.backwards(e1, t, $k(e1), n)).bind((e1)=>{
                const o = e1.container.data;
                return qk(e1.container, t + o.length, n);
            });
        }
    }, Wk = (e1, t, n)=>{
        if (!es(e1)) return I.none();
        const o = e1.data;
        if (t <= o.length) return I.some(jk(e1, t));
        {
            const r = Ei(Hk);
            return I.from(r.forwards(e1, t, $k(e1), n)).bind((e1)=>Wk(e1.container, t - o.length, n));
        }
    }, Kk = (e1, t, n, o, r)=>{
        const s = Ei(e1, ((e1)=>(t)=>e1.isBlock(t) || H([
                    "BR",
                    "IMG",
                    "HR",
                    "INPUT"
                ], t.nodeName) || "false" === e1.getContentEditable(t))(e1));
        return I.from(s.backwards(t, n, o, r));
    }, Yk = (e1)=>"" !== e1 && -1 !== " \xa0\ufeff\f\n\r\t\v".indexOf(e1), Gk = (e1, t)=>e1.substring(t.length), Xk = (e1, t, n, o = !1)=>{
        if (!(r = t).collapsed || !es(r.startContainer)) return I.none();
        var r;
        const s = {
            text: "",
            offset: 0
        }, a = e1.getParent(t.startContainer, e1.isBlock) || e1.getRoot();
        return Kk(e1, t.startContainer, t.startOffset, (e1, t, r)=>(s.text = r + s.text, s.offset += t, ((e1, t, n, o = !1)=>{
                let r;
                const s = n.charAt(0);
                for(r = t - 1; r >= 0; r--){
                    const a = e1.charAt(r);
                    if (!o && Yk(a)) return I.none();
                    if (s === a && Ke(e1, n, r, t)) break;
                }
                return I.some(r);
            })(s.text, s.offset, n, o).getOr(t)), a).bind((e1)=>{
            const o = t.cloneRange();
            if (o.setStart(e1.container, e1.offset), o.setEnd(t.endContainer, t.endOffset), o.collapsed) return I.none();
            const r = ((e1)=>Li(e1.toString().replace(/\u00A0/g, " ")))(o);
            return 0 !== r.lastIndexOf(n) ? I.none() : I.some({
                text: Gk(r, n),
                range: o,
                trigger: n
            });
        });
    }, Zk = (e1)=>{
        if (((e1)=>3 === e1.nodeType)(e1)) return jk(e1, e1.data.length);
        {
            const t = e1.childNodes;
            return t.length > 0 ? Zk(t[t.length - 1]) : jk(e1, t.length);
        }
    }, Qk = (e1, t)=>{
        const n = e1.childNodes;
        return n.length > 0 && t < n.length ? Qk(n[t], 0) : n.length > 0 && ((e1)=>1 === e1.nodeType)(e1) && n.length === t ? Zk(n[n.length - 1]) : jk(e1, t);
    }, Jk = (e1, t, n, o = {})=>{
        var r;
        const s = t(), a = null !== (r = e1.selection.getRng().startContainer.nodeValue) && void 0 !== r ? r : "", i = Y(s.lookupByTrigger(n.trigger), (t)=>n.text.length >= t.minChars && t.matches.getOrThunk(()=>((e1)=>(t)=>{
                        const n = Qk(t.startContainer, t.startOffset);
                        return !((e1, t)=>{
                            var n;
                            const o = null !== (n = e1.getParent(t.container, e1.isBlock)) && void 0 !== n ? n : e1.getRoot();
                            return Kk(e1, t.container, t.offset, (e1, t)=>0 === t ? -1 : t, o).filter((e1)=>{
                                const t = e1.container.data.charAt(e1.offset - 1);
                                return !Yk(t);
                            }).isSome();
                        })(e1, n);
                    })(e1.dom))(n.range, a, n.text));
        if (0 === i.length) return I.none();
        const l = Promise.all(V(i, (e1)=>e1.fetch(n.text, e1.maxResults, o).then((t)=>({
                    matchText: n.text,
                    items: t,
                    columns: e1.columns,
                    onAction: e1.onAction,
                    highlightOn: e1.highlightOn
                }))));
        return I.some({
            lookupData: l,
            context: n
        });
    };
    var eN;
    !function(e1) {
        e1[e1.Error = 0] = "Error", e1[e1.Value = 1] = "Value";
    }(eN || (eN = {}));
    const tN = (e1, t, n)=>e1.stype === eN.Error ? t(e1.serror) : n(e1.svalue), nN = (e1)=>({
            stype: eN.Value,
            svalue: e1
        }), oN = (e1)=>({
            stype: eN.Error,
            serror: e1
        }), rN = tN, sN = (e1)=>f(e1) && fe(e1).length > 100 ? " removed due to size" : JSON.stringify(e1, null, 2), aN = (e1, t)=>oN([
            {
                path: e1,
                getErrorInfo: t
            }
        ]), iN = (e1)=>({
            extract: (t, n)=>{
                var o, r;
                return o = e1(n), r = (e1)=>((e1, t)=>aN(e1, N(t)))(t, e1), o.stype === eN.Error ? r(o.serror) : o;
            },
            toString: N("val")
        }), lN = iN(nN), dN = N(lN), cN = (e1, t)=>iN((n)=>{
            const o = typeof n;
            return e1(n) ? nN(n) : oN(`Expected type: ${t} but got: ${o}`);
        }), uN = cN(E, "number"), mN = cN(m, "string"), fN = cN(b, "boolean"), gN = cN(w, "function"), pN = (e1)=>{
        if (Object(e1) !== e1) return !0;
        switch(({}).toString.call(e1).slice(8, -1)){
            case "Boolean":
            case "Number":
            case "String":
            case "Date":
            case "RegExp":
            case "Blob":
            case "FileList":
            case "ImageData":
            case "ImageBitmap":
            case "ArrayBuffer":
                return !0;
            case "Array":
            case "Object":
                return Object.keys(e1).every((t)=>pN(e1[t]));
            default:
                return !1;
        }
    };
    iN((e1)=>pN(e1) ? nN(e1) : oN("Expected value to be acceptable for sending via postMessage"));
    const hN = (e1)=>({
            tag: "defaultedThunk",
            process: N(e1)
        }), bN = (e1, t, n)=>{
        switch(e1.tag){
            case "field":
                return t(e1.key, e1.newKey, e1.presence, e1.prop);
            case "custom":
                return n(e1.newKey, e1.instantiator);
        }
    }, vN = (e1)=>{
        const t = ((e1)=>{
            const t = [], n = [];
            return q(e1, (e1)=>{
                tN(e1, (e1)=>n.push(e1), (e1)=>t.push(e1));
            }), {
                values: t,
                errors: n
            };
        })(e1);
        var n;
        return t.errors.length > 0 ? (n = t.errors, S(oN, ee)(n)) : nN(t.values);
    }, yN = (e1, t, n, o)=>o(_e(e1, t).getOrThunk(()=>n(e1))), CN = (e1, t, n, o, r)=>{
        const s = (e1)=>r.extract(t.concat([
                o
            ]), e1), a = (e1)=>e1.fold(()=>nN(I.none()), (e1)=>{
                const n = r.extract(t.concat([
                    o
                ]), e1);
                var s, a;
                return s = n, a = I.some, s.stype === eN.Value ? {
                    stype: eN.Value,
                    svalue: a(s.svalue)
                } : s;
            });
        switch(e1.tag){
            case "required":
                return ((e1, t, n, o)=>_e(t, n).fold(()=>((e1, t, n)=>aN(e1, ()=>'Could not find valid *required* value for "' + t + '" in ' + sN(n)))(e1, n, t), o))(t, n, o, s);
            case "defaultedThunk":
                return yN(n, o, e1.process, s);
            case "option":
                return ((e1, t, n)=>n(_e(e1, t)))(n, o, a);
            case "defaultedOptionThunk":
                return ((e1, t, n, o)=>o(_e(e1, t).map((t)=>!0 === t ? n(e1) : t)))(n, o, e1.process, a);
            case "mergeWithThunk":
                return yN(n, o, N({}), (t)=>{
                    const o = Me(e1.process(n), t);
                    return s(o);
                });
        }
    }, wN = (e1)=>({
            extract: (t, n)=>((e1, t, n)=>{
                    const o = {}, r = [];
                    for (const s of n)bN(s, (n, s, a, i)=>{
                        const l = CN(a, e1, t, n, i);
                        rN(l, (e1)=>{
                            r.push(...e1);
                        }, (e1)=>{
                            o[s] = e1;
                        });
                    }, (e1, n)=>{
                        o[e1] = n(t);
                    });
                    return r.length > 0 ? oN(r) : nN(o);
                })(t, n, e1),
            toString: ()=>{
                const t = V(e1, (e1)=>bN(e1, (e1, t, n, o)=>e1 + " -> " + o.toString(), (e1, t)=>"state(" + e1 + ")"));
                return "obj{\n" + t.join("\n") + "}";
            }
        }), EN = (e1, t, n)=>{
        var o;
        return o = ((e1, t, n)=>((e1, t)=>e1.stype === eN.Error ? {
                    stype: eN.Error,
                    serror: t(e1.serror)
                } : e1)(t.extract([
                e1
            ], n), (e1)=>({
                    input: n,
                    errors: e1
                })))(e1, t, n), tN(o, Te.error, Te.value);
    }, _N = (e1, t, n, o)=>({
            tag: "field",
            key: e1,
            newKey: t,
            presence: n,
            prop: o
        }), xN = (e1, t)=>_N(e1, e1, {
            tag: "required",
            process: {}
        }, t), SN = (e1)=>xN(e1, mN), kN = (e1)=>xN(e1, gN), NN = (e1, t)=>_N(e1, e1, {
            tag: "option",
            process: {}
        }, t), RN = (e1)=>NN(e1, mN), AN = (e1)=>NN(e1, gN), TN = (e1, t)=>_N(e1, e1, hN(t), dN()), ON = (e1, t, n)=>_N(e1, e1, hN(t), n), BN = (e1, t)=>ON(e1, t, uN), PN = (e1, t)=>ON(e1, t, fN), DN = (e1, t)=>ON(e1, t, gN), LN = SN("type");
    SN("name"), SN("label"), SN("text"), SN("title"), SN("icon"), SN("url");
    const MN = SN("value"), IN = kN("fetch");
    kN("getSubmenuItems");
    const FN = kN("onAction");
    kN("onItemAction"), DN("onSetup", ()=>x), RN("name");
    const UN = RN("text");
    RN("role");
    const zN = RN("icon");
    RN("url"), RN("tooltip"), RN("label"), RN("shortcut"), AN("select");
    const jN = PN("active", !1);
    PN("borderless", !1);
    const HN = PN("enabled", !0);
    PN("primary", !1);
    const $N = TN("meta", {});
    DN("onAction", x), wN([
        (()=>ON("type", "autocompleteitem", mN))(0, "autocompleteitem"),
        jN,
        HN,
        $N,
        MN,
        UN,
        zN
    ]);
    const VN = wN([
        LN,
        SN("trigger"),
        BN("minChars", 1),
        TN("columns", 1),
        BN("maxResults", 10),
        AN("matches"),
        IN,
        FN,
        (qN = mN, ON("highlightOn", [], (WN = qN, {
            extract: (e1, t)=>{
                const n = V(t, (t, n)=>WN.extract(e1.concat([
                        "[" + n + "]"
                    ]), t));
                return vN(n);
            },
            toString: ()=>"array(" + WN.toString() + ")"
        })))
    ]);
    var qN, WN;
    const KN = (e1)=>{
        const t = e1.ui.registry.getAll().popups, n = he(t, (e1)=>{
            var t;
            return (t = e1, EN("Autocompleter", VN, t)).fold((e1)=>{
                var t;
                throw new Error("Errors: \n" + ((e1)=>{
                    const t = e1.length > 10 ? e1.slice(0, 10).concat([
                        {
                            path: [],
                            getErrorInfo: N("... (only showing first ten failures)")
                        }
                    ]) : e1;
                    return V(t, (e1)=>"Failed path: (" + e1.path.join(" > ") + ")\n" + e1.getErrorInfo());
                })((t = e1).errors).join("\n") + "\n\nInput object: " + sN(t.input));
            }, R);
        }), o = dt(we(n, (e1)=>e1.trigger)), r = Ee(n);
        return {
            dataset: n,
            triggers: o,
            lookupByTrigger: (e1)=>Y(r, (t)=>t.trigger === e1)
        };
    }, YN = (e1)=>{
        const t = Ve(), n = Ne(!1), o = t.isSet, r = ()=>{
            o() && (((e1)=>{
                e1.dispatch("AutocompleterEnd");
            })(e1), n.set(!1), t.clear());
        }, s = st(()=>KN(e1)), a = (a)=>{
            ((n)=>t.get().map((t)=>Xk(e1.dom, e1.selection.getRng(), t.trigger, !0).bind((t)=>Jk(e1, s, t, n))).getOrThunk(()=>((e1, t)=>{
                        const n = t(), o = e1.selection.getRng();
                        return ((e1, t, n)=>ue(n.triggers, (n)=>Xk(e1, t, n)))(e1.dom, o, n).bind((n)=>Jk(e1, t, n));
                    })(e1, s)))(a).fold(r, (r)=>{
                ((e1)=>{
                    o() || t.set({
                        trigger: e1.trigger,
                        matchLength: e1.text.length
                    });
                })(r.context), r.lookupData.then((o)=>{
                    t.get().map((s)=>{
                        const a = r.context;
                        s.trigger === a.trigger && (t.set({
                            ...s,
                            matchLength: a.text.length
                        }), n.get() ? (fd(e1, {
                            range: a.range
                        }), ((e1, t)=>{
                            e1.dispatch("AutocompleterUpdate", t);
                        })(e1, {
                            lookupData: o
                        })) : (n.set(!0), fd(e1, {
                            range: a.range
                        }), ((e1, t)=>{
                            e1.dispatch("AutocompleterStart", t);
                        })(e1, {
                            lookupData: o
                        })));
                    });
                });
            });
        }, i = ()=>t.get().bind(({ trigger: t })=>{
                const o = e1.selection.getRng();
                return Xk(e1.dom, o, t, n.get()).filter(({ range: e1 })=>((e1, t)=>{
                        const n = e1.compareBoundaryPoints(window.Range.START_TO_START, t), o = e1.compareBoundaryPoints(window.Range.END_TO_END, t);
                        return n >= 0 && o <= 0;
                    })(o, e1)).map(({ range: e1 })=>e1);
            });
        e1.addCommand("mceAutocompleterReload", (e1, t)=>{
            const n = f(t) ? t.fetchOptions : {};
            a(n);
        }), e1.addCommand("mceAutocompleterClose", r), e1.addCommand("mceAutocompleterRefreshActiveRange", ()=>{
            i().each((t)=>{
                fd(e1, {
                    range: t
                });
            });
        }), e1.editorCommands.addQueryStateHandler("mceAutoCompleterInRange", ()=>i().isSome()), ((e1, t)=>{
            const n = rt(t.load, 50);
            e1.on("input", (t)=>{
                ("insertCompositionText" !== t.inputType || e1.composing) && n.throttle();
            }), e1.on("keydown", (e1)=>{
                const o = e1.which;
                8 === o ? n.throttle() : 27 === o ? (n.cancel(), t.cancelIfNecessary()) : 38 !== o && 40 !== o || n.cancel();
            }, !0), e1.on("remove", n.cancel);
        })(e1, {
            cancelIfNecessary: r,
            load: a
        });
    }, GN = Kt().browser.isSafari(), XN = (e1)=>Bi(mn(e1)), ZN = (e1, t)=>{
        var n;
        return 0 === e1.startOffset && e1.endOffset === (null === (n = t.textContent) || void 0 === n ? void 0 : n.length);
    }, QN = (e1, t)=>I.from(e1.getParent(t.container(), "details")), JN = (e1, t)=>QN(e1, t).isSome(), eR = (e1, t)=>{
        const n = t.getNode();
        v(n) || e1.selection.setCursorLocation(n, t.offset());
    }, tR = (e1, t, n)=>{
        const o = e1.dom.getParent(t.container(), "details");
        if (o && !o.open) {
            const t = e1.dom.select("summary", o)[0];
            t && (n ? km(t) : Nm(t)).each((t)=>eR(e1, t));
        } else eR(e1, t);
    }, nR = (e1, t, n)=>{
        const { dom: o, selection: r } = e1, s = e1.getBody();
        if ("character" === n) {
            const n = Pl.fromRangeStart(r.getRng()), a = o.getParent(n.container(), o.isBlock), i = QN(o, n), l = a && o.isEmpty(a), d = h(null == a ? void 0 : a.previousSibling), c = h(null == a ? void 0 : a.nextSibling);
            return !!(l && (t ? c : d) && wm(!t, s, n).exists((e1)=>JN(o, e1) && !Ue(i, QN(o, e1)))) || wm(t, s, n).fold(L, (n)=>{
                const r = QN(o, n);
                if (JN(o, n) && !Ue(i, r)) {
                    if (t || tR(e1, n, !1), a && l) {
                        if (t && d) return !0;
                        if (!t && c) return !0;
                        tR(e1, n, t), e1.dom.remove(a);
                    }
                    return !0;
                }
                return !1;
            });
        }
        return !1;
    }, oR = (e1, t, n, o)=>{
        const r = e1.selection.getRng(), s = Pl.fromRangeStart(r), a = e1.getBody();
        return "selection" === o ? ((e1, t)=>{
            const n = t.startSummary.exists((t)=>t.contains(e1.startContainer)), o = t.startSummary.exists((t)=>t.contains(e1.endContainer)), r = t.startDetails.forall((e1)=>t.endDetails.forall((t)=>e1 !== t));
            return (n || o) && !(n && o) || r;
        })(r, t) : n ? ((e1, t)=>t.startSummary.exists((t)=>((e1, t)=>Nm(t).exists((n)=>as(n.getNode()) && Sm(t, n).exists((t)=>t.isEqual(e1)) || n.isEqual(e1)))(e1, t)))(s, t) || ((e1, t, n)=>n.startDetails.exists((n)=>xm(e1, t).forall((e1)=>!n.contains(e1.container()))))(a, s, t) : ((e1, t)=>t.startSummary.exists((t)=>((e1, t)=>km(t).exists((t)=>t.isEqual(e1)))(e1, t)))(s, t) || ((e1, t)=>t.startDetails.exists((n)=>Sm(n, e1).forall((n)=>t.startSummary.exists((t)=>!t.contains(e1.container()) && t.contains(n.container())))))(s, t);
    }, rR = (e1, t, n)=>((e1, t, n)=>((e1, t)=>{
                const n = I.from(e1.getParent(t.startContainer, "details")), o = I.from(e1.getParent(t.endContainer, "details"));
                if (n.isSome() || o.isSome()) {
                    const t = n.bind((t)=>I.from(e1.select("summary", t)[0]));
                    return I.some({
                        startSummary: t,
                        startDetails: n,
                        endDetails: o
                    });
                }
                return I.none();
            })(e1.dom, e1.selection.getRng()).fold(()=>nR(e1, t, n), (o)=>oR(e1, o, t, n) || nR(e1, t, n)))(e1, t, n) || GN && ((e1, t, n)=>{
            const o = e1.selection, r = o.getNode(), s = o.getRng(), a = Pl.fromRangeStart(s);
            return !!bs(r) && ("selection" === n && ZN(s, r) || Qh(t, a, r) ? XN(r) : e1.undoManager.transact(()=>{
                const s = o.getSel();
                let { anchorNode: a, anchorOffset: i, focusNode: l, focusOffset: d } = null != s ? s : {};
                const c = ()=>{
                    C(a) && C(i) && C(l) && C(d) && (null == s || s.setBaseAndExtent(a, i, l, d));
                }, u = (e1, t)=>{
                    q(e1.childNodes, (e1)=>{
                        rf(e1) && t.appendChild(e1);
                    });
                }, m = e1.dom.create("span", {
                    "data-mce-bogus": "1"
                });
                u(r, m), r.appendChild(m), c(), "word" !== n && "line" !== n || null == s || s.modify("extend", t ? "right" : "left", n), !o.isCollapsed() && ZN(o.getRng(), m) ? XN(r) : (e1.execCommand(t ? "ForwardDelete" : "Delete"), a = null == s ? void 0 : s.anchorNode, i = null == s ? void 0 : s.anchorOffset, l = null == s ? void 0 : s.focusNode, d = null == s ? void 0 : s.focusOffset, u(m, r), c()), e1.dom.remove(m);
            }), !0);
        })(e1, t, n) ? I.some(x) : I.none(), sR = (e1)=>(t, n, o = {})=>{
            const r = t.getBody(), s = {
                bubbles: !0,
                composed: !0,
                data: null,
                isComposing: !1,
                detail: 0,
                view: null,
                target: r,
                currentTarget: r,
                eventPhase: Event.AT_TARGET,
                originalTarget: r,
                explicitOriginalTarget: r,
                isTrusted: !1,
                srcElement: r,
                cancelable: !1,
                preventDefault: x,
                inputType: n
            }, a = Ua(new InputEvent(e1));
            return t.dispatch(e1, {
                ...a,
                ...s,
                ...o
            });
        }, aR = sR("input"), iR = sR("beforeinput"), lR = Kt(), dR = lR.os, cR = dR.isMacOS() || dR.isiOS(), uR = lR.browser.isFirefox(), mR = (e1, t)=>{
        const n = e1.dom, o = e1.schema.getMoveCaretBeforeOnEnterElements();
        if (!t) return;
        if (/^(LI|DT|DD)$/.test(t.nodeName)) {
            const e1 = ((e1)=>{
                for(; e1;){
                    if (qr(e1) || es(e1) && e1.data && /[\r\n\s]/.test(e1.data)) return e1;
                    e1 = e1.nextSibling;
                }
                return null;
            })(t.firstChild);
            e1 && /^(UL|OL|DL)$/.test(e1.nodeName) && t.insertBefore(n.doc.createTextNode(it), t.firstChild);
        }
        const r = n.createRng();
        if (t.normalize(), t.hasChildNodes()) {
            const e1 = new Fr(t, t);
            let n, s = t;
            for(; n = e1.current();){
                if (es(n)) {
                    r.setStart(n, 0), r.setEnd(n, 0);
                    break;
                }
                if (o[n.nodeName.toLowerCase()]) {
                    r.setStartBefore(n), r.setEndBefore(n);
                    break;
                }
                s = n, n = e1.next();
            }
            n || (r.setStart(s, 0), r.setEnd(s, 0));
        } else as(t) ? t.nextSibling && n.isBlock(t.nextSibling) ? (r.setStartBefore(t), r.setEndBefore(t)) : (r.setStartAfter(t), r.setEndAfter(t)) : (r.setStart(t, 0), r.setEnd(t, 0));
        e1.selection.setRng(r), ep(e1, r);
    }, fR = (e1, t)=>{
        const n = e1.getRoot();
        let o, r = t;
        for(; r !== n && r && "false" !== e1.getContentEditable(r);){
            if ("true" === e1.getContentEditable(r)) {
                o = r;
                break;
            }
            r = r.parentNode;
        }
        return r !== n ? o : n;
    }, gR = (e1)=>I.from(e1.dom.getParent(e1.selection.getStart(!0), e1.dom.isBlock)), pR = (e1)=>{
        e1.innerHTML = '<br data-mce-bogus="1">';
    }, hR = (e1, t)=>{
        Ad(e1).toLowerCase() === t.tagName.toLowerCase() && ((e1, t, n)=>{
            const o = e1.dom;
            I.from(n.style).map(o.parseStyle).each((e1)=>{
                const n = {
                    ...Fo(mn(t)),
                    ...e1
                };
                o.setStyles(t, n);
            });
            const r = I.from(n.class).map((e1)=>e1.split(/\s+/)), s = I.from(t.className).map((e1)=>Y(e1.split(/\s+/), (e1)=>"" !== e1));
            ze(r, s, (e1, n)=>{
                const r = Y(n, (t)=>!H(e1, t)), s = [
                    ...e1,
                    ...r
                ];
                o.setAttrib(t, "class", s.join(" "));
            });
            const a = [
                "style",
                "class"
            ], i = Ce(n, (e1, t)=>!H(a, t));
            o.setAttribs(t, i);
        })(e1, t, Td(e1));
    }, bR = (e1, t, n, o, r = !0, s, a)=>{
        const i = e1.dom, l = e1.schema, d = Ad(e1), c = n ? n.nodeName.toUpperCase() : "";
        let u = t;
        const m = l.getTextInlineElements();
        let f;
        f = s || "TABLE" === c || "HR" === c ? i.create(s || d, a || {}) : n.cloneNode(!1);
        let g = f;
        if (r) {
            do if (m[u.nodeName]) {
                if (Am(u) || Hm(u)) continue;
                const e1 = u.cloneNode(!1);
                i.setAttrib(e1, "id", ""), f.hasChildNodes() ? (e1.appendChild(f.firstChild), f.appendChild(e1)) : (g = e1, f.appendChild(e1));
            }
            while ((u = u.parentNode) && u !== o);
        } else i.setAttrib(f, "style", null), i.setAttrib(f, "class", null);
        return hR(e1, f), pR(g), f;
    }, vR = (e1, t)=>{
        const n = null == e1 ? void 0 : e1.parentNode;
        return C(n) && n.nodeName === t;
    }, yR = (e1)=>C(e1) && /^(OL|UL|LI)$/.test(e1.nodeName), CR = (e1)=>C(e1) && /^(LI|DT|DD)$/.test(e1.nodeName), wR = (e1)=>{
        const t = e1.parentNode;
        return CR(t) ? t : e1;
    }, ER = (e1, t, n)=>{
        let o = e1[n ? "firstChild" : "lastChild"];
        for(; o && !qr(o);)o = o[n ? "nextSibling" : "previousSibling"];
        return o === t;
    }, _R = (e1)=>X(we(Fo(mn(e1)), (e1, t)=>`${t}: ${e1};`), (e1, t)=>e1 + t, ""), xR = (e1, t)=>t && "A" === t.nodeName && e1.isEmpty(t), SR = (e1, t)=>e1.nodeName === t || e1.previousSibling && e1.previousSibling.nodeName === t, kR = (e1, t)=>C(t) && e1.isBlock(t) && !/^(TD|TH|CAPTION|FORM)$/.test(t.nodeName) && !/^(fixed|absolute)/i.test(t.style.position) && e1.isEditable(t.parentNode) && "false" !== e1.getContentEditable(t), NR = (e1, t, n)=>es(t) ? e1 ? 1 === n && t.data.charAt(n - 1) === Pi ? 0 : n : n === t.data.length - 1 && t.data.charAt(n) === Pi ? t.data.length : n : n, RR = {
        insert: (e1, t)=>{
            let n, o, r, s, a = !1;
            const i = e1.dom, l = e1.schema.getNonEmptyElements(), d = e1.selection.getRng(), c = Ad(e1), u = mn(d.startContainer), f = $n(u, d.startOffset), g = f.exists((e1)=>kn(e1) && !gr(e1)), p = d.collapsed && g, b = (t, o)=>bR(e1, n, S, x, Dd(e1), t, o), v = (e1)=>{
                const t = NR(e1, n, o);
                if (es(n) && (e1 ? t > 0 : t < n.data.length)) return !1;
                if ((n.parentNode === S || n === S) && a && !e1) return !0;
                if (e1 && qr(n) && n === S.firstChild) return !0;
                if (SR(n, "TABLE") || SR(n, "HR")) return ((e1)=>"BR" === e1.nodeName || e1.nextSibling && "BR" === e1.nextSibling.nodeName)(n) ? !e1 : a && !e1 || !a && e1;
                const r = new Fr(n, S);
                let s;
                for(es(n) && (e1 && 0 === t ? r.prev() : e1 || t !== n.data.length || r.next()); s = r.current();){
                    if (qr(s)) {
                        if (!s.getAttribute("data-mce-bogus")) {
                            const e1 = s.nodeName.toLowerCase();
                            if (l[e1] && "br" !== e1) return !1;
                        }
                    } else if (es(s) && !zr(s.data)) return !1;
                    e1 ? r.prev() : r.next();
                }
                return !0;
            }, w = ()=>{
                let t;
                return t = /^(H[1-6]|PRE|FIGURE)$/.test(r) && "HGROUP" !== k ? b(c) : b(), ((e1, t)=>{
                    const n = Ld(e1);
                    return !y(t) && (m(n) ? H(an.explode(n), t.nodeName.toLowerCase()) : n);
                })(e1, s) && kR(i, s) && i.isEmpty(S, void 0, {
                    includeZwsp: !0
                }) ? t = i.split(s, S) : i.insertAfter(t, S), mR(e1, t), t;
            };
            Lg(i, d).each((e1)=>{
                d.setStart(e1.startContainer, e1.startOffset), d.setEnd(e1.endContainer, e1.endOffset);
            }), n = d.startContainer, o = d.startOffset;
            const E = !(!t || !t.shiftKey), _ = !(!t || !t.ctrlKey);
            qr(n) && n.hasChildNodes() && !p && (a = o > n.childNodes.length - 1, n = n.childNodes[Math.min(o, n.childNodes.length - 1)] || n, o = a && es(n) ? n.data.length : 0);
            const x = fR(i, n);
            if (!x || ((e1, t)=>{
                const n = e1.dom.getParent(t, "ol,ul,dl");
                return null !== n && "false" === e1.dom.getContentEditableParent(n);
            })(e1, n)) return;
            E || (n = ((e1, t, n, o, r)=>{
                var s, a;
                const i = e1.dom, l = null !== (s = fR(i, o)) && void 0 !== s ? s : i.getRoot();
                let d = i.getParent(o, i.isBlock);
                if (!d || !kR(i, d)) {
                    if (d = d || l, !d.hasChildNodes()) {
                        const o = i.create(t);
                        return hR(e1, o), d.appendChild(o), n.setStart(o, 0), n.setEnd(o, 0), o;
                    }
                    let s, c = o;
                    for(; c && c.parentNode !== d;)c = c.parentNode;
                    for(; c && !i.isBlock(c);)s = c, c = c.previousSibling;
                    const u = null === (a = null == s ? void 0 : s.parentElement) || void 0 === a ? void 0 : a.nodeName;
                    if (s && u && e1.schema.isValidChild(u, t.toLowerCase())) {
                        const a = s.parentNode, l = i.create(t);
                        for(hR(e1, l), a.insertBefore(l, s), c = s; c && !i.isBlock(c);){
                            const e1 = c.nextSibling;
                            l.appendChild(c), c = e1;
                        }
                        n.setStart(o, r), n.setEnd(o, r);
                    }
                }
                return o;
            })(e1, c, d, n, o));
            let S = i.getParent(n, i.isBlock) || i.getRoot();
            s = C(null == S ? void 0 : S.parentNode) ? i.getParent(S.parentNode, i.isBlock) : null, r = S ? S.nodeName.toUpperCase() : "";
            const k = s ? s.nodeName.toUpperCase() : "";
            if ("LI" !== k || _ || (S = s, s = s.parentNode, r = k), qr(s) && ((e1, t, n)=>!t && n.nodeName.toLowerCase() === Ad(e1) && e1.dom.isEmpty(n) && ((t, n)=>{
                    let o = n;
                    for(; o && o !== t && h(o.nextSibling);){
                        const t = o.parentElement;
                        if (!t || (r = t, !xe(e1.schema.getTextBlockElements(), r.nodeName.toLowerCase()))) return hs(t);
                        o = t;
                    }
                    var r;
                    return !1;
                })(e1.getBody(), n))(e1, E, S)) return ((e1, t, n)=>{
                var o, r, s;
                const a = t(Ad(e1)), i = ((e1, t)=>e1.dom.getParent(t, hs))(e1, n);
                i && (e1.dom.insertAfter(a, i), mR(e1, a), (null !== (s = null === (r = null === (o = n.parentElement) || void 0 === o ? void 0 : o.childNodes) || void 0 === r ? void 0 : r.length) && void 0 !== s ? s : 0) > 1 && e1.dom.remove(n));
            })(e1, b, S);
            if (/^(LI|DT|DD)$/.test(r) && qr(s) && i.isEmpty(S)) return void ((e1, t, n, o, r)=>{
                const s = e1.dom, a = e1.selection.getRng(), i = n.parentNode;
                if (n === e1.getBody() || !i) return;
                var l;
                yR(l = n) && yR(l.parentNode) && (r = "LI");
                const d = CR(o) ? _R(o) : void 0;
                let c = CR(o) && d ? t(r, {
                    style: _R(o)
                }) : t(r);
                if (ER(n, o, !0) && ER(n, o, !1)) {
                    if (vR(n, "LI")) {
                        const e1 = wR(n);
                        s.insertAfter(c, e1), ((e1)=>{
                            var t;
                            return (null === (t = e1.parentNode) || void 0 === t ? void 0 : t.firstChild) === e1;
                        })(n) ? s.remove(e1) : s.remove(n);
                    } else s.replace(c, n);
                } else if (ER(n, o, !0)) vR(n, "LI") ? (s.insertAfter(c, wR(n)), c.appendChild(s.doc.createTextNode(" ")), c.appendChild(n)) : i.insertBefore(c, n), s.remove(o);
                else if (ER(n, o, !1)) s.insertAfter(c, wR(n)), s.remove(o);
                else {
                    n = wR(n);
                    const e1 = a.cloneRange();
                    e1.setStartAfter(o), e1.setEndAfter(n);
                    const t = e1.extractContents();
                    if ("LI" === r && ((e1)=>e1.firstChild && "LI" === e1.firstChild.nodeName)(t)) {
                        const e1 = Y(V(c.children, mn), O(On("br")));
                        c = t.firstChild, s.insertAfter(t, n), q(e1, (e1)=>lo(mn(c), e1)), d && c.setAttribute("style", d);
                    } else s.insertAfter(t, n), s.insertAfter(c, n);
                    s.remove(o);
                }
                mR(e1, c);
            })(e1, b, s, S, c);
            if (!(p || S !== e1.getBody() && kR(i, S))) return;
            const N = S.parentNode;
            let R;
            if (p) R = b(c), f.fold(()=>{
                co(u, mn(R));
            }, (e1)=>{
                ao(e1, mn(R));
            }), e1.selection.setCursorLocation(R, 0);
            else if (Fi(S)) R = Wi(S), i.isEmpty(S) && pR(S), hR(e1, R), mR(e1, R);
            else if (v(!1)) R = w();
            else if (v(!0) && N) {
                const t = Pl.fromRangeStart(d), n = Yp(t), o = mn(S), r = ch(o, t, e1.schema) ? uh(o, t, e1.schema).bind((e1)=>I.from(e1.getNode())) : I.none();
                R = N.insertBefore(b(), S);
                const s = SR(S, "HR") || n ? R : r.getOr(S);
                mR(e1, s);
            } else {
                const t = ((e1)=>{
                    const t = e1.cloneRange();
                    return t.setStart(e1.startContainer, NR(!0, e1.startContainer, e1.startOffset)), t.setEnd(e1.endContainer, NR(!1, e1.endContainer, e1.endOffset)), t;
                })(d).cloneRange();
                t.setEndAfter(S);
                const n = t.extractContents();
                ((e1)=>{
                    q(br(mn(e1), Rn), (e1)=>{
                        const t = e1.dom;
                        t.nodeValue = Li(t.data);
                    });
                })(n), ((e1)=>{
                    let t = e1;
                    do es(t) && (t.data = t.data.replace(/^[\r\n]+/, "")), t = t.firstChild;
                    while (t);
                })(n), R = n.firstChild, i.insertAfter(n, S), ((e1, t, n)=>{
                    var o;
                    const r = [];
                    if (!n) return;
                    let s = n;
                    for(; s = s.firstChild;){
                        if (e1.isBlock(s)) return;
                        qr(s) && !t[s.nodeName.toLowerCase()] && r.push(s);
                    }
                    let a = r.length;
                    for(; a--;)s = r[a], (!s.hasChildNodes() || s.firstChild === s.lastChild && "" === (null === (o = s.firstChild) || void 0 === o ? void 0 : o.nodeValue) || xR(e1, s)) && e1.remove(s);
                })(i, l, R), ((e1, t)=>{
                    t.normalize();
                    const n = t.lastChild;
                    (!n || qr(n) && /^(left|right)$/gi.test(e1.getStyle(n, "float", !0))) && e1.add(t, "br");
                })(i, S), i.isEmpty(S) && pR(S), R.normalize(), i.isEmpty(R) ? (i.remove(R), w()) : (hR(e1, R), mR(e1, R));
            }
            i.setAttrib(R, "id", ""), e1.dispatch("NewBlock", {
                newBlock: R
            });
        },
        fakeEventName: "insertParagraph"
    }, AR = (e1, t, n)=>{
        const o = e1.dom.createRng();
        n ? (o.setStartBefore(t), o.setEndBefore(t)) : (o.setStartAfter(t), o.setEndAfter(t)), e1.selection.setRng(o), ep(e1, o);
    }, TR = (e1, t)=>{
        const n = cn("br");
        ao(mn(t), n), e1.undoManager.add();
    }, OR = (e1, t)=>{
        BR(e1.getBody(), t) || io(mn(t), cn("br"));
        const n = cn("br");
        io(mn(t), n), AR(e1, n.dom, !1), e1.undoManager.add();
    }, BR = (e1, t)=>{
        var n;
        return n = Pl.after(t), !!as(n.getNode()) || xm(e1, Pl.after(t)).map((e1)=>as(e1.getNode())).getOr(!1);
    }, PR = (e1)=>e1 && "A" === e1.nodeName && "href" in e1, DR = (e1)=>e1.fold(L, PR, PR, L), LR = (e1, t)=>{
        t.fold(x, T(TR, e1), T(OR, e1), x);
    }, MR = {
        insert: (e1, t)=>{
            const n = ((e1)=>{
                const t = T(zh, e1), n = Pl.fromRangeStart(e1.selection.getRng());
                return Q_(t, e1.getBody(), n).filter(DR);
            })(e1);
            n.isSome() ? n.each(T(LR, e1)) : ((e1, t)=>{
                const n = e1.selection, o = e1.dom, r = n.getRng();
                let s, a = !1;
                Lg(o, r).each((e1)=>{
                    r.setStart(e1.startContainer, e1.startOffset), r.setEnd(e1.endContainer, e1.endOffset);
                });
                let i = r.startOffset, l = r.startContainer;
                if (qr(l) && l.hasChildNodes()) {
                    const e1 = i > l.childNodes.length - 1;
                    l = l.childNodes[Math.min(i, l.childNodes.length - 1)] || l, i = e1 && es(l) ? l.data.length : 0;
                }
                let d = o.getParent(l, o.isBlock);
                const c = d && d.parentNode ? o.getParent(d.parentNode, o.isBlock) : null, u = c ? c.nodeName.toUpperCase() : "", m = !(!t || !t.ctrlKey);
                "LI" !== u || m || (d = c), es(l) && i >= l.data.length && (((e1, t, n)=>{
                    const o = new Fr(t, n);
                    let r;
                    const s = e1.getNonEmptyElements();
                    for(; r = o.next();)if (s[r.nodeName.toLowerCase()] || es(r) && r.length > 0) return !0;
                    return !1;
                })(e1.schema, l, d || o.getRoot()) || (s = o.create("br"), r.insertNode(s), r.setStartAfter(s), r.setEndAfter(s), a = !0)), s = o.create("br"), Ll(o, r, s), AR(e1, s, a), e1.undoManager.add();
            })(e1, t);
        },
        fakeEventName: "insertLineBreak"
    }, IR = (e1, t)=>gR(e1).filter((e1)=>t.length > 0 && vn(mn(e1), t)).isSome(), FR = ke([
        {
            br: []
        },
        {
            block: []
        },
        {
            none: []
        }
    ]), UR = (e1, t)=>((e1)=>IR(e1, Pd(e1)))(e1), zR = (e1)=>(t, n)=>((e1)=>gR(e1).filter((e1)=>Ni(mn(e1))).isSome())(t) === e1, jR = (e1, t)=>(n, o)=>{
            const r = ((e1)=>gR(e1).fold(N(""), (e1)=>e1.nodeName.toUpperCase()))(n) === e1.toUpperCase();
            return r === t;
        }, HR = (e1)=>{
        const t = fR(e1.dom, e1.selection.getStart());
        return y(t);
    }, $R = (e1)=>jR("pre", e1), VR = (e1)=>(t, n)=>Rd(t) === e1, qR = (e1, t)=>((e1)=>IR(e1, Bd(e1)))(e1), WR = (e1, t)=>t, KR = (e1)=>{
        const t = Ad(e1), n = fR(e1.dom, e1.selection.getStart());
        return C(n) && e1.schema.isValidChild(n.nodeName, t);
    }, YR = (e1)=>{
        const t = e1.selection.getRng(), n = mn(t.startContainer), o = $n(n, t.startOffset).map((e1)=>kn(e1) && !gr(e1));
        return t.collapsed && o.getOr(!0);
    }, GR = (e1, t)=>(n, o)=>X(e1, (e1, t)=>e1 && t(n, o), !0) ? I.some(t) : I.none(), XR = (e1, t, n)=>{
        if (!t.mode.isReadOnly()) {
            if (t.selection.isCollapsed() || ((e1)=>{
                e1.execCommand("delete");
            })(t), C(n) && iR(t, e1.fakeEventName).isDefaultPrevented()) return;
            e1.insert(t, n), C(n) && aR(t, e1.fakeEventName);
        }
    }, ZR = (e1, t)=>{
        if (e1.mode.isReadOnly()) return;
        const n = ()=>XR(MR, e1, t), o = ()=>XR(RR, e1, t), r = ((e1, t)=>H_([
                GR([
                    UR
                ], FR.none()),
                GR([
                    $R(!0),
                    HR
                ], FR.none()),
                GR([
                    jR("summary", !0)
                ], FR.br()),
                GR([
                    $R(!0),
                    VR(!1),
                    WR
                ], FR.br()),
                GR([
                    $R(!0),
                    VR(!1)
                ], FR.block()),
                GR([
                    $R(!0),
                    VR(!0),
                    WR
                ], FR.block()),
                GR([
                    $R(!0),
                    VR(!0)
                ], FR.br()),
                GR([
                    zR(!0),
                    WR
                ], FR.br()),
                GR([
                    zR(!0)
                ], FR.block()),
                GR([
                    qR
                ], FR.br()),
                GR([
                    WR
                ], FR.br()),
                GR([
                    KR
                ], FR.block()),
                GR([
                    YR
                ], FR.block())
            ], [
                e1,
                !(!t || !t.shiftKey)
            ]).getOr(FR.none()))(e1, t);
        switch(Od(e1)){
            case "linebreak":
                r.fold(n, n, x);
                break;
            case "block":
                r.fold(o, o, x);
                break;
            case "invert":
                r.fold(o, n, x);
                break;
            default:
                r.fold(n, o, x);
        }
    }, QR = Kt(), JR = QR.os.isiOS() && QR.browser.isSafari(), eA = (e1, t)=>{
        var n;
        t.isDefaultPrevented() || (t.preventDefault(), (n = e1.undoManager).typing && (n.typing = !1, n.add()), e1.undoManager.transact(()=>{
            ZR(e1, t);
        }));
    }, tA = Kt(), nA = (e1)=>e1.stopImmediatePropagation(), oA = (e1)=>e1.keyCode === wg.PAGE_UP || e1.keyCode === wg.PAGE_DOWN, rA = (e1, t, n)=>{
        n && !e1.get() ? t.on("NodeChange", nA, !0) : !n && e1.get() && t.off("NodeChange", nA), e1.set(n);
    }, sA = (e1, t)=>e1 === t || e1.contains(t), aA = (e1, t)=>{
        const n = t.container(), o = t.offset();
        return es(n) ? (n.insertData(o, e1), I.some(Pl(n, o + e1.length))) : om(t).map((n)=>{
            const o = un(e1);
            return t.isAtEnd() ? io(n, o) : ao(n, o), Pl(o.dom, e1.length);
        });
    }, iA = T(aA, it), lA = T(aA, " "), dA = (e1)=>(t)=>{
            e1.selection.setRng(t.toRange()), e1.nodeChanged();
        }, cA = (e1)=>{
        const t = Pl.fromRangeStart(e1.selection.getRng()), n = mn(e1.getBody());
        if (e1.selection.isCollapsed()) {
            const o = T(zh, e1), r = Pl.fromRangeStart(e1.selection.getRng());
            return Q_(o, e1.getBody(), r).bind(((e1)=>(t)=>t.fold((t)=>Sm(e1.dom, Pl.before(t)), (e1)=>km(e1), (e1)=>Nm(e1), (t)=>xm(e1.dom, Pl.after(t))))(n)).map((o)=>()=>((e1, t, n)=>(o)=>yh(e1, o, n) ? iA(t) : lA(t))(n, t, e1.schema)(o).each(dA(e1)));
        }
        return I.none();
    }, uA = (e1)=>{
        var t, n;
        return je(nn.browser.isFirefox() && e1.selection.isEditable() && (t = e1.dom, n = e1.selection.getRng().startContainer, t.isEditable(t.getParent(n, "summary"))), ()=>{
            const t = mn(e1.getBody());
            e1.selection.isCollapsed() || e1.getDoc().execCommand("Delete"), ((e1, t, n)=>yh(e1, t, n) ? iA(t) : lA(t))(t, Pl.fromRangeStart(e1.selection.getRng()), e1.schema).each(dA(e1));
        });
    }, mA = (e1)=>lu(e1) ? [
            {
                keyCode: wg.TAB,
                action: VS(zk, e1, !0)
            },
            {
                keyCode: wg.TAB,
                shiftKey: !0,
                action: VS(zk, e1, !1)
            }
        ] : [], fA = (e1)=>{
        if (e1.addShortcut("Meta+P", "", "mcePrint"), YN(e1), Nw(e1)) return Ne(null);
        {
            const t = Yx(e1);
            return ((e1)=>{
                e1.on("beforeinput", (t)=>{
                    e1.selection.isEditable() && !$(t.getTargetRanges(), (t)=>!((e1, t)=>!sA(e1.getBody(), t.startContainer) || !sA(e1.getBody(), t.endContainer) || tp(e1.dom, t))(e1, t)) || t.preventDefault();
                });
            })(e1), ((e1)=>{
                e1.on("keyup compositionstart", T(BS, e1));
            })(e1), ((e1, t)=>{
                e1.on("keydown", (n)=>{
                    n.isDefaultPrevented() || ((e1, t, n)=>{
                        const o = nn.os.isMacOS() || nn.os.isiOS();
                        qS([
                            {
                                keyCode: wg.RIGHT,
                                action: VS(LS, e1, !0)
                            },
                            {
                                keyCode: wg.LEFT,
                                action: VS(LS, e1, !1)
                            },
                            {
                                keyCode: wg.UP,
                                action: VS(MS, e1, !1)
                            },
                            {
                                keyCode: wg.DOWN,
                                action: VS(MS, e1, !0)
                            },
                            ...o ? [
                                {
                                    keyCode: wg.UP,
                                    action: VS(FS, e1, !1),
                                    metaKey: !0,
                                    shiftKey: !0
                                },
                                {
                                    keyCode: wg.DOWN,
                                    action: VS(FS, e1, !0),
                                    metaKey: !0,
                                    shiftKey: !0
                                }
                            ] : [],
                            {
                                keyCode: wg.RIGHT,
                                action: VS(Bk, e1, !0)
                            },
                            {
                                keyCode: wg.LEFT,
                                action: VS(Bk, e1, !1)
                            },
                            {
                                keyCode: wg.UP,
                                action: VS(Pk, e1, !1)
                            },
                            {
                                keyCode: wg.DOWN,
                                action: VS(Pk, e1, !0)
                            },
                            {
                                keyCode: wg.UP,
                                action: VS(Pk, e1, !1)
                            },
                            {
                                keyCode: wg.UP,
                                action: VS(jS, e1, !1)
                            },
                            {
                                keyCode: wg.DOWN,
                                action: VS(jS, e1, !0)
                            },
                            {
                                keyCode: wg.RIGHT,
                                action: VS(KS, e1, !0)
                            },
                            {
                                keyCode: wg.LEFT,
                                action: VS(KS, e1, !1)
                            },
                            {
                                keyCode: wg.UP,
                                action: VS(YS, e1, !1)
                            },
                            {
                                keyCode: wg.DOWN,
                                action: VS(YS, e1, !0)
                            },
                            {
                                keyCode: wg.RIGHT,
                                action: VS(Wx, e1, t, !0)
                            },
                            {
                                keyCode: wg.LEFT,
                                action: VS(Wx, e1, t, !1)
                            },
                            {
                                keyCode: wg.RIGHT,
                                ctrlKey: !o,
                                altKey: o,
                                action: VS(Gx, e1, t)
                            },
                            {
                                keyCode: wg.LEFT,
                                ctrlKey: !o,
                                altKey: o,
                                action: VS(Xx, e1, t)
                            },
                            {
                                keyCode: wg.UP,
                                action: VS(zS, e1, !1)
                            },
                            {
                                keyCode: wg.DOWN,
                                action: VS(zS, e1, !0)
                            }
                        ], n).each((e1)=>{
                            n.preventDefault();
                        });
                    })(e1, t, n);
                });
            })(e1, t), ((e1, t)=>{
                let n = !1;
                e1.on("keydown", (o)=>{
                    n = o.keyCode === wg.BACKSPACE, o.isDefaultPrevented() || ((e1, t, n)=>{
                        const o = n.keyCode === wg.BACKSPACE ? "deleteContentBackward" : "deleteContentForward", r = e1.selection.isCollapsed(), s = r ? "character" : "selection", a = (e1)=>r ? e1 ? "word" : "line" : "selection";
                        WS([
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(CS, e1)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(S_, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(S_, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(b_, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(b_, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(eS, e1, t, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(eS, e1, t, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(kb, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(kb, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(rR, e1, !1, s)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(rR, e1, !0, s)
                            },
                            ...cR ? [
                                {
                                    keyCode: wg.BACKSPACE,
                                    altKey: !0,
                                    action: VS(rR, e1, !1, a(!0))
                                },
                                {
                                    keyCode: wg.DELETE,
                                    altKey: !0,
                                    action: VS(rR, e1, !0, a(!0))
                                },
                                {
                                    keyCode: wg.BACKSPACE,
                                    metaKey: !0,
                                    action: VS(rR, e1, !1, a(!1))
                                }
                            ] : [
                                {
                                    keyCode: wg.BACKSPACE,
                                    ctrlKey: !0,
                                    action: VS(rR, e1, !1, a(!0))
                                },
                                {
                                    keyCode: wg.DELETE,
                                    ctrlKey: !0,
                                    action: VS(rR, e1, !0, a(!0))
                                }
                            ],
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(O_, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(O_, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(mS, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(mS, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(c_, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(c_, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(i_, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(i_, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(dS, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(dS, e1, !0)
                            },
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(T_, e1, !1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(T_, e1, !0)
                            }
                        ], n).filter((t)=>e1.selection.isEditable()).each((t)=>{
                            n.preventDefault(), iR(e1, o).isDefaultPrevented() || (t(), aR(e1, o));
                        });
                    })(e1, t, o);
                }), e1.on("keyup", (t)=>{
                    t.isDefaultPrevented() || ((e1, t, n)=>{
                        qS([
                            {
                                keyCode: wg.BACKSPACE,
                                action: VS(x_, e1)
                            },
                            {
                                keyCode: wg.DELETE,
                                action: VS(x_, e1)
                            },
                            ...cR ? [
                                {
                                    keyCode: wg.BACKSPACE,
                                    altKey: !0,
                                    action: VS(cS, e1)
                                },
                                {
                                    keyCode: wg.DELETE,
                                    altKey: !0,
                                    action: VS(cS, e1)
                                },
                                ...n ? [
                                    {
                                        keyCode: uR ? 224 : 91,
                                        action: VS(cS, e1)
                                    }
                                ] : []
                            ] : [
                                {
                                    keyCode: wg.BACKSPACE,
                                    ctrlKey: !0,
                                    action: VS(cS, e1)
                                },
                                {
                                    keyCode: wg.DELETE,
                                    ctrlKey: !0,
                                    action: VS(cS, e1)
                                }
                            ]
                        ], t);
                    })(e1, t, n), n = !1;
                });
            })(e1, t), ((e1)=>{
                let t = I.none();
                e1.on("keydown", (n)=>{
                    n.keyCode === wg.ENTER && (JR && ((e1)=>{
                        if (!e1.collapsed) return !1;
                        const t = e1.startContainer;
                        if (es(t)) {
                            const n = /^[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uD7B0-\uD7FF]$/, o = t.data.charAt(e1.startOffset - 1);
                            return n.test(o);
                        }
                        return !1;
                    })(e1.selection.getRng()) ? ((e1)=>{
                        t = I.some(e1.selection.getBookmark()), e1.undoManager.add();
                    })(e1) : eA(e1, n));
                }), e1.on("keyup", (n)=>{
                    n.keyCode === wg.ENTER && t.each(()=>((e1, n)=>{
                            e1.undoManager.undo(), t.fold(x, (t)=>e1.selection.moveToBookmark(t)), eA(e1, n), t = I.none();
                        })(e1, n));
                });
            })(e1), ((e1)=>{
                e1.on("keydown", (t)=>{
                    t.isDefaultPrevented() || ((e1, t)=>{
                        WS([
                            {
                                keyCode: wg.SPACEBAR,
                                action: VS(cA, e1)
                            },
                            {
                                keyCode: wg.SPACEBAR,
                                action: VS(uA, e1)
                            }
                        ], t).each((n)=>{
                            t.preventDefault(), iR(e1, "insertText", {
                                data: " "
                            }).isDefaultPrevented() || (n(), aR(e1, "insertText", {
                                data: " "
                            }));
                        });
                    })(e1, t);
                });
            })(e1), ((e1)=>{
                e1.on("input", (t)=>{
                    t.isComposing || ((e1)=>{
                        const t = mn(e1.getBody());
                        e1.selection.isCollapsed() && Nh(t, Pl.fromRangeStart(e1.selection.getRng()), e1.schema).each((t)=>{
                            e1.selection.setRng(t.toRange());
                        });
                    })(e1);
                });
            })(e1), ((e1)=>{
                e1.on("keydown", (t)=>{
                    t.isDefaultPrevented() || ((e1, t)=>{
                        qS([
                            ...mA(e1)
                        ], t).each((e1)=>{
                            t.preventDefault();
                        });
                    })(e1, t);
                });
            })(e1), ((e1, t)=>{
                e1.on("keydown", (n)=>{
                    n.isDefaultPrevented() || ((e1, t, n)=>{
                        const o = nn.os.isMacOS() || nn.os.isiOS();
                        qS([
                            {
                                keyCode: wg.END,
                                action: VS(IS, e1, !0)
                            },
                            {
                                keyCode: wg.HOME,
                                action: VS(IS, e1, !1)
                            },
                            ...o ? [] : [
                                {
                                    keyCode: wg.HOME,
                                    action: VS(FS, e1, !1),
                                    ctrlKey: !0,
                                    shiftKey: !0
                                },
                                {
                                    keyCode: wg.END,
                                    action: VS(FS, e1, !0),
                                    ctrlKey: !0,
                                    shiftKey: !0
                                }
                            ],
                            {
                                keyCode: wg.END,
                                action: VS(GS, e1, !0)
                            },
                            {
                                keyCode: wg.HOME,
                                action: VS(GS, e1, !1)
                            },
                            {
                                keyCode: wg.END,
                                action: VS(Zx, e1, !0, t)
                            },
                            {
                                keyCode: wg.HOME,
                                action: VS(Zx, e1, !1, t)
                            }
                        ], n).each((e1)=>{
                            n.preventDefault();
                        });
                    })(e1, t, n);
                });
            })(e1, t), ((e1, t)=>{
                if (tA.os.isMacOS()) return;
                const n = Ne(!1);
                e1.on("keydown", (t)=>{
                    oA(t) && rA(n, e1, !0);
                }), e1.on("keyup", (o)=>{
                    o.isDefaultPrevented() || ((e1, t, n)=>{
                        qS([
                            {
                                keyCode: wg.PAGE_UP,
                                action: VS(Zx, e1, !1, t)
                            },
                            {
                                keyCode: wg.PAGE_DOWN,
                                action: VS(Zx, e1, !0, t)
                            }
                        ], n);
                    })(e1, t, o), oA(o) && n.get() && (rA(n, e1, !1), e1.nodeChanged());
                });
            })(e1, t), t;
        }
    };
    class gA {
        constructor(e1){
            let t;
            this.lastPath = [], this.editor = e1;
            const n = this;
            "onselectionchange" in e1.getDoc() || e1.on("NodeChange click mouseup keyup focus", (n)=>{
                const o = e1.selection.getRng(), r = {
                    startContainer: o.startContainer,
                    startOffset: o.startOffset,
                    endContainer: o.endContainer,
                    endOffset: o.endOffset
                };
                "nodechange" !== n.type && Rg(r, t) || e1.dispatch("SelectionChange"), t = r;
            }), e1.on("contextmenu", ()=>{
                ng(e1), e1.dispatch("SelectionChange");
            }), e1.on("SelectionChange", ()=>{
                const t = e1.selection.getStart(!0);
                t && tf(e1) && !n.isSameElementPath(t) && e1.dom.isChildOf(t, e1.getBody()) && e1.nodeChanged({
                    selectionChange: !0
                });
            }), e1.on("mouseup", (t)=>{
                !t.isDefaultPrevented() && tf(e1) && ("IMG" === e1.selection.getNode().nodeName ? sg.setEditorTimeout(e1, ()=>{
                    e1.nodeChanged();
                }) : e1.nodeChanged());
            });
        }
        nodeChanged(e1 = {}) {
            const t = this.editor, n = t.selection;
            let o;
            if (t.initialized && n && !_c(t) && !hu(t)) {
                const r = t.getBody();
                o = n.getStart(!0) || r, o.ownerDocument === t.getDoc() && t.dom.isChildOf(o, r) || (o = r);
                const s = [];
                t.dom.getParent(o, (e1)=>e1 === r || (s.push(e1), !1)), t.dispatch("NodeChange", {
                    ...e1,
                    element: o,
                    parents: s
                });
            }
        }
        isSameElementPath(e1) {
            let t;
            const n = this.editor, o = oe(n.dom.getParents(e1, M, n.getBody()));
            if (o.length === this.lastPath.length) {
                for(t = o.length; t >= 0 && o[t] === this.lastPath[t]; t--);
                if (-1 === t) return this.lastPath = o, !0;
            }
            return this.lastPath = o, !1;
        }
    }
    const pA = "x-tinymce/html", hA = N(pA), bA = "\x3c!-- " + pA + " --\x3e", vA = (e1)=>bA + e1, yA = (e1)=>-1 !== e1.indexOf(bA), CA = "%MCEPASTEBIN%", wA = (e1)=>e1.dom.get("mcepastebin"), EA = (e1)=>C(e1) && "mcepastebin" === e1.id, _A = (e1)=>e1 === CA, xA = (e1, t)=>(an.each(t, (t)=>{
            e1 = u(t, RegExp) ? e1.replace(t, "") : e1.replace(t[0], t[1]);
        }), e1), SA = (e1)=>xA(e1, [
            /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/gi,
            /<!--StartFragment-->|<!--EndFragment-->/g,
            [
                /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
                (e1, t, n)=>t || n ? it : " "
            ],
            /<br class="Apple-interchange-newline">/g,
            /<br>$/i
        ]), kA = (e1, t)=>({
            content: e1,
            cancelled: t
        }), NA = (e1, t)=>(e1.insertContent(t, {
            merge: Kc(e1),
            paste: !0
        }), !0), RA = (e1)=>/^https?:\/\/[\w\-\/+=.,!;:&%@^~(){}?#]+$/i.test(e1), AA = (e1, t, n)=>!(e1.selection.isCollapsed() || !RA(t)) && ((e1, t, n)=>(e1.undoManager.extra(()=>{
                n(e1, t);
            }, ()=>{
                e1.execCommand("mceInsertLink", !1, t);
            }), !0))(e1, t, n), TA = (e1, t, n)=>!!((e1, t)=>RA(t) && $(iu(e1), (e1)=>Ge(t.toLowerCase(), `.${e1.toLowerCase()}`)))(e1, t) && ((e1, t, n)=>(e1.undoManager.extra(()=>{
                n(e1, t);
            }, ()=>{
                e1.insertContent('<img src="' + t + '">');
            }), !0))(e1, t, n), OA = (()=>{
        let e1 = 0;
        return ()=>"mceclip" + e1++;
    })(), BA = (e1)=>{
        const t = Ck();
        return wk(t, e1), fk(t), t;
    }, PA = (e1, t, n, o, r)=>{
        const s = ((e1, t, n)=>((e1, t, n)=>{
                const o = ((e1, t, n)=>e1.dispatch("PastePreProcess", {
                        content: t,
                        internal: n
                    }))(e1, t, n), r = ((e1, t)=>{
                    const n = KC({
                        sanitize: su(e1),
                        sandbox_iframes: uu(e1),
                        sandbox_iframes_exclusions: mu(e1),
                        convert_unsafe_embeds: fu(e1)
                    }, e1.schema);
                    n.addNodeFilter("meta", (e1)=>{
                        an.each(e1, (e1)=>{
                            e1.remove();
                        });
                    });
                    const o = n.parse(t, {
                        forced_root_block: !1,
                        isRootContent: !0
                    });
                    return Tp({
                        validate: !0
                    }, e1.schema).serialize(o);
                })(e1, o.content);
                return e1.hasEventListeners("PastePostProcess") && !o.isDefaultPrevented() ? ((e1, t, n)=>{
                    const o = e1.dom.create("div", {
                        style: "display:none"
                    }, t), r = ((e1, t, n)=>e1.dispatch("PastePostProcess", {
                            node: t,
                            internal: n
                        }))(e1, o, n);
                    return kA(r.node.innerHTML, r.isDefaultPrevented());
                })(e1, r, n) : kA(r, o.isDefaultPrevented());
            })(e1, t, n))(e1, t, n);
        if (!s.cancelled) {
            const t = s.content, n = ()=>((e1, t, n)=>{
                    n || !Yc(e1) ? NA(e1, t) : ((e1, t)=>{
                        an.each([
                            AA,
                            TA,
                            NA
                        ], (n)=>!n(e1, t, NA));
                    })(e1, t);
                })(e1, t, o);
            r ? iR(e1, "insertFromPaste", {
                dataTransfer: BA(t)
            }).isDefaultPrevented() || (n(), aR(e1, "insertFromPaste")) : n();
        }
    }, DA = (e1, t, n, o)=>{
        const r = n || yA(t);
        PA(e1, ((e1)=>e1.replace(bA, ""))(t), r, !1, o);
    }, LA = (e1, t, n)=>{
        const o = e1.dom.encode(t).replace(/\r\n/g, "\n"), r = ((e1, t, n)=>{
            const o = e1.split(/\n\n/), r = ((e1, t)=>{
                let n = "<" + e1;
                const o = we(t, (e1, t)=>t + '="' + ua.encodeAllRaw(e1) + '"');
                return o.length && (n += " " + o.join(" ")), n + ">";
            })(t, n), s = "</" + t + ">", a = V(o, (e1)=>e1.split(/\n/).join("<br />"));
            return 1 === a.length ? a[0] : V(a, (e1)=>r + e1 + s).join("");
        })(Hr(o, Xc(e1)), Ad(e1), Td(e1));
        PA(e1, r, !1, !0, n);
    }, MA = (e1)=>{
        const t = {};
        if (e1 && e1.types) for(let n = 0; n < e1.types.length; n++){
            const o = e1.types[n];
            try {
                t[o] = e1.getData(o);
            } catch (e1) {
                t[o] = "";
            }
        }
        return t;
    }, IA = (e1, t)=>t in e1 && e1[t].length > 0, FA = (e1)=>IA(e1, "text/html") || IA(e1, "text/plain"), UA = (e1, t, n)=>{
        const o = "paste" === t.type ? t.clipboardData : t.dataTransfer;
        var r;
        if (jc(e1) && o) {
            const s = ((e1, t)=>{
                const n = t.items ? te(ce(t.items), (e1)=>"file" === e1.kind ? [
                        e1.getAsFile()
                    ] : []) : [], o = t.files ? ce(t.files) : [];
                return Y(n.length > 0 ? n : o, ((e1)=>{
                    const t = iu(e1);
                    return (e1)=>Ye(e1.type, "image/") && $(t, (t)=>((e1)=>{
                                const t = e1.toLowerCase(), n = {
                                    jpg: "jpeg",
                                    jpe: "jpeg",
                                    jfi: "jpeg",
                                    jif: "jpeg",
                                    jfif: "jpeg",
                                    pjpeg: "jpeg",
                                    pjp: "jpeg",
                                    svg: "svg+xml"
                                };
                                return an.hasOwn(n, t) ? "image/" + n[t] : "image/" + t;
                            })(t) === e1.type);
                })(e1));
            })(e1, o);
            if (s.length > 0) return t.preventDefault(), (r = s, Promise.all(V(r, (e1)=>by(e1).then((t)=>({
                        file: e1,
                        uri: t
                    }))))).then((t)=>{
                n && e1.selection.setRng(n), q(t, (t)=>{
                    ((e1, t)=>{
                        py(t.uri).each(({ data: n, type: o, base64Encoded: r })=>{
                            const s = r ? n : btoa(n), a = t.file, i = e1.editorUpload.blobCache, l = i.getByData(s, o), d = null != l ? l : ((e1, t, n, o)=>{
                                const r = OA(), s = Id(e1) && C(n.name), a = s ? ((e1, t)=>{
                                    const n = t.match(/([\s\S]+?)(?:\.[a-z0-9.]+)$/i);
                                    return C(n) ? e1.dom.encode(n[1]) : void 0;
                                })(e1, n.name) : r, i = s ? n.name : void 0, l = t.create(r, n, o, a, i);
                                return t.add(l), l;
                            })(e1, i, a, s);
                            DA(e1, `<img src="${d.blobUri()}">`, !1, !0);
                        });
                    })(e1, t);
                });
            }), !0;
        }
        return !1;
    }, zA = (e1, t, n, o, r)=>{
        let s = SA(n);
        const a = IA(t, hA()) || yA(n), i = !a && ((e1)=>!/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(e1))(s), l = RA(s);
        (_A(s) || !s.length || i && !l) && (o = !0), (o || l) && (s = IA(t, "text/plain") && i ? t["text/plain"] : ((e1)=>{
            const t = Ra(), n = KC({}, t);
            let o = "";
            const r = t.getVoidElements(), s = an.makeMap("script noscript style textarea video audio iframe object", " "), a = t.getBlockElements(), i = (e1)=>{
                const n = e1.name, l = e1;
                if ("br" !== n) {
                    if ("wbr" !== n) {
                        if (r[n] && (o += " "), s[n]) o += " ";
                        else {
                            if (3 === e1.type && (o += e1.value), !(e1.name in t.getVoidElements())) {
                                let t = e1.firstChild;
                                if (t) do i(t);
                                while (t = t.next);
                            }
                            a[n] && l.next && (o += "\n", "p" === n && (o += "\n"));
                        }
                    }
                } else o += "\n";
            };
            return e1 = xA(e1, [
                /<!\[[^\]]+\]>/g
            ]), i(n.parse(e1)), o;
        })(s)), _A(s) || (o ? LA(e1, s, r) : DA(e1, s, a, r));
    }, jA = (e1, t, n)=>{
        ((e1, t, n)=>{
            let o;
            e1.on("keydown", (e1)=>{
                ((e1)=>wg.metaKeyPressed(e1) && 86 === e1.keyCode || e1.shiftKey && 45 === e1.keyCode)(e1) && !e1.isDefaultPrevented() && (o = e1.shiftKey && 86 === e1.keyCode);
            }), e1.on("paste", (r)=>{
                if (r.isDefaultPrevented() || ((e1)=>{
                    var t, n;
                    return nn.os.isAndroid() && 0 === (null === (n = null === (t = e1.clipboardData) || void 0 === t ? void 0 : t.items) || void 0 === n ? void 0 : n.length);
                })(r)) return;
                const s = "text" === n.get() || o;
                o = !1;
                const a = MA(r.clipboardData);
                !FA(a) && UA(e1, r, t.getLastRng() || e1.selection.getRng()) || (IA(a, "text/html") ? (r.preventDefault(), zA(e1, a, a["text/html"], s, !0)) : IA(a, "text/plain") && IA(a, "text/uri-list") ? (r.preventDefault(), zA(e1, a, a["text/plain"], s, !0)) : (t.create(), sg.setEditorTimeout(e1, ()=>{
                    const n = t.getHtml();
                    t.remove(), zA(e1, a, n, s, !1);
                }, 0)));
            });
        })(e1, t, n), ((e1)=>{
            const t = (e1)=>Ye(e1, "webkit-fake-url"), n = (e1)=>Ye(e1, "data:");
            e1.parser.addNodeFilter("img", (o, r, s)=>{
                if (!jc(e1) && ((e1)=>{
                    var t;
                    return !0 === (null === (t = e1.data) || void 0 === t ? void 0 : t.paste);
                })(s)) for (const r of o){
                    const o = r.attr("src");
                    m(o) && !r.attr("data-mce-object") && o !== nn.transparentSrc && (t(o) || !Zc(e1) && n(o)) && r.remove();
                }
            });
        })(e1);
    }, HA = (e1, t, n, o)=>{
        ((e1, t, n)=>{
            if (!e1) return !1;
            try {
                return e1.clearData(), e1.setData("text/html", t), e1.setData("text/plain", n), e1.setData(hA(), t), !0;
            } catch (e1) {
                return !1;
            }
        })(e1.clipboardData, t.html, t.text) ? (e1.preventDefault(), o()) : n(t.html, o);
    }, $A = (e1)=>(t, n)=>{
            const { dom: o, selection: r } = e1, s = o.create("div", {
                contenteditable: "false",
                "data-mce-bogus": "all"
            }), a = o.create("div", {
                contenteditable: "true"
            }, t);
            o.setStyles(s, {
                position: "fixed",
                top: "0",
                left: "-3000px",
                width: "1000px",
                overflow: "hidden"
            }), s.appendChild(a), o.add(e1.getBody(), s);
            const i = r.getRng();
            a.focus();
            const l = o.createRng();
            l.selectNodeContents(a), r.setRng(l), sg.setEditorTimeout(e1, ()=>{
                r.setRng(i), o.remove(s), n();
            }, 0);
        }, VA = (e1)=>({
            html: vA(e1.selection.getContent({
                contextual: !0
            })),
            text: e1.selection.getContent({
                format: "text"
            })
        }), qA = (e1)=>!e1.selection.isCollapsed() || ((e1)=>!!e1.dom.getParent(e1.selection.getStart(), "td[data-mce-selected],th[data-mce-selected]", e1.getBody()))(e1), WA = (e1, t)=>{
        var n, o;
        return Fg.getCaretRangeFromPoint(null !== (n = t.clientX) && void 0 !== n ? n : 0, null !== (o = t.clientY) && void 0 !== o ? o : 0, e1.getDoc());
    }, KA = (e1, t)=>{
        e1.focus(), t && e1.selection.setRng(t);
    }, YA = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi, GA = (e1)=>an.trim(e1).replace(YA, Ma).toLowerCase(), XA = (e1, t, n)=>{
        const o = qc(e1);
        if (n || "all" === o || !Wc(e1)) return t;
        const r = o ? o.split(/[, ]/) : [];
        if (r && "none" !== o) {
            const n = e1.dom, o = e1.selection.getNode();
            t = t.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, (e1, t, s, a)=>{
                const i = n.parseStyle(n.decode(s)), l = {};
                for(let e1 = 0; e1 < r.length; e1++){
                    const t = i[r[e1]];
                    let s = t, a = n.getStyle(o, r[e1], !0);
                    /color/.test(r[e1]) && (s = GA(s), a = GA(a)), a !== s && (l[r[e1]] = t);
                }
                const d = n.serializeStyle(l, "span");
                return d ? t + ' style="' + d + '"' + a : t + a;
            });
        } else t = t.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, "$1$3");
        return t = t.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, (e1, t, n, o)=>t + ' style="' + n + '"' + o), t;
    }, ZA = (e1)=>{
        const t = Ne(!1), n = Ne(Gc(e1) ? "text" : "html"), o = ((e1)=>{
            const t = Ne(null);
            return {
                create: ()=>((e1, t)=>{
                        const { dom: n, selection: o } = e1, r = e1.getBody();
                        t.set(o.getRng());
                        const s = n.add(e1.getBody(), "div", {
                            id: "mcepastebin",
                            class: "mce-pastebin",
                            contentEditable: !0,
                            "data-mce-bogus": "all",
                            style: "position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0"
                        }, CA);
                        nn.browser.isFirefox() && n.setStyle(s, "left", "rtl" === n.getStyle(r, "direction", !0) ? 65535 : -65535), n.bind(s, "beforedeactivate focusin focusout", (e1)=>{
                            e1.stopPropagation();
                        }), s.focus(), o.select(s, !0);
                    })(e1, t),
                remove: ()=>((e1, t)=>{
                        const n = e1.dom;
                        if (wA(e1)) {
                            let o;
                            const r = t.get();
                            for(; o = wA(e1);)n.remove(o), n.unbind(o);
                            r && e1.selection.setRng(r);
                        }
                        t.set(null);
                    })(e1, t),
                getEl: ()=>wA(e1),
                getHtml: ()=>((e1)=>{
                        const t = e1.dom, n = (e1, n)=>{
                            e1.appendChild(n), t.remove(n, !0);
                        }, [o, ...r] = Y(e1.getBody().childNodes, EA);
                        q(r, (e1)=>{
                            n(o, e1);
                        });
                        const s = t.select("div[id=mcepastebin]", o);
                        for(let e1 = s.length - 1; e1 >= 0; e1--){
                            const r = t.create("div");
                            o.insertBefore(r, s[e1]), n(r, s[e1]);
                        }
                        return o ? o.innerHTML : "";
                    })(e1),
                getLastRng: t.get
            };
        })(e1);
        ((e1)=>{
            (nn.browser.isChromium() || nn.browser.isSafari()) && ((e1, t)=>{
                e1.on("PastePreProcess", (n)=>{
                    n.content = t(e1, n.content, n.internal);
                });
            })(e1, XA);
        })(e1), ((e1, t)=>{
            e1.addCommand("mceTogglePlainTextPaste", ()=>{
                ((e1, t)=>{
                    "text" === t.get() ? (t.set("html"), gd(e1, !1)) : (t.set("text"), gd(e1, !0)), e1.focus();
                })(e1, t);
            }), e1.addCommand("mceInsertClipboardContent", (t, n)=>{
                n.html && DA(e1, n.html, n.internal, !1), n.text && LA(e1, n.text, !1);
            });
        })(e1, n), ((e1)=>{
            const t = (t)=>(n)=>{
                    t(e1, n);
                }, n = Hc(e1);
            w(n) && e1.on("PastePreProcess", t(n));
            const o = $c(e1);
            w(o) && e1.on("PastePostProcess", t(o));
        })(e1), e1.addQueryStateHandler("mceTogglePlainTextPaste", ()=>"text" === n.get()), e1.on("PreInit", ()=>{
            ((e1)=>{
                e1.on("cut", ((e1)=>(t)=>{
                        !t.isDefaultPrevented() && qA(e1) && e1.selection.isEditable() && HA(t, VA(e1), $A(e1), ()=>{
                            if (nn.browser.isChromium() || nn.browser.isFirefox()) {
                                const t = e1.selection.getRng();
                                sg.setEditorTimeout(e1, ()=>{
                                    e1.selection.setRng(t), e1.execCommand("Delete");
                                }, 0);
                            } else e1.execCommand("Delete");
                        });
                    })(e1)), e1.on("copy", ((e1)=>(t)=>{
                        !t.isDefaultPrevented() && qA(e1) && HA(t, VA(e1), $A(e1), x);
                    })(e1));
            })(e1), ((e1, t)=>{
                zc(e1) && e1.on("dragend dragover draggesture dragdrop drop drag", (e1)=>{
                    e1.preventDefault(), e1.stopPropagation();
                }), jc(e1) || e1.on("drop", (e1)=>{
                    const t = e1.dataTransfer;
                    t && ((e1)=>$(e1.files, (e1)=>/^image\//.test(e1.type)))(t) && e1.preventDefault();
                }), e1.on("drop", (n)=>{
                    if (n.isDefaultPrevented()) return;
                    const o = WA(e1, n);
                    if (y(o)) return;
                    const r = MA(n.dataTransfer), s = IA(r, hA());
                    if ((!FA(r) || ((e1)=>{
                        const t = e1["text/plain"];
                        return !!t && 0 === t.indexOf("file://");
                    })(r)) && UA(e1, n, o)) return;
                    const a = r[hA()], i = a || r["text/html"] || r["text/plain"], l = ((e1, t, n, o)=>{
                        const r = e1.getParent(n, (e1)=>js(t, e1));
                        if (!h(e1.getParent(n, "summary"))) return !0;
                        if (r && xe(o, "text/html")) {
                            const e1 = (new DOMParser).parseFromString(o["text/html"], "text/html").body;
                            return !h(e1.querySelector(r.nodeName.toLowerCase()));
                        }
                        return !1;
                    })(e1.dom, e1.schema, o.startContainer, r), d = t.get();
                    d && !l || i && (n.preventDefault(), sg.setEditorTimeout(e1, ()=>{
                        e1.undoManager.transact(()=>{
                            (a || d && l) && e1.execCommand("Delete"), KA(e1, o);
                            const t = SA(i);
                            r["text/html"] ? DA(e1, t, s, !0) : LA(e1, t, !0);
                        });
                    }));
                }), e1.on("dragstart", (e1)=>{
                    t.set(!0);
                }), e1.on("dragover dragend", (n)=>{
                    jc(e1) && !t.get() && (n.preventDefault(), KA(e1, WA(e1, n))), "dragend" === n.type && t.set(!1);
                }), ((e1)=>{
                    e1.on("input", (t)=>{
                        const n = (e1)=>h(e1.querySelector("summary"));
                        if ("deleteByDrag" === t.inputType) {
                            const t = Y(e1.dom.select("details"), n);
                            q(t, (t)=>{
                                as(t.firstChild) && t.firstChild.remove();
                                const n = e1.dom.create("summary");
                                n.appendChild(Oi().dom), t.prepend(n);
                            });
                        }
                    });
                })(e1);
            })(e1, t), jA(e1, o, n);
        });
    }, QA = as, JA = es, eT = (e1)=>cs(e1.dom), tT = (e1)=>(t)=>Cn(mn(e1), t), nT = (e1, t)=>tr(mn(e1), eT, tT(t)), oT = (e1, t, n)=>{
        const o = new Fr(e1, t), r = n ? o.next.bind(o) : o.prev.bind(o);
        let s = e1;
        for(let t = n ? e1 : r(); t && !QA(t); t = r())fl(t) && (s = t);
        return s;
    }, rT = (e1)=>{
        const t = ((e1, t, n)=>{
            const o = Pl.fromRangeStart(e1).getNode(), r = ((e1, t, n)=>tr(mn(e1), (e1)=>((e1)=>ds(e1.dom))(e1) || n.isBlock(_n(e1)), tT(t)).getOr(mn(t)).dom)(o, t, n), s = oT(o, r, !1), a = oT(o, r, !0), i = document.createRange();
            return nT(s, r).fold(()=>{
                JA(s) ? i.setStart(s, 0) : i.setStartBefore(s);
            }, (e1)=>i.setStartBefore(e1.dom)), nT(a, r).fold(()=>{
                JA(a) ? i.setEnd(a, a.data.length) : i.setEndAfter(a);
            }, (e1)=>i.setEndAfter(e1.dom)), i;
        })(e1.selection.getRng(), e1.getBody(), e1.schema);
        e1.selection.setRng(Hb(t));
    };
    var sT;
    !function(e1) {
        e1.Before = "before", e1.After = "after";
    }(sT || (sT = {}));
    const aT = (e1, t)=>Math.abs(e1.left - t), iT = (e1, t)=>Math.abs(e1.right - t), lT = (e1, t)=>((e1)=>X(e1, (e1, t)=>e1.fold(()=>I.some(t), (e1)=>{
                    const n = Math.min(t.left, e1.left), o = Math.min(t.top, e1.top), r = Math.max(t.right, e1.right), s = Math.max(t.bottom, e1.bottom);
                    return I.some({
                        top: o,
                        right: r,
                        bottom: s,
                        left: n,
                        width: r - n,
                        height: s - o
                    });
                }), I.none()))(Y(e1, (e1)=>{
            var n, o;
            return (n = t) >= (o = e1).top && n <= o.bottom;
        })).fold(()=>[
                [],
                e1
            ], (t)=>{
            const { pass: n, fail: o } = K(e1, (e1)=>((e1, t)=>{
                    const n = ((e1, t)=>Math.max(0, Math.min(e1.bottom, t.bottom) - Math.max(e1.top, t.top)))(e1, t) / Math.min(e1.height, t.height);
                    return ((e1, t)=>e1.top < t.bottom && e1.bottom > t.top)(e1, t) && n > .5;
                })(e1, t));
            return [
                n,
                o
            ];
        }), dT = (e1, t, n)=>t > e1.left && t < e1.right ? 0 : Math.min(Math.abs(e1.left - t), Math.abs(e1.right - t)), cT = (e1, t, n, o)=>{
        const r = (e1)=>fl(e1.node) ? I.some(e1) : qr(e1.node) ? cT(ce(e1.node.childNodes), t, n, !1) : I.none(), s = (e1, s)=>{
            const a = ae(e1, (e1, o)=>s(e1, t, n) - s(o, t, n));
            return ue(a, r).map((e1)=>o && !es(e1.node) && a.length > 1 ? ((e1, o, s)=>r(o).filter((o)=>Math.abs(s(e1, t, n) - s(o, t, n)) < 2 && es(o.node)))(e1, a[1], s).getOr(e1) : e1);
        }, [a, i] = lT(Rx(e1), n), { pass: l, fail: d } = K(i, (e1)=>e1.top < n);
        return s(a, dT).orThunk(()=>s(d, el)).orThunk(()=>s(l, el));
    }, uT = (e1, t, n)=>((e1, t, n)=>{
            const o = mn(e1), r = Pn(o), s = fn(r, t, n).filter((e1)=>wn(o, e1)).getOr(o);
            return ((e1, t, n, o)=>{
                const r = (t, s)=>{
                    const a = Y(t.dom.childNodes, O((e1)=>qr(e1) && e1.classList.contains("mce-drag-container")));
                    return s.fold(()=>cT(a, n, o, !0), (e1)=>{
                        const t = Y(a, (t)=>t !== e1.dom);
                        return cT(t, n, o, !0);
                    }).orThunk(()=>(Cn(t, e1) ? I.none() : Mn(t)).bind((e1)=>r(e1, I.some(t))));
                };
                return r(t, I.none());
            })(o, s, t, n);
        })(e1, t, n).filter((e1)=>Bu(e1.node)).map((e1)=>((e1, t)=>({
                    node: e1.node,
                    position: aT(e1, t) < iT(e1, t) ? sT.Before : sT.After
                }))(e1, t)), mT = (e1)=>{
        var t, n;
        const o = e1.getBoundingClientRect(), r = e1.ownerDocument, s = r.documentElement, a = r.defaultView;
        return {
            top: o.top + (null !== (t = null == a ? void 0 : a.scrollY) && void 0 !== t ? t : 0) - s.clientTop,
            left: o.left + (null !== (n = null == a ? void 0 : a.scrollX) && void 0 !== n ? n : 0) - s.clientLeft
        };
    }, fT = (e1)=>({
            target: e1,
            srcElement: e1
        }), gT = (e1, t, n, o)=>{
        const r = ((e1, t)=>{
            const n = ((e1)=>{
                const t = Ck(), n = ((e1)=>{
                    const t = e1;
                    return I.from(t[dk]);
                })(e1);
                return fk(e1), sk(t), t.dropEffect = e1.dropEffect, t.effectAllowed = e1.effectAllowed, ((e1)=>{
                    const t = e1;
                    return I.from(t[nk]);
                })(e1).each((e1)=>t.setDragImage(e1.image, e1.x, e1.y)), q(e1.types, (n)=>{
                    "Files" !== n && t.setData(n, e1.getData(n));
                }), q(e1.files, (e1)=>t.items.add(e1)), ((e1)=>{
                    const t = e1;
                    return I.from(t[ok]);
                })(e1).each((e1)=>{
                    ((e1, t)=>{
                        rk(t)(e1);
                    })(t, e1);
                }), n.each((n)=>{
                    uk(e1, n), uk(t, n);
                }), t;
            })(e1);
            return "dragstart" === t ? (sk(n), mk(n)) : "drop" === t ? (ak(n), fk(n)) : (ik(n), gk(n)), n;
        })(n, e1);
        return v(o) ? ((e1, t, n)=>{
            const o = B("Function not supported on simulated event.");
            return {
                bubbles: !0,
                cancelBubble: !1,
                cancelable: !0,
                composed: !1,
                currentTarget: null,
                defaultPrevented: !1,
                eventPhase: 0,
                isTrusted: !0,
                returnValue: !1,
                timeStamp: 0,
                type: e1,
                composedPath: o,
                initEvent: o,
                preventDefault: x,
                stopImmediatePropagation: x,
                stopPropagation: x,
                AT_TARGET: window.Event.AT_TARGET,
                BUBBLING_PHASE: window.Event.BUBBLING_PHASE,
                CAPTURING_PHASE: window.Event.CAPTURING_PHASE,
                NONE: window.Event.NONE,
                altKey: !1,
                button: 0,
                buttons: 0,
                clientX: 0,
                clientY: 0,
                ctrlKey: !1,
                layerX: 0,
                layerY: 0,
                metaKey: !1,
                movementX: 0,
                movementY: 0,
                offsetX: 0,
                offsetY: 0,
                pageX: 0,
                pageY: 0,
                relatedTarget: null,
                screenX: 0,
                screenY: 0,
                shiftKey: !1,
                x: 0,
                y: 0,
                detail: 0,
                view: null,
                which: 0,
                initUIEvent: o,
                initMouseEvent: o,
                getModifierState: o,
                dataTransfer: n,
                ...fT(t)
            };
        })(e1, t, r) : ((e1, t, n, o)=>({
                ...t,
                dataTransfer: o,
                type: e1,
                ...fT(n)
            }))(e1, o, t, r);
    }, pT = cs, hT = ((...e1)=>(t)=>{
            for(let n = 0; n < e1.length; n++)if (e1[n](t)) return !0;
            return !1;
        })(pT, ds), bT = (e1, t, n, o)=>{
        const r = e1.dom, s = t.cloneNode(!0);
        r.setStyles(s, {
            width: n,
            height: o
        }), r.setAttrib(s, "data-mce-selected", null);
        const a = r.create("div", {
            class: "mce-drag-container",
            "data-mce-bogus": "all",
            unselectable: "on",
            contenteditable: "false"
        });
        return r.setStyles(a, {
            position: "absolute",
            opacity: .5,
            overflow: "hidden",
            border: 0,
            padding: 0,
            margin: 0,
            width: n,
            height: o
        }), r.setStyles(s, {
            margin: 0,
            boxSizing: "border-box"
        }), a.appendChild(s), a;
    }, vT = (e1, t)=>(n)=>()=>{
                const o = "left" === e1 ? n.scrollX : n.scrollY;
                n.scroll({
                    [e1]: o + t,
                    behavior: "smooth"
                });
            }, yT = vT("left", -32), CT = vT("left", 32), wT = vT("top", -32), ET = vT("top", 32), _T = (e1)=>{
        e1 && e1.parentNode && e1.parentNode.removeChild(e1);
    }, xT = (e1, t, n, o, r)=>{
        "dragstart" === t && wk(o, e1.dom.getOuterHTML(n));
        const s = gT(t, n, o, r);
        return e1.dispatch(t, s);
    }, ST = (e1, t)=>{
        const n = ot((e1, n)=>((e1, t, n)=>{
                e1._selectionOverrides.hideFakeCaret(), uT(e1.getBody(), t, n).fold(()=>e1.selection.placeCaretAt(t, n), (o)=>{
                    const r = e1._selectionOverrides.showCaret(1, o.node, o.position === sT.Before, !1);
                    r ? e1.selection.setRng(r) : e1.selection.placeCaretAt(t, n);
                });
            })(t, e1, n), 0);
        t.on("remove", n.cancel);
        const o = e1;
        return (r)=>e1.on((e1)=>{
                const s = Math.max(Math.abs(r.screenX - e1.screenX), Math.abs(r.screenY - e1.screenY));
                if (!e1.dragging && s > 10) {
                    const n = xT(t, "dragstart", e1.element, e1.dataTransfer, r);
                    if (C(n.dataTransfer) && (e1.dataTransfer = n.dataTransfer), n.isDefaultPrevented()) return;
                    e1.dragging = !0, t.focus();
                }
                if (e1.dragging) {
                    const s = r.currentTarget === t.getDoc().documentElement, l = ((e1, t)=>({
                            pageX: t.pageX - e1.relX,
                            pageY: t.pageY + 5
                        }))(e1, ((e1, t)=>{
                        var n, o, r;
                        return n = ((e1)=>e1.inline ? mT(e1.getBody()) : {
                                left: 0,
                                top: 0
                            })(e1), o = ((e1)=>{
                            const t = e1.getBody();
                            return e1.inline ? {
                                left: t.scrollLeft,
                                top: t.scrollTop
                            } : {
                                left: 0,
                                top: 0
                            };
                        })(e1), r = ((e1, t)=>{
                            if (t.target.ownerDocument !== e1.getDoc()) {
                                const n = mT(e1.getContentAreaContainer()), o = ((e1)=>{
                                    const t = e1.getBody(), n = e1.getDoc().documentElement, o = {
                                        left: t.scrollLeft,
                                        top: t.scrollTop
                                    }, r = {
                                        left: t.scrollLeft || n.scrollLeft,
                                        top: t.scrollTop || n.scrollTop
                                    };
                                    return e1.inline ? o : r;
                                })(e1);
                                return {
                                    left: t.pageX - n.left + o.left,
                                    top: t.pageY - n.top + o.top
                                };
                            }
                            return {
                                left: t.pageX,
                                top: t.pageY
                            };
                        })(e1, t), {
                            pageX: r.left - n.left + o.left,
                            pageY: r.top - n.top + o.top
                        };
                    })(t, r));
                    a = e1.ghost, i = t.getBody(), a.parentNode !== i && i.appendChild(a), ((e1, t, n, o, r, s, a, i, l, d, c, u)=>{
                        let m = 0, f = 0;
                        e1.style.left = t.pageX + "px", e1.style.top = t.pageY + "px", t.pageX + n > r && (m = t.pageX + n - r), t.pageY + o > s && (f = t.pageY + o - s), e1.style.width = n - m + "px", e1.style.height = o - f + "px";
                        const g = l.clientHeight, p = l.clientWidth, h = a + l.getBoundingClientRect().top, b = i + l.getBoundingClientRect().left;
                        c.on((e1)=>{
                            e1.intervalId.clear(), e1.dragging && u && (a + 8 >= g ? e1.intervalId.set(ET(d)) : a - 8 <= 0 ? e1.intervalId.set(wT(d)) : i + 8 >= p ? e1.intervalId.set(CT(d)) : i - 8 <= 0 ? e1.intervalId.set(yT(d)) : h + 16 >= window.innerHeight ? e1.intervalId.set(ET(window)) : h - 16 <= 0 ? e1.intervalId.set(wT(window)) : b + 16 >= window.innerWidth ? e1.intervalId.set(CT(window)) : b - 16 <= 0 && e1.intervalId.set(yT(window)));
                        });
                    })(e1.ghost, l, e1.width, e1.height, e1.maxX, e1.maxY, r.clientY, r.clientX, t.getContentAreaContainer(), t.getWin(), o, s), n.throttle(r.clientX, r.clientY);
                }
                var a, i;
            });
    }, kT = (e1, t, n)=>{
        e1.on((e1)=>{
            e1.intervalId.clear(), e1.dragging && n.fold(()=>xT(t, "dragend", e1.element, e1.dataTransfer), (n)=>xT(t, "dragend", e1.element, e1.dataTransfer, n));
        }), NT(e1);
    }, NT = (e1)=>{
        e1.on((e1)=>{
            e1.intervalId.clear(), _T(e1.ghost);
        }), e1.clear();
    }, RT = (e1)=>{
        const t = Ve(), n = ni.DOM, o = document, r = ((e1, t)=>(n)=>{
                if (((e1)=>0 === e1.button)(n)) {
                    const o = Q(t.dom.getParents(n.target), hT).getOr(null);
                    if (C(o) && ((e1, t, n)=>pT(n) && n !== t && e1.isEditable(n.parentElement))(t.dom, t.getBody(), o)) {
                        const r = t.dom.getPos(o), s = t.getBody(), a = t.getDoc().documentElement;
                        e1.set({
                            element: o,
                            dataTransfer: Ck(),
                            dragging: !1,
                            screenX: n.screenX,
                            screenY: n.screenY,
                            maxX: (t.inline ? s.scrollWidth : a.offsetWidth) - 2,
                            maxY: (t.inline ? s.scrollHeight : a.offsetHeight) - 2,
                            relX: n.pageX - r.x,
                            relY: n.pageY - r.y,
                            width: o.offsetWidth,
                            height: o.offsetHeight,
                            ghost: bT(t, o, o.offsetWidth, o.offsetHeight),
                            intervalId: $e(100)
                        });
                    }
                }
            })(t, e1), s = ST(t, e1), a = ((e1, t)=>(n)=>{
                e1.on((e1)=>{
                    var o;
                    if (e1.intervalId.clear(), e1.dragging) {
                        if (((e1, t, n)=>!y(t) && t !== n && !e1.dom.isChildOf(t, n) && e1.dom.isEditable(t))(t, ((e1)=>{
                            const t = e1.getSel();
                            if (C(t)) {
                                const e1 = t.getRangeAt(0).startContainer;
                                return es(e1) ? e1.parentNode : e1;
                            }
                            return null;
                        })(t.selection), e1.element)) {
                            const r = null !== (o = t.getDoc().elementFromPoint(n.clientX, n.clientY)) && void 0 !== o ? o : t.getBody();
                            xT(t, "drop", r, e1.dataTransfer, n).isDefaultPrevented() || t.undoManager.transact(()=>{
                                ((e1, t)=>{
                                    const n = e1.getParent(t.parentNode, e1.isBlock);
                                    _T(t), n && n !== e1.getRoot() && e1.isEmpty(n) && Bi(mn(n));
                                })(t.dom, e1.element), ((e1)=>{
                                    const t = e1.getData("text/html");
                                    return "" === t ? I.none() : I.some(t);
                                })(e1.dataTransfer).each((e1)=>t.insertContent(e1)), t._selectionOverrides.hideFakeCaret();
                            });
                        }
                        xT(t, "dragend", t.getBody(), e1.dataTransfer, n);
                    }
                }), NT(e1);
            })(t, e1), i = ((e1, t)=>(n)=>kT(e1, t, I.some(n)))(t, e1);
        e1.on("mousedown", r), e1.on("mousemove", s), e1.on("mouseup", a), n.bind(o, "mousemove", s), n.bind(o, "mouseup", i), e1.on("remove", ()=>{
            n.unbind(o, "mousemove", s), n.unbind(o, "mouseup", i);
        }), e1.on("keydown", (n)=>{
            n.keyCode === wg.ESC && kT(t, e1, I.none());
        });
    }, AT = cs, TT = (e1, t)=>Nb(e1.getBody(), t), OT = (e1)=>{
        const t = e1.selection, n = e1.dom, o = e1.getBody(), r = Au(e1, o, n.isBlock, ()=>vg(e1)), s = "sel-" + n.uniqueId(), a = "data-mce-selected";
        let i;
        const l = (e1)=>e1 !== o && (AT(e1) || gs(e1)) && n.isChildOf(e1, o) && n.isEditable(e1.parentNode), d = (n, o, s, a = !0)=>e1.dispatch("ShowCaret", {
                target: o,
                direction: n,
                before: s
            }).isDefaultPrevented() ? null : (a && t.scrollIntoView(o, -1 === n), r.show(s, o)), c = (e1)=>zi(e1) || Vi(e1) || qi(e1), u = (e1)=>c(e1.startContainer) || c(e1.endContainer), m = (t)=>{
            const o = e1.schema.getVoidElements(), r = n.createRng(), s = t.startContainer, a = t.startOffset, i = t.endContainer, l = t.endOffset;
            return xe(o, s.nodeName.toLowerCase()) ? 0 === a ? r.setStartBefore(s) : r.setStartAfter(s) : r.setStart(s, a), xe(o, i.nodeName.toLowerCase()) ? 0 === l ? r.setEndBefore(i) : r.setEndAfter(i) : r.setEnd(i, l), r;
        }, f = (r, c)=>{
            if (!r) return null;
            if (r.collapsed) {
                if (!u(r)) {
                    const e1 = c ? 1 : -1, t = nm(e1, o, r), s = t.getNode(!c);
                    if (C(s)) {
                        if (Bu(s)) return d(e1, s, !!c && !t.isAtEnd(), !1);
                        if (Ui(s) && cs(s.nextSibling)) {
                            const e1 = n.createRng();
                            return e1.setStart(s, 0), e1.setEnd(s, 0), e1;
                        }
                    }
                    const a = t.getNode(c);
                    if (C(a)) {
                        if (Bu(a)) return d(e1, a, !c && !t.isAtEnd(), !1);
                        if (Ui(a) && cs(a.previousSibling)) {
                            const e1 = n.createRng();
                            return e1.setStart(a, 1), e1.setEnd(a, 1), e1;
                        }
                    }
                }
                return null;
            }
            let m = r.startContainer, f = r.startOffset;
            const g = r.endOffset;
            if (es(m) && 0 === f && AT(m.parentNode) && (m = m.parentNode, f = n.nodeIndex(m), m = m.parentNode), !qr(m)) return null;
            if (g === f + 1 && m === r.endContainer) {
                const o = m.childNodes[f];
                if (l(o)) return ((o)=>{
                    const r = o.cloneNode(!0), l = e1.dispatch("ObjectSelected", {
                        target: o,
                        targetClone: r
                    });
                    if (l.isDefaultPrevented()) return null;
                    const d = ((o, r)=>{
                        const a = mn(e1.getBody()), i = e1.getDoc(), l = rr(a, "#" + s).getOrThunk(()=>{
                            const e1 = dn('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>', i);
                            return go(e1, "id", s), co(a, e1), e1;
                        }), d = n.createRng();
                        wo(l), mo(l, [
                            un(it, i),
                            mn(r),
                            un(it, i)
                        ]), d.setStart(l.dom.firstChild, 1), d.setEnd(l.dom.lastChild, 0), Do(l, {
                            top: n.getPos(o, e1.getBody()).y + "px"
                        }), oo(l);
                        const c = t.getSel();
                        return c && (c.removeAllRanges(), c.addRange(d)), d;
                    })(o, l.targetClone), c = mn(o);
                    return q(vr(mn(e1.getBody()), `*[${a}]`), (e1)=>{
                        Cn(c, e1) || yo(e1, a);
                    }), n.getAttrib(o, a) || o.setAttribute(a, "1"), i = o, p(), d;
                })(o);
            }
            return null;
        }, g = ()=>{
            i && i.removeAttribute(a), rr(mn(e1.getBody()), "#" + s).each(Eo), i = null;
        }, p = ()=>{
            r.hide();
        };
        return Nw(e1) || (e1.on("click", (t)=>{
            n.isEditable(t.target) || (t.preventDefault(), e1.focus());
        }), e1.on("blur NewBlock", g), e1.on("ResizeWindow FullscreenStateChanged", r.reposition), e1.on("tap", (t)=>{
            const n = t.target, o = TT(e1, n);
            AT(o) ? (t.preventDefault(), m_(e1, o).each(f)) : l(n) && m_(e1, n).each(f);
        }, !0), e1.on("mousedown", (r)=>{
            const s = r.target;
            if (s !== o && "HTML" !== s.nodeName && !n.isChildOf(s, o)) return;
            if (!((e1, t, n)=>{
                const o = mn(e1.getBody()), r = e1.inline ? o : mn(Pn(o).dom.documentElement), s = ((e1, t, n, o)=>{
                    const r = ((e1)=>e1.dom.getBoundingClientRect())(t);
                    return {
                        x: n - (e1 ? r.left + t.dom.clientLeft + aE(t) : 0),
                        y: o - (e1 ? r.top + t.dom.clientTop + sE(t) : 0)
                    };
                })(e1.inline, r, t, n);
                return ((e1, t, n)=>{
                    const o = oE(e1), r = rE(e1);
                    return t >= 0 && n >= 0 && t <= o && n <= r;
                })(r, s.x, s.y);
            })(e1, r.clientX, r.clientY)) return;
            g(), p();
            const a = TT(e1, s);
            AT(a) ? (r.preventDefault(), m_(e1, a).each(f)) : uT(o, r.clientX, r.clientY).each((n)=>{
                var o;
                r.preventDefault(), (o = d(1, n.node, n.position === sT.Before, !1)) && t.setRng(o), Wr(a) ? a.focus() : e1.getBody().focus();
            });
        }), e1.on("keypress", (e1)=>{
            wg.modifierPressed(e1) || AT(t.getNode()) && e1.preventDefault();
        }), e1.on("GetSelectionRange", (e1)=>{
            let t = e1.range;
            if (i) {
                if (!i.parentNode) return void (i = null);
                t = t.cloneRange(), t.selectNode(i), e1.range = t;
            }
        }), e1.on("focusin", (t)=>{
            if (r.isShowing() && e1.getBody().contains(t.target) && t.target !== e1.getBody() && !e1.dom.isEditable(t.target.parentNode)) {
                r.hide(), t.target.contains(e1.selection.getNode()) || (e1.selection.select(t.target, !0), e1.selection.collapse(!0));
                const n = f(e1.selection.getRng(), !0);
                n && e1.selection.setRng(n);
            }
        }), e1.on("SetSelectionRange", (e1)=>{
            e1.range = m(e1.range);
            const t = f(e1.range, e1.forward);
            t && (e1.range = t);
        }), e1.on("AfterSetSelectionRange", (e1)=>{
            const t = e1.range, o = t.startContainer.parentElement;
            var r;
            u(t) || qr(r = o) && "mcepastebin" === r.id || p(), ((e1)=>C(e1) && n.hasClass(e1, "mce-offscreen-selection"))(o) || g();
        }), ((e1)=>{
            RT(e1), Ac(e1) && ((e1)=>{
                const t = (t)=>{
                    if (!t.isDefaultPrevented()) {
                        const n = t.dataTransfer;
                        n && (H(n.types, "Files") || n.files.length > 0) && (t.preventDefault(), "drop" === t.type && mE(e1, "Dropped file type is not supported"));
                    }
                }, n = (n)=>{
                    mg(e1, n.target) && t(n);
                }, o = ()=>{
                    const o = ni.DOM, r = e1.dom, s = document, a = e1.inline ? e1.getBody() : e1.getDoc(), i = [
                        "drop",
                        "dragover"
                    ];
                    q(i, (e1)=>{
                        o.bind(s, e1, n), r.bind(a, e1, t);
                    }), e1.on("remove", ()=>{
                        q(i, (e1)=>{
                            o.unbind(s, e1, n), r.unbind(a, e1, t);
                        });
                    });
                };
                e1.on("init", ()=>{
                    sg.setEditorTimeout(e1, o, 0);
                });
            })(e1);
        })(e1), ((e1)=>{
            const t = ot(()=>{
                if (!e1.removed && e1.getBody().contains(document.activeElement)) {
                    const t = e1.selection.getRng();
                    if (t.collapsed) {
                        const n = f_(e1, t, !1);
                        e1.selection.setRng(n);
                    }
                }
            }, 0);
            e1.on("focus", ()=>{
                t.throttle();
            }), e1.on("blur", ()=>{
                t.cancel();
            });
        })(e1), ((e1)=>{
            e1.on("init", ()=>{
                e1.on("focusin", (t)=>{
                    const n = t.target;
                    if (gs(n)) {
                        const t = Nb(e1.getBody(), n), o = cs(t) ? t : n;
                        e1.selection.getNode() !== o && m_(e1, o).each((t)=>e1.selection.setRng(t));
                    }
                });
            });
        })(e1)), {
            showCaret: d,
            showBlockCaretContainer: (e1)=>{
                e1.hasAttribute("data-mce-caret") && (Wi(e1), t.scrollIntoView(e1));
            },
            hideFakeCaret: p,
            destroy: ()=>{
                r.destroy(), i = null;
            }
        };
    }, BT = (e1, t)=>{
        let n = t;
        for(let t = e1.previousSibling; es(t); t = t.previousSibling)n += t.data.length;
        return n;
    }, PT = (e1, t, n, o, r)=>{
        if (es(n) && (o < 0 || o > n.data.length)) return [];
        const s = r && es(n) ? [
            BT(n, o)
        ] : [
            o
        ];
        let a = n;
        for(; a !== t && a.parentNode;)s.push(e1.nodeIndex(a, r)), a = a.parentNode;
        return a === t ? s.reverse() : [];
    }, DT = (e1, t, n, o, r, s, a = !1)=>({
            start: PT(e1, t, n, o, a),
            end: PT(e1, t, r, s, a)
        }), LT = (e1, t)=>{
        const n = t.slice(), o = n.pop();
        return E(o) ? X(n, (e1, t)=>e1.bind((e1)=>I.from(e1.childNodes[t])), I.some(e1)).bind((e1)=>es(e1) && (o < 0 || o > e1.data.length) ? I.none() : I.some({
                node: e1,
                offset: o
            })) : I.none();
    }, MT = (e1, t)=>LT(e1, t.start).bind(({ node: n, offset: o })=>LT(e1, t.end).map(({ node: e1, offset: t })=>{
                const r = document.createRange();
                return r.setStart(n, o), r.setEnd(e1, t), r;
            })), IT = (e1, t, n)=>{
        if (t && e1.isEmpty(t) && !n(t)) {
            const o = t.parentNode;
            e1.remove(t, es(t.firstChild) && zr(t.firstChild.data)), IT(e1, o, n);
        }
    }, FT = (e1, t, n, o = !0)=>{
        const r = t.startContainer.parentNode, s = t.endContainer.parentNode;
        t.deleteContents(), o && !n(t.startContainer) && (es(t.startContainer) && 0 === t.startContainer.data.length && e1.remove(t.startContainer), es(t.endContainer) && 0 === t.endContainer.data.length && e1.remove(t.endContainer), IT(e1, r, n), r !== s && IT(e1, s, n));
    }, UT = (e1, t)=>I.from(e1.dom.getParent(t.startContainer, e1.dom.isBlock)), zT = (e1, t, n)=>{
        const o = e1.dynamicPatternsLookup({
            text: n,
            block: t
        });
        return {
            ...e1,
            blockPatterns: rd(o).concat(e1.blockPatterns),
            inlinePatterns: sd(o).concat(e1.inlinePatterns)
        };
    }, jT = (e1, t, n, o)=>{
        const r = e1.createRng();
        return r.setStart(t, 0), r.setEnd(n, o), r.toString();
    }, HT = (e1, t)=>e1.create("span", {
            "data-mce-type": "bookmark",
            id: t
        }), $T = (e1, t)=>{
        const n = e1.createRng();
        return n.setStartAfter(t.start), n.setEndBefore(t.end), n;
    }, VT = (e1, t, n)=>{
        const o = MT(e1.getRoot(), n).getOrDie("Unable to resolve path range"), r = o.startContainer, s = o.endContainer, a = 0 === o.endOffset ? s : s.splitText(o.endOffset), i = 0 === o.startOffset ? r : r.splitText(o.startOffset), l = i.parentNode;
        return {
            prefix: t,
            end: a.parentNode.insertBefore(HT(e1, t + "-end"), a),
            start: l.insertBefore(HT(e1, t + "-start"), i)
        };
    }, qT = (e1, t, n)=>{
        IT(e1, e1.get(t.prefix + "-end"), n), IT(e1, e1.get(t.prefix + "-start"), n);
    }, WT = (e1)=>0 === e1.start.length, KT = (e1, t, n, o)=>{
        const r = t.start;
        var s;
        return Kk(e1, o.container, o.offset, (s = r, (e1, t)=>{
            const n = e1.data.substring(0, t), o = n.lastIndexOf(s.charAt(s.length - 1)), r = n.lastIndexOf(s);
            return -1 !== r ? r + s.length : -1 !== o ? o + 1 : -1;
        }), n).bind((o)=>{
            var s, a;
            const i = null !== (a = null === (s = n.textContent) || void 0 === s ? void 0 : s.indexOf(r)) && void 0 !== a ? a : -1;
            if (-1 !== i && o.offset >= i + r.length) {
                const t = e1.createRng();
                return t.setStart(o.container, o.offset - r.length), t.setEnd(o.container, o.offset), I.some(t);
            }
            {
                const s = o.offset - r.length;
                return qk(o.container, s, n).map((t)=>{
                    const n = e1.createRng();
                    return n.setStart(t.container, t.offset), n.setEnd(o.container, o.offset), n;
                }).filter((e1)=>e1.toString() === r).orThunk(()=>KT(e1, t, n, jk(o.container, 0)));
            }
        });
    }, YT = (e1, t, n, o)=>{
        const r = e1.dom, s = r.getRoot(), a = n.pattern, i = n.position.container, l = n.position.offset;
        return qk(i, l - n.pattern.end.length, t).bind((d)=>{
            const c = DT(r, s, d.container, d.offset, i, l, o);
            if (WT(a)) return I.some({
                matches: [
                    {
                        pattern: a,
                        startRng: c,
                        endRng: c
                    }
                ],
                position: d
            });
            {
                const i = GT(e1, n.remainingPatterns, d.container, d.offset, t, o), l = i.getOr({
                    matches: [],
                    position: d
                }), u = l.position, m = ((e1, t, n, o, r, s = !1)=>{
                    if (0 === t.start.length && !s) {
                        const t = e1.createRng();
                        return t.setStart(n, o), t.setEnd(n, o), I.some(t);
                    }
                    return Vk(n, o, r).bind((n)=>KT(e1, t, r, n).bind((e1)=>{
                            var t;
                            if (s) {
                                if (e1.endContainer === n.container && e1.endOffset === n.offset) return I.none();
                                if (0 === n.offset && (null === (t = e1.endContainer.textContent) || void 0 === t ? void 0 : t.length) === e1.endOffset) return I.none();
                            }
                            return I.some(e1);
                        }));
                })(r, a, u.container, u.offset, t, i.isNone());
                return m.map((e1)=>{
                    const t = ((e1, t, n, o = !1)=>DT(e1, t, n.startContainer, n.startOffset, n.endContainer, n.endOffset, o))(r, s, e1, o);
                    return {
                        matches: l.matches.concat([
                            {
                                pattern: a,
                                startRng: t,
                                endRng: c
                            }
                        ]),
                        position: jk(e1.startContainer, e1.startOffset)
                    };
                });
            }
        });
    }, GT = (e1, t, n, o, r, s)=>{
        const a = e1.dom;
        return Vk(n, o, a.getRoot()).bind((i)=>{
            const l = jT(a, r, n, o);
            for(let a = 0; a < t.length; a++){
                const d = t[a];
                if (!Ge(l, d.end)) continue;
                const c = t.slice();
                c.splice(a, 1);
                const u = YT(e1, r, {
                    pattern: d,
                    remainingPatterns: c,
                    position: i
                }, s);
                if (u.isNone() && o > 0) return GT(e1, t, n, o - 1, r, s);
                if (u.isSome()) return u;
            }
            return I.none();
        });
    }, XT = (e1, t, n)=>{
        e1.selection.setRng(n), "inline-format" === t.type ? q(t.format, (t)=>{
            e1.formatter.apply(t);
        }) : e1.execCommand(t.cmd, !1, t.value);
    }, ZT = (e1, t, n, o, r, s)=>{
        var a;
        return ((e1, t)=>{
            const n = ne(e1, (e1)=>$(t, (t)=>e1.pattern.start === t.pattern.start && e1.pattern.end === t.pattern.end));
            return e1.length === t.length ? n ? e1 : t : e1.length > t.length ? e1 : t;
        })(GT(e1, r.inlinePatterns, n, o, t, s).fold(()=>[], (e1)=>e1.matches), GT(e1, (a = r.inlinePatterns, ae(a, (e1, t)=>t.end.length - e1.end.length)), n, o, t, s).fold(()=>[], (e1)=>e1.matches));
    }, QT = (e1, t)=>{
        if (0 === t.length) return;
        const n = e1.dom, o = e1.selection.getBookmark(), r = ((e1, t)=>{
            const n = De("mce_textpattern"), o = G(t, (t, o)=>{
                const r = VT(e1, n + `_end${t.length}`, o.endRng);
                return t.concat([
                    {
                        ...o,
                        endMarker: r
                    }
                ]);
            }, []);
            return G(o, (t, r)=>{
                const s = o.length - t.length - 1, a = WT(r.pattern) ? r.endMarker : VT(e1, n + `_start${s}`, r.startRng);
                return t.concat([
                    {
                        ...r,
                        startMarker: a
                    }
                ]);
            }, []);
        })(n, t);
        q(r, (t)=>{
            const o = n.getParent(t.startMarker.start, n.isBlock), r = (e1)=>e1 === o;
            WT(t.pattern) ? ((e1, t, n, o)=>{
                const r = $T(e1.dom, n);
                FT(e1.dom, r, o), XT(e1, t, r);
            })(e1, t.pattern, t.endMarker, r) : ((e1, t, n, o, r)=>{
                const s = e1.dom, a = $T(s, o), i = $T(s, n);
                FT(s, i, r), FT(s, a, r);
                const l = {
                    prefix: n.prefix,
                    start: n.end,
                    end: o.start
                }, d = $T(s, l);
                XT(e1, t, d);
            })(e1, t.pattern, t.startMarker, t.endMarker, r), qT(n, t.endMarker, r), qT(n, t.startMarker, r);
        }), e1.selection.moveToBookmark(o);
    }, JT = (e1, t, n)=>((e1, t, n)=>{
            if (es(e1) && 0 >= e1.length) return I.some(jk(e1, 0));
            {
                const t = Ei(Hk);
                return I.from(t.forwards(e1, 0, $k(e1), n)).map((e1)=>jk(e1.container, 0));
            }
        })(t, 0, t).map((o)=>{
            const r = o.container;
            return Wk(r, n.start.length, t).each((n)=>{
                const o = e1.createRng();
                o.setStart(r, 0), o.setEnd(n.container, n.offset), FT(e1, o, (e1)=>e1 === t);
            }), r;
        }), eO = (e1)=>(t, n)=>{
            const o = t.dom, r = n.pattern, s = MT(o.getRoot(), n.range).getOrDie("Unable to resolve path range");
            return UT(t, s).each((n)=>{
                "block-format" === r.type ? ((e1, t)=>{
                    const n = t.get(e1);
                    return p(n) && le(n).exists((e1)=>xe(e1, "block"));
                })(r.format, t.formatter) && t.undoManager.transact(()=>{
                    e1(t.dom, n, r), t.formatter.apply(r.format);
                }) : "block-command" === r.type && t.undoManager.transact(()=>{
                    e1(t.dom, n, r), t.execCommand(r.cmd, !1, r.value);
                });
            }), !0;
        }, tO = (e1)=>(t, n)=>{
            const o = ((e1)=>ae(e1, (e1, t)=>t.start.length - e1.start.length))(t), r = n.replace(it, " ");
            return Q(o, (t)=>e1(t, n, r));
        }, nO = (e1, t)=>(n, o, r, s, a)=>{
            var i;
            void 0 === a && (a = null !== (i = o.textContent) && void 0 !== i ? i : "");
            const l = n.dom, d = Ad(n);
            return l.is(o, d) ? e1(r.blockPatterns, a).map((e1)=>t && an.trim(a).length === e1.start.length ? [] : [
                    {
                        pattern: e1,
                        range: DT(l, l.getRoot(), o, 0, o, 0, s)
                    }
                ]).getOr([]) : [];
        }, oO = eO((e1, t, n)=>{
        JT(e1, t, n).each((e1)=>{
            const t = mn(e1), n = Xo(t);
            /^\s[^\s]/.test(n) && Zo(t, n.slice(1));
        });
    }), rO = tO((e1, t, n)=>0 === t.indexOf(e1.start) || 0 === n.indexOf(e1.start)), sO = nO(rO, !0), aO = eO(JT), iO = tO((e1, t, n)=>t === e1.start || n === e1.start), lO = nO(iO, !1), dO = (e1, t, n)=>{
        for(let o = 0; o < e1.length; o++)if (n(e1[o], t)) return !0;
        return !1;
    }, cO = (e1)=>{
        const t = [
            ",",
            ".",
            ";",
            ":",
            "!",
            "?"
        ], n = [
            32
        ], o = ()=>{
            var t, n;
            return t = Qc(e1).filter((t)=>"inline-command" !== t.type && "block-command" !== t.type || e1.queryCommandSupported(t.cmd)), n = Jc(e1), {
                inlinePatterns: sd(t),
                blockPatterns: rd(t),
                dynamicPatternsLookup: n
            };
        }, r = ()=>((e1)=>e1.options.isSet("text_patterns_lookup"))(e1);
        e1.on("keydown", (t)=>{
            if (13 === t.keyCode && !wg.modifierPressed(t) && e1.selection.isCollapsed() && e1.selection.isEditable()) {
                const n = ad(o(), "enter");
                (n.inlinePatterns.length > 0 || n.blockPatterns.length > 0 || r()) && ((e1, t)=>((e1, t)=>{
                        const n = e1.selection.getRng();
                        return UT(e1, n).map((o)=>{
                            var r;
                            const s = Math.max(0, n.startOffset), a = zT(t, o, null !== (r = o.textContent) && void 0 !== r ? r : "");
                            return {
                                inlineMatches: ZT(e1, o, n.startContainer, s, a, !0),
                                blockMatches: sO(e1, o, a, !0)
                            };
                        }).filter(({ inlineMatches: e1, blockMatches: t })=>t.length > 0 || e1.length > 0);
                    })(e1, t).fold(L, ({ inlineMatches: t, blockMatches: n })=>(e1.undoManager.add(), e1.undoManager.extra(()=>{
                            e1.execCommand("mceInsertNewLine");
                        }, ()=>{
                            ((e1)=>{
                                e1.insertContent(Pi, {
                                    preserve_zwsp: !0
                                });
                            })(e1), QT(e1, t), ((e1, t)=>{
                                if (0 === t.length) return;
                                const n = e1.selection.getBookmark();
                                q(t, (t)=>oO(e1, t)), e1.selection.moveToBookmark(n);
                            })(e1, n);
                            const o = e1.selection.getRng(), r = Vk(o.startContainer, o.startOffset, e1.dom.getRoot());
                            e1.execCommand("mceInsertNewLine"), r.each((t)=>{
                                const n = t.container;
                                n.data.charAt(t.offset - 1) === at && (n.deleteData(t.offset - 1, 1), IT(e1.dom, n.parentNode, (t)=>t === e1.dom.getRoot()));
                            });
                        }), !0)))(e1, n) && t.preventDefault();
            }
        }, !0), e1.on("keydown", (t)=>{
            if (32 === t.keyCode && e1.selection.isCollapsed() && e1.selection.isEditable()) {
                const n = ad(o(), "space");
                (n.blockPatterns.length > 0 || r()) && ((e1, t)=>((e1, t)=>{
                        const n = e1.selection.getRng();
                        return UT(e1, n).map((o)=>{
                            const r = Math.max(0, n.startOffset), s = jT(e1.dom, o, n.startContainer, r), a = zT(t, o, s);
                            return lO(e1, o, a, !1, s);
                        }).filter((e1)=>e1.length > 0);
                    })(e1, t).fold(L, (t)=>(e1.undoManager.transact(()=>{
                            ((e1, t)=>{
                                q(t, (t)=>aO(e1, t));
                            })(e1, t);
                        }), !0)))(e1, n) && t.preventDefault();
            }
        }, !0);
        const s = ()=>{
            if (e1.selection.isCollapsed() && e1.selection.isEditable()) {
                const t = ad(o(), "space");
                (t.inlinePatterns.length > 0 || r()) && ((e1, t)=>{
                    const n = e1.selection.getRng();
                    UT(e1, n).map((o)=>{
                        const r = Math.max(0, n.startOffset - 1), s = jT(e1.dom, o, n.startContainer, r), a = zT(t, o, s), i = ZT(e1, o, n.startContainer, r, a, !1);
                        i.length > 0 && e1.undoManager.transact(()=>{
                            QT(e1, i);
                        });
                    });
                })(e1, t);
            }
        };
        e1.on("keyup", (e1)=>{
            dO(n, e1, (e1, t)=>e1 === t.keyCode && !wg.modifierPressed(t)) && s();
        }), e1.on("keypress", (n)=>{
            dO(t, n, (e1, t)=>e1.charCodeAt(0) === t.charCode) && sg.setEditorTimeout(e1, s);
        });
    }, uO = (e1)=>{
        const t = an.each, n = wg.BACKSPACE, o = wg.DELETE, r = e1.dom, s = e1.selection, a = e1.parser, i = nn.browser, l = i.isFirefox(), d = i.isChromium() || i.isSafari(), c = nn.deviceType.isiPhone() || nn.deviceType.isiPad(), u = nn.os.isMacOS() || nn.os.isiOS(), m = (t, n)=>{
            try {
                e1.getDoc().execCommand(t, !1, String(n));
            } catch (e1) {}
        }, f = (e1)=>e1.isDefaultPrevented(), g = ()=>{
            e1.shortcuts.add("meta+a", null, "SelectAll");
        }, p = ()=>{
            e1.inline || r.bind(e1.getDoc(), "mousedown mouseup", (t)=>{
                let n;
                if (t.target === e1.getDoc().documentElement) {
                    if (n = s.getRng(), e1.getBody().focus(), "mousedown" === t.type) {
                        if (zi(n.startContainer)) return;
                        s.placeCaretAt(t.clientX, t.clientY);
                    } else s.setRng(n);
                }
            });
        }, h = ()=>{
            Range.prototype.getClientRects || e1.on("mousedown", (t)=>{
                if (!f(t) && "HTML" === t.target.nodeName) {
                    const t = e1.getBody();
                    t.blur(), sg.setEditorTimeout(e1, ()=>{
                        t.focus();
                    });
                }
            });
        }, b = ()=>{
            const t = Bc(e1);
            e1.on("click", (n)=>{
                const o = n.target;
                /^(IMG|HR)$/.test(o.nodeName) && r.isEditable(o) && (n.preventDefault(), e1.selection.select(o), e1.nodeChanged()), "A" === o.nodeName && r.hasClass(o, t) && 0 === o.childNodes.length && r.isEditable(o.parentNode) && (n.preventDefault(), s.select(o));
            });
        }, v = ()=>{
            e1.on("keydown", (e1)=>{
                if (!f(e1) && e1.keyCode === n && s.isCollapsed() && 0 === s.getRng().startOffset) {
                    const t = s.getNode().previousSibling;
                    if (t && t.nodeName && "table" === t.nodeName.toLowerCase()) return e1.preventDefault(), !1;
                }
                return !0;
            });
        }, y = ()=>{
            xc(e1) || e1.on("BeforeExecCommand mousedown", ()=>{
                m("StyleWithCSS", !1), m("enableInlineTableEditing", !1), nc(e1) || m("enableObjectResizing", !1);
            });
        }, C = ()=>{
            e1.contentStyles.push("img:-moz-broken {-moz-force-broken-image-icon:1;min-width:24px;min-height:24px}");
        }, w = ()=>{
            e1.inline || e1.on("keydown", ()=>{
                document.activeElement === document.body && e1.getWin().focus();
            });
        }, E = ()=>{
            e1.inline || (e1.contentStyles.push("body {min-height: 150px}"), e1.on("click", (t)=>{
                let n;
                "HTML" === t.target.nodeName && (n = e1.selection.getRng(), e1.getBody().focus(), e1.selection.setRng(n), e1.selection.normalize(), e1.nodeChanged());
            }));
        }, _ = ()=>{
            u && e1.on("keydown", (t)=>{
                !wg.metaKeyPressed(t) || t.shiftKey || 37 !== t.keyCode && 39 !== t.keyCode || (t.preventDefault(), e1.selection.getSel().modify("move", 37 === t.keyCode ? "backward" : "forward", "lineboundary"));
            });
        }, S = ()=>{
            e1.on("click", (e1)=>{
                let t = e1.target;
                do {
                    if ("A" === t.tagName) return void e1.preventDefault();
                }while (t = t.parentNode);
            }), e1.contentStyles.push(".mce-content-body {-webkit-touch-callout: none}");
        }, k = ()=>{
            e1.on("init", ()=>{
                e1.dom.bind(e1.getBody(), "submit", (e1)=>{
                    e1.preventDefault();
                });
            });
        }, N = x;
        return Nw(e1) ? (d && (p(), b(), k(), g(), c && (w(), E(), S())), l && (h(), y(), C(), _())) : (e1.on("keydown", (t)=>{
            if (f(t) || t.keyCode !== wg.BACKSPACE) return;
            let n = s.getRng();
            const o = n.startContainer, a = n.startOffset, i = r.getRoot();
            let l = o;
            if (n.collapsed && 0 === a) {
                for(; l.parentNode && l.parentNode.firstChild === l && l.parentNode !== i;)l = l.parentNode;
                "BLOCKQUOTE" === l.nodeName && (e1.formatter.toggle("blockquote", void 0, l), n = r.createRng(), n.setStart(o, 0), n.setEnd(o, 0), s.setRng(n));
            }
        }), (()=>{
            const t = (e1)=>{
                const t = r.create("body"), n = e1.cloneContents();
                return t.appendChild(n), s.serializer.serialize(t, {
                    format: "html"
                });
            };
            e1.on("keydown", (s)=>{
                const a = s.keyCode;
                if (!f(s) && (a === o || a === n) && e1.selection.isEditable()) {
                    const n = e1.selection.isCollapsed(), o = e1.getBody();
                    if (n && !Es(e1.schema, o)) return;
                    if (!n && !((n)=>{
                        const o = t(n), s = r.createRng();
                        return s.selectNode(e1.getBody()), o === t(s);
                    })(e1.selection.getRng())) return;
                    s.preventDefault(), e1.setContent(""), o.firstChild && r.isBlock(o.firstChild) ? e1.selection.setCursorLocation(o.firstChild, 0) : e1.selection.setCursorLocation(o, 0), e1.nodeChanged();
                }
            });
        })(), nn.windowsPhone || e1.on("keyup focusin mouseup", (t)=>{
            wg.modifierPressed(t) || ((e1)=>{
                const t = e1.getBody(), n = e1.selection.getRng();
                return n.startContainer === n.endContainer && n.startContainer === t && 0 === n.startOffset && n.endOffset === t.childNodes.length;
            })(e1) || s.normalize();
        }, !0), d && (p(), b(), e1.on("init", ()=>{
            m("DefaultParagraphSeparator", Ad(e1));
        }), k(), v(), a.addNodeFilter("br", (e1)=>{
            let t = e1.length;
            for(; t--;)"Apple-interchange-newline" === e1[t].attr("class") && e1[t].remove();
        }), c ? (w(), E(), S()) : g()), l && (e1.on("mousedown", (t)=>{
            ze(I.from(t.clientX), I.from(t.clientY), (n, o)=>{
                const r = e1.getDoc().caretPositionFromPoint(n, o), s = (null == r ? void 0 : r.offsetNode.childNodes[r.offset - (r.offset > 0 ? 1 : 0)]) || (null == r ? void 0 : r.offsetNode);
                if (s && "IMG" === (a = s).nodeName && e1.dom.isEditable(a)) {
                    const n = s.getBoundingClientRect();
                    t.preventDefault(), e1.hasFocus() || e1.focus(), e1.selection.select(s), t.clientX < n.left || t.clientY < n.top ? e1.selection.collapse(!0) : (t.clientX > n.right || t.clientY > n.bottom) && e1.selection.collapse(!1);
                }
                var a;
            });
        }), e1.on("keydown", (t)=>{
            if (!f(t) && t.keyCode === n) {
                if (!e1.getBody().getElementsByTagName("hr").length) return;
                if (s.isCollapsed() && 0 === s.getRng().startOffset) {
                    const e1 = s.getNode(), n = e1.previousSibling;
                    if ("HR" === e1.nodeName) return r.remove(e1), void t.preventDefault();
                    n && n.nodeName && "hr" === n.nodeName.toLowerCase() && (r.remove(n), t.preventDefault());
                }
            }
        }), h(), (()=>{
            const n = ()=>{
                const n = r.getAttribs(s.getStart().cloneNode(!1));
                return ()=>{
                    const o = s.getStart();
                    o !== e1.getBody() && (r.setAttrib(o, "style", null), t(n, (e1)=>{
                        o.setAttributeNode(e1.cloneNode(!0));
                    }));
                };
            }, o = ()=>!s.isCollapsed() && r.getParent(s.getStart(), r.isBlock) !== r.getParent(s.getEnd(), r.isBlock);
            e1.on("keypress", (t)=>{
                let r;
                return !(!(f(t) || 8 !== t.keyCode && 46 !== t.keyCode) && o() && (r = n(), e1.getDoc().execCommand("delete", !1), r(), t.preventDefault(), 1));
            }), r.bind(e1.getDoc(), "cut", (t)=>{
                if (!f(t) && o()) {
                    const t = n();
                    sg.setEditorTimeout(e1, ()=>{
                        t();
                    });
                }
            });
        })(), y(), e1.on("SetContent ExecCommand", (e1)=>{
            "setcontent" !== e1.type && "mceInsertLink" !== e1.command || t(r.select("a:not([data-mce-block])"), (e1)=>{
                var t;
                let n = e1.parentNode;
                const o = r.getRoot();
                if ((null == n ? void 0 : n.lastChild) === e1) {
                    for(; n && !r.isBlock(n);){
                        if ((null === (t = n.parentNode) || void 0 === t ? void 0 : t.lastChild) !== n || n === o) return;
                        n = n.parentNode;
                    }
                    r.add(n, "br", {
                        "data-mce-bogus": 1
                    });
                }
            });
        }), C(), _(), v())), {
            refreshContentEditable: N,
            isHidden: ()=>{
                if (!l || e1.removed) return !1;
                const t = e1.selection.getSel();
                return !t || !t.rangeCount || 0 === t.rangeCount;
            }
        };
    }, mO = ni.DOM, fO = (e1)=>e1.inline ? e1.getElement().nodeName.toLowerCase() : void 0, gO = (e1)=>Ce(e1, (e1)=>!1 === v(e1)), pO = (e1)=>{
        const t = e1.options.get, n = e1.editorUpload.blobCache;
        return gO({
            allow_conditional_comments: t("allow_conditional_comments"),
            allow_html_data_urls: t("allow_html_data_urls"),
            allow_svg_data_urls: t("allow_svg_data_urls"),
            allow_html_in_named_anchor: t("allow_html_in_named_anchor"),
            allow_script_urls: t("allow_script_urls"),
            allow_html_in_comments: t("allow_html_in_comments"),
            allow_mathml_annotation_encodings: t("allow_mathml_annotation_encodings"),
            allow_unsafe_link_target: t("allow_unsafe_link_target"),
            convert_unsafe_embeds: t("convert_unsafe_embeds"),
            convert_fonts_to_spans: t("convert_fonts_to_spans"),
            extended_mathml_attributes: t("extended_mathml_attributes"),
            extended_mathml_elements: t("extended_mathml_elements"),
            fix_list_elements: t("fix_list_elements"),
            font_size_legacy_values: t("font_size_legacy_values"),
            forced_root_block: t("forced_root_block"),
            forced_root_block_attrs: t("forced_root_block_attrs"),
            preserve_cdata: t("preserve_cdata"),
            inline_styles: t("inline_styles"),
            root_name: fO(e1),
            sandbox_iframes: t("sandbox_iframes"),
            sandbox_iframes_exclusions: mu(e1),
            sanitize: t("xss_sanitization"),
            validate: !0,
            blob_cache: n,
            document: e1.getDoc()
        });
    }, hO = (e1)=>{
        const t = e1.options.get;
        return gO({
            custom_elements: t("custom_elements"),
            extended_valid_elements: t("extended_valid_elements"),
            invalid_elements: t("invalid_elements"),
            invalid_styles: t("invalid_styles"),
            schema: t("schema"),
            valid_children: t("valid_children"),
            valid_classes: t("valid_classes"),
            valid_elements: t("valid_elements"),
            valid_styles: t("valid_styles"),
            verify_html: t("verify_html"),
            padd_empty_block_inline_children: t("format_empty_lines")
        });
    }, bO = (e1)=>e1.inline ? e1.ui.styleSheetLoader : e1.dom.styleSheetLoader, vO = (e1)=>{
        const t = bO(e1), n = Jd(e1), o = e1.contentCSS, r = ()=>{
            t.unloadAll(o), e1.inline || e1.ui.styleSheetLoader.unloadAll(n);
        }, s = ()=>{
            e1.removed ? r() : e1.on("remove", r);
        };
        if (e1.contentStyles.length > 0) {
            let t = "";
            an.each(e1.contentStyles, (e1)=>{
                t += e1 + "\r\n";
            }), e1.dom.addStyle(t);
        }
        const a = Promise.all(((e1, t, n)=>{
            const { pass: o, fail: r } = K(t, (e1)=>tinymce.Resource.has(SE(e1))), s = o.map((t)=>{
                const n = tinymce.Resource.get(SE(t));
                return m(n) ? Promise.resolve(bO(e1).loadRawCss(t, n)) : Promise.resolve();
            }), a = [
                ...s,
                bO(e1).loadAll(r)
            ];
            return e1.inline ? a : a.concat([
                e1.ui.styleSheetLoader.loadAll(n)
            ]);
        })(e1, o, n)).then(s).catch(s), i = Qd(e1);
        return i && ((e1, t)=>{
            const n = mn(e1.getBody()), o = Gn(Yn(n)), r = cn("style");
            go(r, "type", "text/css"), co(r, un(t)), co(o, r), e1.on("remove", ()=>{
                Eo(r);
            });
        })(e1, i), a;
    }, yO = (e1)=>{
        !0 !== e1.removed && (((e1)=>{
            Nw(e1) || e1.load({
                initial: !0,
                format: "html"
            }), e1.startContent = e1.getContent({
                format: "raw"
            });
        })(e1), ((e1)=>{
            e1.bindPendingEventDelegates(), e1.initialized = !0, ((e1)=>{
                e1.dispatch("Init");
            })(e1), e1.focus(!0), ((e1)=>{
                const t = e1.dom.getRoot();
                e1.inline || tf(e1) && e1.selection.getStart(!0) !== t || km(t).each((t)=>{
                    const n = t.getNode(), o = Zr(n) ? km(n).getOr(t) : t;
                    e1.selection.setRng(o.toRange());
                });
            })(e1), e1.nodeChanged({
                initial: !0
            });
            const t = Lc(e1);
            w(t) && t.call(e1, e1), ((e1)=>{
                const t = Ic(e1);
                t && sg.setEditorTimeout(e1, ()=>{
                    let n;
                    n = !0 === t ? e1 : e1.editorManager.get(t), n && !n.destroyed && (n.focus(), n.selection.scrollIntoView());
                }, 100);
            })(e1), CE(e1) && EE(e1, !0);
        })(e1));
    }, CO = (e1)=>{
        const t = e1.getElement();
        let n = e1.getDoc();
        e1.inline && (mO.addClass(t, "mce-content-body"), e1.contentDocument = n = document, e1.contentWindow = window, e1.bodyElement = t, e1.contentAreaContainer = t);
        const o = e1.getBody();
        o.disabled = !0, e1.readonly = xc(e1), e1._editableRoot = Sc(e1), !hu(e1) && e1.hasEditableRoot() && (e1.inline && "static" === mO.getStyle(o, "position", !0) && (o.style.position = "relative"), o.contentEditable = "true"), o.disabled = !1, e1.editorUpload = PE(e1), e1.schema = Ra(hO(e1)), e1.dom = ni(n, {
            keep_values: !0,
            url_converter: e1.convertURL,
            url_converter_scope: e1,
            update_styles: !0,
            root_element: e1.inline ? e1.getBody() : null,
            collect: e1.inline,
            schema: e1.schema,
            contentCssCors: qd(e1),
            referrerPolicy: Wd(e1),
            onSetAttrib: (t)=>{
                e1.dispatch("SetAttrib", t);
            }
        }), e1.parser = ((e1)=>{
            const t = KC(pO(e1), e1.schema);
            return t.addAttributeFilter("data-mce-src,data-mce-href,data-mce-style", (e1, t)=>{
                for(let n = 0; n < e1.length; n++)e1[n].attr(t, null);
            }), t.addAttributeFilter("src,href,style,tabindex", (t, n)=>{
                const o = e1.dom, r = "data-mce-" + n;
                let s = t.length;
                for(; s--;){
                    const a = t[s];
                    let i = a.attr(n);
                    if (i && !a.attr(r)) {
                        if (0 === i.indexOf("data:") || 0 === i.indexOf("blob:")) continue;
                        "style" === n ? (i = o.serializeStyle(o.parseStyle(i), a.name), i.length || (i = null), a.attr(r, i), a.attr(n, i)) : "tabindex" === n ? (a.attr(r, i), a.attr(n, null)) : a.attr(r, e1.convertURL(i, n, a.name));
                    }
                }
            }), t.addNodeFilter("script", (e1)=>{
                let t = e1.length;
                for(; t--;){
                    const n = e1[t], o = n.attr("type") || "no/type";
                    0 !== o.indexOf("mce-") && n.attr("type", "mce-" + o);
                }
            }), ou(e1) && t.addNodeFilter("#cdata", (t)=>{
                var n;
                let o = t.length;
                for(; o--;){
                    const r = t[o];
                    r.type = 8, r.name = "#comment", r.value = "[CDATA[" + e1.dom.encode(null !== (n = r.value) && void 0 !== n ? n : "") + "]]";
                }
            }), t.addNodeFilter("p,h1,h2,h3,h4,h5,h6,div", (t)=>{
                let n = t.length;
                const o = e1.schema.getNonEmptyElements();
                for(; n--;){
                    const e1 = t[n];
                    e1.isEmpty(o) && 0 === e1.getAll("br").length && e1.append(new up("br", 1));
                }
            }), t;
        })(e1), e1.serializer = Fw(((e1)=>{
            const t = e1.options.get;
            return {
                ...pO(e1),
                ...hO(e1),
                ...gO({
                    remove_trailing_brs: t("remove_trailing_brs"),
                    pad_empty_with_br: t("pad_empty_with_br"),
                    url_converter: t("url_converter"),
                    url_converter_scope: t("url_converter_scope"),
                    element_format: t("element_format"),
                    entities: t("entities"),
                    entity_encoding: t("entity_encoding"),
                    indent: t("indent"),
                    indent_after: t("indent_after"),
                    indent_before: t("indent_before")
                })
            };
        })(e1), e1), e1.selection = Lw(e1.dom, e1.getWin(), e1.serializer, e1), e1.annotator = Kf(e1), e1.formatter = VE(e1), e1.undoManager = WE(e1), e1._nodeChangeDispatcher = new gA(e1), e1._selectionOverrides = OT(e1), ((e1)=>{
            const t = Ve(), n = Ne(!1), o = rt((t)=>{
                e1.dispatch("longpress", {
                    ...t,
                    type: "longpress"
                }), n.set(!0);
            }, 400);
            e1.on("touchstart", (e1)=>{
                ES(e1).each((r)=>{
                    o.cancel();
                    const s = {
                        x: r.clientX,
                        y: r.clientY,
                        target: e1.target
                    };
                    o.throttle(e1), n.set(!1), t.set(s);
                });
            }, !0), e1.on("touchmove", (r)=>{
                o.cancel(), ES(r).each((o)=>{
                    t.on((r)=>{
                        ((e1, t)=>{
                            const n = Math.abs(e1.clientX - t.x), o = Math.abs(e1.clientY - t.y);
                            return n > 5 || o > 5;
                        })(o, r) && (t.clear(), n.set(!1), e1.dispatch("longpresscancel"));
                    });
                });
            }, !0), e1.on("touchend touchcancel", (r)=>{
                o.cancel(), "touchcancel" !== r.type && t.get().filter((e1)=>e1.target.isEqualNode(r.target)).each(()=>{
                    n.get() ? r.preventDefault() : e1.dispatch("tap", {
                        ...r,
                        type: "tap"
                    });
                });
            }, !0);
        })(e1), ((e1)=>{
            ((e1)=>{
                e1.on("click", (t)=>{
                    e1.dom.getParent(t.target, "details") && t.preventDefault();
                });
            })(e1), ((e1)=>{
                e1.parser.addNodeFilter("details", (t)=>{
                    const n = du(e1);
                    q(t, (e1)=>{
                        "expanded" === n ? e1.attr("open", "open") : "collapsed" === n && e1.attr("open", null);
                    });
                }), e1.serializer.addNodeFilter("details", (t)=>{
                    const n = cu(e1);
                    q(t, (e1)=>{
                        "expanded" === n ? e1.attr("open", "open") : "collapsed" === n && e1.attr("open", null);
                    });
                });
            })(e1);
        })(e1), ((e1)=>{
            const t = "contenteditable", n = " " + an.trim(tu(e1)) + " ", o = " " + an.trim(eu(e1)) + " ", r = RS(n), s = RS(o), a = nu(e1);
            a.length > 0 && e1.on("BeforeSetContent", (t)=>{
                ((e1, t, n)=>{
                    let o = t.length, r = n.content;
                    if ("raw" !== n.format) {
                        for(; o--;)r = r.replace(t[o], AS(e1, r, eu(e1)));
                        n.content = r;
                    }
                })(e1, a, t);
            }), e1.parser.addAttributeFilter("class", (e1)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    r(o) ? o.attr(t, "true") : s(o) && o.attr(t, "false");
                }
            }), e1.serializer.addAttributeFilter(t, (e1)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    if (!r(o) && !s(o)) continue;
                    const i = o.attr("data-mce-content");
                    a.length > 0 && i ? TS(a, i) ? (o.name = "#text", o.type = 3, o.raw = !0, o.value = i) : o.remove() : o.attr(t, null);
                }
            });
        })(e1), Nw(e1) || (((e1)=>{
            e1.on("mousedown", (t)=>{
                t.detail >= 3 && (t.preventDefault(), rT(e1));
            });
        })(e1), ((e1)=>{
            cO(e1);
        })(e1));
        const r = fA(e1);
        ((e1, t)=>{
            e1.addCommand("delete", ()=>{
                ((e1, t)=>{
                    wS(e1, t, !1).fold(()=>{
                        e1.selection.isEditable() && (Kh(e1), Zh(e1));
                    }, D);
                })(e1, t);
            }), e1.addCommand("forwardDelete", ()=>{
                ((e1, t)=>{
                    wS(e1, t, !0).fold(()=>{
                        e1.selection.isEditable() && Yh(e1);
                    }, D);
                })(e1, t);
            });
        })(e1, r), ((e1)=>{
            e1.on("NodeChange", ()=>((e1)=>{
                    const t = e1.dom, n = e1.selection, o = e1.schema, r = o.getBlockElements(), s = n.getStart(), a = e1.getBody();
                    let i, l, d = null;
                    const c = Ad(e1);
                    if (!s || !qr(s)) return;
                    const u = a.nodeName.toLowerCase();
                    if (!o.isValidChild(u, c.toLowerCase()) || ((e1, t, n)=>$(Zp(mn(n), mn(t)), (t)=>_S(e1, t.dom)))(r, a, s)) return;
                    if (a.firstChild === a.lastChild && as(a.firstChild)) return i = kS(e1), i.appendChild(Oi().dom), a.replaceChild(i, a.firstChild), e1.selection.setCursorLocation(i, 0), void e1.nodeChanged();
                    let m = a.firstChild;
                    for(; m;)if (qr(m) && Is(o, m), xS(o, m)) {
                        if (SS(r, m)) {
                            l = m, m = m.nextSibling, t.remove(l);
                            continue;
                        }
                        if (!i) {
                            if (!d && e1.hasFocus() && (d = R_(e1.selection.getRng(), ()=>document.createElement("span"))), !m.parentNode) {
                                m = null;
                                break;
                            }
                            i = kS(e1), a.insertBefore(i, m);
                        }
                        l = m, m = m.nextSibling, i.appendChild(l);
                    } else i = null, m = m.nextSibling;
                    d && (e1.selection.setRng(A_(d)), e1.nodeChanged());
                })(e1));
        })(e1), ((e1)=>{
            var t;
            const n = e1.dom, o = Ad(e1), r = null !== (t = rc(e1)) && void 0 !== t ? t : "", s = (t, a)=>{
                if (((e1)=>{
                    if (GE(e1)) {
                        const t = e1.keyCode;
                        return !XE(e1) && (wg.metaKeyPressed(e1) || e1.altKey || t >= 112 && t <= 123 || H(KE, t));
                    }
                    return !1;
                })(t)) return;
                const i = e1.getBody(), l = !((e1)=>GE(e1) && !(XE(e1) || "keyup" === e1.type && 229 === e1.keyCode))(t) && ((e1, t, n)=>{
                    if (e1.isEmpty(t, void 0, {
                        skipBogus: !1,
                        includeZwsp: !0
                    })) {
                        const o = t.firstElementChild;
                        return !o || !e1.getStyle(t.firstElementChild, "padding-left") && !e1.getStyle(t.firstElementChild, "padding-right") && n === o.nodeName.toLowerCase();
                    }
                    return !1;
                })(n, i, o);
                ("" !== n.getAttrib(i, YE) !== l || a) && (n.setAttrib(i, YE, l ? r : null), ((e1, t)=>{
                    e1.dispatch("PlaceholderToggle", {
                        state: t
                    });
                })(e1, l), e1.on(l ? "keydown" : "keyup", s), e1.off(l ? "keyup" : "keydown", s));
            };
            et(r) && e1.on("init", (t)=>{
                s(t, !0), e1.on("change SetContent ExecCommand", s), e1.on("paste", (t)=>sg.setEditorTimeout(e1, ()=>s(t)));
            });
        })(e1), ZA(e1);
        const s = ((e1)=>{
            const t = e1;
            return ((e1)=>_e(e1.plugins, "rtc").bind((e1)=>I.from(e1.setup)))(e1).fold(()=>(t.rtcInstance = kw(e1), I.none()), (e1)=>(t.rtcInstance = (()=>{
                    const e1 = N(null), t = N("");
                    return {
                        init: {
                            bindEvents: x
                        },
                        undoManager: {
                            beforeChange: x,
                            add: e1,
                            undo: e1,
                            redo: e1,
                            clear: x,
                            reset: x,
                            hasUndo: L,
                            hasRedo: L,
                            transact: e1,
                            ignore: x,
                            extra: x
                        },
                        formatter: {
                            match: L,
                            matchAll: N([]),
                            matchNode: N(void 0),
                            canApply: L,
                            closest: t,
                            apply: x,
                            remove: x,
                            toggle: x,
                            formatChanged: N({
                                unbind: x
                            })
                        },
                        editor: {
                            getContent: t,
                            setContent: N({
                                content: "",
                                html: ""
                            }),
                            insertContent: N(""),
                            addVisual: x
                        },
                        selection: {
                            getContent: t
                        },
                        autocompleter: {
                            addDecoration: x,
                            removeDecoration: x
                        },
                        raw: {
                            getModel: N(I.none())
                        }
                    };
                })(), I.some(()=>e1().then((e1)=>(t.rtcInstance = ((e1)=>{
                            const t = (e1)=>f(e1) ? e1 : {}, { init: n, undoManager: o, formatter: r, editor: s, selection: a, autocompleter: i, raw: l } = e1;
                            return {
                                init: {
                                    bindEvents: n.bindEvents
                                },
                                undoManager: {
                                    beforeChange: o.beforeChange,
                                    add: o.add,
                                    undo: o.undo,
                                    redo: o.redo,
                                    clear: o.clear,
                                    reset: o.reset,
                                    hasUndo: o.hasUndo,
                                    hasRedo: o.hasRedo,
                                    transact: (e1, t, n)=>o.transact(n),
                                    ignore: (e1, t)=>o.ignore(t),
                                    extra: (e1, t, n, r)=>o.extra(n, r)
                                },
                                formatter: {
                                    match: (e1, n, o, s)=>r.match(e1, t(n), s),
                                    matchAll: r.matchAll,
                                    matchNode: r.matchNode,
                                    canApply: (e1)=>r.canApply(e1),
                                    closest: (e1)=>r.closest(e1),
                                    apply: (e1, n, o)=>r.apply(e1, t(n)),
                                    remove: (e1, n, o, s)=>r.remove(e1, t(n)),
                                    toggle: (e1, n, o)=>r.toggle(e1, t(n)),
                                    formatChanged: (e1, t, n, o, s)=>r.formatChanged(t, n, o, s)
                                },
                                editor: {
                                    getContent: (e1)=>s.getContent(e1),
                                    setContent: (e1, t)=>({
                                            content: s.setContent(e1, t),
                                            html: ""
                                        }),
                                    insertContent: (e1, t)=>(s.insertContent(e1), ""),
                                    addVisual: s.addVisual
                                },
                                selection: {
                                    getContent: (e1, t)=>a.getContent(t)
                                },
                                autocompleter: {
                                    addDecoration: i.addDecoration,
                                    removeDecoration: i.removeDecoration
                                },
                                raw: {
                                    getModel: ()=>I.some(l.getRawModel())
                                }
                            };
                        })(e1), e1.rtc.isRemote)))));
        })(e1);
        ((e1)=>{
            const t = e1.getDoc(), n = e1.getBody();
            ((e1)=>{
                e1.dispatch("PreInit");
            })(e1), Fc(e1) || (t.body.spellcheck = !1, mO.setAttrib(n, "spellcheck", "false")), e1.quirks = uO(e1), ((e1)=>{
                e1.dispatch("PostRender");
            })(e1);
            const o = ec(e1);
            void 0 !== o && (n.dir = o);
            const r = Uc(e1);
            r && ((e1, t)=>{
                ((e1, t)=>{
                    e1.on("BeforeSetContent", (e1)=>{
                        q(t, (t)=>{
                            e1.content = e1.content.replace(t, (e1)=>"\x3c!--mce:protected " + escape(e1) + "--\x3e");
                        });
                    });
                })(e1, t), ((e1, t)=>{
                    e1.serializer.addNodeFilter("#comment", (e1)=>{
                        let n = e1.length;
                        for(; n--;){
                            const o = e1[n], r = o.value;
                            if (0 === (null == r ? void 0 : r.indexOf("mce:protected "))) {
                                const e1 = unescape(r).substr(14);
                                $(t, (t)=>{
                                    const n = e1.match(t);
                                    return null !== n && n[0].length === e1.length;
                                }) ? (o.name = "#text", o.type = 3, o.raw = !0, o.value = e1) : o.remove();
                            }
                        }
                    });
                })(e1, t);
            })(e1, r), e1.on("SetContent", ()=>{
                e1.addVisual(e1.getBody());
            }), e1.on("compositionstart compositionend", (t)=>{
                e1.composing = "compositionstart" === t.type;
            });
        })(e1), ((e1)=>{
            const t = gu(e1);
            var n;
            m(pu(e1)) || !v(t) && "INVALID" != (((e1)=>"gpl" === e1.toLowerCase())(n = t) || ((e1)=>e1.length >= 64 && e1.length <= 255)(n) ? "VALID" : "INVALID") || console.warn("TinyMCE is running in evaluation mode. Provide a valid license key or add license_key: 'gpl' to the init config to agree to the open source license terms. Read more at https://www.tiny.cloud/license-key/");
        })(e1), s.fold(()=>{
            const t = ((e1)=>{
                let t = !1;
                const n = setTimeout(()=>{
                    t || e1.setProgressState(!0);
                }, 500);
                return ()=>{
                    clearTimeout(n), t = !0, e1.setProgressState(!1);
                };
            })(e1);
            vO(e1).then(()=>{
                yO(e1), t();
            });
        }, (t)=>{
            e1.setProgressState(!0), vO(e1).then(()=>{
                t().then((t)=>{
                    e1.setProgressState(!1), yO(e1), Tw(e1);
                }, (t)=>{
                    e1.notificationManager.open({
                        type: "error",
                        text: String(t)
                    }), yO(e1), Tw(e1);
                });
            });
        });
    }, wO = ni.DOM, EO = ni.DOM, _O = (e1, t)=>({
            editorContainer: e1,
            iframeContainer: t,
            api: {}
        }), xO = (e1)=>{
        const t = e1.getElement();
        return e1.inline ? _O(null) : ((e1)=>{
            const t = EO.create("div");
            return EO.insertAfter(t, e1), _O(t, t);
        })(t);
    }, SO = async (e1)=>{
        e1.dispatch("ScriptsLoaded"), ((e1)=>{
            const t = an.trim(Ud(e1)), n = e1.ui.registry.getAll().icons, o = {
                ...Jw.get("default").icons,
                ...Jw.get(t).icons
            };
            pe(o, (t, o)=>{
                xe(n, o) || e1.ui.registry.addIcon(o, t);
            });
        })(e1), ((e1)=>{
            const t = ic(e1);
            if (m(t)) {
                const n = dE.get(t);
                e1.theme = n(e1, dE.urls[t]) || {}, w(e1.theme.init) && e1.theme.init(e1, dE.urls[t] || e1.documentBaseUrl.replace(/\/$/, ""));
            } else e1.theme = {};
        })(e1), ((e1)=>{
            const t = dc(e1), n = eE.get(t);
            e1.model = n(e1, eE.urls[t]);
        })(e1), ((e1)=>{
            const t = [];
            q(Nc(e1), (n)=>{
                ((e1, t, n)=>{
                    const o = lE.get(n), r = lE.urls[n] || e1.documentBaseUrl.replace(/\/$/, "");
                    if (n = an.trim(n), o && -1 === an.inArray(t, n)) {
                        if (e1.plugins[n]) return;
                        try {
                            const s = o(e1, r) || {};
                            e1.plugins[n] = s, w(s.init) && (s.init(e1, r), t.push(n));
                        } catch (t) {
                            ((e1, t, n)=>{
                                const o = li.translate([
                                    "Failed to initialize plugin: {0}",
                                    t
                                ]);
                                ld(e1, "PluginLoadError", {
                                    message: o
                                }), pE(o, n), mE(e1, o);
                            })(e1, n, t);
                        }
                    }
                })(e1, t, ((e1)=>e1.replace(/^\-/, ""))(n));
            });
        })(e1);
        const t = await ((e1)=>{
            const t = e1.getElement();
            return e1.orgDisplay = t.style.display, m(ic(e1)) ? ((e1)=>{
                const t = e1.theme.renderUI;
                return t ? t() : xO(e1);
            })(e1) : w(ic(e1)) ? ((e1)=>{
                const t = e1.getElement(), n = ic(e1)(e1, t);
                return n.editorContainer.nodeType && (n.editorContainer.id = n.editorContainer.id || e1.id + "_parent"), n.iframeContainer && n.iframeContainer.nodeType && (n.iframeContainer.id = n.iframeContainer.id || e1.id + "_iframecontainer"), n.height = n.iframeHeight ? n.iframeHeight : t.offsetHeight, n;
            })(e1) : xO(e1);
        })(e1);
        ((e1, t)=>{
            const n = {
                show: I.from(t.show).getOr(x),
                hide: I.from(t.hide).getOr(x),
                isEnabled: I.from(t.isEnabled).getOr(M),
                setEnabled: (n)=>{
                    n && ("readonly" === e1.mode.get() || CE(e1)) || I.from(t.setEnabled).each((e1)=>e1(n));
                }
            };
            e1.ui = {
                ...e1.ui,
                ...n
            };
        })(e1, I.from(t.api).getOr({})), e1.editorContainer = t.editorContainer, ((e1)=>{
            e1.contentCSS = e1.contentCSS.concat(((e1)=>kE(e1, Zd(e1)))(e1), ((e1)=>kE(e1, Jd(e1)))(e1));
        })(e1), e1.inline ? CO(e1) : ((e1, t)=>{
            ((e1, t)=>{
                const n = nn.browser.isFirefox() ? Pc(e1) : "Rich Text Area", o = e1.translate(n), r = bo(mn(e1.getElement()), "tabindex").bind(nt), s = ((e1, t, n, o)=>{
                    const r = cn("iframe");
                    return o.each((e1)=>go(r, "tabindex", e1)), po(r, n), po(r, {
                        id: e1 + "_ifr",
                        frameBorder: "0",
                        allowTransparency: "true",
                        title: t
                    }), cr(r, "tox-edit-area__iframe"), r;
                })(e1.id, o, Ed(e1), r).dom;
                s.onload = ()=>{
                    s.onload = null, e1.dispatch("load");
                }, e1.contentAreaContainer = t.iframeContainer, e1.iframeElement = s, e1.iframeHTML = ((e1)=>{
                    let t = _d(e1) + "<html><head>";
                    xd(e1) !== e1.documentBaseUrl && (t += '<base href="' + e1.documentBaseURI.getURI() + '" />'), t += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
                    const n = Sd(e1), o = kd(e1), r = e1.translate(Pc(e1));
                    return Nd(e1) && (t += '<meta http-equiv="Content-Security-Policy" content="' + Nd(e1) + '" />'), t += `</head><body id="${n}" class="mce-content-body ${o}" data-id="${e1.id}" aria-label="${r}"><br></body></html>`, t;
                })(e1), wO.add(t.iframeContainer, s);
            })(e1, t), t.editorContainer && (t.editorContainer.style.display = e1.orgDisplay, e1.hidden = wO.isHidden(t.editorContainer)), e1.getElement().style.display = "none", wO.setAttrib(e1.id, "aria-hidden", "true"), e1.getElement().style.visibility = e1.orgVisibility, ((e1)=>{
                const t = e1.iframeElement, n = ()=>{
                    e1.contentDocument = t.contentDocument, CO(e1);
                };
                if (au(e1) || nn.browser.isFirefox()) {
                    const t = e1.getDoc();
                    t.open(), t.write(e1.iframeHTML), t.close(), n();
                } else {
                    const r = (o = mn(t), Jn(o, "load", to, ()=>{
                        r.unbind(), n();
                    }));
                    t.srcdoc = e1.iframeHTML;
                }
                var o;
            })(e1);
        })(e1, {
            editorContainer: t.editorContainer,
            iframeContainer: t.iframeContainer
        });
    }, kO = ni.DOM, NO = (e1)=>"-" === e1.charAt(0), RO = (e1, t, n)=>I.from(t).filter((e1)=>et(e1) && !Jw.has(e1)).map((t)=>({
                url: `${e1.editorManager.baseURL}/icons/${t}/icons${n}.js`,
                name: I.some(t)
            })), AO = (e1, t)=>{
        const n = ri.ScriptLoader, o = ()=>{
            !e1.removed && ((e1)=>{
                const t = ic(e1);
                return !m(t) || C(dE.get(t));
            })(e1) && ((e1)=>{
                const t = dc(e1);
                return C(eE.get(t));
            })(e1) && SO(e1);
        };
        ((e1, t)=>{
            const n = ic(e1);
            if (m(n) && !NO(n) && !xe(dE.urls, n)) {
                const o = lc(e1), r = o ? e1.documentBaseURI.toAbsolute(o) : `themes/${n}/theme${t}.js`;
                dE.load(n, r).catch(()=>{
                    ((e1, t, n)=>{
                        fE(e1, "ThemeLoadError", gE("theme", t, n));
                    })(e1, r, n);
                });
            }
        })(e1, t), ((e1, t)=>{
            const n = dc(e1);
            if ("plugin" !== n && !xe(eE.urls, n)) {
                const o = cc(e1), r = m(o) ? e1.documentBaseURI.toAbsolute(o) : `models/${n}/model${t}.js`;
                eE.load(n, r).catch(()=>{
                    ((e1, t, n)=>{
                        fE(e1, "ModelLoadError", gE("model", t, n));
                    })(e1, r, n);
                });
            }
        })(e1, t), ((e1, t)=>{
            const n = Kd(t), o = Yd(t);
            if (!li.hasCode(n) && "en" !== n) {
                const r = et(o) ? o : `${t.editorManager.baseURL}/langs/${n}.js`;
                e1.add(r).catch(()=>{
                    ((e1, t, n)=>{
                        fE(e1, "LanguageLoadError", gE("language", t, n));
                    })(t, r, n);
                });
            }
        })(n, e1), ((e1, t, n)=>{
            const o = RO(t, "default", n), r = ((e1)=>I.from(zd(e1)).filter(et).map((e1)=>({
                        url: e1,
                        name: I.none()
                    })))(t).orThunk(()=>RO(t, Ud(t), ""));
            q(((e1)=>{
                const t = [], n = (e1)=>{
                    t.push(e1);
                };
                for(let t = 0; t < e1.length; t++)e1[t].each(n);
                return t;
            })([
                o,
                r
            ]), (n)=>{
                e1.add(n.url).catch(()=>{
                    ((e1, t, n)=>{
                        fE(e1, "IconsLoadError", gE("icons", t, n));
                    })(t, n.url, n.name.getOrUndefined());
                });
            });
        })(n, e1, t), ((e1, t)=>{
            const n = (t, n)=>{
                lE.load(t, n).catch(()=>{
                    ((e1, t, n)=>{
                        fE(e1, "PluginLoadError", gE("plugin", t, n));
                    })(e1, n, t);
                });
            };
            pe(Rc(e1), (t, o)=>{
                n(o, t), e1.options.set("plugins", Nc(e1).concat(o));
            }), q(Nc(e1), (e1)=>{
                !(e1 = an.trim(e1)) || lE.urls[e1] || NO(e1) || n(e1, `plugins/${e1}/plugin${t}.js`);
            });
        })(e1, t), n.loadQueue().then(o, o);
    }, TO = Kt().deviceType, OO = TO.isPhone(), BO = TO.isTablet(), PO = (e1)=>{
        if (y(e1)) return [];
        {
            const t = p(e1) ? e1 : e1.split(/[ ,]/), n = V(t, Ze);
            return Y(n, et);
        }
    }, DO = (e1, t)=>{
        const n = ((t)=>{
            const n = {}, o = {};
            return ye(t, (t, n)=>H(e1, n), ve(n), ve(o)), {
                t: n,
                f: o
            };
        })(t);
        var o, r;
        return o = n.t, r = n.f, {
            sections: N(o),
            options: N(r)
        };
    }, LO = (e1, t)=>xe(e1.sections(), t), MO = (e1, t)=>({
            table_grid: !1,
            object_resizing: !1,
            resize: !1,
            toolbar_mode: _e(e1, "toolbar_mode").getOr("scrolling"),
            toolbar_sticky: !1,
            ...t ? {
                menubar: !1
            } : {}
        }), IO = (e1, t)=>{
        var n;
        const o = null !== (n = t.external_plugins) && void 0 !== n ? n : {};
        return e1 && e1.external_plugins ? an.extend({}, e1.external_plugins, o) : o;
    }, FO = (e1, t, n, o, r)=>{
        var s;
        const a = e1 ? {
            mobile: MO(null !== (s = r.mobile) && void 0 !== s ? s : {}, t)
        } : {}, i = DO([
            "mobile"
        ], Me(a, r)), l = an.extend(n, o, i.options(), ((e1, t)=>e1 && LO(t, "mobile"))(e1, i) ? ((e1, t, n = {})=>{
            const o = e1.sections(), r = _e(o, t).getOr({});
            return an.extend({}, n, r);
        })(i, "mobile") : {}, {
            external_plugins: IO(o, i.options())
        });
        return ((e1, t, n, o)=>{
            const r = PO(n.forced_plugins), s = PO(o.plugins), a = ((e1, t)=>LO(e1, t) ? e1.sections()[t] : {})(t, "mobile"), i = ((e1, t, n, o)=>e1 && LO(t, "mobile") ? o : n)(e1, t, s, a.plugins ? PO(a.plugins) : s), l = ((e1, t)=>[
                    ...PO(e1),
                    ...PO(t)
                ])(r, i);
            return an.extend(o, {
                forced_plugins: r,
                plugins: l
            });
        })(e1, i, o, l);
    }, UO = (e1)=>{
        ((e1)=>{
            const t = (t)=>()=>{
                    q("left,center,right,justify".split(","), (n)=>{
                        t !== n && e1.formatter.remove("align" + n);
                    }), "none" !== t && ((t)=>{
                        e1.formatter.toggle(t, void 0), e1.nodeChanged();
                    })("align" + t);
                };
            e1.editorCommands.addCommands({
                JustifyLeft: t("left"),
                JustifyCenter: t("center"),
                JustifyRight: t("right"),
                JustifyFull: t("justify"),
                JustifyNone: t("none")
            });
        })(e1), ((e1)=>{
            const t = (t)=>()=>{
                    const n = e1.selection, o = n.isCollapsed() ? [
                        e1.dom.getParent(n.getNode(), e1.dom.isBlock)
                    ] : n.getSelectedBlocks();
                    return $(o, (n)=>C(e1.formatter.matchNode(n, t)));
                };
            e1.editorCommands.addCommands({
                JustifyLeft: t("alignleft"),
                JustifyCenter: t("aligncenter"),
                JustifyRight: t("alignright"),
                JustifyFull: t("alignjustify")
            }, "state");
        })(e1);
    }, zO = (e1, t)=>{
        const n = e1.selection, o = e1.dom;
        return /^ | $/.test(t) ? ((e1, t, n, o)=>{
            const r = mn(e1.getRoot());
            return n = Ch(r, Pl.fromRangeStart(t), o) ? n.replace(/^ /, "&nbsp;") : n.replace(/^&nbsp;/, " "), wh(r, Pl.fromRangeEnd(t), o) ? n.replace(/(&nbsp;| )(<br( \/)>)?$/, "&nbsp;") : n.replace(/&nbsp;(<br( \/)?>)?$/, " ");
        })(o, n.getRng(), t, e1.schema) : t;
    }, jO = (e1, t)=>{
        if (e1.selection.isEditable()) {
            const { content: n, details: o } = ((e1)=>{
                if ("string" != typeof e1) {
                    const t = an.extend({
                        paste: e1.paste,
                        data: {
                            paste: e1.paste
                        }
                    }, e1);
                    return {
                        content: e1.content,
                        details: t
                    };
                }
                return {
                    content: e1,
                    details: {}
                };
            })(t);
            QC(e1, {
                ...o,
                content: zO(e1, n),
                format: "html",
                set: !1,
                selection: !0
            }).each((t)=>{
                const n = ((e1, t, n)=>Rw(e1).editor.insertContent(t, n))(e1, t.content, o);
                JC(e1, n, t), e1.addVisual();
            });
        }
    }, HO = {
        "font-size": "size",
        "font-family": "face"
    }, $O = On("font"), VO = (e1)=>(t, n)=>I.from(n).map(mn).filter(Nn).bind((n)=>((e1, t, n)=>_r(mn(n), (t)=>((t)=>Io(t, e1).orThunk(()=>$O(t) ? _e(HO, e1).bind((e1)=>bo(t, e1)) : I.none()))(t), (e1)=>Cn(mn(t), e1)))(e1, t, n.dom).or(((e1, t)=>I.from(ni.DOM.getStyle(t, e1, !0)))(e1, n.dom))).getOr(""), qO = VO("font-size"), WO = S((e1)=>e1.replace(/[\'\"\\]/g, "").replace(/,\s+/g, ","), VO("font-family")), KO = (e1)=>km(e1.getBody()).bind((e1)=>{
            const t = e1.container();
            return I.from(es(t) ? t.parentNode : t);
        }), YO = (e1, t)=>((e1, t)=>((e1)=>I.from(e1.selection.getRng()).bind((t)=>{
                    const n = e1.getBody();
                    return t.startContainer === n && 0 === t.startOffset ? I.none() : I.from(e1.selection.getStart(!0));
                }))(e1).orThunk(T(KO, e1)).map(mn).filter(Nn).bind(t))(e1, k(I.some, t)), GO = (e1, t)=>{
        if (/^[0-9.]+$/.test(t)) {
            const n = parseInt(t, 10);
            if (n >= 1 && n <= 7) {
                const o = ((e1)=>an.explode(e1.options.get("font_size_style_values")))(e1), r = ((e1)=>an.explode(e1.options.get("font_size_classes")))(e1);
                return r.length > 0 ? r[n - 1] || t : o[n - 1] || t;
            }
            return t;
        }
        return t;
    }, XO = (e1)=>{
        const t = e1.split(/\s*,\s*/);
        return V(t, (e1)=>-1 === e1.indexOf(" ") || Ye(e1, '"') || Ye(e1, "'") ? e1 : `'${e1}'`).join(",");
    }, ZO = (e1, t)=>{
        if (e1.mode.isReadOnly()) return;
        const n = e1.dom, o = e1.selection.getRng(), r = t ? e1.selection.getStart() : e1.selection.getEnd(), s = t ? o.startContainer : o.endContainer, a = fR(n, s);
        if (!a || !a.isContentEditable) return;
        const i = t ? ao : io, l = Ad(e1);
        ((e1, t, n, o)=>{
            const r = e1.dom, s = (e1)=>r.isBlock(e1) && e1.parentElement === n, a = s(t) ? t : r.getParent(o, s, n);
            return I.from(a).map(mn);
        })(e1, r, a, s).each((t)=>{
            const n = bR(e1, s, t.dom, a, !1, l);
            i(t, mn(n)), e1.selection.setCursorLocation(n, 0), e1.dispatch("NewBlock", {
                newBlock: n
            }), aR(e1, "insertParagraph");
        });
    }, QO = (e1)=>{
        UO(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                "Cut,Copy,Paste": (t)=>{
                    const n = e1.getDoc();
                    let o;
                    try {
                        n.execCommand(t);
                    } catch (e1) {
                        o = !0;
                    }
                    if ("paste" !== t || n.queryCommandEnabled(t) || (o = !0), o || !n.queryCommandSupported(t)) {
                        let t = e1.translate("Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.");
                        (nn.os.isMacOS() || nn.os.isiOS()) && (t = t.replace(/Ctrl\+/g, "\u2318+")), e1.notificationManager.open({
                            text: t,
                            type: "error"
                        });
                    }
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceAddUndoLevel: ()=>{
                    e1.undoManager.add();
                },
                mceEndUndoLevel: ()=>{
                    e1.undoManager.add();
                },
                Undo: ()=>{
                    e1.undoManager.undo();
                },
                Redo: ()=>{
                    e1.undoManager.redo();
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceSelectNodeDepth: (t, n, o)=>{
                    let r = 0;
                    e1.dom.getParent(e1.selection.getNode(), (t)=>!qr(t) || r++ !== o || (e1.selection.select(t), !1), e1.getBody());
                },
                mceSelectNode: (t, n, o)=>{
                    e1.selection.select(o);
                },
                selectAll: ()=>{
                    const t = e1.dom.getParent(e1.selection.getStart(), ds);
                    if (t) {
                        const n = e1.dom.createRng();
                        n.selectNodeContents(t), e1.selection.setRng(n);
                    }
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceCleanup: ()=>{
                    const t = e1.selection.getBookmark();
                    e1.setContent(e1.getContent()), e1.selection.moveToBookmark(t);
                },
                insertImage: (t, n, o)=>{
                    jO(e1, e1.dom.createHTML("img", {
                        src: o
                    }));
                },
                insertHorizontalRule: ()=>{
                    e1.execCommand("mceInsertContent", !1, "<hr>");
                },
                insertText: (t, n, o)=>{
                    jO(e1, e1.dom.encode(o));
                },
                insertHTML: (t, n, o)=>{
                    jO(e1, o);
                },
                mceInsertContent: (t, n, o)=>{
                    jO(e1, o);
                },
                mceSetContent: (t, n, o)=>{
                    e1.setContent(o);
                },
                mceReplaceContent: (t, n, o)=>{
                    e1.execCommand("mceInsertContent", !1, o.replace(/\{\$selection\}/g, e1.selection.getContent({
                        format: "text"
                    })));
                },
                mceNewDocument: ()=>{
                    e1.setContent(Vc(e1));
                }
            });
        })(e1), ((e1)=>{
            const t = (t, n, o)=>{
                if (e1.mode.isReadOnly()) return;
                const r = m(o) ? {
                    href: o
                } : o, s = e1.dom.getParent(e1.selection.getNode(), "a");
                f(r) && m(r.href) && (r.href = r.href.replace(/ /g, "%20"), s && r.href || e1.formatter.remove("link"), r.href && e1.formatter.apply("link", r, s));
            };
            e1.editorCommands.addCommands({
                unlink: ()=>{
                    if (e1.selection.isEditable()) {
                        if (e1.selection.isCollapsed()) {
                            const t = e1.dom.getParent(e1.selection.getStart(), "a");
                            return void (t && e1.dom.remove(t, !0));
                        }
                        e1.formatter.remove("link");
                    }
                },
                mceInsertLink: t,
                createLink: t
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                Indent: ()=>{
                    ((e1)=>{
                        vS(e1, "indent");
                    })(e1);
                },
                Outdent: ()=>{
                    yS(e1);
                }
            }), e1.editorCommands.addCommands({
                Outdent: ()=>pS(e1)
            }, "state");
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                InsertNewBlockBefore: ()=>{
                    ((e1)=>{
                        ZO(e1, !0);
                    })(e1);
                },
                InsertNewBlockAfter: ()=>{
                    ((e1)=>{
                        ZO(e1, !1);
                    })(e1);
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                insertParagraph: ()=>{
                    XR(RR, e1);
                },
                mceInsertNewLine: (t, n, o)=>{
                    ZR(e1, o);
                },
                InsertLineBreak: (t, n, o)=>{
                    XR(MR, e1);
                }
            });
        })(e1), ((e1)=>{
            ((e1)=>{
                const t = (t, n)=>{
                    e1.formatter.toggle(t, n), e1.nodeChanged();
                };
                e1.editorCommands.addCommands({
                    "Bold,Italic,Underline,Strikethrough,Superscript,Subscript": (e1)=>{
                        t(e1);
                    },
                    "ForeColor,HiliteColor": (e1, n, o)=>{
                        t(e1, {
                            value: o
                        });
                    },
                    BackColor: (e1, n, o)=>{
                        t("hilitecolor", {
                            value: o
                        });
                    },
                    FontName: (t, n, o)=>{
                        ((e1, t)=>{
                            const n = GO(e1, t);
                            e1.formatter.toggle("fontname", {
                                value: XO(n)
                            }), e1.nodeChanged();
                        })(e1, o);
                    },
                    FontSize: (t, n, o)=>{
                        ((e1, t)=>{
                            e1.formatter.toggle("fontsize", {
                                value: GO(e1, t)
                            }), e1.nodeChanged();
                        })(e1, o);
                    },
                    LineHeight: (t, n, o)=>{
                        ((e1, t)=>{
                            e1.formatter.toggle("lineheight", {
                                value: String(t)
                            }), e1.nodeChanged();
                        })(e1, o);
                    },
                    Lang: (e1, n, o)=>{
                        var r;
                        t(e1, {
                            value: o.code,
                            customValue: null !== (r = o.customCode) && void 0 !== r ? r : null
                        });
                    },
                    RemoveFormat: (t)=>{
                        e1.formatter.remove(t);
                    },
                    mceBlockQuote: ()=>{
                        t("blockquote");
                    },
                    FormatBlock: (e1, n, o)=>{
                        t(m(o) ? o : "p");
                    },
                    mceToggleFormat: (e1, n, o)=>{
                        t(o);
                    }
                });
            })(e1), ((e1)=>{
                const t = (t)=>e1.formatter.match(t);
                e1.editorCommands.addCommands({
                    "Bold,Italic,Underline,Strikethrough,Superscript,Subscript": (e1)=>t(e1),
                    mceBlockQuote: ()=>t("blockquote")
                }, "state"), e1.editorCommands.addQueryValueHandler("FontName", ()=>((e1)=>YO(e1, (t)=>WO(e1.getBody(), t.dom)).getOr(""))(e1)), e1.editorCommands.addQueryValueHandler("FontSize", ()=>((e1)=>YO(e1, (t)=>qO(e1.getBody(), t.dom)).getOr(""))(e1)), e1.editorCommands.addQueryValueHandler("LineHeight", ()=>((e1)=>YO(e1, (t)=>{
                            const n = mn(e1.getBody()), o = _r(t, (e1)=>Io(e1, "line-height"), T(Cn, n));
                            return o.getOrThunk(()=>{
                                const e1 = parseFloat(Lo(t, "line-height")), n = parseFloat(Lo(t, "font-size"));
                                return String(e1 / n);
                            });
                        }).getOr(""))(e1));
            })(e1);
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceRemoveNode: (t, n, o)=>{
                    const r = null != o ? o : e1.selection.getNode();
                    if (r !== e1.getBody()) {
                        const t = e1.selection.getBookmark();
                        e1.dom.remove(r, !0), e1.selection.moveToBookmark(t);
                    }
                },
                mcePrint: ()=>{
                    e1.getWin().print();
                },
                mceFocus: (t, n, o)=>{
                    ((e1, t)=>{
                        e1.removed || (t ? Cg(e1) : ((e1)=>{
                            const t = e1.selection, n = e1.getBody();
                            let o = t.getRng();
                            e1.quirks.refreshContentEditable();
                            const r = (e1)=>{
                                og(e1).each((t)=>{
                                    e1.selection.setRng(t), o = t;
                                });
                            };
                            !vg(e1) && e1.hasEditableRoot() && r(e1);
                            const s = ((e1, t)=>e1.dom.getParent(t, (t)=>"true" === e1.dom.getContentEditable(t)))(e1, t.getNode());
                            if (s && e1.dom.isChildOf(s, n)) return ((e1, t)=>null !== e1.dom.getParent(t, (t)=>"false" === e1.dom.getContentEditable(t)))(e1, s) || bg(n), bg(s), e1.hasEditableRoot() || r(e1), hg(e1, o), void Cg(e1);
                            e1.inline || (nn.browser.isOpera() || bg(n), e1.getWin().focus()), (nn.browser.isFirefox() || e1.inline) && (bg(n), hg(e1, o)), Cg(e1);
                        })(e1));
                    })(e1, !0 === o);
                },
                mceToggleVisualAid: ()=>{
                    e1.hasVisual = !e1.hasVisual, e1.addVisual();
                }
            });
        })(e1);
    }, JO = [
        "toggleview"
    ], eB = (e1)=>H(JO, e1.toLowerCase());
    class tB {
        constructor(e1){
            this.commands = {
                state: {},
                exec: {},
                value: {}
            }, this.editor = e1;
        }
        execCommand(e1, t = !1, n, o) {
            const r = this.editor, s = e1.toLowerCase(), a = null == o ? void 0 : o.skip_focus;
            if (r.removed) return !1;
            if ("mcefocus" !== s && (/^(mceAddUndoLevel|mceEndUndoLevel)$/i.test(s) || a ? ((e1)=>{
                og(e1).each((t)=>e1.selection.setRng(t));
            })(r) : r.focus()), r.dispatch("BeforeExecCommand", {
                command: e1,
                ui: t,
                value: n
            }).isDefaultPrevented()) return !1;
            const i = this.commands.exec[s];
            return !!w(i) && (i(s, t, n), r.dispatch("ExecCommand", {
                command: e1,
                ui: t,
                value: n
            }), !0);
        }
        queryCommandState(e1) {
            if (!eB(e1) && this.editor.quirks.isHidden() || this.editor.removed) return !1;
            const t = e1.toLowerCase(), n = this.commands.state[t];
            return !!w(n) && n(t);
        }
        queryCommandValue(e1) {
            if (!eB(e1) && this.editor.quirks.isHidden() || this.editor.removed) return "";
            const t = e1.toLowerCase(), n = this.commands.value[t];
            return w(n) ? n(t) : "";
        }
        addCommands(e1, t = "exec") {
            const n = this.commands;
            pe(e1, (e1, o)=>{
                q(o.toLowerCase().split(","), (o)=>{
                    n[t][o] = e1;
                });
            });
        }
        addCommand(e1, t, n) {
            const o = e1.toLowerCase();
            this.commands.exec[o] = (e1, o, r)=>t.call(null != n ? n : this.editor, o, r);
        }
        queryCommandSupported(e1) {
            const t = e1.toLowerCase();
            return !!this.commands.exec[t];
        }
        addQueryStateHandler(e1, t, n) {
            this.commands.state[e1.toLowerCase()] = ()=>t.call(null != n ? n : this.editor);
        }
        addQueryValueHandler(e1, t, n) {
            this.commands.value[e1.toLowerCase()] = ()=>t.call(null != n ? n : this.editor);
        }
    }
    const nB = an.makeMap("focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange mouseout mouseenter mouseleave wheel keydown keypress keyup input beforeinput contextmenu dragstart dragend dragover draggesture dragdrop drop drag submit compositionstart compositionend compositionupdate touchstart touchmove touchend touchcancel", " ");
    class oB {
        static isNative(e1) {
            return !!nB[e1.toLowerCase()];
        }
        constructor(e1){
            this.bindings = {}, this.settings = e1 || {}, this.scope = this.settings.scope || this, this.toggleEvent = this.settings.toggleEvent || L;
        }
        fire(e1, t) {
            return this.dispatch(e1, t);
        }
        dispatch(e1, t) {
            const n = e1.toLowerCase(), o = za(n, null != t ? t : {}, this.scope);
            this.settings.beforeFire && this.settings.beforeFire(o);
            const r = this.bindings[n];
            if (r) for(let e1 = 0, t = r.length; e1 < t; e1++){
                const t = r[e1];
                if (!t.removed) {
                    if (t.once && this.off(n, t.func), o.isImmediatePropagationStopped()) return o;
                    if (!1 === t.func.call(this.scope, o)) return o.preventDefault(), o;
                }
            }
            return o;
        }
        on(e1, t, n, o) {
            if (!1 === t && (t = L), t) {
                const r = {
                    func: t,
                    removed: !1
                };
                o && an.extend(r, o);
                const s = e1.toLowerCase().split(" ");
                let a = s.length;
                for(; a--;){
                    const e1 = s[a];
                    let t = this.bindings[e1];
                    t || (t = [], this.toggleEvent(e1, !0)), t = n ? [
                        r,
                        ...t
                    ] : [
                        ...t,
                        r
                    ], this.bindings[e1] = t;
                }
            }
            return this;
        }
        off(e1, t) {
            if (e1) {
                const n = e1.toLowerCase().split(" ");
                let o = n.length;
                for(; o--;){
                    const r = n[o];
                    let s = this.bindings[r];
                    if (!r) return pe(this.bindings, (e1, t)=>{
                        this.toggleEvent(t, !1), delete this.bindings[t];
                    }), this;
                    if (s) {
                        if (t) {
                            const e1 = K(s, (e1)=>e1.func === t);
                            s = e1.fail, this.bindings[r] = s, q(e1.pass, (e1)=>{
                                e1.removed = !0;
                            });
                        } else s.length = 0;
                        s.length || (this.toggleEvent(e1, !1), delete this.bindings[r]);
                    }
                }
            } else pe(this.bindings, (e1, t)=>{
                this.toggleEvent(t, !1);
            }), this.bindings = {};
            return this;
        }
        once(e1, t, n) {
            return this.on(e1, t, n, {
                once: !0
            });
        }
        has(e1) {
            e1 = e1.toLowerCase();
            const t = this.bindings[e1];
            return !(!t || 0 === t.length);
        }
    }
    const rB = (e1)=>(e1._eventDispatcher || (e1._eventDispatcher = new oB({
            scope: e1,
            toggleEvent: (t, n)=>{
                oB.isNative(t) && e1.toggleNativeEvent && e1.toggleNativeEvent(t, n);
            }
        })), e1._eventDispatcher), sB = {
        fire (e1, t, n) {
            return console.warn('The "fire" event api has been deprecated and will be removed in TinyMCE 9. Use "dispatch" instead.', (new Error).stack), this.dispatch(e1, t, n);
        },
        dispatch (e1, t, n) {
            const o = this;
            if (o.removed && "remove" !== e1 && "detach" !== e1) return za(e1.toLowerCase(), null != t ? t : {}, o);
            const r = rB(o).dispatch(e1, t);
            if (!1 !== n && o.parent) {
                let t = o.parent();
                for(; t && !r.isPropagationStopped();)t.dispatch(e1, r, !1), t = t.parent ? t.parent() : void 0;
            }
            return r;
        },
        on (e1, t, n) {
            return rB(this).on(e1, t, n);
        },
        off (e1, t) {
            return rB(this).off(e1, t);
        },
        once (e1, t) {
            return rB(this).once(e1, t);
        },
        hasEventListeners (e1) {
            return rB(this).has(e1);
        }
    }, aB = ni.DOM;
    let iB;
    const lB = (e1, t)=>{
        if ("selectionchange" === t) return e1.getDoc();
        if (!e1.inline && /^(?:mouse|touch|click|contextmenu|drop|dragover|dragend)/.test(t)) return e1.getDoc().documentElement;
        const n = sc(e1);
        return n ? (e1.eventRoot || (e1.eventRoot = aB.select(n)[0]), e1.eventRoot) : e1.getBody();
    }, dB = (e1, t, n)=>{
        ((e1)=>!e1.hidden && !CE(e1))(e1) ? e1.dispatch(t, n) : CE(e1) && ((e1, t)=>{
            if (((e1)=>"click" === e1.type)(t) && !wg.metaKeyPressed(t)) {
                const n = mn(t.target);
                ((e1, t)=>sr(t, "a", (t)=>Cn(t, mn(e1.getBody()))).bind((e1)=>bo(e1, "href")))(e1, n).each((n)=>{
                    if (t.preventDefault(), /^#/.test(n)) {
                        const t = e1.dom.select(`${n},[name="${We(n, "#")}"]`);
                        t.length && e1.selection.scrollIntoView(t[0], !0);
                    } else window.open(n, "_blank", "rel=noopener noreferrer,menubar=yes,toolbar=yes,location=yes,status=yes,resizable=yes,scrollbars=yes");
                });
            } else ((e1)=>H(xE, e1.type))(t) && e1.dispatch(t.type, t);
        })(e1, n);
    }, cB = (e1, t)=>{
        if (e1.delegates || (e1.delegates = {}), e1.delegates[t] || e1.removed) return;
        const n = lB(e1, t);
        if (sc(e1)) {
            if (iB || (iB = {}, e1.editorManager.on("removeEditor", ()=>{
                e1.editorManager.activeEditor || iB && (pe(iB, (t, n)=>{
                    e1.dom.unbind(lB(e1, n));
                }), iB = null);
            })), iB[t]) return;
            const o = (n)=>{
                const o = n.target, r = e1.editorManager.get();
                let s = r.length;
                for(; s--;){
                    const e1 = r[s].getBody();
                    (e1 === o || aB.isChildOf(o, e1)) && dB(r[s], t, n);
                }
            };
            iB[t] = o, aB.bind(n, t, o);
        } else {
            const o = (n)=>{
                dB(e1, t, n);
            };
            aB.bind(n, t, o), e1.delegates[t] = o;
        }
    }, uB = {
        ...sB,
        bindPendingEventDelegates () {
            const e1 = this;
            an.each(e1._pendingNativeEvents, (t)=>{
                cB(e1, t);
            });
        },
        toggleNativeEvent (e1, t) {
            const n = this;
            "focus" !== e1 && "blur" !== e1 && (n.removed || (t ? n.initialized ? cB(n, e1) : n._pendingNativeEvents ? n._pendingNativeEvents.push(e1) : n._pendingNativeEvents = [
                e1
            ] : n.initialized && n.delegates && (n.dom.unbind(lB(n, e1), e1, n.delegates[e1]), delete n.delegates[e1])));
        },
        unbindAllNativeEvents () {
            const e1 = this, t = e1.getBody(), n = e1.dom;
            e1.delegates && (pe(e1.delegates, (t, n)=>{
                e1.dom.unbind(lB(e1, n), n, t);
            }), delete e1.delegates), !e1.inline && t && n && (t.onload = null, n.unbind(e1.getWin()), n.unbind(e1.getDoc())), n && (n.unbind(t), n.unbind(e1.getContainer()));
        }
    }, mB = (e1)=>m(e1) ? {
            value: e1.split(/[ ,]/),
            valid: !0
        } : _(e1, m) ? {
            value: e1,
            valid: !0
        } : {
            valid: !1,
            message: "The value must be a string[] or a comma/space separated string."
        }, fB = (e1, t)=>e1 + (tt(t.message) ? "" : `. ${t.message}`), gB = (e1)=>e1.valid, pB = (e1, t, n = "")=>{
        const o = t(e1);
        return b(o) ? o ? {
            value: e1,
            valid: !0
        } : {
            valid: !1,
            message: n
        } : o;
    }, hB = (e1)=>e1.readonly, bB = [
        "design",
        "readonly"
    ], vB = (e1, t, n, o)=>{
        const r = n[t.get()], s = n[o];
        try {
            s.activate();
        } catch (e1) {
            return void console.error(`problem while activating editor mode ${o}:`, e1);
        }
        r.deactivate(), r.editorReadOnly !== s.editorReadOnly && ((e1, t)=>{
            const n = mn(e1.getBody());
            t ? (e1.readonly = !0, e1.hasEditableRoot() && (n.dom.contentEditable = "true"), vE(e1)) : (e1.readonly = !1, yE(e1));
        })(e1, s.editorReadOnly), t.set(o), ((e1, t)=>{
            e1.dispatch("SwitchMode", {
                mode: t
            });
        })(e1, o);
    }, yB = (e1)=>{
        const t = Ne("design"), n = Ne({
            design: {
                activate: x,
                deactivate: x,
                editorReadOnly: !1
            },
            readonly: {
                activate: x,
                deactivate: x,
                editorReadOnly: !0
            }
        });
        return ((e1)=>{
            const t = (t)=>{
                hB(e1) && ((e1)=>$(e1, (e1)=>"characterData" === e1.type || "childList" === e1.type))(t) && ((e1)=>{
                    const t = e1.undoManager.add();
                    C(t) && (e1.undoManager.undo(), e1.undoManager.reset());
                })(e1);
            }, n = new MutationObserver(t);
            e1.on("beforeinput paste cut dragend dragover draggesture dragdrop drop drag", (t)=>{
                hB(e1) && t.preventDefault();
            }), e1.on("BeforeExecCommand", (t)=>{
                "Undo" !== t.command && "Redo" !== t.command || !hB(e1) || t.preventDefault();
            }), e1.on("compositionstart", ()=>{
                hB(e1) && n.observe(e1.getBody(), {
                    characterData: !0,
                    childList: !0,
                    subtree: !0
                });
            }), e1.on("compositionend", ()=>{
                if (hB(e1)) {
                    const e1 = n.takeRecords();
                    t(e1);
                }
                n.disconnect();
            });
        })(e1), ((e1)=>{
            ((e1)=>{
                e1.serializer ? _E(e1) : e1.on("PreInit", ()=>{
                    _E(e1);
                });
            })(e1), ((e1)=>{
                e1.on("ShowCaret ObjectSelected", (t)=>{
                    CE(e1) && t.preventDefault();
                }), e1.on("DisabledStateChange", (t)=>{
                    t.isDefaultPrevented() || EE(e1, t.state);
                });
            })(e1);
        })(e1), {
            isReadOnly: ()=>hB(e1),
            set: (o)=>((e1, t, n, o)=>{
                    if (!(o === n.get() || e1.initialized && CE(e1))) {
                        if (!xe(t, o)) throw new Error(`Editor mode '${o}' is invalid`);
                        e1.initialized ? vB(e1, n, t, o) : e1.on("init", ()=>vB(e1, n, t, o));
                    }
                })(e1, n.get(), t, o),
            get: ()=>t.get(),
            register: (e1, t)=>{
                n.set(((e1, t, n)=>{
                    if (H(bB, t)) throw new Error(`Cannot override default mode ${t}`);
                    return {
                        ...e1,
                        [t]: {
                            ...n,
                            deactivate: ()=>{
                                try {
                                    n.deactivate();
                                } catch (e1) {
                                    console.error(`problem while deactivating editor mode ${t}:`, e1);
                                }
                            }
                        }
                    };
                })(n.get(), e1, t));
            }
        };
    }, CB = an.each, wB = an.explode, EB = {
        f1: 112,
        f2: 113,
        f3: 114,
        f4: 115,
        f5: 116,
        f6: 117,
        f7: 118,
        f8: 119,
        f9: 120,
        f10: 121,
        f11: 122,
        f12: 123
    }, _B = an.makeMap("alt,ctrl,shift,meta,access"), xB = (e1)=>{
        const t = {}, n = nn.os.isMacOS() || nn.os.isiOS();
        CB(wB(e1.toLowerCase(), "+"), (e1)=>{
            ((e1)=>e1 in _B)(e1) ? t[e1] = !0 : /^[0-9]{2,}$/.test(e1) ? t.keyCode = parseInt(e1, 10) : (t.charCode = e1.charCodeAt(0), t.keyCode = EB[e1] || e1.toUpperCase().charCodeAt(0));
        });
        const o = [
            t.keyCode
        ];
        let r;
        for(r in _B)t[r] ? o.push(r) : t[r] = !1;
        return t.id = o.join(","), t.access && (t.alt = !0, n ? t.ctrl = !0 : t.shift = !0), t.meta && (n ? t.meta = !0 : (t.ctrl = !0, t.meta = !1)), t;
    };
    class SB {
        constructor(e1){
            this.shortcuts = {}, this.pendingPatterns = [], this.editor = e1;
            const t = this;
            e1.on("keyup keypress keydown", (e1)=>{
                !t.hasModifier(e1) && !t.isFunctionKey(e1) || e1.isDefaultPrevented() || (CB(t.shortcuts, (n)=>{
                    t.matchShortcut(e1, n) && (t.pendingPatterns = n.subpatterns.slice(0), "keydown" === e1.type && t.executeShortcutAction(n));
                }), t.matchShortcut(e1, t.pendingPatterns[0]) && (1 === t.pendingPatterns.length && "keydown" === e1.type && t.executeShortcutAction(t.pendingPatterns[0]), t.pendingPatterns.shift()));
            });
        }
        add(e1, t, n, o) {
            const r = this, s = r.normalizeCommandFunc(n);
            return CB(wB(an.trim(e1)), (e1)=>{
                const n = r.createShortcut(e1, t, s, o);
                r.shortcuts[n.id] = n;
            }), !0;
        }
        remove(e1) {
            const t = this.createShortcut(e1);
            return !!this.shortcuts[t.id] && (delete this.shortcuts[t.id], !0);
        }
        normalizeCommandFunc(e1) {
            const t = this, n = e1;
            return "string" == typeof n ? ()=>{
                t.editor.execCommand(n, !1, null);
            } : an.isArray(n) ? ()=>{
                t.editor.execCommand(n[0], n[1], n[2]);
            } : n;
        }
        createShortcut(e1, t, n, o) {
            const r = an.map(wB(e1, ">"), xB);
            return r[r.length - 1] = an.extend(r[r.length - 1], {
                func: n,
                scope: o || this.editor
            }), an.extend(r[0], {
                desc: this.editor.translate(t),
                subpatterns: r.slice(1)
            });
        }
        hasModifier(e1) {
            return e1.altKey || e1.ctrlKey || e1.metaKey;
        }
        isFunctionKey(e1) {
            return "keydown" === e1.type && e1.keyCode >= 112 && e1.keyCode <= 123;
        }
        matchShortcut(e1, t) {
            return !!t && t.ctrl === e1.ctrlKey && t.meta === e1.metaKey && t.alt === e1.altKey && t.shift === e1.shiftKey && !!(e1.keyCode === t.keyCode || e1.charCode && e1.charCode === t.charCode) && (e1.preventDefault(), !0);
        }
        executeShortcutAction(e1) {
            return e1.func ? e1.func.call(e1.scope) : null;
        }
    }
    const kB = ()=>{
        const e1 = (()=>{
            const e1 = {}, t = {}, n = {}, o = {}, r = {}, s = {}, a = {}, i = {}, l = {}, d = (e1, t)=>(n, o)=>{
                    e1[n.toLowerCase()] = {
                        ...o,
                        type: t
                    };
                };
            var c;
            return {
                addButton: d(e1, "button"),
                addGroupToolbarButton: d(e1, "grouptoolbarbutton"),
                addToggleButton: d(e1, "togglebutton"),
                addMenuButton: d(e1, "menubutton"),
                addSplitButton: d(e1, "splitbutton"),
                addMenuItem: d(t, "menuitem"),
                addNestedMenuItem: d(t, "nestedmenuitem"),
                addToggleMenuItem: d(t, "togglemenuitem"),
                addAutocompleter: d(n, "autocompleter"),
                addContextMenu: d(r, "contextmenu"),
                addContextToolbar: d(s, "contexttoolbar"),
                addContextForm: (c = s, (e1, t)=>{
                    c[e1.toLowerCase()] = {
                        type: "contextform",
                        ...t
                    };
                }),
                addSidebar: d(i, "sidebar"),
                addView: d(l, "views"),
                addIcon: (e1, t)=>o[e1.toLowerCase()] = t,
                addContext: (e1, t)=>a[e1.toLowerCase()] = t,
                getAll: ()=>({
                        buttons: e1,
                        menuItems: t,
                        icons: o,
                        popups: n,
                        contextMenus: r,
                        contextToolbars: s,
                        sidebars: i,
                        views: l,
                        contexts: a
                    })
            };
        })();
        return {
            addAutocompleter: e1.addAutocompleter,
            addButton: e1.addButton,
            addContextForm: e1.addContextForm,
            addContextMenu: e1.addContextMenu,
            addContextToolbar: e1.addContextToolbar,
            addIcon: e1.addIcon,
            addMenuButton: e1.addMenuButton,
            addMenuItem: e1.addMenuItem,
            addNestedMenuItem: e1.addNestedMenuItem,
            addSidebar: e1.addSidebar,
            addSplitButton: e1.addSplitButton,
            addToggleButton: e1.addToggleButton,
            addGroupToolbarButton: e1.addGroupToolbarButton,
            addToggleMenuItem: e1.addToggleMenuItem,
            addView: e1.addView,
            addContext: e1.addContext,
            getAll: e1.getAll
        };
    }, NB = ni.DOM, RB = an.extend, AB = an.each;
    class TB {
        constructor(e1, t, n){
            this.plugins = {}, this.contentCSS = [], this.contentStyles = [], this.loadedCSS = {}, this.isNotDirty = !1, this.composing = !1, this.destroyed = !1, this.hasHiddenInput = !1, this.iframeElement = null, this.initialized = !1, this.readonly = !1, this.removed = !1, this.startContent = "", this._pendingNativeEvents = [], this._skinLoaded = !1, this._editableRoot = !0, this.editorManager = n, this.documentBaseUrl = n.documentBaseURL, RB(this, uB);
            const o = this;
            this.id = e1, this.hidden = !1;
            const r = ((e1, t)=>{
                const n = Ie(t);
                return FO(OO || BO, OO, n, e1, n);
            })(n.defaultOptions, t);
            this.options = ((e1, t, n = t)=>{
                const o = {}, r = {}, s = (e1, t, n)=>{
                    const o = pB(t, n);
                    return gB(o) ? (r[e1] = o.value, !0) : (console.warn(fB(`Invalid value passed for the ${e1} option`, o)), !1);
                }, a = (e1)=>xe(o, e1);
                return {
                    register: (e1, n)=>{
                        const a = ((e1)=>m(e1.processor))(n) ? ((e1)=>{
                            const t = (()=>{
                                switch(e1){
                                    case "array":
                                        return p;
                                    case "boolean":
                                        return b;
                                    case "function":
                                        return w;
                                    case "number":
                                        return E;
                                    case "object":
                                        return f;
                                    case "string":
                                        return m;
                                    case "string[]":
                                        return mB;
                                    case "object[]":
                                        return (e1)=>_(e1, f);
                                    case "regexp":
                                        return (e1)=>u(e1, RegExp);
                                    default:
                                        return M;
                                }
                            })();
                            return (n)=>pB(n, t, `The value must be a ${e1}.`);
                        })(n.processor) : n.processor, i = ((e1, t, n)=>{
                            if (!v(t)) {
                                const o = pB(t, n);
                                if (gB(o)) return o.value;
                                console.error(fB(`Invalid default value passed for the "${e1}" option`, o));
                            }
                        })(e1, n.default, a);
                        o[e1] = {
                            ...n,
                            default: i,
                            processor: a
                        }, _e(r, e1).orThunk(()=>_e(t, e1)).each((t)=>s(e1, t, a));
                    },
                    isRegistered: a,
                    get: (e1)=>_e(r, e1).orThunk(()=>_e(o, e1).map((e1)=>e1.default)).getOrUndefined(),
                    set: (e1, t)=>{
                        if (a(e1)) {
                            const n = o[e1];
                            return n.immutable ? (console.error(`"${e1}" is an immutable option and cannot be updated`), !1) : s(e1, t, n.processor);
                        }
                        return console.warn(`"${e1}" is not a registered option. Ensure the option has been registered before setting a value.`), !1;
                    },
                    unset: (e1)=>{
                        const t = a(e1);
                        return t && delete r[e1], t;
                    },
                    isSet: (e1)=>xe(r, e1),
                    debug: ()=>{
                        try {
                            console.log(JSON.parse(JSON.stringify(n, (e1, t)=>b(t) || E(t) || m(t) || h(t) || p(t) || g(t) ? t : Object.prototype.toString.call(t))));
                        } catch (e1) {
                            console.error(e1);
                        }
                    }
                };
            })(0, r, t), ((e1)=>{
                const t = e1.options.register;
                t("id", {
                    processor: "string",
                    default: e1.id
                }), t("selector", {
                    processor: "string"
                }), t("target", {
                    processor: "object"
                }), t("suffix", {
                    processor: "string"
                }), t("cache_suffix", {
                    processor: "string"
                }), t("base_url", {
                    processor: "string"
                }), t("referrer_policy", {
                    processor: "string",
                    default: ""
                }), t("language_load", {
                    processor: "boolean",
                    default: !0
                }), t("inline", {
                    processor: "boolean",
                    default: !1
                }), t("iframe_attrs", {
                    processor: "object",
                    default: {}
                }), t("doctype", {
                    processor: "string",
                    default: "<!DOCTYPE html>"
                }), t("document_base_url", {
                    processor: "string",
                    default: e1.documentBaseUrl
                }), t("body_id", {
                    processor: wd(e1, "tinymce"),
                    default: "tinymce"
                }), t("body_class", {
                    processor: wd(e1),
                    default: ""
                }), t("content_security_policy", {
                    processor: "string",
                    default: ""
                }), t("br_in_pre", {
                    processor: "boolean",
                    default: !0
                }), t("forced_root_block", {
                    processor: (e1)=>{
                        const t = m(e1) && et(e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be a non-empty string."
                        };
                    },
                    default: "p"
                }), t("forced_root_block_attrs", {
                    processor: "object",
                    default: {}
                }), t("newline_behavior", {
                    processor: (e1)=>{
                        const t = H([
                            "block",
                            "linebreak",
                            "invert",
                            "default"
                        ], e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be one of: block, linebreak, invert or default."
                        };
                    },
                    default: "default"
                }), t("br_newline_selector", {
                    processor: "string",
                    default: ".mce-toc h2,figcaption,caption"
                }), t("no_newline_selector", {
                    processor: "string",
                    default: ""
                }), t("keep_styles", {
                    processor: "boolean",
                    default: !0
                }), t("end_container_on_empty_block", {
                    processor: (e1)=>b(e1) || m(e1) ? {
                            valid: !0,
                            value: e1
                        } : {
                            valid: !1,
                            message: "Must be boolean or a string"
                        },
                    default: "blockquote"
                }), t("font_size_style_values", {
                    processor: "string",
                    default: "xx-small,x-small,small,medium,large,x-large,xx-large"
                }), t("font_size_legacy_values", {
                    processor: "string",
                    default: "xx-small,small,medium,large,x-large,xx-large,300%"
                }), t("font_size_classes", {
                    processor: "string",
                    default: ""
                }), t("automatic_uploads", {
                    processor: "boolean",
                    default: !0
                }), t("images_reuse_filename", {
                    processor: "boolean",
                    default: !1
                }), t("images_replace_blob_uris", {
                    processor: "boolean",
                    default: !0
                }), t("icons", {
                    processor: "string",
                    default: ""
                }), t("icons_url", {
                    processor: "string",
                    default: ""
                }), t("images_upload_url", {
                    processor: "string",
                    default: ""
                }), t("images_upload_base_path", {
                    processor: "string",
                    default: ""
                }), t("images_upload_credentials", {
                    processor: "boolean",
                    default: !1
                }), t("images_upload_handler", {
                    processor: "function"
                }), t("language", {
                    processor: "string",
                    default: "en"
                }), t("language_url", {
                    processor: "string",
                    default: ""
                }), t("entity_encoding", {
                    processor: "string",
                    default: "named"
                }), t("indent", {
                    processor: "boolean",
                    default: !0
                }), t("indent_before", {
                    processor: "string",
                    default: "p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,details,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist"
                }), t("indent_after", {
                    processor: "string",
                    default: "p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,details,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist"
                }), t("indent_use_margin", {
                    processor: "boolean",
                    default: !1
                }), t("indentation", {
                    processor: "string",
                    default: "40px"
                }), t("content_css", {
                    processor: (e1)=>{
                        const t = !1 === e1 || m(e1) || _(e1, m);
                        return t ? m(e1) ? {
                            value: V(e1.split(","), Ze),
                            valid: t
                        } : p(e1) ? {
                            value: e1,
                            valid: t
                        } : !1 === e1 ? {
                            value: [],
                            valid: t
                        } : {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be false, a string or an array of strings."
                        };
                    },
                    default: bc(e1) ? [] : [
                        "default"
                    ]
                }), t("content_style", {
                    processor: "string"
                }), t("content_css_cors", {
                    processor: "boolean",
                    default: !1
                }), t("font_css", {
                    processor: (e1)=>{
                        const t = m(e1) || _(e1, m);
                        return t ? {
                            value: p(e1) ? e1 : V(e1.split(","), Ze),
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be a string or an array of strings."
                        };
                    },
                    default: []
                }), t("extended_mathml_attributes", {
                    processor: "string[]"
                }), t("extended_mathml_elements", {
                    processor: "string[]"
                }), t("inline_boundaries", {
                    processor: "boolean",
                    default: !0
                }), t("inline_boundaries_selector", {
                    processor: "string",
                    default: "a[href],code,span.mce-annotation"
                }), t("object_resizing", {
                    processor: (e1)=>{
                        const t = b(e1) || m(e1);
                        return t ? !1 === e1 || pd.isiPhone() || pd.isiPad() ? {
                            value: "",
                            valid: t
                        } : {
                            value: !0 === e1 ? "table,img,figure.image,div,video,iframe" : e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be boolean or a string"
                        };
                    },
                    default: !hd
                }), t("resize_img_proportional", {
                    processor: "boolean",
                    default: !0
                }), t("event_root", {
                    processor: "string"
                }), t("service_message", {
                    processor: "string"
                }), t("onboarding", {
                    processor: "boolean",
                    default: !0
                }), t("tiny_cloud_entry_url", {
                    processor: "string"
                }), t("theme", {
                    processor: (e1)=>!1 === e1 || m(e1) || w(e1),
                    default: "silver"
                }), t("theme_url", {
                    processor: "string"
                }), t("formats", {
                    processor: "object"
                }), t("format_empty_lines", {
                    processor: "boolean",
                    default: !1
                }), t("format_noneditable_selector", {
                    processor: "string",
                    default: ""
                }), t("preview_styles", {
                    processor: (e1)=>{
                        const t = !1 === e1 || m(e1);
                        return t ? {
                            value: !1 === e1 ? "" : e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be false or a string"
                        };
                    },
                    default: "font-family font-size font-weight font-style text-decoration text-transform color background-color border border-radius outline text-shadow"
                }), t("custom_ui_selector", {
                    processor: "string",
                    default: ""
                }), t("hidden_input", {
                    processor: "boolean",
                    default: !0
                }), t("submit_patch", {
                    processor: "boolean",
                    default: !0
                }), t("encoding", {
                    processor: "string"
                }), t("add_form_submit_trigger", {
                    processor: "boolean",
                    default: !0
                }), t("add_unload_trigger", {
                    processor: "boolean",
                    default: !0
                }), t("custom_undo_redo_levels", {
                    processor: "number",
                    default: 0
                }), t("disable_nodechange", {
                    processor: "boolean",
                    default: !1
                }), t("disabled", {
                    processor: (t)=>b(t) ? (e1.initialized && hu(e1) !== t && Promise.resolve().then(()=>{
                            ((e1, t)=>{
                                e1.dispatch("DisabledStateChange", {
                                    state: t
                                });
                            })(e1, t);
                        }), {
                            valid: !0,
                            value: t
                        }) : {
                            valid: !1,
                            message: "The value must be a boolean."
                        },
                    default: !1
                }), t("readonly", {
                    processor: "boolean",
                    default: !1
                }), t("editable_root", {
                    processor: "boolean",
                    default: !0
                }), t("plugins", {
                    processor: "string[]",
                    default: []
                }), t("external_plugins", {
                    processor: "object"
                }), t("forced_plugins", {
                    processor: "string[]"
                }), t("model", {
                    processor: "string",
                    default: e1.hasPlugin("rtc") ? "plugin" : "dom"
                }), t("model_url", {
                    processor: "string"
                }), t("block_unsupported_drop", {
                    processor: "boolean",
                    default: !0
                }), t("visual", {
                    processor: "boolean",
                    default: !0
                }), t("visual_table_class", {
                    processor: "string",
                    default: "mce-item-table"
                }), t("visual_anchor_class", {
                    processor: "string",
                    default: "mce-item-anchor"
                }), t("iframe_aria_text", {
                    processor: "string",
                    default: "Rich Text Area".concat(e1.hasPlugin("help") ? ". Press ALT-0 for help." : "")
                }), t("setup", {
                    processor: "function"
                }), t("init_instance_callback", {
                    processor: "function"
                }), t("url_converter", {
                    processor: "function",
                    default: e1.convertURL
                }), t("url_converter_scope", {
                    processor: "object",
                    default: e1
                }), t("urlconverter_callback", {
                    processor: "function"
                }), t("allow_conditional_comments", {
                    processor: "boolean",
                    default: !1
                }), t("allow_html_data_urls", {
                    processor: "boolean",
                    default: !1
                }), t("allow_svg_data_urls", {
                    processor: "boolean"
                }), t("allow_html_in_named_anchor", {
                    processor: "boolean",
                    default: !1
                }), t("allow_html_in_comments", {
                    processor: "boolean",
                    default: !0
                }), t("allow_script_urls", {
                    processor: "boolean",
                    default: !1
                }), t("allow_unsafe_link_target", {
                    processor: "boolean",
                    default: !1
                }), t("allow_mathml_annotation_encodings", {
                    processor: (e1)=>{
                        const t = _(e1, m);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be an array of strings."
                        };
                    },
                    default: []
                }), t("convert_fonts_to_spans", {
                    processor: "boolean",
                    default: !0,
                    deprecated: !0
                }), t("fix_list_elements", {
                    processor: "boolean",
                    default: !1
                }), t("preserve_cdata", {
                    processor: "boolean",
                    default: !1
                }), t("remove_trailing_brs", {
                    processor: "boolean",
                    default: !0
                }), t("pad_empty_with_br", {
                    processor: "boolean",
                    default: !1
                }), t("inline_styles", {
                    processor: "boolean",
                    default: !0,
                    deprecated: !0
                }), t("element_format", {
                    processor: "string",
                    default: "html"
                }), t("entities", {
                    processor: "string"
                }), t("schema", {
                    processor: "string",
                    default: "html5"
                }), t("convert_urls", {
                    processor: "boolean",
                    default: !0
                }), t("relative_urls", {
                    processor: "boolean",
                    default: !0
                }), t("remove_script_host", {
                    processor: "boolean",
                    default: !0
                }), t("custom_elements", {
                    processor: Cd
                }), t("extended_valid_elements", {
                    processor: "string"
                }), t("invalid_elements", {
                    processor: "string"
                }), t("invalid_styles", {
                    processor: Cd
                }), t("valid_children", {
                    processor: "string"
                }), t("valid_classes", {
                    processor: Cd
                }), t("valid_elements", {
                    processor: "string"
                }), t("valid_styles", {
                    processor: Cd
                }), t("verify_html", {
                    processor: "boolean",
                    default: !0
                }), t("auto_focus", {
                    processor: (e1)=>m(e1) || !0 === e1
                }), t("browser_spellcheck", {
                    processor: "boolean",
                    default: !1
                }), t("protect", {
                    processor: "array"
                }), t("images_file_types", {
                    processor: "string",
                    default: "jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp"
                }), t("deprecation_warnings", {
                    processor: "boolean",
                    default: !0
                }), t("a11y_advanced_options", {
                    processor: "boolean",
                    default: !1
                }), t("api_key", {
                    processor: "string"
                }), t("license_key", {
                    processor: "string"
                }), t("paste_block_drop", {
                    processor: "boolean",
                    default: !1
                }), t("paste_data_images", {
                    processor: "boolean",
                    default: !0
                }), t("paste_preprocess", {
                    processor: "function"
                }), t("paste_postprocess", {
                    processor: "function"
                }), t("paste_webkit_styles", {
                    processor: "string",
                    default: "none"
                }), t("paste_remove_styles_if_webkit", {
                    processor: "boolean",
                    default: !0
                }), t("paste_merge_formats", {
                    processor: "boolean",
                    default: !0
                }), t("smart_paste", {
                    processor: "boolean",
                    default: !0
                }), t("paste_as_text", {
                    processor: "boolean",
                    default: !1
                }), t("paste_tab_spaces", {
                    processor: "number",
                    default: 4
                }), t("text_patterns", {
                    processor: (e1)=>_(e1, f) || !1 === e1 ? {
                            value: id(!1 === e1 ? [] : e1),
                            valid: !0
                        } : {
                            valid: !1,
                            message: "Must be an array of objects or false."
                        },
                    default: [
                        {
                            start: "*",
                            end: "*",
                            format: "italic"
                        },
                        {
                            start: "**",
                            end: "**",
                            format: "bold"
                        },
                        {
                            start: "#",
                            format: "h1",
                            trigger: "space"
                        },
                        {
                            start: "##",
                            format: "h2",
                            trigger: "space"
                        },
                        {
                            start: "###",
                            format: "h3",
                            trigger: "space"
                        },
                        {
                            start: "####",
                            format: "h4",
                            trigger: "space"
                        },
                        {
                            start: "#####",
                            format: "h5",
                            trigger: "space"
                        },
                        {
                            start: "######",
                            format: "h6",
                            trigger: "space"
                        },
                        {
                            start: "1.",
                            cmd: "InsertOrderedList",
                            trigger: "space"
                        },
                        {
                            start: "*",
                            cmd: "InsertUnorderedList",
                            trigger: "space"
                        },
                        {
                            start: "-",
                            cmd: "InsertUnorderedList",
                            trigger: "space"
                        },
                        {
                            start: ">",
                            cmd: "mceBlockQuote",
                            trigger: "space"
                        },
                        {
                            start: "---",
                            cmd: "InsertHorizontalRule",
                            trigger: "space"
                        }
                    ]
                }), t("text_patterns_lookup", {
                    processor: (e1)=>{
                        var t;
                        return w(e1) ? {
                            value: (t = e1, (e1)=>{
                                const n = t(e1);
                                return id(n);
                            }),
                            valid: !0
                        } : {
                            valid: !1,
                            message: "Must be a single function"
                        };
                    },
                    default: (e1)=>[]
                }), t("noneditable_class", {
                    processor: "string",
                    default: "mceNonEditable"
                }), t("editable_class", {
                    processor: "string",
                    default: "mceEditable"
                }), t("noneditable_regexp", {
                    processor: (e1)=>_(e1, vd) ? {
                            value: e1,
                            valid: !0
                        } : vd(e1) ? {
                            value: [
                                e1
                            ],
                            valid: !0
                        } : {
                            valid: !1,
                            message: "Must be a RegExp or an array of RegExp."
                        },
                    default: []
                }), t("table_tab_navigation", {
                    processor: "boolean",
                    default: !0
                }), t("highlight_on_focus", {
                    processor: "boolean",
                    default: !0
                }), t("xss_sanitization", {
                    processor: "boolean",
                    default: !0
                }), t("details_initial_state", {
                    processor: (e1)=>{
                        const t = H([
                            "inherited",
                            "collapsed",
                            "expanded"
                        ], e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be one of: inherited, collapsed, or expanded."
                        };
                    },
                    default: "inherited"
                }), t("details_serialized_state", {
                    processor: (e1)=>{
                        const t = H([
                            "inherited",
                            "collapsed",
                            "expanded"
                        ], e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be one of: inherited, collapsed, or expanded."
                        };
                    },
                    default: "inherited"
                }), t("init_content_sync", {
                    processor: "boolean",
                    default: !1
                }), t("newdocument_content", {
                    processor: "string",
                    default: ""
                }), t("sandbox_iframes", {
                    processor: "boolean",
                    default: !0
                }), t("sandbox_iframes_exclusions", {
                    processor: "string[]",
                    default: [
                        "youtube.com",
                        "youtu.be",
                        "vimeo.com",
                        "player.vimeo.com",
                        "dailymotion.com",
                        "embed.music.apple.com",
                        "open.spotify.com",
                        "giphy.com",
                        "dai.ly",
                        "codepen.io"
                    ]
                }), t("convert_unsafe_embeds", {
                    processor: "boolean",
                    default: !0
                }), e1.on("ScriptsLoaded", ()=>{
                    t("directionality", {
                        processor: "string",
                        default: li.isRtl() ? "rtl" : void 0
                    }), t("placeholder", {
                        processor: "string",
                        default: bd.getAttrib(e1.getElement(), "placeholder")
                    });
                });
            })(o);
            const s = this.options.get;
            s("deprecation_warnings") && ((e1, t)=>{
                ((e1, t)=>{
                    const n = qw(e1), o = Yw(t), r = o.length > 0, s = n.length > 0, a = "mobile" === t.theme;
                    if (r || s || a) {
                        const e1 = "\n- ", t = a ? `\n\nThemes:${e1}mobile` : "", i = r ? `\n\nPlugins:${e1}${o.join(e1)}` : "", l = s ? `\n\nOptions:${e1}${n.join(e1)}` : "";
                        console.warn("The following deprecated features are currently enabled and have been removed in TinyMCE 7.0. These features will no longer work and should be removed from the TinyMCE configuration. See https://www.tiny.cloud/docs/tinymce/7/migration-from-6x/ for more information." + t + i + l);
                    }
                })(e1, t), ((e1, t)=>{
                    const n = Ww(e1), o = Gw(t), r = o.length > 0, s = n.length > 0;
                    if (r || s) {
                        const e1 = "\n- ", t = r ? `\n\nPlugins:${e1}${o.map(Xw).join(e1)}` : "", a = s ? `\n\nOptions:${e1}${n.join(e1)}` : "";
                        console.warn("The following deprecated features are currently enabled but will be removed soon." + t + a);
                    }
                })(e1, t);
            })(t, r);
            const a = s("suffix");
            a && (n.suffix = a), this.suffix = n.suffix;
            const i = s("base_url");
            i && n._setBaseUrl(i), this.baseUri = n.baseURI;
            const l = Wd(o);
            l && (ri.ScriptLoader._setReferrerPolicy(l), ni.DOM.styleSheetLoader._setReferrerPolicy(l));
            const d = kc(o);
            C(d) && ni.DOM.styleSheetLoader._setContentCssCors(d), di.languageLoad = s("language_load"), di.baseURL = n.baseURL, this.setDirty(!1), this.documentBaseURI = new BC(xd(o), {
                base_uri: this.baseUri
            }), this.baseURI = this.baseUri, this.inline = bc(o), this.hasVisual = Tc(o), this.shortcuts = new SB(this), this.editorCommands = new tB(this), QO(this);
            const c = s("cache_suffix");
            c && (nn.cacheSuffix = c.replace(/^[\?\&]+/, "")), this.ui = {
                registry: kB(),
                styleSheetLoader: void 0,
                show: x,
                hide: x,
                setEnabled: x,
                isEnabled: M
            }, this.mode = yB(o), n.dispatch("SetupEditor", {
                editor: this
            });
            const y = Dc(o);
            w(y) && y.call(o, o);
        }
        render() {
            ((e1)=>{
                const t = e1.id;
                li.setCode(Kd(e1));
                const n = ()=>{
                    kO.unbind(window, "ready", n), e1.render();
                };
                if (!Wa.Event.domLoaded) return void kO.bind(window, "ready", n);
                if (!e1.getElement()) return;
                const o = mn(e1.getElement()), r = Co(o);
                e1.on("remove", ()=>{
                    W(o.dom.attributes, (e1)=>yo(o, e1.name)), po(o, r);
                }), e1.ui.styleSheetLoader = ((e1, t)=>Ys.forElement(e1, {
                        contentCssCors: kc(t),
                        referrerPolicy: Wd(t)
                    }))(o, e1), bc(e1) ? e1.inline = !0 : (e1.orgVisibility = e1.getElement().style.visibility, e1.getElement().style.visibility = "hidden");
                const s = e1.getElement().form || kO.getParent(t, "form");
                s && (e1.formElement = s, vc(e1) && !Jr(e1.getElement()) && (kO.insertAfter(kO.create("input", {
                    type: "hidden",
                    name: t
                }), t), e1.hasHiddenInput = !0), e1.formEventDelegate = (t)=>{
                    e1.dispatch(t.type, t);
                }, kO.bind(s, "submit reset", e1.formEventDelegate), e1.on("reset", ()=>{
                    e1.resetContent();
                }), !yc(e1) || s.submit.nodeType || s.submit.length || s._mceOldSubmit || (s._mceOldSubmit = s.submit, s.submit = ()=>(e1.editorManager.triggerSave(), e1.setDirty(!1), s._mceOldSubmit(s)))), e1.windowManager = cE(e1), e1.notificationManager = iE(e1), ((e1)=>"xml" === e1.options.get("encoding"))(e1) && e1.on("GetContent", (e1)=>{
                    e1.save && (e1.content = kO.encode(e1.content));
                }), Cc(e1) && e1.on("submit", ()=>{
                    e1.initialized && e1.save();
                }), wc(e1) && (e1._beforeUnload = ()=>{
                    !e1.initialized || e1.destroyed || e1.isHidden() || e1.save({
                        format: "raw",
                        no_events: !0,
                        set_dirty: !1
                    });
                }, e1.editorManager.on("BeforeUnload", e1._beforeUnload)), e1.editorManager.add(e1), AO(e1, e1.suffix);
            })(this);
        }
        focus(e1) {
            this.execCommand("mceFocus", !1, e1);
        }
        hasFocus() {
            return vg(this);
        }
        translate(e1) {
            return li.translate(e1);
        }
        getParam(e1, t, n) {
            const o = this.options;
            return o.isRegistered(e1) || (C(n) ? o.register(e1, {
                processor: n,
                default: t
            }) : o.register(e1, {
                processor: M,
                default: t
            })), o.isSet(e1) || v(t) ? o.get(e1) : t;
        }
        hasPlugin(e1, t) {
            return !(!H(Nc(this), e1) || t && void 0 === lE.get(e1));
        }
        nodeChanged(e1) {
            this._nodeChangeDispatcher.nodeChanged(e1);
        }
        addCommand(e1, t, n) {
            this.editorCommands.addCommand(e1, t, n);
        }
        addQueryStateHandler(e1, t, n) {
            this.editorCommands.addQueryStateHandler(e1, t, n);
        }
        addQueryValueHandler(e1, t, n) {
            this.editorCommands.addQueryValueHandler(e1, t, n);
        }
        addShortcut(e1, t, n, o) {
            this.shortcuts.add(e1, t, n, o);
        }
        execCommand(e1, t, n, o) {
            return this.editorCommands.execCommand(e1, t, n, o);
        }
        queryCommandState(e1) {
            return this.editorCommands.queryCommandState(e1);
        }
        queryCommandValue(e1) {
            return this.editorCommands.queryCommandValue(e1);
        }
        queryCommandSupported(e1) {
            return this.editorCommands.queryCommandSupported(e1);
        }
        show() {
            const e1 = this;
            e1.hidden && (e1.hidden = !1, e1.inline ? e1.getBody().contentEditable = "true" : (NB.show(e1.getContainer()), NB.hide(e1.id)), e1.load(), e1.dispatch("show"));
        }
        hide() {
            const e1 = this;
            e1.hidden || (e1.save(), e1.inline ? (e1.getBody().contentEditable = "false", e1 === e1.editorManager.focusedEditor && (e1.editorManager.focusedEditor = null)) : (NB.hide(e1.getContainer()), NB.setStyle(e1.id, "display", e1.orgDisplay)), e1.hidden = !0, e1.dispatch("hide"));
        }
        isHidden() {
            return this.hidden;
        }
        setProgressState(e1, t) {
            this.dispatch("ProgressState", {
                state: e1,
                time: t
            });
        }
        load(e1 = {}) {
            const t = this, n = t.getElement();
            if (t.removed) return "";
            if (n) {
                const o = {
                    ...e1,
                    load: !0
                }, r = Jr(n) ? n.value : n.innerHTML, s = t.setContent(r, o);
                return o.no_events || t.dispatch("LoadContent", {
                    ...o,
                    element: n
                }), s;
            }
            return "";
        }
        save(e1 = {}) {
            const t = this;
            let n = t.getElement();
            if (!n || !t.initialized || t.removed) return "";
            const o = {
                ...e1,
                save: !0,
                element: n
            };
            let r = t.getContent(o);
            const s = {
                ...o,
                content: r
            };
            if (s.no_events || t.dispatch("SaveContent", s), "raw" === s.format && t.dispatch("RawSaveContent", s), r = s.content, Jr(n)) n.value = r;
            else {
                !e1.is_removing && t.inline || (n.innerHTML = r);
                const o = NB.getParent(t.id, "form");
                o && AB(o.elements, (e1)=>e1.name !== t.id || (e1.value = r, !1));
            }
            return s.element = o.element = n = null, !1 !== s.set_dirty && t.setDirty(!1), r;
        }
        setContent(e1, t) {
            return Uw(this, e1, t);
        }
        getContent(e1) {
            return ((e1, t = {})=>{
                const n = ((e1, t)=>({
                        ...e1,
                        format: t,
                        get: !0,
                        getInner: !0
                    }))(t, t.format ? t.format : "html");
                return XC(e1, n).fold(R, (t)=>{
                    const n = ((e1, t)=>Rw(e1).editor.getContent(t))(e1, t);
                    return ZC(e1, n, t);
                });
            })(this, e1);
        }
        insertContent(e1, t) {
            t && (e1 = RB({
                content: e1
            }, t)), this.execCommand("mceInsertContent", !1, e1);
        }
        resetContent(e1) {
            void 0 === e1 ? Uw(this, this.startContent, {
                format: "raw"
            }) : Uw(this, e1), this.undoManager.reset(), this.setDirty(!1), this.nodeChanged();
        }
        isDirty() {
            return !this.isNotDirty;
        }
        setDirty(e1) {
            const t = !this.isNotDirty;
            this.isNotDirty = !e1, e1 && e1 !== t && this.dispatch("dirty");
        }
        getContainer() {
            const e1 = this;
            return e1.container || (e1.container = e1.editorContainer || NB.get(e1.id + "_parent")), e1.container;
        }
        getContentAreaContainer() {
            return this.contentAreaContainer;
        }
        getElement() {
            return this.targetElm || (this.targetElm = NB.get(this.id)), this.targetElm;
        }
        getWin() {
            const e1 = this;
            if (!e1.contentWindow) {
                const t = e1.iframeElement;
                t && (e1.contentWindow = t.contentWindow);
            }
            return e1.contentWindow;
        }
        getDoc() {
            const e1 = this;
            if (!e1.contentDocument) {
                const t = e1.getWin();
                t && (e1.contentDocument = t.document);
            }
            return e1.contentDocument;
        }
        getBody() {
            var e1, t;
            const n = this.getDoc();
            return null !== (t = null !== (e1 = this.bodyElement) && void 0 !== e1 ? e1 : null == n ? void 0 : n.body) && void 0 !== t ? t : null;
        }
        convertURL(e1, t, n) {
            const o = this, r = o.options.get, s = Mc(o);
            if (w(s)) return s.call(o, e1, n, !0, t);
            if (!r("convert_urls") || "link" === n || f(n) && "LINK" === n.nodeName || 0 === e1.indexOf("file:") || 0 === e1.length) return e1;
            const a = new BC(e1);
            return "http" !== a.protocol && "https" !== a.protocol && "" !== a.protocol ? e1 : r("relative_urls") ? o.documentBaseURI.toRelative(e1) : e1 = o.documentBaseURI.toAbsolute(e1, r("remove_script_host"));
        }
        addVisual(e1) {
            ((e1, t)=>{
                ((e1, t)=>{
                    Aw(e1).editor.addVisual(t);
                })(e1, t);
            })(this, e1);
        }
        setEditableRoot(e1) {
            ((e1, t)=>{
                e1._editableRoot !== t && (e1._editableRoot = t, CE(e1) || (e1.getBody().contentEditable = String(e1.hasEditableRoot()), e1.nodeChanged()), ((e1, t)=>{
                    e1.dispatch("EditableRootStateChange", {
                        state: t
                    });
                })(e1, t));
            })(this, e1);
        }
        hasEditableRoot() {
            return this._editableRoot;
        }
        remove() {
            ((e1)=>{
                if (!e1.removed) {
                    const { _selectionOverrides: t, editorUpload: n } = e1, o = e1.getBody(), r = e1.getElement();
                    o && e1.save({
                        is_removing: !0
                    }), e1.removed = !0, e1.unbindAllNativeEvents(), e1.hasHiddenInput && C(null == r ? void 0 : r.nextSibling) && Zw.remove(r.nextSibling), ((e1)=>{
                        e1.dispatch("remove");
                    })(e1), e1.editorManager.remove(e1), !e1.inline && o && ((e1)=>{
                        Zw.setStyle(e1.id, "display", e1.orgDisplay);
                    })(e1), ((e1)=>{
                        e1.dispatch("detach");
                    })(e1), Zw.remove(e1.getContainer()), Qw(t), Qw(n), e1.destroy();
                }
            })(this);
        }
        destroy(e1) {
            ((e1, t)=>{
                const { selection: n, dom: o } = e1;
                e1.destroyed || (t || e1.removed ? (t || (e1.editorManager.off("beforeunload", e1._beforeUnload), e1.theme && e1.theme.destroy && e1.theme.destroy(), Qw(n), Qw(o)), ((e1)=>{
                    const t = e1.formElement;
                    t && (t._mceOldSubmit && (t.submit = t._mceOldSubmit, delete t._mceOldSubmit), Zw.unbind(t, "submit reset", e1.formEventDelegate));
                })(e1), ((e1)=>{
                    const t = e1;
                    t.contentAreaContainer = t.formElement = t.container = t.editorContainer = null, t.bodyElement = t.contentDocument = t.contentWindow = null, t.iframeElement = t.targetElm = null;
                    const n = e1.selection;
                    if (n) {
                        const e1 = n.dom;
                        t.selection = n.win = n.dom = e1.doc = null;
                    }
                })(e1), e1.destroyed = !0) : e1.remove());
            })(this, e1);
        }
        uploadImages() {
            return this.editorUpload.uploadImages();
        }
        _scanForImages() {
            return this.editorUpload.scanForImages();
        }
    }
    const OB = ni.DOM, BB = an.each;
    let PB, DB = !1, LB = [];
    const MB = (e1)=>{
        const t = e1.type;
        BB(zB.get(), (n)=>{
            switch(t){
                case "scroll":
                    n.dispatch("ScrollWindow", e1);
                    break;
                case "resize":
                    n.dispatch("ResizeWindow", e1);
            }
        });
    }, IB = (e1)=>{
        if (e1 !== DB) {
            const t = ni.DOM;
            e1 ? (t.bind(window, "resize", MB), t.bind(window, "scroll", MB)) : (t.unbind(window, "resize", MB), t.unbind(window, "scroll", MB)), DB = e1;
        }
    }, FB = (e1)=>{
        const t = LB;
        return LB = Y(LB, (t)=>e1 !== t), zB.activeEditor === e1 && (zB.activeEditor = LB.length > 0 ? LB[0] : null), zB.focusedEditor === e1 && (zB.focusedEditor = null), t.length !== LB.length;
    }, UB = "CSS1Compat" !== document.compatMode, zB = {
        ...sB,
        baseURI: null,
        baseURL: null,
        defaultOptions: {},
        documentBaseURL: null,
        suffix: null,
        majorVersion: "7",
        minorVersion: "9.3",
        releaseDate: "2026-05-19",
        i18n: li,
        activeEditor: null,
        focusedEditor: null,
        setup () {
            const e1 = this;
            let t = "", n = "", o = BC.getDocumentBaseUrl(document.location);
            /^[^:]+:\/\/\/?[^\/]+\//.test(o) && (o = o.replace(/[\?#].*$/, "").replace(/[\/\\][^\/]+$/, ""), /[\/\\]$/.test(o) || (o += "/"));
            const r = window.tinymce || window.tinyMCEPreInit;
            if (r) t = r.base || r.baseURL, n = r.suffix;
            else {
                const e1 = document.getElementsByTagName("script");
                for(let o = 0; o < e1.length; o++){
                    const r = e1[o].src || "";
                    if ("" === r) continue;
                    const s = r.substring(r.lastIndexOf("/"));
                    if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(r)) {
                        -1 !== s.indexOf(".min") && (n = ".min"), t = r.substring(0, r.lastIndexOf("/"));
                        break;
                    }
                }
                if (!t && document.currentScript) {
                    const e1 = document.currentScript.src;
                    -1 !== e1.indexOf(".min") && (n = ".min"), t = e1.substring(0, e1.lastIndexOf("/"));
                }
            }
            var s;
            e1.baseURL = new BC(o).toAbsolute(t), e1.documentBaseURL = o, e1.baseURI = new BC(e1.baseURL), e1.suffix = n, (s = e1).on("AddEditor", T(gg, s)), s.on("RemoveEditor", T(pg, s));
        },
        overrideDefaults (e1) {
            const t = e1.base_url;
            t && this._setBaseUrl(t);
            const n = e1.suffix;
            n && (this.suffix = n), this.defaultOptions = e1;
            const o = e1.plugin_base_urls;
            void 0 !== o && pe(o, (e1, t)=>{
                di.PluginManager.urls[t] = e1;
            });
        },
        init (e1) {
            const t = this;
            let n;
            const o = an.makeMap("area base basefont br col frame hr img input isindex link meta param embed source wbr track colgroup option table tbody tfoot thead tr th td script noscript style textarea video audio iframe object menu", " ");
            let r = (e1)=>{
                n = e1;
            };
            const s = ()=>{
                let n = 0;
                const a = [];
                let i;
                OB.unbind(window, "ready", s), (()=>{
                    const n = e1.onpageload;
                    n && n.apply(t, []);
                })(), i = me(((e1)=>nn.browser.isIE() || nn.browser.isEdge() ? (pE("TinyMCE does not support the browser you are using. For a list of supported browsers please see: https://www.tiny.cloud/docs/tinymce/7/support/#supportedwebbrowsers"), []) : UB ? (pE("Failed to initialize the editor as the document is not in standards mode. TinyMCE requires standards mode."), []) : m(e1.selector) ? OB.select(e1.selector) : C(e1.target) ? [
                        e1.target
                    ] : [])(e1)), an.each(i, (e1)=>{
                    var n;
                    (n = t.get(e1.id)) && n.initialized && !(n.getContainer() || n.getBody()).parentNode && (FB(n), n.unbindAllNativeEvents(), n.destroy(!0), n.removed = !0);
                }), i = an.grep(i, (e1)=>!t.get(e1.id)), 0 === i.length ? r([]) : BB(i, (s)=>{
                    ((e1, t)=>e1.inline && t.tagName.toLowerCase() in o)(e1, s) ? pE("Could not initialize inline editor on invalid inline target element", s) : ((e1, o, s)=>{
                        const l = new TB(e1, o, t);
                        a.push(l), l.on("init", ()=>{
                            ++n === i.length && r(a);
                        }), l.targetElm = l.targetElm || s, l.render();
                    })(((e1)=>{
                        let t = e1.id;
                        return t || (t = _e(e1, "name").filter((e1)=>!OB.get(e1)).getOrThunk(OB.uniqueId), e1.setAttribute("id", t)), t;
                    })(s), e1, s);
                });
            };
            return OB.bind(window, "ready", s), new Promise((e1)=>{
                n ? e1(n) : r = (t)=>{
                    e1(t);
                };
            });
        },
        get (e1) {
            return 0 === arguments.length ? LB.slice(0) : m(e1) ? Q(LB, (t)=>t.id === e1).getOr(null) : E(e1) && LB[e1] ? LB[e1] : null;
        },
        add (e1) {
            const t = this, n = t.get(e1.id);
            return n === e1 || (null === n && LB.push(e1), IB(!0), t.activeEditor = e1, t.dispatch("AddEditor", {
                editor: e1
            }), PB || (PB = (e1)=>{
                const n = t.dispatch("BeforeUnload");
                if (n.returnValue) return e1.preventDefault(), e1.returnValue = n.returnValue, n.returnValue;
            }, window.addEventListener("beforeunload", PB))), e1;
        },
        createEditor (e1, t) {
            return this.add(new TB(e1, t, this));
        },
        remove (e1) {
            const t = this;
            let n;
            if (e1) {
                if (!m(e1)) return n = e1, h(t.get(n.id)) ? null : (FB(n) && t.dispatch("RemoveEditor", {
                    editor: n
                }), 0 === LB.length && window.removeEventListener("beforeunload", PB), n.remove(), IB(LB.length > 0), n);
                BB(OB.select(e1), (e1)=>{
                    n = t.get(e1.id), n && t.remove(n);
                });
            } else for(let e1 = LB.length - 1; e1 >= 0; e1--)t.remove(LB[e1]);
        },
        execCommand (e1, t, n) {
            var o;
            const r = this, s = f(n) ? null !== (o = n.id) && void 0 !== o ? o : n.index : n;
            switch(e1){
                case "mceAddEditor":
                    if (!r.get(s)) {
                        const e1 = n.options;
                        new TB(s, e1, r).render();
                    }
                    return !0;
                case "mceRemoveEditor":
                    {
                        const e1 = r.get(s);
                        return e1 && e1.remove(), !0;
                    }
                case "mceToggleEditor":
                    {
                        const e1 = r.get(s);
                        return e1 ? (e1.isHidden() ? e1.show() : e1.hide(), !0) : (r.execCommand("mceAddEditor", !1, n), !0);
                    }
            }
            return !!r.activeEditor && r.activeEditor.execCommand(e1, t, n);
        },
        triggerSave: ()=>{
            BB(LB, (e1)=>{
                e1.save();
            });
        },
        addI18n: (e1, t)=>{
            li.add(e1, t);
        },
        translate: (e1)=>li.translate(e1),
        setActive (e1) {
            const t = this.activeEditor;
            this.activeEditor !== e1 && (t && t.dispatch("deactivate", {
                relatedTarget: e1
            }), e1.dispatch("activate", {
                relatedTarget: t
            })), this.activeEditor = e1;
        },
        _setBaseUrl (e1) {
            this.baseURL = new BC(this.documentBaseURL).toAbsolute(e1.replace(/\/+$/, "")), this.baseURI = new BC(this.baseURL);
        }
    };
    zB.setup();
    const jB = (()=>{
        const e1 = Ve();
        return {
            FakeClipboardItem: (e1)=>({
                    items: e1,
                    types: fe(e1),
                    getType: (t)=>_e(e1, t).getOrUndefined()
                }),
            write: (t)=>{
                e1.set(t);
            },
            read: ()=>e1.get().getOrUndefined(),
            clear: e1.clear
        };
    })(), HB = Math.min, $B = Math.max, VB = Math.round, qB = (e1, t, n)=>{
        let o = t.x, r = t.y;
        const s = e1.w, a = e1.h, i = t.w, l = t.h, d = (n || "").split("");
        return "b" === d[0] && (r += l), "r" === d[1] && (o += i), "c" === d[0] && (r += VB(l / 2)), "c" === d[1] && (o += VB(i / 2)), "b" === d[3] && (r -= a), "r" === d[4] && (o -= s), "c" === d[3] && (r -= VB(a / 2)), "c" === d[4] && (o -= VB(s / 2)), WB(o, r, s, a);
    }, WB = (e1, t, n, o)=>({
            x: e1,
            y: t,
            w: n,
            h: o
        }), KB = {
        inflate: (e1, t, n)=>WB(e1.x - t, e1.y - n, e1.w + 2 * t, e1.h + 2 * n),
        relativePosition: qB,
        findBestRelativePosition: (e1, t, n, o)=>{
            for(let r = 0; r < o.length; r++){
                const s = qB(e1, t, o[r]);
                if (s.x >= n.x && s.x + s.w <= n.w + n.x && s.y >= n.y && s.y + s.h <= n.h + n.y) return o[r];
            }
            return null;
        },
        intersect: (e1, t)=>{
            const n = $B(e1.x, t.x), o = $B(e1.y, t.y), r = HB(e1.x + e1.w, t.x + t.w), s = HB(e1.y + e1.h, t.y + t.h);
            return r - n < 0 || s - o < 0 ? null : WB(n, o, r - n, s - o);
        },
        clamp: (e1, t, n)=>{
            let o = e1.x, r = e1.y, s = e1.x + e1.w, a = e1.y + e1.h;
            const i = t.x + t.w, l = t.y + t.h, d = $B(0, t.x - o), c = $B(0, t.y - r), u = $B(0, s - i), m = $B(0, a - l);
            return o += d, r += c, n && (s += d, a += c, o -= u, r -= m), s -= u, a -= m, WB(o, r, s - o, a - r);
        },
        create: WB,
        fromClientRect: (e1)=>WB(e1.left, e1.top, e1.width, e1.height)
    }, YB = (()=>{
        const e1 = {}, t = {}, n = {};
        return {
            load: (n, o)=>{
                const r = `Script at URL "${o}" failed to load`, s = `Script at URL "${o}" did not call \`tinymce.Resource.add('${n}', data)\` within 1 second`;
                if (void 0 !== e1[n]) return e1[n];
                {
                    const a = new Promise((e1, a)=>{
                        const i = ((e1, t, n = 1e3)=>{
                            let o = !1, r = null;
                            const s = (e1)=>(...t)=>{
                                    o || (o = !0, null !== r && (window.clearTimeout(r), r = null), e1.apply(null, t));
                                }, a = s(e1), i = s(t);
                            return {
                                start: (...e1)=>{
                                    o || null !== r || (r = window.setTimeout(()=>i.apply(null, e1), n));
                                },
                                resolve: a,
                                reject: i
                            };
                        })(e1, a);
                        t[n] = i.resolve, ri.ScriptLoader.loadScript(o).then(()=>i.start(s), ()=>i.reject(r));
                    });
                    return e1[n] = a, a;
                }
            },
            add: (o, r)=>{
                void 0 !== t[o] && (t[o](r), delete t[o]), e1[o] = Promise.resolve(r), n[o] = r;
            },
            has: (e1)=>e1 in n,
            get: (e1)=>n[e1],
            unload: (t)=>{
                delete e1[t], delete n[t];
            }
        };
    })();
    let GB;
    try {
        const e1 = "__storage_test__";
        GB = window.localStorage, GB.setItem(e1, e1), GB.removeItem(e1);
    } catch (e1) {
        GB = (()=>{
            let e1 = {}, t = [];
            const n = {
                getItem: (t)=>e1[t] || null,
                setItem: (n, o)=>{
                    t.push(n), e1[n] = String(o);
                },
                key: (e1)=>t[e1],
                removeItem: (n)=>{
                    t = t.filter((e1)=>e1 === n), delete e1[n];
                },
                clear: ()=>{
                    t = [], e1 = {};
                },
                length: 0
            };
            return Object.defineProperty(n, "length", {
                get: ()=>t.length,
                configurable: !1,
                enumerable: !1
            }), n;
        })();
    }
    const XB = {
        geom: {
            Rect: KB
        },
        util: {
            Delay: sg,
            Tools: an,
            VK: wg,
            URI: BC,
            EventDispatcher: oB,
            Observable: sB,
            I18n: li,
            LocalStorage: GB,
            ImageUploader: (e1)=>{
                const t = RE(), n = BE(e1, t);
                return {
                    upload: (t, o = !0)=>n.upload(t, o ? OE(e1) : void 0)
                };
            }
        },
        dom: {
            EventUtils: Wa,
            TreeWalker: Fr,
            TextSeeker: Ei,
            DOMUtils: ni,
            ScriptLoader: ri,
            RangeUtils: Fg,
            Serializer: Fw,
            StyleSheetLoader: Ks,
            ControlSelection: kg,
            BookmarkManager: Yf,
            Selection: Lw,
            Event: Wa.Event
        },
        html: {
            Styles: Ia,
            Entities: ua,
            Node: up,
            Schema: Ra,
            DomParser: KC,
            Writer: Ap,
            Serializer: Tp
        },
        Env: nn,
        AddOnManager: di,
        Annotator: Kf,
        Formatter: VE,
        UndoManager: WE,
        EditorCommands: tB,
        WindowManager: cE,
        NotificationManager: iE,
        EditorObservable: uB,
        Shortcuts: SB,
        Editor: TB,
        FocusManager: rg,
        EditorManager: zB,
        DOM: ni.DOM,
        ScriptLoader: ri.ScriptLoader,
        PluginManager: lE,
        ThemeManager: dE,
        ModelManager: eE,
        IconManager: Jw,
        Resource: YB,
        FakeClipboard: jB,
        trim: an.trim,
        isArray: an.isArray,
        is: an.is,
        toArray: an.toArray,
        makeMap: an.makeMap,
        each: an.each,
        map: an.map,
        grep: an.grep,
        inArray: an.inArray,
        extend: an.extend,
        walk: an.walk,
        resolve: an.resolve,
        explode: an.explode,
        _addCacheSuffix: an._addCacheSuffix
    }, ZB = an.extend(zB, XB);
    ((e1)=>{
        window.tinymce = e1, window.tinyMCE = e1;
    })(ZB), ((e1)=>{
        try {
            module.exports = e1;
        } catch (e1) {}
    })(ZB);
}();

});

})();
//# sourceMappingURL=tinymce.min.d6d461c5.js.map
